let moduleHk = {
  common: {
    next_step: "下壹步",

    submit_info: "提交信息",

    submit: "提交",

    confirm_next_step: "確認無誤，下壹步",

    back_pre_step: "返回上壹步",

    understand_everything: "我已清楚明白全部內容",

    confirm: "確定", //U
    complete: "完成", //U
    opera_success: "操作成功", // U
    male: "男", // U
    female: "女", //U

    login_password: '請輸入登錄密碼',

    tips: "提示", //U
    ok: "知道了",
    select_placeholder_default: "請選擇",
    uploading_text: "上傳中...",
    loading_text: "加載中...",
    checking_text: "驗證中...",
    withdraw_text: "正在轉出",
    message_send_pending_text: "短信發送中...",
    message_send_success_text: "驗證碼已發送",
    //效验错误toast提示文字
    email_verify_fail_text: "請填寫正確格式的郵箱",
    trade_password_verify_fail_text: "密碼應為數字和字母結合，長度不低於6位", //U
    trade_password_repeat_fail_text: "兩次輸入不壹致", //U
    phone_verify_fail_text: "請輸入正確的手機號",
    captcha_verify_fail_text: "請填寫圖片驗證碼",
    card_verify_fail_text: "請填寫正確的證件號碼",
    agreement_verify_fail_text: "請閱讀並同意上述協定",
    amount_verify_fail_text: "您輸入的金額超出範圍",
    no_network_tip: "請檢查網絡連接",

    usd: "美元", //U  2020.12.8
    hkd: "港幣", //U  2020.12.8
    rmb: "人民幣", //U  2020.12.8

    countryname: "國籍",
    edit_info:'修改資料',
    confirm_info:'確認資料'
  },

  // 开户提示语
  error_text:'僅數字和字母',
  error_tips:'樣本：C6666664',
  error_zh_text:'僅數字+X',

  // 选择国籍title
  choose_nationality:'選擇國籍',

  // 证件号错误提示
  error_hk_tips:'證件號碼不能小於6位數',
  error_cn_tips:'身份證號碼格式有誤',

  //h5页面模块
  h5Page:{
    login:{
      title:'登錄'
    },
    transaction:{
      title:'交易設置'
    },
    futuresSetup:{
      title:'期貨開倉設置'
    },
    operation:{
      title:'操作記錄'
    },
    account:{
      title:'帳戶/組'
    },
    order:{
      title:'訂單執行'
    },
    accountDetails:{
      title:'帳戶明細'
    },
  },

  //登录

  login: {
    title: "登錄",

    forget_password_text: "忘記登錄密碼",

    register_text_prev: "沒有帳號，",

    register_text_next: "立即註冊",

    password_login_title: "密碼登錄",

    account_placeholder: "帳號/郵箱/證件號",

    password_placeholder: "登錄密碼",

    message_password_title: "短信驗證碼登錄",

    phone_placeholder: "手機號",

    captcha_placeholder: "圖片驗證碼",

    message_code_placeholder: "短信驗證碼",

    send_message_btn_text: "點擊獲取",

    title_h5: "登录",

    account_placeholder_h5:"账号ID/用户名/邮箱名/身份证号",
    faceIDOrFingerprint: "指紋或FaceID驗證",
    account_password_login: "帳號密碼",
    message_login_text: "短信驗證碼",
    isCheckAgreementTips: "請閱讀並同意免責申明"
  },

  //注册

  register: {
    nav_title: "高盈證券",
    nav_titile2: "登錄密碼", //U
    title: "註冊", //U
    password_setting_page_title: "設置登錄密碼", //U
    phone_placeholder: "手機號",

    captcha_placeholder: "圖片驗證碼",

    message_code_placeholder: "短信驗證碼",

    send_message_btn_text: "點擊獲取",

    argeement_text: ["我已閱讀並同意", "產品使用許可協議", "和", "隱私協議"],

    password_placeholder: "密碼至少8位數字和字母組合",

    confirm_placeholder: "確認密碼",

    password_verify_fail_text: "兩次輸入不壹致",

    register_success_text: "註冊成功"
  },

  //忘记密码

  forget_password: {
    nav_title: "找回登錄密碼",
    first_step_desc: "請輸入註冊時的手機號",
    phone_placeholder: "手機號",

    captcha_placeholder: "圖片驗證碼",

    message_code_placeholder: "短信驗證碼",

    send_message_btn_text: "點擊獲取",

    set_login_password_text: "請設置登錄密碼",

    password_placeholder: "至少八位數字和字母組合",

    confirm_placeholder: "再次輸入密碼",

    email_address: "郵箱地址",

    tips1: "前後密碼不一致，請重新輸入",
    tips2: "密碼設置成功",
    tips3:"密碼是至少8位數字和字母組合"
  },

  selectopening: {
    navtitle: "選擇用戶類型",
    openuser: "個人開戶",
    openmu: "機構開戶",
    openbtn: "立即開戶",
    service: "本服務由",
    servicemiddle: "高盈證券有限公司",
    serviceend: "提供",
	market_hk:"港美股市場",
	compliant:"合規運營",
	company_commission:"我司接受香港證監會監管。",
	latency:"超低延時",
	transaction_latency:"與主流交易所搭建專屬服務器，交易延時降到最低。",
	commission:"超低傭金",
	transaction_costs:"極具競爭力的傭金比例，最大程度節省您的交易成本。",
	activate:"去開通",
	market_glo:"期貨市場",
	dialogMessage:"該用戶是否持有香港銀行帳戶?",
	yes:"是",
	no:"否",
	toastMessage:"暫時只接受持有香港銀行帳戶的用戶開戶"
  },

  //开户流程

  open_account: {
    mode_select: {
      nav_title: "選擇開戶方式",

      page_title: "請選擇您所屬國家地區",

      mode_list: [
		{
		  icon: require("@/assets/images/icon_modeSelect_hk.png"),

		  title: "中國香港用戶",

		  prepare_text: "開戶準備",

		  prepare_list: ["香港公民身份證"],

		  index: 1
		},
        {
          icon: require("@/assets/images/icon_modechoose_china.png"),

          title: "中國內地用戶",

          prepare_text: "開戶準備",

          prepare_list: ["中國內地公民身份證"],

		  index: 0
        }
      ],

      tip_title: "溫馨提示",

      tip_content:
        "本服務不支持代開帳戶需客戶本人填寫；\n本服務不支持多重國籍客戶開戶",

      footer_text_prev: "本服務由",

      footer_text_middle: "高盈期貨(香港)公司",

      footer_text_next: "提供" //U
    },

    idcard_upload: {
      page_title: "根據身份證核實身份信息(1/2)",

      step_title: "步驟壹：上傳身份證照片",

      step_tip: "請務必上傳清晰完整的證件照",

      face_idcard_upload_label: "上傳身份證正面",

      back_idcard_upload_label: "上傳身份證反面",

      submit_btn_text1: "識別身份證信息",

      submit_btn_text2: "填寫身份信息"
    },

    idcard_verify: {
      nav_title1: "身份認證", //U
      nav_title2: "身份認證", //U
      page_title: "根據身份證核實身份信息(2/2)",
      page_extra_text: "*號必填",
      step_title: "步驟二：核實身份信息",

      step_tip: "查閱下列信息是否與身份證壹致，\n 如有不同，請按真實信息填寫",

      chinese_name_field: {
        label: "中文名"
      },

      english_name_field: {
        label1: "英文名",
        label2: "英文名(拼音)" //U
      },

      sex_field: {
        label: "性别"
      },

      birth_field: {
        label: "出生年月"
      },

      idcard_field: {
        label: "證件號碼"
      },

      address_field: {
        label: "地址歸屬"
        // placeholder: "请选择"
      },

      address_detail_field: {
        label: "詳細住址" // U
        // placeholder: "请填写您的住址"
      }
    },

    address_proof: {
      nav_title: "住址證明",
      page_title: "請上傳住址證明",

      tip:
        "請使用最近三個月內的銀行結單或公共服務單據副本作為 住址證明住址證明應包含完整的姓名住址或聯系地址 日期，如果你的住址和身份證件一致，請上傳證件證明",

      address_proof_field: {
        label: "住址證明"
      },

      address_field: {
        label: "地址歸屬",

        placeholder: "請選擇"
      },

      address_detail_field: {
        label: "詳細地址",
        placeholder: "請填寫您的住址"
      }
    },
    //用户资料
    account_info:{
      nav_title: "帳戶資料",
      page_title: "客戶帳戶資料",

      email_field: {
        label: "郵箱",
        placeholder: "請綁定"
      },
    },

    personal_info_supply: {
      nav_title: "個人信息補充",

      page_title: "請補充個人其他信息",

      page_extra_text_1: "*", //U
      page_extra_text_2: "號必填",

      contact_info: "聯系方式",

      contact_info_desc: "(重要)",

      phone_field: {
        label: "手機號"
      },

      email_field: {
        label: "電子郵箱",
        tip: "電子郵箱用於接受期貨帳戶結算單，請綁定常用郵箱" //U
      },

      education_module_title: "教育/就業情況", //U

      education_field: {
        label: "教育情況",
        columns: [
          //U
          {
            text: "小學",
            value: 1
          },
          {
            text: "中學",
            value: 2
          },
          {
            text: "大學",
            value: 3
          },
          {
            text: "碩士及以上",
            value: 4
          }
        ]
      },

      employment_field: {
        label: "就業情況",
        columns: [
          //U
          {
            text: "受雇",
            value: 1
          },
          {
            text: "自雇",
            value: 2
          },
          {
            text: "退休",
            value: 3
          },
          {
            text: "學生",
            value: 4
          },
          {
            text: "其他",
            value: 5
          }
        ],
        placeholder_other: "請填寫，例如：家庭主婦"
      },

      employer_name_field: {
        label: "雇主名稱",
        placeholder:"選填"
      },

      profession_attr_field: {
        label: "職業屬性",
        placeholder:"選填"
      },

      position_field: {
        label: "職位",
        placeholder:"選填"
      },

      employment_duration_field: {
        label: "受雇年期",
        columns: [
          //U
          {
            text: "不滿壹年",
            value: 1
          },
          {
            text: "1～3年",
            value: 2
          },
          {
            text: "3年以上",
            value: 3
          }
        ]
      },

      company_phone_field: {
        label: "公司/機構電話",
        placeholder:"選填"
      },

      company_address_field: {
        label: "公司/機構地址", //U
        placeholder:"選填"
      }
    },

    email_bind: {
      nav_title: "郵箱",
      page_title: "綁定郵箱",

      bind_title: "兩步綁定郵箱",

      first_step_name: "第壹步",

      first_step_desc: "填寫郵箱號，提交",

      second_step_name: "第二步",

      second_step_desc: "打開郵件，點擊激活按鈕",

      email_field: {
        label: "郵箱",
        placeholder: "郵箱名"
      },

      captcha_field: {
        label: "圖片驗證",
        placeholder: "驗證碼"
      },
      email_send_success_title: "操作成功，郵件已發送，請註意查收", //U
      email_send_success_tip: "請進入郵箱，在郵件中點擊激活按鈕" //U
    },

    customer_state: {
      nav_title: "客戶聲明",
      page_title: "客戶聲明",
      fail_toast_text: "您必須符合上述條件才能開戶", //U
      statement_list: [
        {
          title: "1、本人是該帳戶之最終受益人",
          tip: "我司不接受申請人為非帳戶最終受益人"
        },
        {
          title:
            " 2、您是否與高盈證券有限公司(高盈證券)或聯系人士的職員或代理人有親戚關係？",
          tip: "請提供以下資料",
          input_label_1: "職員/代理人名稱：",
          input_label_2: "關系"
        },
        {
          title:
            "3、您是否是證券/期貨交易所參與者的僱員或代理人，或於證監會註冊的持牌法團/註冊機構？",
          tip: "請提供以下資料",
          input_label_1: "相關參與者或註冊人的姓名是：",
          input_label_2: "閣下的牌照編號："
        },
        {
          title:
            "4、本人是否是美國公民或美國居民或出生於美國或美國領土，或持有“美國永久居民身份證（綠卡）”？",
          tip: "我司不接受申請人是美國公民"
        },
        {
          title:
            "5、您的配偶是否在高盈證券有限公司開設過任何帳戶? 如是，戶口號碼是：",
          tip: "請提供以下資料",
          input_label_1: "配偶帳戶ID："
        }
      ],
      yes: "是",
      no: "否",
      input_placeholder: "請輸入"
    },

    tax_resident_info: {
      page_one: {
        nav_title: "稅務居民資料",

        page_title: "稅務目的地",

        page_extra_text: "請按照實際情況選擇",

        common_country_list: [
          {
            text: "中國內地"
          },
          {
            text: "中國香港"
          },
          {
            text: "中国澳门"
          },
          {
            text: "臺灣"
          },
          {
            text: "日本"
          },
          {
            text: "加拿大"
          },
          {
            text: "泰國"
          },
          {
            text: "印尼"
          }
        ],

        extra: "其他",

        search_placeholder: "請輸入中文或者英文搜索國家",
        toast_fail_text: "稅務目的地請不要超過2個"
      },

      page_two: {
        nav_title: "稅務居民資料",

        page_title: "客戶稅務居民資料",

        tax_area: "納稅地區",

        tax_number_field: {
          label: "稅務編號",

          placeholder: "請錄入"
        },

        residence_jurisdiction_field: {
          label: "居留司法管轄區",

          placeholder: "請錄入"
        }
      }
    },

    country_list: {
      nav_title: "選擇稅務目的地",
      search_bar_placeholder: "請輸入關鍵字搜索",
      no_result_tip: "抱歉，未能匹配到您搜索的內容"
    },

    w_8ben: {
      page_title: "客戶W-8BEN資料",

      taxpayer_name: "納稅人姓名",

      region: "所屬地區",

      address_field: {
        label: "地址歸屬(英文)",

        placeholder: "請選擇"
      },

      address_detail_field: {
        label: "詳細住址(英文)",

        placeholder:
          "請填寫街道請填寫英文詳細地址 格式按照樓棟及單元小區村組街道鄉鎮"
      }
    },

    survey: {
      nav_title: "適當性調查",
      cognition_of_derivatives: "衍生品的認知",
      page_one: {
        invest_target_title: "投資目標",
        invest_target_desc: "*號必填",
        invest_tagert_list: [
          {
            title: "投資目標（可多選）",
            type: "checkbox",
            value: [],
            options: [
              {
                value: 1,
                label: "賺取收入"
              },
              {
                value: 2,
                label: "資本增長"
              },
              {
                value: 3,
                label: "對沖"
              },
              {
                value: 4,
                label: "投機"
              },
              {
                value: 5,
                label: "其他",
                placeholder: "請填寫其他投資目標",
                isChecked: false,
                inputValue: ""
              }
            ]
          }
        ], //U
        derivative_title: "對衍生品的認知", //U
        derivative_tip: "您通過哪種方式了解衍生品",
        whitelist_users_tips: "不瞭解衍生品，無法開戶",
        derivative_tip_two: "可選擇以下任意一項",
        derivative_no_title:
          "如您的回答為「未有衍生產品之認識」。如果您仍然有意認購衍生產品，您僅限於以下情況可作認購:",
        derivative_no: [
          "如該衍生產品是在交易所買賣 - 我們沒有就擬進行的交易向您作出招攬或建議，而且我們已向您解釋該產品所附帶的相關風險；或",
          "如該衍生產品並非在交易所買賣 - 我們沒有就擬進行的交易向您作出招攬或建議，而且我們已就有關交易向您提出警告，並考慮到我們通過盡職調查已知悉或應當知悉的關於您的資訊，尤其是您是一名對衍生品並不瞭解的客戶的事實，就有關交易對您是否在任何情況下都合適。如評估結果顯示有關交易並不適合您，我們只可在執行有關交易是維護您最佳利益的行事方式的前提下，著手執行有關交易。"
        ],
        derivative_no_agree:
          "本人(等) (客戶)沒有上述經驗，但已細閱、同意及明白所有關於衍生產品的風險聲明，本人(等) (客戶)明白於買賣有關衍生產品前必須先具備足夠的認識，並願意接受一切有關的風險。",
        derivative_list: [
          {
            title: "本人是否了解衍生產品的性質和風險",
            options: ["了解", "不了解"]
          },
          {
            title: "1、已接受有關的培訓或課程（可多選）",
            options: ["監管機構", "交易所", "大專院校", "進修學院", "金融機構"]
          },
          {
            title:
              "2、於經濟公司或銀行、基金或資產管理公司、監管機構 或交易所等金融機構有關的工作經驗（可多選）",
            options: ["受監管持牌人士", "管理層", "與衍生工具相關活動"]
          },
          {
            title:
              "3、於過去三年內進行了五次或以上有關任何衍生產品之交易(不論是否在交易所買賣)",
            options: ["是", "否"]
          }
        ] // U
      },

      page_two: {
        investment_exp_title: "投資經驗",
        investment_exp_list: [
          {
            label: "上市證券",
            value: "",
            options: [
              {
                text: "沒有經驗",
                value: 1
              },
              {
                text: "少於壹年",
                value: 2
              },
              {
                text: "壹至三年",
                value: 3
              },
              {
                text: "三至五年",
                value: 4
              },
              {
                text: "五年以上",
                value: 5
              }
            ]
          },
          {
            label: "牛熊證/窩輪",
            value: "",
            options: [
              {
                text: "沒有經驗",
                value: 1
              },
              {
                text: "少於壹年",
                value: 2
              },
              {
                text: "壹至三年",
                value: 3
              },
              {
                text: "三至五年",
                value: 4
              },
              {
                text: "五年以上",
                value: 5
              }
            ]
          },
          {
            label: "期貨/期權",
            value: "",
            options: [
              {
                text: "沒有經驗",
                value: 1
              },
              {
                text: "少於壹年",
                value: 2
              },
              {
                text: "壹至三年",
                value: 3
              },
              {
                text: "三至五年",
                value: 4
              },
              {
                text: "五年以上",
                value: 5
              }
            ]
          },
          {
            label: "杠桿式外匯",
            value: "",
            options: [
              {
                text: "沒有經驗",
                value: 1
              },
              {
                text: "少於壹年",
                value: 2
              },
              {
                text: "壹至三年",
                value: 3
              },
              {
                text: "三至五年",
                value: 4
              },
              {
                text: "五年以上",
                value: 5
              }
            ]
          },
          {
            label: "單位信托基金或債券",
            value: "",
            options: [
              {
                text: "沒有經驗",
                value: 1
              },
              {
                text: "少於壹年",
                value: 2
              },
              {
                text: "壹至三年",
                value: 3
              },
              {
                text: "三至五年",
                value: 4
              },
              {
                text: "五年以上",
                value: 5
              }
            ]
          },
          {
            label: "結構性產品",
            value: "",
            options: [
              {
                text: "沒有經驗",
                value: 1
              },
              {
                text: "少於壹年",
                value: 2
              },
              {
                text: "壹至三年",
                value: 3
              },
              {
                text: "三至五年",
                value: 4
              },
              {
                text: "五年以上",
                value: 5
              }
            ]
          },
          {
            label: "其他",
            value: 2,
            options: [
              {
                text: "沒有經驗",
                value: 1
              },
              {
                text: "少於壹年",
                value: 2
              },
              {
                text: "壹至三年",
                value: 3
              },
              {
                text: "三至五年",
                value: 4
              },
              {
                text: "五年以上",
                value: 5
              }
            ]
          }
        ], //U
        not_allow_open_account_dialog: {
          content: "您對期貨的認知有限，無法開戶！\n建議您先了解期貨知識。",
          cancelButtonText: "返回首頁"
        },
        fail_toast_text: "無法開戶" //U
      },

      page_three: {
        page_title: "財務狀況",
        page_extra_text: "*號必填", //U
        financial_list: [
          {
            type: "select",
            label: "流動資產（港幣）",
            value: "",
            options: [
              {
                text: "＜HKD100,000",
                value: 1
              },
              {
                text: "HKD100,001-HKD500,000",
                value: 2
              },
              {
                text: "HKD500,001-HKD1,000,000",
                value: 3
              },
              {
                text: "HKD1,000,001-HKD5,000,000",
                value: 4
              },
              {
                text: "HKD5,000,001-HKD10,000,000",
                value: 5
              },
              {
                text: ">HKD10,000,000",
                value: 6
              }
            ]
          },
          {
            type: "select",
            label: "資產凈值（港幣）",
            value: "",
            options: [
              {
                text: "＜HKD100,000",
                value: 1
              },
              {
                text: "HKD100,001-HKD500,000",
                value: 2
              },
              {
                text: "HKD500,001-HKD1,000,000",
                value: 3
              },
              {
                text: "HKD1,000,001-HKD5,000,000",
                value: 4
              },
              {
                text: "HKD5,000,001-HKD10,000,000",
                value: 5
              },
              {
                text: ">HKD10,000,000",
                value: 6
              }
            ]
          },
          {
            type: "select",
            label: "每年收入（港幣）",
            value: "",
            options: [
              {
                text: "＜HKD100,000",
                value: 1
              },
              {
                text: "HKD100,000-HKD200,000",
                value: 2
              },
              {
                text: "HKD200,001-HKD500,000",
                value: 3
              },
              {
                text: "HKD500,001-HKD1,000,000",
                value: 4
              },
              {
                text: ">HKD1,000,000",
                value: 5
              }
            ]
          },
          {
            type: "inputCheckbox",
            label: "資金來源（可多選）",
            value: [],
            options: [
              {
                text: "薪金儲蓄",
                value: 1
              },
              {
                text: "家庭",
                value: 2
              },
              {
                text: "營業盈利",
                value: 3
              },
              {
                text: "租金收入",
                value: 4
              },
              {
                text: "金融機構貸款",
                value: 5
              },
              {
                isChecked: false,
                inputValue: "",
                text: "其他",
                placeholder: "請填寫其他資金來源",
                value: 6
              }
            ]
          },
          {
            type: "multiSelect",
            label: "住宅業權（按實際情況選擇）",
            value: "",
            options: [
              {
                text: "擁有",
                value: 1,
                children: {
                  value: "",
                  options: [
                    {
                      value: 1,
                      label: "已抵押"
                    },
                    {
                      value: 2,
                      label: "未抵押"
                    }
                  ]
                }
              },
              {
                text: "沒有",
                value: 2,
                children: {
                  value: "",
                  options: [
                    {
                      value: 1,
                      label: "租住"
                    },
                    {
                      value: 2,
                      label: "與家人同住"
                    }
                  ]
                }
              }
            ]
          }
        ] // U
      }
    },

    risk_disclosure: {
      nav_title: "風險披露",
      page_title: "請了解風險內容並確認",
      toast_fail_text: "請仔細閱讀完風險披露",
      p1: "持牌代表",
      p2: "中央編號",
      p3: "X",
      p4: "普通話",
      p5: "粵語",
      p6: "英語",
      p7: "約",
      p8: "分",
      p9: "秒",
      p10: "請先播放完語音",
    },

    customer_payment: {
      nav_title: "客戶常設授權",
      page_title: "常設授權通用條款（適用於所有帳戶）",
      company_info:[
        "香港尖沙咀港威大廈 6 座 31 樓 3102 室",
        "電話: (852) 2187 2100",
        "傳真: (852) 2187 2107",
        "網址: www.goingf.hk"
      ],
      letter_title:"客戶常設授權",
      customer_letter:[
        "致：高盈證券有限公司",
        "      香港尖沙咀港威大廈 6 座 31 樓 3102 室"
      ],
      // page_name:
      //   "本授權根據（證券及期貨(客戶款項)規則）涵蓋貴公司爲我/我們在香港持有或收取並存放於一個或多個獨立帳戶內的款項(包括因持有並非屬於貴公司的款項而產生之任何利息)(下稱「款項」)。",
      // h: "我/我們授權貴公司: ",
      p: [
        "除文義另有所指外，於本常設授權書內的任何名詞，與《證券及期貨條例》 、《證券及期貨（客戶款項）規則》及《證券及期貨（客戶證券）規則》不時修訂之定義具有相同意思。",
        "按照由客戶續期或根據客戶款項規則或客戶證券規則（視乎情況而定）當作已被續期所制約下，本常設授權書的有效期為十二（12）個月，自本常設授權書之簽發日起計有效。",
        "本人／吾等明白本人／吾等可以以書面形式向高盈證券於上述所列明之地址發出通知，撤回本授權書。撤回本授權書之生效日期為高盈證券收到該通知後起計三十（30）天",
        "本人／吾等明白常設授權續期通知書將於常設授權屆滿前最少十四天寄予本人／吾等。如高盈證券於常設授權有效期屆滿前未有接獲本人／吾等書面反對，則本人／吾等之常設授權會在屆滿時按照常設授權的條款及細則視作為同意續期十二個月。",
        "除非本常設授權書到期或於到期前被撤回（以較早者為準），否則本常設授權書保持有效。",
        "本人／吾等明白及同意，若本人／吾等的帳戶有任何不尋常或可疑活動，高盈證券有權凍結本人／吾等的帳戶並要求本人／吾等的帳戶提供更多資料。",
        "本人／吾等確認高盈證券已向其解釋本常設授權書，本人／吾等完全明白本常設授權書的內容，並已經或有機會就其內容及效力尋求法律顧問的意見。",
        "本人／吾等明白，倘若中文版本與英文版本在解釋或意義方面有任何歧義，應以英文版本為準。"
      ],
      timebtn: "我已清楚明白全部內容"
    },
    customer_payment_two: {
      nav_title: "客戶常設授權",
      page_title: "證券及期貨（客戶款項）規則規定的常設授權",
      // page_name:
      //   "本授权根据（证券及期货（客户款项）规则）涵盖贵公司为我/我们在香港持有或收取并存放于一个或多个独立账户内的款项（包括因持有并非属于贵公司的款项而产生之任何利息）（下称「款项」）。",
      // h: "我/我们授权贵公司：",
      p: [
        "本常設授權是涵蓋高盈證券為本人／吾等在香港以及海外收取或持有並存放於一個或多個獨立帳戶內之款項（包括因持有並非屬於高盈證券之款項而產生之任何利息）（下稱「款項」）。本人茲授權高盈證券處理此等款項。",
        "就高盈證券為吾等在香港收取或持有的款項，本人／吾等進一步授權高盈證券：",
        "1.組合或合併高盈證券所維持的任何性質的任何或全部獨立帳戶，此等組合或合併活動可以個別地或與其他帳戶聯合進行，高盈證券可將該等獨立帳戶內任何數額之款項作出轉移，以解除吾等對高盈證券的義務或法律責任，不論此等義務和法律責任是確實或或然的、原有或附帶的、有抵押或無抵押的、共同或分別的；及",
        "2.高盈證券可將款項的任何款額任何時間維持的獨立帳戶之間轉入轉出以結清吾等對高盈證券負有的債務；及",
        "3.可將帳戶內的款項以高盈證券最終確定的匯率兌換成任何其他貨幣。",
        "就高盈證券為吾等在海外收取或持有的款項，本人／吾等進一步授權高盈證券：",
        "本常設授權書授權高盈證券不需事先通知或取得的確認及／或指示可酌情動用款項的全部或部份作買賣海外證券之用、符合交收或按金要求及或其他用途。高盈證券有權：",
        "將任何數額之款項支付／轉往本人／吾等於高盈證券的帳戶及／或任何海外金融機構及／或結算公司的期貨帳戶及其繼承人及受讓人以作本人／吾等買賣海外證券之用或符合交收或按金的要求（如適用）；及／或",
        "從高盈證券在香港或其他地方設立之一或多個獨立帳戶及在任何海外金融機構及／或結算公司設立之獨立帳戶或於該等帳戶之間來回調動；及／或",
        "訂立外幣兌換合約，適用於當日或之前為了購買海外期貨合約之用或符合交收或按金的要求（如適用）而需要將資金轉換為其他貨幣，此等兌換合約按高盈證券慣例並以市場匯率訂立。外幣兌換合約的內容（包括但不限於訂約時間）由高盈證券全權決定。",
        "高盈證券可以不向本人／吾等發出通知而采取上述行動。",
        "本人／吾等明白本常設授權乃鑑於高盈證券同意開立及繼續維持吾等的證券現金／融資交易帳戶及期貨交易帳戶。",
        "本人／吾等明白本人／吾等的證券可能受制於第三者之權利，高盈證券可於全數抵償該等權利後，方可將本人／吾等的證券退回给本人／吾等。",
        "本人／吾等確認，高盈證券在香港以外地方收取或持有的本人／吾等的資產，是受到有關海外司法管轄區的適用法律及規例所監管的。這些法律及規例與《證券及期貨條例》（第 571 條）及根據該條例制訂的規則可能有所不同。因此，有關資產有可能不會享有賦予本人／吾等在香港收取或持有的資產的相同保障。",
        "(本段只適用於證券融資帳戶) 當客戶在本公司的個人及／或聯名戶口沒有現金結餘時，若透過客戶的個人及／或聯名戶口進行股票孖展貸款，提取資金以滿足其他戶口的按金或交收要求，客戶將面對額外的風險與成本，包括市場風險、保證金交易風險等和需要承擔額外的利息成本。"
      ],
      timebtn: "我已清楚明白全部內容"
    },
    customer_payment_three: {
      nav_title: "客戶常設授權",
      page_title: "證券及期貨（客戶證券）規則規定的常設授權（只適用於證券融資帳戶）",
      p: [
        "本人／吾等確認本人／吾等完全明白本常設授權的內容，並且本人／吾等進一步確認本人／吾等授權高盈證券處理在高盈證券處即將開立" +
        "的證券融資帳戶中所有證券。本人／吾等確認本人／吾等授權高盈證券：",
        "1. 根據證券借貸協議，運用本人／吾等的任何證券或證券抵押品；",
        "2. 把本人／吾等的任何證券抵押品存放於任何認可財務機構，作為該機構向高盈證券提供財務通融的抵押品；",
        "3. 將本人／吾等的任何證券抵押品存放給香港中央結算有限公司（下稱「香港結算」），用作履行及清償本人／吾等的清算責任和債務。"+
        "本人／吾等明白香港結算因應高盈證券承擔的義務對本人／吾等的證券設定第一固定押記；",
        "4. 將本人／吾等的任何證券抵押品存放給任何其他認可結算所或者其他有獲發牌或獲註冊進行證券交易的中介人，作為解除高盈證券在交收上的法律責任的抵押品；以及",
        "5. 若高盈證券在證券交易過程中以及任何其它已經獲發牌或已獲注冊的受規管活動過程中，向本人／吾等提供財務通融，可根據上述第（1）、（2）、（3）和／或（4）段所述調動或存放本人／吾等的任何證券抵押品。",
        "高盈證券可以不向本人／吾等發出通知而采取上述行動。",
        "本人／吾等明白本授權書不影響高盈證券為解除由本人／吾等對高盈證券或第三者所負的法律責任，而處置或促使高盈證券處置本人／吾等證券抵押品的權利。",
        "此賦予高盈證券之授權乃鑒於高盈證券同意繼續維持本人／吾等之證券融資帳戶戶口。"
      ],
      timebtn: "我已清楚明白全部內容"
    },

    risk_content: {
      h: "客戶務須細閱此等風險披露聲明",
      // p: "客戶確認以下買賣期貨或衍生工具的風險：",
      // h1: "A.期貨及期權交易的風險",
      p1: [
        "客戶務須細閱此等風險披露聲明。此等聲明為本協議及開戶表格的組成部份。客戶執行開戶表格，即表示確認其已閱讀並細閱其選擇語言版本（英文或中文）的此等風險披露聲明，並獲邀閱讀該聲明、提出問題及在有此意願的情況下徵求獨立的意見，以及確認其明白與帳戶有關的投資及交易可能產生的風險。",
        "此等風險披露聲明沒有亦不旨在披露與帳戶有關的所有投資及交易的一切風險及相關考慮因素。客戶於全面了解所涉及的風險，並從客戶本身的顧問取得客戶認為適當的獨立意見前，應避免作出任何投資或交易。本公司並非客戶的財務顧問，亦不應被視作客戶的財務顧問。"
      ],
      // h2: "B.關於期貨及期權買賣的額外風險披露",
      p2: [
        // "客戶確認本聲明並不涵蓋買賣期貨及期權的所有風險及其他重要事宜。",
        // "就風險而言，客戶在進行任何上述交易前，應先了解將訂立的合約的性質（及有關的合約關系）和客戶就此須承擔的風險程度。",
        // "期貨及期權買賣對很多公眾投資者都並不適合，客戶應就本身的投資經驗、投資目標、財政資源及其他相關條件，小心衡量自己是否適合參與該等買賣。",
        // "期貨",
        // "1.「杠桿」效應",
        // "期貨交易的風險非常高。由於期貨的開倉保證金的金額較期貨合約本身的價值相對為低，因而能在期貨交易中發揮「杠桿」作用。",
        // "市場輕微的波動也會對客戶投入或將需要投入的資金造成大比例的影響。",
        // "所以，對客戶來說，這種杠桿作用可說是利弊參半，因此客戶可能會損失全部開倉保證金及為維持本身的倉盤而向有關商號存入的額外金額。",
        // "若果市況不利客戶所持倉盤或保證金水平提高，客戶會遭追收保證金，須在短時間內存入額外資金以維持本身倉盤。",
        // "假如客戶未有在指定時間內繳付額外的資金，客戶可能會被迫在虧蝕情況下平倉，而所有因此出現的短欠數額一概由客戶承擔。",
        // "2.減低風險交易指示或投資策略",
        // "使客戶采用某些旨在預設虧損限額的交易指示（如「止蝕」或「止蝕限價」指示），也可能作用不大，因為市況可以令這些交易指示無法執行。",
        // "至於運用不同持倉組合的策略，如「跨期」和「馬鞍式」等組合，所承擔的風險也可能與持有最基本的「長」倉或「短」倉同的高。",
        // "期權",
        // "3.不同風險程度",
        // "期權交易的風險非常高。投資者不論是購入或出售期權，均應先了解其打算買賣的期權類別（即認沽期權或認購期權）以及相關的風險。",
        // "客戶應計入期權金及所有交易成本，然後計算出期權價值必須增加多少才能獲利。",
        // "購入期權的投資者可選擇抵銷或行使期權或任由期權到期。如果期權持有人選擇行使期權，便必須進行現金交收或購入或交付相關的資產。",
        // "若購入的是期貨產品的期權，期權持有人將獲得期貨倉盤，並附帶相關的保證金責任（參閱上文「期貨」一節）。",
        // "如所購入的期權在到期時已無任何價值，客戶將損失所有投資金額，當中包括所有的期權金及交易費用。假如客戶擬購入極價外期權，應註意客戶可以從這類期權獲利的機會極微。",
        // "出售",
        // " (「沽出」或「賣出」）期權承受的風險一般較買入期權高得多。賣方雖然能獲得定額期權金，但亦可能會承受遠高於該筆期權金的損失。倘若市況逆轉，期權賣方便須投入額外保證金來補倉。",
        // "期權賣方還需承擔買方可能會行使期權的風險，即期權賣方在期權買方行使時有責任以現金進行交收或買入或交付相關資產。",
        // "若賣出的是期貨產品的期權，則期權賣方將獲得期貨倉盤及附帶的保證金責任（參閱上文「期貨」一節）。",
        // "若期權賣方持有相應數量的相關資產或期貨或其他期權作「備兌」，則所承受的風險或會減少。假如有關期權並無任何「備兌」安排，虧損風險可以是無限大。",
        // "某些國家的交易所允許期權買方延遲支付期權金，令買方支付保證金費用的責任不超過期權金。",
        // "盡管如此，買方最終仍須承受損失期權金及交易費用的風險。在期權被行使又或到期時，買方有需要支付當時尚未繳付的期權金。",
        // "期貨及期權其他常見風險",
        // "4.合約的條款及細則",
        // "客戶應向替客戶進行交易的商號查詢所買賣的有關期貨或期權合約的條款及細則，以及有關責任（例如在什麽情況下客戶或會有責任就期貨合約的相關資產進行交收，或就期權而言，期權的到期日及行使時間限製）。",
        // "交易所或結算公司在某情況下，或會修改尚未行使的合約的細則（包括期權行使價），以反映合約的相關資產的變化。",
        // "5.暫停或限製交易及價格關系：",
        // "市場情況（例如市場流通量不足）及／或某些市場規則的施行（例如因價格限製或「停板」措施而暫停任何合約或合約月份的交易），都可以增加虧損風險，這是因為投資者屆時將難以或無法執行交易或平掉／抵銷倉盤。如果客戶賣出期權後遇到這種情況，客戶須承受的虧損風險可能會增加。",
        // "此外，相關資產與期貨之間以及相關資產與期權之間的正常價格關系可能並不存在。例如，期貨期權所涉及的期貨合約須受價格限製所規限，但期權本身則不受其規限。",
        // "缺乏相關資產參考價格會導致投資者難以判斷何謂「公平價格」。",
        // "6.存放的現金及財產",
        // "如果客戶為在本地或海外進行的交易存放款項或其他財產，客戶應了解清楚該等款項或財產會獲得哪些保障，特別是在有關商號破產或無力償債時的保障。",
        // "至於能追討多少款項或財產一事，可能須受限於具體法例規定或當地的規則。在某些司法管轄區，收回的款項或財產如有不足之數，則可認定屬於客戶的財產將會如現金般按比例分配予客戶。",
        // "7.傭金及其他收費",
        // "在開始交易之前，客戶先要清楚了解必須繳付的所有傭金、費用或其他收費。這些費用將直接影響客戶可獲得的凈利潤（如有）或增加客戶的虧損。",
        // "8.在其他司法管轄區進行交易",
        // "在其他司法管轄區的市場（包括與本地市場有正式連系的市場）進行交易，或會涉及額外的風險。",
        // "根據這些市場的規例，投資者享有的保障程度可能有所不同，甚或有所下降。在進行交易前，客戶應先行查明有關客戶將進行的該項交易的所有規則。",
        // "客戶本身所在地的監管機構，將不能迫使客戶已執行的交易所在地的所屬司法管轄區的監管機構或市場執行有關的規則。",
        // "有鑒於此，在進行交易之前，客戶應先向有關商號查詢客戶本身地區所屬的司法管轄區及其他司法管轄區可提供哪種補救措施及有關詳情。",
        // "9.貨幣風險",
        // "以外幣計算的合約買賣所帶來的利潤或招致的虧損（不論交易是否在客戶本身所在的司法管轄區或其他地區進行），均會在需要將合約的單位貨幣兌換成另一種貨幣時受到匯率波動的影響。",
        // "10.交易設施",
        // "電子交易的設施是以電腦組成系統來進行交易指示傳遞、執行、配對、登記或交易結算。",
        // "然而，所有設施及系統均有可能會暫時中斷或失靈，而客戶就此所能獲得的賠償或會受製於系統供應商、市場、結算公司及／或參與者商號就其所承擔的責任所施加的限製。由於這些責任限製可以各有不同，客戶應向為客戶進行交易的商號查詢這方面的詳情。",
        // "11.電子交易",
        // "透過某個電子交易系統進行買賣，可能會與透過其他電子交易系統進行買賣有所不同。如果客戶透過某個電子交易系統進行買賣，便須承受該系統帶來的風險，包括有關系統硬件或軟件可能會失靈的風險。",
        // "系統失靈可能會導致客戶的交易指示不能根據指示執行，甚或完全不獲執行。",
        // "12.場外交易",
        // "某些司法管轄區，及只有在特定情況之下，有關商號獲準進行場外交易。為客戶進行交易的商號可能是客戶所進行的買賣的交易對手方。",
        // "在這種情況下，有可能難以或根本無法平掉既有倉盤、評估價值、厘定公平價格又或評估風險。因此，這些交易或會涉及更大的風險。",
        // "此外，場外交易的監管或會比較寬松，又或需遵照不同的監管製度；因此，客戶在進行該等交易前，應先了解適用的規則和有關的風險。",
        // "C.在香港以外地方收取或持有的客戶資產的風險",
        // "持牌人或註冊人在香港以外地方收取或持有的客戶資產，是受到有關海外司法管轄區的適用法律及規例所監管的。這些法律及規例與《證券及期貨條例》（第571章）及根據該條例製訂的規則可能有所不同。",
        // "因此，有關客戶資產將可能不會享有賦予在香港收取或持有的客戶資產的相同保障。",
        // "D.提供代存郵件或將郵件轉交第三方的授權書的風險",
        // "假如客戶向持牌人或註冊人提供授權書，允許他人代存郵件或將郵件轉交予第三方，那麽客戶便須盡速親身收取所有關於客戶帳戶的成交單據及結單，並加以詳細閱讀，以確保可及時偵察到任何差異或錯誤。",
        // "E.免責聲明",
        // "1.期交所免責聲明",
        // "作為在期交所買賣合約基準之股份指數及其他專利產品可由期交所不時發展。期交所臺灣指數期貨為期交所發展之首個該等股份指數。可由期交所不時發展之期交所臺灣指數及該等其他指數或專利產品（「期交所指數」）為期交所之財產。",
        // "編製及計算各期交所指數之程序屬期交所之獨家財產及專利品。",
        // "編製及計算期交所指數之程序及基準可在毋須通知之情況下由期交所隨時作出變動或更改，而期交所亦可隨時要求以期交所可能指定之任何期交所指數為基準之該等期貨或期權合約在買賣及結算時參考一項將會計算之替代指數。",
        // "期交所概無就任何期交所指數或其編製及計算或任何有關資料之準確性或完整性而向任何會員或任何第三者作出保證或聲明或擔保，亦無就與任何期交所指數相關之任何事宜作出或暗示任何該等保證或聲明或任何類型之擔保。",
        // "此外，期交所亦不會就任何期交所指數之使用或其委任以編製及計算任何期交所指數之任何一名或多名人士在編製及計算任何期交所指數時出現之不確、遺漏、錯誤、出錯、延誤、中斷、暫停、變動或不足（包括但不限於因疏忽引致之事宜）或任何會員或任何第三者因買賣以任何期交所指數為基準之期貨及期權合約而直接或間接導致之任何經濟或其他損失承擔任何責任或債務。",
        // "任何會員或任何第三者概不得就與本免責聲明所述有關或因而產生之事宜向期交所提出索償、法律行動或法律訴訟。任何參與買賣以任何期交所指數為基準之期貨及期權合約之會員或任何第三者均完全明了本免責聲明，並不會就該等交易對期交所作出任何依賴。",
        // "2.股份指數期貨及期權",
        // "恒指服務有限公司（「恒指服務」）現時刊印、編製及計算多項股市指數，及可在恒生數據服務有限公司（「恒生數據」）不時要求下，刊印、編製及計算該等額外股市指數（合稱「恒生指數」）。",
        // "恒生指數各自之標記、名稱及編製及計算方法為恒生數據之獨家財產及專利品。",
        // "恒指服務經以許可證之形式，允許期交所使用恒生指數及恒生指數四類分類指數、恒生中資企業指數及恒生中國企業指數，純粹分別用作設立、推廣及買賣以該等指數為基準之期權合約及期貨合約以及可不時允許期交所相應使用任何其他恒生指數用作以該等其恒生指數期權合約及期貨合約（合稱「合約」）之基準。",
        // "編製及計算任何恒生指數之程序及基準及任何有關公式或各項公式、成份股及系數可在無須通知之情況下由恒指服務不時作出變動或更改，而期交所可不時要求期交所可能指定之該等合約之買賣及結算參考一項或多項將會計算之替代指數進行。",
        // "期交所或恒生數據或恒指服務概無就恒生指數或任何恒生指數及其編製及計算或其任何有關資料之正確性或完整性而給予任何會員或任何第三者保證或聲明或擔保，亦無就有關恒生指數或任何恒生指數給予或暗示任何該等保證或聲明或任何類型之擔保。",
        // "此外，期交所、恒生數據或恒指服務亦不會就有關合約或任何合約及／或買賣合約而使用恒生指數或任何恒生指數，或恒指服務編製及計算恒生指數或任何恒生指數之不正確、遺漏、錯誤、出錯、延誤、中斷、暫停、變動或不足（包括但不限於因疏忽引致之事宜）或任何會員或任何第三者因買賣合約或任何合約而直接或間接導致之任何經濟或其他損失承擔任何責任或債務。",
        // "任何會員或任何第三者概不得就本免責聲明所述所產生之事宜向期交所及／或恒生數據及／或恒指服務提出索償、法律行動或法律訴訟。任何買賣合約之會員或任何第三者均完全明了本免責聲明，並不會對期交所、恒生數據、及／或恒指服務作出任何依賴。"

        "1 證券交易的風險",
        "投資附帶風險，過往業績並非未來表現的指標。證券價格有時可能會非常波動。證券價格可升可跌，甚至變成毫無價值。買賣證券未必一" +
          "定能夠賺取利潤，反而可能會招致損失。",
        "2 期貨及期權交易的風險",
        "2.1 買賣期貨合約或期權的虧蝕風險可以極大。在若干情況下，客戶所蒙受的虧蝕可能會超過最初存入的保證金數額。",
        "2.2 即使客戶設定了備用指示，例如「止蝕」或「限價」等指示，亦未必能夠避免損失。市場情況可能使該等指示無法執行。",
        "2.3 客戶可能會在短時間內被要求存入額外的保證金。假如未能在指定的時間內提供所需數額，客戶的未平倉合約可能會被平倉。" +
          "然而，客戶仍然要客戶的帳戶內任何因此而出現的短欠數額負責。",
        "2.4 因此，客戶在買賣前應研究及理解期貨合約及期權，以及根據本身的財政狀況及投資目標，仔細考慮這種買賣是否適合自己。",
        "2.5 如果客戶買賣期權，便應熟悉行使期權及期權到期時的程序，以及客戶在行使期權及期權到期時的權利與責任。",
        "2.6 期權涉及高風險，未必適合所有投資者。投資者應確保在參與期權市場之前了解這些風險。",
        "2.7 有些期權在到期日方可行使（歐式期權的行使），其他期權可於到期前的任何時間行使（美式期權的行使）。有些期權在行使時" +
          "須以正股交收，而其他期權在行使時則須支付現金。",
        "2.8 客户知悉期權乃損耗性資產，期權持有人可能會損失該期權的全部期權金。作為期權持有人，如欲賺取利潤，必須行使期權或" +
          "在市場將期權長倉平倉。在某些情況下，因市場流通量不足，買賣期權會出現困難。",
        "2.9 作為期權沽出人，客户隨時可能要繳付額外的按金。期權沽出人與期權持有人不同，正股價的起跌可令沽出人蒙受無限損失，" +
          "而期權金乃沽出人的唯一回報。",
        "2.10 此外，美式認購（認沽）期權的沽出人可能需要在到期前的任何時候交收正股或支付現金代價，該價格為行使價乘以正股數目" +
          "的積，上述責任可能與沽出期權所收到的期權金的價值完全不成比例，而有關的通知期亦可能甚短。",
        "3 買賣創業板股份的風險",
        "3.1 創業板股份涉及很高的投資風險。尤其是該等公司可在無需具備盈利往績及無需預測未來盈利的情況下在創業板上市。創業板" +
          "股份可能非常波動及流通性很低。",
        "3.2 客戶只應在審慎及仔細考慮後，才作出有關的投資決定。創業板市場的較高風險性質及其他特點，意味著這個市場較適合專業" +
          "及其他熟悉投資技巧的投資者。",
        "3.3 現時有關創業板股份的資料只可以在香港聯合交易所有限公司所操作的互聯網網站上找到。創業板上市公司一般毋須在憲報指" +
          "定的報章刊登付費公告。",
        "3.4 假如客戶對本風險披露聲明的內容或創業板市場的性質及在創業板買賣的股份所涉風險有不明白之處，應尋求獨立的專業意見。" +
          "4 在香港以外地方收取或持有的客戶資產的風險",
        "4.1 本公司在香港以外地方收取或持有的客戶資產，是受到有關海外司法管轄區的適用法律及規例所監管的。這些法律及規例與《證" +
          "券及期貨條例》（第 571 章）及根據該條例制訂的規則可能有所不同。",
        "4.2 因此，有關客戶資產將可能不會享有賦予在香港收取或持有的客戶資產的相同保障。",
        "5 在香港聯合交易所有限公司買賣納斯達克–美國證券交易所證券的風險",
        "5.1 按照納斯達克–美國證券交易所試驗計劃（「試驗計劃」）掛牌買賣的證券是為熟悉投資技巧的投資者而設的。客戶在買賣該項試" +
          "驗計劃的證券之前，應先諮詢本公司的意見和熟悉該項試驗計劃。客戶應知悉，按照該項試驗計劃掛牌買賣的證券並非以香港" +
          "聯合交易所有限公司的主板或創業板作第一或第二上市的證券類別加以監管。",
        "6 使用網上交易協議下之電子服務的風險",
        "1 證券交易的風險",
        "投資附帶風險，過往業績並非未來表現的指標。證券價格有時可能會非常波動。證券價格可升可跌，甚至變成毫無價值。買賣證券未必一" +
          "定能夠賺取利潤，反而可能會招致損失。",
        "2 期貨及期權交易的風險",
        "2.1 買賣期貨合約或期權的虧蝕風險可以極大。在若干情況下，客戶所蒙受的虧蝕可能會超過最初存入的保證金數額。",
        "2.2 即使客戶設定了備用指示，例如「止蝕」或「限價」等指示，亦未必能夠避免損失。市場情況可能使該等指示無法執行。",
        "2.3 客戶可能會在短時間內被要求存入額外的保證金。假如未能在指定的時間內提供所需數額，客戶的未平倉合約可能會被平倉。" +
          "然而，客戶仍然要客戶的帳戶內任何因此而出現的短欠數額負責。",
        "2.4 因此，客戶在買賣前應研究及理解期貨合約及期權，以及根據本身的財政狀況及投資目標，仔細考慮這種買賣是否適合自己。",
        "2.5 如果客戶買賣期權，便應熟悉行使期權及期權到期時的程序，以及客戶在行使期權及期權到期時的權利與責任。",
        "2.6 期權涉及高風險，未必適合所有投資者。投資者應確保在參與期權市場之前了解這些風險。",
        "2.7 有些期權在到期日方可行使（歐式期權的行使），其他期權可於到期前的任何時間行使（美式期權的行使）。有些期權在行使時" +
          "須以正股交收，而其他期權在行使時則須支付現金。",
        "2.8 客户知悉期權乃損耗性資產，期權持有人可能會損失該期權的全部期權金。作為期權持有人，如欲賺取利潤，必須行使期權或" +
          "在市場將期權長倉平倉。在某些情況下，因市場流通量不足，買賣期權會出現困難。",
        "2.9 作為期權沽出人，客户隨時可能要繳付額外的按金。期權沽出人與期權持有人不同，正股價的起跌可令沽出人蒙受無限損失，" +
          "而期權金乃沽出人的唯一回報。",
        "2.10 此外，美式認購（認沽）期權的沽出人可能需要在到期前的任何時候交收正股或支付現金代價，該價格為行使價乘以正股數目" +
          "的積，上述責任可能與沽出期權所收到的期權金的價值完全不成比例，而有關的通知期亦可能甚短。",
        "3 買賣創業板股份的風險",
        "3.1 創業板股份涉及很高的投資風險。尤其是該等公司可在無需具備盈利往績及無需預測未來盈利的情況下在創業板上市。創業板" +
          "股份可能非常波動及流通性很低。",
        "3.2 客戶只應在審慎及仔細考慮後，才作出有關的投資決定。創業板市場的較高風險性質及其他特點，意味著這個市場較適合專業" +
          "及其他熟悉投資技巧的投資者。",
        "3.3 現時有關創業板股份的資料只可以在香港聯合交易所有限公司所操作的互聯網網站上找到。創業板上市公司一般毋須在憲報指" +
          "定的報章刊登付費公告。",
        "3.4 假如客戶對本風險披露聲明的內容或創業板市場的性質及在創業板買賣的股份所涉風險有不明白之處，應尋求獨立的專業意見。",
        "4 在香港以外地方收取或持有的客戶資產的風險",
        "4.1 本公司在香港以外地方收取或持有的客戶資產，是受到有關海外司法管轄區的適用法律及規例所監管的。這些法律及規例與《證" +
          "券及期貨條例》（第 571 章）及根據該條例制訂的規則可能有所不同。",
        "4.2 因此，有關客戶資產將可能不會享有賦予在香港收取或持有的客戶資產的相同保障。",
        "5 在香港聯合交易所有限公司買賣納斯達克–美國證券交易所證券的風險",
        "5.1 按照納斯達克–美國證券交易所試驗計劃（「試驗計劃」）掛牌買賣的證券是為熟悉投資技巧的投資者而設的。客戶在買賣該項試" +
          "驗計劃的證券之前，應先諮詢本公司的意見和熟悉該項試驗計劃。客戶應知悉，按照該項試驗計劃掛牌買賣的證券並非以香港" +
          "聯合交易所有限公司的主板或創業板作第一或第二上市的證券類別加以監管。",
        "6 使用網上交易協議下之電子服務的風險",
        "在需要將產品的單位貨幣兌換成另一種貨幣時受到匯率波動的影響。",
        "11.2 客戶明白若所買賣結構性產品的相關資產並非以港幣為單位，其尚要面對外匯風險。貨幣兌換率的波動可對相關資產的價值造" +
          "成負面影響，連帶影響結構性產品的價格。",
        '12 交易所交易票據（"ETNs"）的風險',
        "12.1 ETN 是一種由承銷銀行發行的無擔保、非次級債務證券，旨在為投資者提供各個市場基準的回報。ETN 的回報通常與一個市場" +
          "基準或策略的表現掛鈎，並扣除適用的費用。與其他債務證券類似，ETN 有到期日，且僅以發行人信用作為支持。",
        "12.2 客戶可以透過交易所買賣 ETN 或於預定到期日收取現金付款，或視乎基準指數的表現有機會直接向發行人提早贖回 ETN（須扣" +
          "除適用的費用）。然而，客戶於贖回時可能受 ETN 的提早贖回條件限制，例如最少贖回數量。",
        "12.3 本公司並不保證客戶於到期日或發行人提早回購時可收回投資本金或任何投資回報。對於 ETN，正面表現的月份或無法抵銷其" +
          "中某些極不利之月度表現。",
        "12.4 ETN 發行人有權隨時按回購價值贖回 ETN。",
        "12.5 若於任何時候 ETN 的回購價值為零，客戶的投資則變得毫無價值。ETN 可能流通性不足，不能保證客戶可隨時按其意願，以目" +
          "標價格買賣。",
        "12.6 儘管 ETF 與 ETN 均有追蹤基準指數的特性，但 ETN 屬於債務證券，並不實際擁有其追蹤的任何資產，擁有的僅是發行人向投" +
          "資者分配理論上存在的基準指數所反映的回報之承諾。ETN 對投資組合的多元化程度有限，投資者須受集中於特定指數及指數" +
          "成份的集中性風險。鑒於 ETN 屬無抵押品的債務工具，若 ETN 發行商發生違約或破產，最大潛在損失可能是投資額的百分之" +
          "一百及無法獲得任何利潤。",
        "12.7 即使受追蹤的相關指數沒有變化，發行人信用評級降级亦會導致 ETN 的價值下跌。因此，買賣 ETN 的客戶直接面臨發行人的" +
          "信用風險，且在發行人宣佈破產的情況下僅擁有無擔保的破產索償權。",
        "12.8 本金金額須扣除定期收納的投資者費用或任何適用的費用，該等費用會對回報產生不利影響。",
        "12.9 個別 ETN 可能會採用槓桿，而 ETN 的價值會因應其對於相關資產的槓桿比率而迅速變化。客戶應注意 ETN 的價值可能會跌至" +
          "零，客戶可能損失所有的投資本金。",
        "13 違約風險及交易對手風險",
        "13.1 所有產品都具有違約風險及/或交易對手風險。違約風險是指發行商未能根據協定缴付。遇上經濟不景，發行商未必能成功借貸" +
          "繼續經營或償還舊債。信貸評级是評估结構性產品違約風險最常用的工具。信貸評級代表信貸評級機構於某一持定時間内的意" +
          "見，而信貸評級往往會因應發行商的財政狀況或市場情況的改變而作出調整。",
        "13.2 交易對手風險指交易方無力履行其財務合約責任，雖然信貸評級的評級有一定的可靠性，客戶除了要參考發行商的信貸評級外，" +
          "更要仔细留意產品的结構本身是否涉及衍生工具，以免招致損失。",
        "14 集體投資計劃的風險",
        "14.1 集體投資計劃可廣泛地（最多 100%）投資於金融衍生工具，定息證券及/或結構性產品（包括但不限於信用違約掉期、次等投資" +
          "級別債務、按揭抵押證券及其他資產抵押證券）、並涉及不同的風險（包括但不限於交易對手風險、流通性風險、信用風險及市場風險）。",
        "14.2 集體投資計劃可能使用衍生工具的交易策略可能招致損失的部份原因包括但不限於：市場狀況動盪、衍生工具與取決其價格的" +
          "證券走勢關連性不完美、市場缺乏流動性，以及交易對手方的違責風險。",
        "15 衍生產品和結構性產品交易的一般風險",
        "15.1 發行商失責風險：倘若結構性產品發行商破產而未能履行其對所發行證券的責任，客戶只被視為無抵押債權人，對發行商任何" +
          "資產均無優先索償權。因此，客戶須特別留意結構性產品發行商的財力及信用。",
        "15.2 非抵押產品風險：非抵押結構性產品並沒有資產擔保。倘若發行商破產，客戶可以損失其全數投資。客戶須細閱上市文件以確" +
          "定產品是否屬非抵押性質，及該產品是否適合自己。",
        "15.3 槓桿風險：衍生權證及牛熊證均是槓桿產品，其價值可按相對相關資產的槓桿比率而快速改變。客戶須留意，衍生權證及牛熊" +
          "證的價值可以跌至零，屆時當初投資的資金將會盡失。",
        "15.4 有效期的考慮：結構性產品設有到期日，到期後的產品即一文不值。客戶須留意產品的到期時間，確保所選產品尚餘的有效期" +
          "能配合其交易策略。",
        "15.5 特殊價格移動：結構性產品的價格或會因為外來因素（如市場供求）而有別於其理論價，因此實際成交價可以高過亦可以低過" +
          "理論價。",
        "15.6 流通量風險：聯交所規定所有結構性產品發行商要為每一隻個別產品委任一名流通量提供者。流通量提供者的職責在為產品提" +
          "供兩邊開盤方便買賣。若有流通量提供者失責或停止履行職責，有關產品的客戶或就不能進行買賣，直至有新的流通量提供者" +
          "委任出來止。",
        "16 買賣衍生權證的特定風險",
        "16.1 時間損耗風險：假若其他情況不變，衍生權證愈接近到期日，價值會愈低，因此不能視為長線投資。",
        "16.2 波幅風險：衍生權證的價格可隨相關資產價格的引申波幅而升跌，客戶須注意相關資產的波幅。",
        "16.3 非長期有效：與股票不同，衍生權證有到期日，並非長期有效。衍生權證到期時如非價內權證，則不會有價值。",
        "16.4 成交額：衍生權證成交額高不應被認作為其價值會上升。除了市場力量外，衍生權證的價值還受其它因素影響，包括相關資產" +
          "價格及波幅、剩餘到期時間、利率及預期股息。",
        "17 買賣牛熊證的特定風險",
        "17.1 強制收回風險：客戶買賣牛熊證，須留意牛熊證可以即日「取消」或強制收回的特色。若牛熊證的相關資產值等同上市文件所" +
          "述的強制收回價/水平，牛熊證即停止買賣。屆時，客戶只能收回已停止買賣的牛熊證由產品發行商按上市文件所述計算出來的" +
          "剩餘價值（注意：剩餘價值可以是零）。",
        "17.2 融資成本：牛熊證的發行價已包括融資成本。融資成本會隨牛熊證接近到期日而逐漸減少。牛熊證的年期愈長，總融資成本愈" +
          "高。若一天牛熊證被收回，客戶即損失牛熊證整個有效期的融資成本。融資成本的計算程式載於牛熊證的上市文件。",
        "17.3 限定的有效期：牛熊證有一固定有效期，並於指定日期到期。有效期可以是 3 個月至 5 年不等。若在到期前遭提早收回牛熊證" +
          "的有效期將變得更短。期間牛熊證的價值會隨著相關資產價格的變動而波動，於到期後或遭提早收回後更可能會變得沒有價值。",
        "17.4 相關資產的走勢：牛熊證的價格變動雖然趨向緊貼相關資產的價格變動，但在某些情況下未必與相關資產價格的變動同步（即" +
          "對沖值不一定等於 1）。牛熊證的價格受多個因素所影響，包括其本身的供求、財務費用及距離到期的時限。此外，個別牛熊證" +
          "的對沖值亦不會經常接近 1，特別是當相關資產的價格接近收回價時。",
        "17.5 接近收回價時的交易：相關資產價格接近收回價時，牛熊證的價格可能會變得更加波動，買賣差價可能會較闊，流通量亦可能" +
          "較低。牛熊證隨時會被收回而交易終止。由於任何在強制收回事件後始執行的交易將不被承認並會被取消，而強制收回事件發" +
          "生的時間與牛熊證停止買賣之間可能有時差，一些在強制收回事件發生後才達成的交易即使已被證券商確認最後亦會被取消，" +
          "因此客戶買賣接近收回價的牛熊證時需額外小心。",
        "17.6 海外資產發行的牛熊證：若屬海外資產發行的牛熊證，強制收回事件可能會於香港交易所交易時段以外的時間發生。",
        "18 交易所買賣基金的特定風險",
        "18.1 市場風險：交易所買賣基金主要為追蹤某些指數、行業/領域又或資產組別（如股票、債券或商品）的表現。交易所買賣基金經" +
          "理可用不同策略達至目標，但通常也不能在跌市中酌情採取防守策略。客戶必須要有因為相關指數/資產的波動而蒙受損失的準備。",
        "18.2 追蹤誤差：這是指交易所買賣基金的表現與相關指數/資產的表現脫節，原因可以來自交易所買賣基金的交易費及其他費用、相" +
          "關指數/資產改變組合、交易所買賣基金經理的複製策略等等因素。（常見的複製策略包括完全複製/選具代表性樣本以及綜合複製。）",
        "18.3 以折讓或溢價交易：交易所買賣基金的價格可能會高於或低於其資產淨值，當中主要是供求因素的問題，在市場大幅波動兼變" +
          "化不定期間尤其多見，專門追蹤一些對直接投資設限的市場/行業的交易所買賣基金亦可能會有此情況。",
        "18.4 流通量風險：證券莊家是負責提供流通量、方便買賣交易所買賣基金的交易所參與者。儘管交易所買賣基金多有一個或以上的" +
          "證券莊家，但若有證券莊家失責或停止履行職責，客戶或就不能進行買賣。",
        "18.5 由衍生工具構成的 ETF 風險：",
        '(a) 交易所買賣基金（"ETF"）可投資於衍生工具。由衍生工具構成的 ETF 可投資於 CAAP、指數期貨合約及其他金融衍生工具。',
        "(b) 投資於金融衍生工具不等同直接投資於組成基礎指數之相關資產。",
        "(c) 金融衍生工具乃一種合約。由衍生工具構成的 ETF 及其交易對手（即與由衍生工具構成的 ETF 達成協議之人士）根據衍" +
          "生工具合約之條款同意在合約中列明之特定情況下或發生特定事件時向對方支付若干款項。金融衍生工具之價值視乎或" +
          "來自或參考相關資產之價值（例如證券或指數）而定。",
        "(d) 若干金融衍生工具可能產生槓杆效應，令由衍生工具構成的 ETF 承受更大風險及增加其成本。金融衍生工具或會較容易" +
          "受到影響有關投資價值之因素所影響。因此，金融衍生工具價格變化幅度甚大，並偶爾會出現急速之大幅價格變動。故" +
          "此，金融衍生工具出現相對較為輕微之價格變動，有可能即時導致由衍生工具構成的 ETF 蒙受重大損失（或收益）。與只" +
          "投資傳統證券相比，由衍生工具構成的 ETF 可能會因投資金融衍生工具而蒙受大於或可能相等於金融衍生工具全部價值的損失。",
        "(e) 此外，不少金融衍生工具均不在證券交易所買賣，這意味著由衍生工具構成的 ETF 較難出售其金融衍生工具投資以籌措" +
          "現金及╱或已變現收益或損失或對該等金融衍生工具進行準確估值。出售或購買不在證券交易所買賣之金融衍生工具均" +
          "須私下協商，且一般並非由中央結算機構擔保、每日盯市、結算及隔離帳戶審查機制、中介機構最低資本規定或政府機關" +
          "監管，亦可能較難找到自願之買方╱賣方，原因是並無監管規定要求市場作價者確保該等金融衍生工具有持續市場。",
        "18.6 衍生工具之交易對手風險：如有關衍生工具風險一節所述，金融衍生工具乃一種合約。根據多份金融衍生工具合約將予支付之" +
          "款項並非通過中央結算機構支付，亦非獲中央結算機構作擔保。因此，由衍生工具構成的 ETF 因投資金融衍生工具而須承受其" +
          "交易對手不願或未能根據合約履行付款（及其他）責任之風險。倘金融衍生工具之交易對手涉及任何無力償還債務事件，金融" +
          "衍生工具之價值或會大幅下跌，甚至不具任何價值，由衍生工具構成的 ETF 或遲遲無法收回款項，原因是投資於金融衍生工具" +
          "不等同直接投資於組成基礎指數之相關資產。",
        "18.7 期貨買賣風險：期貨乃高度槓桿化，意指期貨合約價格的較小變動或會導致高於實繳保證金比例的利潤或損失，及或會導致超" +
          "過預繳任何保證金數額的不可估量的進一步損失。不少期貨合約買賣須遵守每日價格波動限制，即禁止於特定日期按基於上一" +
          "日收市價的規定價格範圍以外之價格進行期貨交易。這或會產生流動性風險，原因是管理人於不斷變動的市場變現期貨持倉或" +
          "會成本高昂或行不通。",
        "18.8 「CAAP」指以美元為單位之中國 A 股連接產品，即為（a）基礎指數所掛鈎或不掛鈎之 A 股；或（b）基礎指數，掛鈎之金融" +
          "衍生工具（例如認股權證、票據或參與證明）。",
        "19 槓桿及反向產品的主要風險",
        "19.1 投資風險：買賣槓桿及反向產品涉及投資風險及並非為所有投資者而設。不保證可取回投資本金。",
        "19.2 波動風險：槓桿及反向產品涉及使用槓桿和重新平衡活動，因而其價格可能會比傳統的交易所買賣基金（ETF）更波動。",
        "19.3 不同於傳統的 ETF：槓桿及反向產品與傳統的 ETF 不同，具有不同的特性及風險。",
        "19.4 長線持有的風險：槓桿及反向產品並非為持有超過重新平衡活動的間距，一般為一天而設。在每日重新平衡及複合效應下，有" +
          "關產品超過一天的表現會從幅度或方向上偏離相關指數同期的槓桿或相反表現。在市況波動時有關偏離會更明顯。隨著一段時" +
          "間受到每日重新平衡活動、相關指數波動，以及複合效應對每日回報的影響，可能會出現相關指數上升或表現平穩，但槓桿產" +
          "品卻錄得虧損。同樣地亦有可能會出現相關指數下跌或表現平穩，但反向產品卻錄得虧損。",
        "19.5 重新平衡活動的風險：槓桿及反向產品不保證每天都可以重新平衡其投資組合，以實現其投資目標。市場中斷、規管限制或市" +
          "場異常波動可能會對產品的重新平衡活動造成不利影響。",
        "19.6 即日投資風險：槓桿及反向產品的槓桿倍數會隨交易日市場走勢而改變，但直至交易日完結都不會重新平衡。因此槓桿及反向" +
          "產品於交易日內的回報有可能會多於或少於相關指數的槓桿或相反回報。",
        "19.7 重整組合的風險：相對傳統的 ETF，每日重新平衡活動會令槓桿及反向產品的投資交易次數較頻密，因而增加經紀佣金和其他" +
          "買賣開支。",
        "19.8 關聯風險：費用、開支、交易成本及使用衍生工具的成本，可令有關產品的單日表現，與相關指數的單日槓桿/反向表現的關聯" +
          "度下降。",
        "19.9 終止運作風險：如所有證券莊家均辭任，槓桿及反向產品必須終止運作。槓桿及反向產品必須在最後一名證券莊家辭任生效時" +
          "同時終止運作。",
        "19.10 槓桿風險（僅適用於槓桿產品）：在槓桿效應下，當相關指數變動，或者當相關指數的計價貨幣不同於有關槓桿產品的基準貨幣，" +
          "而有關貨幣的匯價出現波動時，會令槓桿產品的盈利和虧損倍增。",
        "19.11 有別於傳統的回報模式（僅適用於反向產品）：反向產品旨在提供與相關指數相反的單日回報。如果有關指數長時間上升，或者" +
          "當相關指數的計價貨幣不同於有關反向產品的基準貨幣，而該計價貨幣的匯價長時間上升時，反向產品可能會損失大部分或所有價值。",
        "19.12 反向產品與沽空（僅適用於反向產品）：投資反向產品並不等同於建立短倉。因為涉及重新平衡活動，反向產品的表現可能會偏" +
          "離短倉表現，特別是當市況波動和走勢經常搖擺不定的時候。",
        "20 供股權證的風險",
        "20.1 供股權證是公司向現有股東一次性發行股份，讓他們有機會通過在未來的某個日期以折扣價購買額外的新股，來維持所有權的" +
          "原有比例不被稀釋。",
        "20.2 直至購買新股的日期為止，客戶可以按照與普通股交易的方式進行供股權證交易。如果客戶不打算行使認購權，可以在公開市" +
          "場上出售。",
        "20.3 認購權一旦行使，便不能再次使用。如果客戶在這段時間內不行使認購權，認購權將會失效。",
        "20.4 面對有折扣提供的股票很容易受到誘惑，但客戶不應假設這是買平貨，而是應先了解資金籌集的背後原因，才作出明智的決定。",
        "20.5 一家公司可能會使用供股來彌補債務，特別是當他們無法從其他來源借錢時。客戶應留意管理層有否透露任何潛在的問題。",
        "20.6 如果客戶決定不行使新股認購權，則由於所發行股份數量的增加，客戶所持有公司的總股權將被攤薄。",
        "20.7 如果客戶在指定的時間範圍內不參與供股，客戶的未繳款供股權將會失效。公司將在扣除報價和費用後，出售這些權利並分配" +
          "任何淨收益。如果有的話，過期收益的金額將不會通知投資者，直到報價關閉。因此不能保證客戶不會失去收益。",
        "20.8 由供股權證所產生的投資和收益的價值可能會下降，客戶可能會收回比原本投資更少的資金。",
        "21 買賣與股票掛釣的工具（「ELI」）的風險",
        "21.1 如客戶指示本公司用該戶口買賣與股票掛釣的工具，客戶確認 ELI 並不保本，而如 ELI 的參考資產的價格與客戶的看法不同，" +
          "則客戶可蒙受損失。",
        "21.2 在極端的情況下，客戶可損失全部投資。在若干情況下的損失風險甚大，除非客戶明白正在進行的買賣的性質以及所須承擔的" +
          "風險，否則不應買賣該等工具。客戶並須因應本身的環境及財政狀況，審慎考慮究竟有關買賣是否適合。",
        "21.3 客戶明白雖然大部分 ELI 一般較普通定期存款或債券的利息為高，但客戶的 ELI 的潛在收益可以發行人指定的預先釐定的水平為上限。",
        "21.4 在投資期間內，客戶於參考資產並無權利。該／該等參考資產的市價變動未必會導致 ELI 的市價及／或潛在回報有相應的變動。",
        "21.5 客戶完全明白投資 ELI 令客戶承受股權風險。客戶承受正股及股市價格波動，以及股息、企業行動及對手方風險的影響。倘相" +
          "關工具的價格跌至低於轉換價，客戶將接納法律責任，以預先議定的轉換價購入相關工具，而非收取與 ELI 的本金。因此，倘" +
          "ELI 的價值低於客戶原本的投資，則客戶將收到一項價值下跌的工具，而倘相關工具變得毫無價值，則更可能會失去全部本金或" +
          "存款。ELI 並非以任何資產或抵押品擔保。",
        "21.6 客戶完全明白當購買 ELI 時，客戶倚賴發行商的信用可靠性。如發行商違約或資不抵債，則不論參考資產的表現，客戶將須倚" +
          "賴客戶的分銷商代表客戶採取行動，以發行商無抵押的債權人身份提出索償。",
        "21.7 發行商可為其 ELI 提供有限度的莊家安排。但是，如客戶嘗試於發行商提供的莊家安排下在到期前終止 ELI，則客戶可收取一" +
          "筆大幅低於客戶原本的投資金額的款項。與股票掛釣的工具或會「不能轉讓」，客戶或許無法將有關工具平倉或變現。ELI 的發" +
          "行商亦可擔當不同角色，如 ELI 的安排行、市場代理及計算代理。ELI 的發行商、其子公司及聯營公司擔當不同角色亦可引致利益衝突。",
        "21.8 客戶應注意，正股的任何派息可影響其價格，而由於除息定價，可影響 ELI 到期時的回報。客戶亦應注意，發行商可因正股的" +
          "企業行動而對 ELI 作出調整。",
        "21.9 潛在孳息率：客戶應就買賣 ELI 相關的費用及開支以及到期時的付款／交付諮詢客戶的經紀。港交所發佈的潛在孳息率並無將" +
          "費用及開支計算在內。",
        "22 期貨 ETF 涉及的特定風險",
        "22.1 期貨合約轉倉風險：期貨合約是透過期貨交易所訂立的具約束力協議，於未來的特定時間買賣相關資產。「轉倉」是指，當現有" +
          "期貨合約即將到期，以代表同一相關資產但到期日較後的期貨合約取代。當期貨合約轉倉（即賣出近期的期貨合約，再買入較" +
          "長期的期貨合約）時，如較長期的期貨合約的價格高於即將到期的現有期貨合約價格，轉倉可能會導致虧損（即負轉倉收益" +
          "「negativerollyield」）。在此情況下，出售近期期貨合約所得的收益，並不足以購買相同數量而到期日較後的期貨合約，因後者的" +
          "價格較高，這會對期貨 ETF 的資產淨值有不利影響。",
        "22.2 持有期貨合約數量的法定限制風險：在獲認可交易所上市的期貨合約受限於法定持倉限制，不能持有多於某一特定數量之期貨" +
          "合約。若期貨 ETF 的期貨合約持倉已增加至接近有關上限，則可能因無法購買更多期貨合約而未能新增 ETF 單位，此情況可能" +
          "令上市的 ETF 單位的交易價格偏離於其資產淨值。",
        "23 人民幣計價證券之風險",
        "23.1 人民幣不能自由兌換。人民幣與外幣（包括港元）之間的轉換，是受中國的監管限制，並會影響以人民幣計價證券的流動性。",
        "23.2 人民幣計價的證券可能沒有定期交易或活躍市場。因此，客戶或許不能及時出售，或大幅折讓其產品的價值以作出售。",
        "23.3 如人民幣貶值，以港元計價的投資亦會下降。",
        "24 有關透過滬港通及/或深港通交易之特別風險",
        "以下是一些通過本公司透過滬港通及/或深港通（下稱“中港通”）買賣上海證券交易所及/或深圳證券交易所之風險。由於涉及風" +
          "險，客戶只應在完全理解中港通之性質及客戶將承受之風險才進行有關交易。客戶應按經驗、目的、財務資源及其他因素小心" +
          "考慮（及在有需要時資詢客戶的顧問）該等交易是否適合客戶。",
        "24.1 中國相關風險：中國是一新興市場。投資於中國涉及特別的考慮和風險，包括但不只限於較大的價格波動性、較不發達的監管" +
          "及法律架構，以及經濟、社會及政治不穩定性等。",
        "24.2 股票風險：投資中港通證券的回報率可能會高於短期和較長期債務證券。然而，投資中華通證券的相關風險亦可能較高，原因" +
          "在於投資中港通證券的表現取決於難以預測的因素，該等因素包括市場突然或長期低迷的可能性以及與個別公司有關的風險。",
        "24.3 流通量風險：無法保證可以就中港通建立或維持一個活躍的交易市場。如果中港通證券的價差很大，客戶以期望的價格出售中" +
          "港通證券的能力可能會受到重大影響。",
        "25 深交所創業板市場風險",
        "25.1 參與深交所創業板市場只限於機構專業投資者。",
        "25.2 深交所創業板股票涉及高投資風險因為在深圳創業板上市的公司通常為初創公司，經營規模及股本較小。由於市場上的股份流" +
          "通量較小，其股票價格可能更容易受到操縱。因此，它們的股票價格和流動性波動較大。",
        "25.3 深交所創業板的公司上市規則和法規，不如深交所主機板那麼嚴格。在深交所創業板除牌的情況可能更加普遍和更快。如果客" +
          "戶投資的公司被除牌，這可能對客戶產生不利影響。投資於深交所創業板上市的股票可能導致客戶的重大損失。",
        "26 上海交易所（上交所）科創板市場風險",
        "26.1 規管差異風險：上交所科創板市場與上交所主板市場在上市、交易、信息披露以及其他事項的規則和指引方面都存在較大差異。" +
          "例如，就上市條件而言，尋求在科創板市場上市的公司將適用更短的盈利歷史、更低的淨利潤和營業收入，以及更低的經營活" +
          "動產生的現金流量要求。科創板上市公司較之主板和中小板公司對於股本總額的要求也更低。科創板上市公司的交易安排亦與" +
          "主板上市公司不同，例如價格限制、最小買賣盤和最大買賣盤。關於上交所科創板與主板的上市條件詳情，請參閱上交所網站。",
        "26.2 退市風險：科創板退市制度較主板不同，可能導致科創板市場上市公司退市的情形更多，退市速度更快。",
        "26.3 公司經營風險：科創板市場上市公司一般處於發展初期，經營歷史較短，規模較小，經營穩定性較低，抵抗市場風險和行業風" +
          "險的能力較弱。儘管它們可能擁有更大的發展潛力並可更多地借助於科技創新，其未來表現（尤其是那些尚未有良好盈利記錄" +
          "的公司）存在很大的不確定性。",
        "26.4 大幅股價波動：科創板市場上市公司股價可能隨市況變化、投資者投機行為或公司業績變動等情況而頻繁發生大幅波動。流通" +
          "股本較少的科創板市場上市公司可能較容易被主要股東操縱股價。不穩定的公司業績亦令此類公司的估值較為困難。",
        "26.5 技術風險：科創板市場上市公司的新技術能否轉化為現實中的產品或服務具有不確定性。當其所在的行業正經歷快速的技術更" +
          "新換代時，其產品可能面臨被淘汰的危險而令其公司難以為繼。",
        "26.6 其他：投資者亦應參閱上海證券交易所科創板股票交易必備條款。每位內地投資者在交易上海科創板股票之前都須認可該揭示書條款。",
        "27 單位信託基金交易的特定風險",
        "27.1 基金單位的價格會波動，甚至變成毫無價值。基金過往的表現並不代表將來表現。",
        "27.2 不同類別基金所附帶的風險有所不同。客戶在決定是否投資該產品前，應審慎閱讀相關產品的銷售文件（包括基金說明書、產" +
          "品資料概覽及基金單張等）所披露的細節及風險。主要風險包括但不限於：",
        "(a) 信貸風險：這風險通常適用於所有固定收入（即債券）以及貨幣市場工具的基金。債券附帶發債機構違責的風險，即發行" +
          "商有機會未能如期支付本金和利息。信貸評級機構給予的信貸評級並非對發債機構信用可靠程度的保證。",
        "(b) 流動性風險：此風險在基金內某些證券（包括債券等）可能在巿場上較難買入或沽售出現。未上市或未被評級的證券可能" +
          "需較長時間或無法於市場上沽出，因此具有較高的流通性風險。這些風險有可能導致投資者招致嚴重虧損。",
        "(c) 利率風險：如產品投資於債券，就較易受到利率波動的影響。一般來說，利率上升，債券價格便會下跌。投資於債券的基" +
          "金的價格便有可能下跌。",
        "(d) 市場風險：投資價值可能會因政治、法律、經濟條件及利率變化而有波動。這些變化在全部市場及資產類別上都很普遍，" +
          "客戶取回的投資金額有可能少於初次投放的資金。",
        "27.3 投資於高息債券的基金，除以上列舉的一般風險外，還須承受其他風險，例如：",
        "(a) 較高的信貸風險：高息債券的評級通常低於投資級別，或不獲評級，因此涉及的發債機構違責風險往往較高；",
        "(b) 受制於經濟周期的轉變：經濟下滑時，高息債券價值的跌幅往往會較投資級別債券為大，原因是（i）投資者會較為審慎，" +
          "不願承擔風險；（ii）違責風險加劇。",
        "(c) 資本增長風險：派息基金，特別是某些高息債券基金可能會以資本來支付費用及／或股息。此舉有可能令基金可供日後投" +
          "資的資金減少，削弱資本增長。",
        "(d) 股息分派風險：派息基金，特別是某些高息債券基金可能不會派息，取而代之的是將股息再投資在基金上，又或投資經理" +
          "可能有酌情權決定是否動用基金的收入及／或資本作分派之用。此外，分派收益高並不意味投資者的總投資可取得正回" +
          "報或高回報。",
        "(e) 其他主要風險：投資於債券，特別是高息債券的基金，可能尚涉及其他主要風險，包括投資集中於某特定種類的專門性債" +
          "項或某特定地區市場或主權證券。",
        "27.4 投資於「需具備衍生工具知識」基金的風險：",
        "「需具備衍生工具知識」的基金可廣泛地使用金融衍生工具達致其投資目的，可能含有槓桿效應。使用金融衍生工具可令基金" +
          "承受額外風險，包括但不限於波動性風險及對手風險。基金經理可投資於結構性產品、衍生工具及可投資於非投資級別的債務" +
          "證券，最高達基金總資產淨值 100%。在惡劣情況下，投資可能招致重大損失。",
        "28 債券的特定風險",
        "28.1 債券只在到期日提供 100%本金保證，但要視乎其發行人及/或擔保人（如適用）的信貸風險。",
        "28.2 債券不應被視為一般或定期存款。",
        "28.3 債券的價格會波動，甚至變成毫無價值。",
        "28.4 產品主要風險：客戶在決定是否投資該產品前，應審慎閱讀相關產品認購書（如適用）所披露的細節及風險。主要風險包括但" +
          "不限於下頁所載：",
        "(a) 信貸風險：客戶須承擔發行人及擔保人（如適用）的信貸風險，他們的信貸評級如有任何變動將會影響本債券的價格及價" +
          "值。債券附帶發債機構違責的風險，即發行人有機會未能如期支付本金和利息。在最壞的情況下如發行人及擔保人（如適" +
          "用）破產，客戶可能會損失全部投資。信貸評級機構給予的信貸評級並非對發行人信用可靠程度的保證。",
        "(b) 流動性風險：債券的流動性可能有限，及可能無活躍交易，及/或沒有經紀在市場提供報價，因此：",
        "(i) 不可以在任何時間均能提供債券的市值及/或參考買入/賣出價，因其將取決於市場的流動性和情况；",
        "(ii) 可能需要較長時間或無法於市場上出售債券；及",
        "(iii) 所執行的賣出價可能與本行參考買入價有很大的差別，對客戶不利。",
        "(c) 利率風險：債券較易受到利率波動的影響。一般來說，利率上升，債券價格便會下跌。",
        "(d) 市場風險：投資價值可能會因政治、法律、經濟條件及利率變化而有波動。這些變化在全部市場及資產類別上都很普遍，" +
          "投資者取回的投資金額有可能少於初次投放的資金。",
        "28.5 投資於高息債券，除以上列舉的一般風險外，還須承受其他風險，例如：",
        "(a) 較高的信貸風險：高息債券的評級通常低於投資級別，或不獲評級，因此涉及的發債機構違責風險往往較高；",
        "(b) 受制於經濟周期的轉變：經濟下滑時，高息債券價值的跌幅往往會較投資級別債券為大，原因是（i）投資者會較為審慎，" +
          "不願承擔風險；（ii）違責風險加劇。",
        "28.6 某些債券可能別具特點及風險，投資時須格外注意。這些包括：",
        "(a) 永續性債券的風險：永續性債券不設到期日，其利息派付取決於發行人在非常長遠的時間內的存續能力，利息或會因根據" +
          "其條款及細則而有所延遲或終止。一般而言，永續性債券一般為可贖回及/或為後償債券，客戶須要承受再投資風險/或為" +
          "後償債券風險，詳情如下。",
        "(b) 可提早贖回債券的再投資風險：如果這是可提早贖回的債券，當發行人於債券到期前行使贖回權，客戶便會面對再投資風" +
          "險。客戶於再投資時可能會收到較小的孳息率。",
        "(c) 後償債券的風險：後償債券於發行人遣債後的清盤過程中獲較低之索償權，因此後償債券之持有人將承受比優先債券更" +
          "高的風險。後償債券為無抵押，其信貸評級及債務的優先次序較優先債券為低。客戶應特別注意產品之信貸資料，包括發" +
          "行人，債券或擔保人的信貸評級（視情況而定）。",
        "(d) 浮息及／或延遲派付利息的風險：如果債券具有浮息及／或延遲派付利息的條款，客戶便無法確定將收取的利息金額及" +
          "利息派付的時間。",
        "(e) 可延遲到期日的風險：如果債券具有可延遲到期日的條款，客戶便沒有一個訂明償還本金的確實時間表。",
        "(f) 可換股或可交換性質的債券的投資風險：屬可換股或可交換性質的債券，客戶須同時承受股票及債券的投資風險；及／或" +
          "具有或然撇減或彌補虧損特點的債券。當發生觸發事件時，這些債券可能會作全數或部分撇賬，或轉換為普通股。"
      ]
    },

    customer_agreement: {
      page_title: "證券及/或期貨客戶協定",
      p1: [
        "高盈證券有限公司",
        "香港尖沙咀港威大廈 6 座 31 樓 3102 室",
        "中央編號BPS863，根據《證券及期貨條例》獲發牌進行第1類（證券交易），第2類（期貨合約交易）及第5類（就期貨合約提供意見）受規管活動",
        "客戶協議書",
        "一般條款和條件"
      ],
      main: [
        { NumScale: "1", isNumBold: true, label: "定義和詮釋", content: "" },
        {
          NumScale: "1.1",
          isNumBold: false,
          label: "定義:",
          content: "於此等條款內，除非文義另有所指，下列詞語具有以下涵義："
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「帳戶」",
          content:
            "指以客戶名義於相關公司不時開立和維持的任何一個或多個任何性質的帳戶，包括但不限於證券現金帳戶、股票期權帳戶、證券保證金帳戶和期貨帳戶，以按本協議條款規定取得服務及/或進行交易；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「開戶表格」",
          content:
            "指客戶不時按本公司規定或接納之形式填妥的任何及所有開戶表格、客戶資料表格及文件，包括與任何開戶表格或文件相關或隨附的任何附註和聲明，這可能按照本協議不時作出修訂；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「協議」",
          content: "包括此等條款、此等條款之附件、開戶表格及其他文件；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「反洗錢條例」",
          content: "指《打擊洗錢及恐怖分子資金籌集條例》（香港法例第615章）;"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「適用法規」",
          content:
            "指香港或其他地方本公司、客戶或其他相關人士受其規限的任何監管機構、稅務機構、政府機構、交易所、結算所、結算系統或專業團體的任何法律、規例或指令，或任何規則、指示、指引、守則、常規、程序或慣例（不論是否具有法律效力）;"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「有聯繫實體」",
          content: "具有證券及期貨條例所賦予之涵義；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「授權人士」",
          content:
            "對個人客戶而言，指該客戶及開戶表格中指明為授權人士的任何人士，對公司客戶而言，則指開戶表格中指明為授權人士的任何人士，而在兩種情況下均包括由客戶不時以書面聲明通知本公司的受委任替換或增補授權人士的任何其他人士，上述委任（受本公司的批准所限）由本公司實際收到通知時起生效；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「營業日」",
          content:
            "指香港公司辦公的日子（星期六及星期日，以及香港於上午九時正至下午五時正任何時間懸掛黑色暴雨警告或八號或以上颱風訊號的日子除外）；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「中央結算系統」",
          content: "指香港結算營運的中央結算及結算系統；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「結算系統」",
          content:
            "就任何市場而言，指不時用於進行證券或合約交易的交易結算系統（包括中央結算系統、衍生工具結算系統及場外衍生產品結算系統）;"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「結算所」",
          content:
            "就任何市場而言，指不時為有關買賣的任何證券或合約提供結算及／或交收服務的實體（包括香港結算、聯交所期權結算所、香港期貨結算及場外結算公司）;"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「客戶」或「你」或「閣下」",
          content:
            "指已開立及維持帳戶的人士，並且在文義許可的情況下包括授權人士。「你的」須據此解釋;及"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(a)",
          content:
            "在客戶是自然人的情況下，不論他是否破產，應包括其遺產代理人、財產接管人或受託人;"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(b)",
          content:
            "在客戶是獨資經營機構的情況下，不論他是否破產，應包括獨資經營者、其遺產代理人、財產接管人或受託人、以及該商號的繼任者；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(c)",
          content:
            "在客戶是合伙經營的情況下，不論他是否破產，應包括於維持帳戶期間不時擔任該商行合夥人之合夥人，以及其各自之遺產代理人、財產接管人或受託人、以及該商號的繼任者;及"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(d)",
          content: "在客戶是公司的情況下，應包括該公司、及其繼任者和受讓人；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「操守準則」",
          content:
            "指由證監會發出，並可不時被修訂或替代的《證券及期貨事務監察委員會持牌人或註冊人操守準則》；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「押記資產」",
          content: "指："
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(a)",
          content: "不時在帳戶內的一切投資產品、應收賬項、款項及任何其他財產；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(b)",
          content:
            "客戶現在或將來由本公司、其代名人或任何高盈證券成員不時管有、保管或控制及作任何用途的一切其他資產品、應收賬項、款項及任何財產；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(c)",
          content: "所有附加或替代的投資產品；以及"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(d)",
          content:
            "以上任何一项或與其有關並透過贖回、紅利、優先、選擇或其他形式於任何時間累計或提供的一切已付或應付股息、利息、權利、權益、款項或財產;"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「抵押品」",
          content: "指任何："
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(a)",
          content: "客戶在本協議下設立的產權負擔；及"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(b)",
          content: "客戶授予的其他現存或未來的產權負擔，"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "",
          content:
            "並以本公司、其代名人及/或任何高盈證券成員作為受益人以擔保債務的清償或解除；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「本公司」或「我方」或「我們」",
          content: "（個別或統稱）指："
        },
        {
          NumScale: "",
          isNumBold: false,
          label:
            "高盈證券有限公司（中央編號BPS863），一間在香港註冊成立並獲證監會發牌進行第一類（證券交易）、第二類（期貨合約交易）及第五類（就期貨合約提供意見）受規管活動的公司，及其繼任者和受讓人，包括（如文義所指）其代理、代名人、代表、主管人員及僱員",
          content: ""
        },
        {
          NumScale: "",
          isNumBold: false,
          label:
            "如文義所指乃第一類、第二類及第五類受規管活動，「本公司」或「我方」或「我們」應指高盈證券有限公司。",
          content: ""
        },
        {
          NumScale: "",
          isNumBold: false,
          label:
            "如需進一步了解詳情以及本公司的最新註冊狀況，請參閱本公司網站。",
          content: ""
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "此外，「我方的」將按此詮釋；",
          content: ""
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「商品」",
          content:
            "指香港期交所規則、規例及程序界定的商品及／或本公司就本協議而言接納的任何商品，不論是否能夠交付，包括但不限於農業商品、金屬、貨幣、股份、利率、指數（不論股市指數或其他）或其他金融合約、能源、權利或權限，而如文義所指，包括上述任何一項的合約，而「多種商品」將按此詮釋；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「複雜產品」",
          content: "具有操守準則所賦予之涵義；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「合約」",
          content:
            "視乎文義指任何在附件III（期權交易）描述的期權合約、期貨合約（定義見於附件IX（期貨交易））及/或期權合約（定義見於附件IX（期貨交易））中按上下文可能要求所描述的期權合約，多份合約將按此詮釋；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「法團專業投資者」",
          content:
            "屬於《證券及期貨（專業投資者）規則》（香港法例第571D章）第4、6或7條所指的信託法團、法團或合夥；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「衍生工具結算系統」",
          content:
            "指香港期交所結算所和聯交所期權結算所營運的衍生產品結算及交收系統；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「短欠」",
          content: "指任何帳戶不時的負結餘，不論以任何方式及不論如何產生；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「解散」",
          content:
            "，就一名人士而言，亦包括該名人士解散、結業、清盤或破產，以及根據註冊成立、成立、或駐在或經營業務或擁有資產的任何司法管轄區法律進行的任何同等或類似程序，而「已解散」將按此詮釋；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「電子服務」",
          content:
            "指本公司及/或其代表為向客戶提供服務之目的而提供的任何電腦或電子服務、系統或設施（包括但不限於短訊服務（俗稱短訊）、本公司網站/手機應用程式以及演算交易服務），包括但不限於使客戶能在香港或其它地方發出執行交易的電子指示及接收資訊及通訊的服務；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「產權負擔」",
          content:
            "指任何按揭、押記、質押、債券、留置權、以擔保方式轉讓、財務租賃、遞延購買、售後購回或售後回租安排、押貨預支、賣方保留所有權、第三方權利或權益，或就任何資產而給予或招致的其他產權負擔或抵押權益，或讓任何債權人或任何協議對任何其他債權人或協議享有優先權的任何安排，並包括就設立或授予上述任何一項而訂立的任何協議或義務；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「違約事件」",
          content:
            "指本協議中描述的任何事件，包括但不限於第21.1條（違約）中所列的任何事件以及附件I（保證金融資）第3.5條（未能滿足追收保證金要求）中所列的事件；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「交易所」",
          content: "，就任何市場而言，指進行投資產品買賣的交易所；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「交易所買賣衍生產品」",
          content:
            "，指屬於香港或證監會不時指定的司法管轄區的交易所內買賣的衍生產品的複雜產品；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「金融糾紛調解中心」",
          content: "指金融糾紛調解中心有限公司;"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「基金」",
          content:
            "指透過本公司分銷或提供的任何單位信託、投資基金、互惠基金或其他集體投資計劃；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「期貨帳戶」",
          content:
            "指於本公司開設以主要用作購入、投資、沽售、買賣、達成、交易、收購、持有、轉讓、訂立、結算、交收、處置或以其他方式處理商品及／或合約之用途（不時由客戶指示本公司執行）的帳戶；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「香港期交所結算所」",
          content:
            "指香港期貨結算有限公司及其繼任人和受讓人，包括，如文義所指，其代理人、代名人、代表、主管人員及僱員；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「香港交易所」",
          content: "指香港交易及結算所有限公司；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「香港期交所」",
          content:
            "指香港期貨交易所有限公司及其繼承人和受讓人，包括，如文義所指，其代理、代名人、代表、主管人員及僱員；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「香港結算」",
          content:
            "指香港中央結算有限公司（香港交易所全資子公司）以及其繼任人和受讓人，包括，如文義所指，其代理、代名人、代表、主管人員及僱員；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「香港」",
          content: "指中華人民共和國香港特別行政區；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「香港監管機構」",
          content:
            "指聯交所（包括有關結算所）、證監會及／或於香港對本公司或交易擁有司法管轄權的任何其他監管機構；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「高盈證券」",
          content:
            "指高盈證券有限公司，其子公司、關聯公司及有聯繫實體；「高盈證券成員」將按此詮釋；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「個人專業投資者」",
          content:
            "屬於《證券及期貨（專業投資者）規則》（香港法例第571D章）第5條所指的個人；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「機構專業投資者」",
          content:
            "屬於證券及期貨條例附表1第1部第1條「專業投資者」的定義第（a）至（i）段所指的人士；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「指示」",
          content:
            "指任何由客戶（無論是本人或通過任何授權人士）以任何方式（包括但不限於口頭、電話、傳真、電郵、互聯網或任何其他電子方式（包括通過電子服務）或任何書面形式）給予或傳達予本公司的授權、要求、申請、指示或指令（以任何形式及任何方式發送），或者是本公司合理地認為是客戶的授權、要求、申請、指示或指令，並包括任何撤銷、駁回或修改任何過往的授權、要求、指示或指令的授權、要求、指示或指令；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「投資者賠償基金」",
          content: "指根據證券及期貨條例第236條成立的投資者賠償基金；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「投資諮詢服務」",
          content:
            "指本公司就任何投資產品不時向客戶提供的任何投資意見或資產策略配置建議；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「投資產品」",
          content: "指證券、合約及其他金融或投資產品（不論如何描述）；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「負債」",
          content:
            "指客戶有關任何帳戶及本協議欠負、結欠本公司、其代名人或任何高盈證券成員或產生的所有款項、債項、負債及義務，不論實際或或然，現在或未來、當事或附帶、有抵押或無抵押，或客戶於任何帳戶或不論以任何方式或貨幣成為或可能向本公司負責（不論作為主要債務人或保證人，亦不論單獨或聯同任何其他人士，及不以任何名義、身份、形式或格式），包括因貨幣、股票經紀、保證金證券交易及其他金融交易產生的所有金錢義務，連同利息（由適用到期日起或在其他情況下，由請求日期起至本公司全數接獲實際及無條件付款日期（包括該日在內））、法律費用及本公司、其代名人或任何高盈證券成員有關該款項、負債及義務產生的所有其他成本、收費及開支（包括但不限於收回或嘗試收回該款項、債項、負債及／或義務或強制執行本公司在本協議下的權利及權力索償產生的任何匯兌虧損及開支）；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「登錄識別碼」",
          content: "指為接達電子服務而與密碼結合使用的某些資訊；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「市場」",
          content:
            "指場外市場或任何交易所、適用交易商協會或本公司為投資產品提供的任何市場，不論於香港或境外；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「重大不利影響」",
          content: "指以下各項發生的重大不利影響："
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(a)",
          content: "客戶整體的業務，運營，財產，財務及其他狀況或發展前景；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(b)",
          content:
            "客戶履行其在本協議或其與公司或任何高盈證券成員簽訂的任何其他協議項下義務的能力；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(c)",
          content:
            "任何該等協議的有效性、合法性或可執行性，或本公司在該等協議項下的權利；或"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(d)",
          content:
            "客戶根據該等協議授予的任何抵押的有效性、合法性或可執行性，或任何該等抵押的優先權和排序；;"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「其他文件」",
          content:
            "指客戶或本公司就有關本協議產生或預計進行的任何事宜簽署、接納或向另一方發出的表格、函件、通知、結單、確認書及其他文件，以不時經修訂或補充者為準；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「場外交易結算及交收系統」",
          content:
            "指場外結算公司為支持其結算服務而開發的場外交易結算及交收系統；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「場外結算公司」",
          content:
            "指聯交所成立的香港場外結算有限公司，作為中央交易對手為場外衍生產品交易提供結算及交收服務；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「密碼」",
          content:
            "指客戶密碼以及與登錄識別碼結合使用的其他加密和安全措施，以使客戶能夠接達電子服務；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「個人資料（私隱）條例」",
          content:
            "指《個人資料（私隱）條例》（香港法例第486章）及根據該條例作出的所有附屬法例、規則、守則和指引；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「中國」",
          content:
            "指中華人民共和國，但不包括香港、澳門特別行政區以及中華民國（台灣）；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「專業投資者」",
          content: "具有證券及期貨條例附表1第1部第1條所賦予之涵義；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「人民幣」",
          content: "指中國的法定貨幣；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「規則」",
          content:
            "，就任何市場而言，指有關交易所、結算所或結算系統的一般規則、運作程序及其他適用規則、慣例、常規、程序及規例，以及其不時之修訂或補充；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「證券」",
          content:
            "指（a）證券及期貨條例所界定的證券；及（b）任何機構（不論已註冊成立或非註冊成立）或任何政府機構不論任何形式或如何發行於市場買賣及就本協議獲本公司接納的任何股份、股票、債權證、借貸股份、基金、債券、票據、單位信託、場外交易衍生產品、存款證或其他商業票據或證券或其他類似工具，並且按本公司的絕對酌情權，可包括（i）上述任何一項的權利、選擇權或權益（不論以單位或其他方式說明）；（ii）上述任何一項的權益或分享權證書、臨時或中期證書、收據或認購或購買權證；或（iii）通常稱為證券的任何工具；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「證券現金帳戶」",
          content:
            "指於本公司的帳戶，以主要進行及記錄本公司按照客戶的指示進行的證券交易；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「證券保證金帳戶」",
          content:
            "指於本公司的帳戶，以主要用於執行及記錄本公司按照客戶指示利用信貸融資（定義見於附件I（保證金融資））進行的交易；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「證券交易」",
          content:
            "指本公司按客戶指示進行的任何交易，以買入、投資、認購、賣出、交換或以其他方式買賣或處置任何證券，包括以本公司或本公司代名人的名義持有證券；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「聯交所」",
          content:
            "指香港聯合交易所有限公司及其繼任人及承讓人，包括，如文義所指，其代理、代名人、代表、主管人員及僱員；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「聯交所期權結算所」",
          content:
            "指香港聯合交易所期權結算所有限公司及其繼任人及承讓人，包括，如文義所指，其代理、代名人、代表、主管人員及僱員；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「證監會」",
          content: "指香港證券及期貨事務監察委員會及其繼任人和受讓人；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「證券及期貨條例」",
          content:
            "指《證券及期貨條例》（香港法例第571章）及根據該條例作出的所有附屬法例、規則、守則和指引；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「賣空指令」",
          content:
            "，就在聯交所交易的證券而言，具有證券及期貨條例賦予的涵義，以及在其他所有情況下，是指代表客戶賣空任何投資產品的指令；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「股票期權帳戶」",
          content:
            "指於本公司的帳戶，以按照客戶指示進行期權交易，並主要受附件III（期權交易）所載條款的管轄；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「此等條款」",
          content: "指可能不時修訂或補充的一般條款和條件（不包括其附件）；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「交易時段」",
          content: "具有第5.5條（交易日）所賦予之涵義；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「交易」",
          content:
            "指根據本協議預計進行、提供或作出、生效或進行的任何交易、買賣、協議、行動、服務；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「美國」",
          content:
            "指美利堅合眾國（爲避免歧義，包括其各州、領土、屬地以及哥倫比亞區）；及"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "「美籍人士」",
          content: "包括"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(a)",
          content: "身為美國公民或居民的任何自然人；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(b)",
          content:
            "根據美國或其任何政治分部法律組成或註冊成立的法團、合夥商號或其他業務機構；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(c)",
          content:
            "身為上述美國人士的執行人或受託人管理，或收入（不論來源）受美國聯邦所得稅規限的任何遺產或信託；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(d)",
          content:
            "交易商或受信人士為上述人士的實益持有的任何帳戶（任何遺產或信託除外）；及;"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(e)",
          content:
            "根據任何司法管轄區的法律組成及註冊成立的任何合夥商號或法團，為由上述人士組成，主要用於投資於並非根據一九三三年美國證券法註冊的證券,"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "",
          content:
            "但不包括於美國以外為有效業務原因作為當地從事銀行或保險業務及並非主要為投資於根據並非一九三三年美國證券法註冊的證券的受規管分行或代理的美國銀行或保險公司任何分行或代理。"
        },
        {
          NumScale: "1.2",
          isNumBold: false,
          label: "釋義",
          content: "：於此等條款及本協議內："
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(a)「包括」",
          content: "指包括但不限於；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(b)控股公司」及「子公司」",
          content: "將分別具有《公司條例》（香港法例第622章）賦予的涵義；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(c)",
          content:
            "提述條、分條或附表，為此等條款的條、分條或附表，而提述開戶表格指客戶或其代表填妥的開戶表格，而倘該資料於其後以向本公司發出通知予以修訂，指經該通知修訂的開戶表格；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(d)",
          content:
            "提述條例指不時經修訂、補充、延伸、規範或重新頒佈的香港法例或法律及相關的任何附屬法例；;"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(e)",
          content:
            "提述男性稱謂包括女性及中性，而提述單數包括眾數，反之亦然，而提述人士包括個人、公司、機構、商號、法團、法人團體、政府、國家或國家實體、組織、合夥商號或其他實體或機構（不論是否為註冊成立，亦不論是否具有法人資格）或前述任何兩者或以上；,"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(f)",
          content: "條款的標題僅供參考，並不影響其詮釋；及"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(g)",
          content:
            "附件構成本協議整體的一部分，除非另有明確說明，否則附件應與本條款及本協議其他部分一起閱讀。"
        },
        {
          NumScale: "1.3",
          isNumBold: false,
          label: "歧異",
          content:
            "：倘有任何歧異，有關服務、投資產品、安排或交易的條款將按以下次序適用：（i）有關客戶由其提供或接納的任何額外或特定表格或文件（除下述（ii）和（iii）所述部分）；（ii）管轄該表格或文件的相關附件，及（iii）適用於該表格或文件的任何一般條款及條件（包括此等條款）。"
        },
        {
          NumScale: "1.4",
          isNumBold: false,
          label: "適用法規",
          content: "：除本協議外，所有服務、產品、安排及交易將受適用法規規限。"
        },
        {
          NumScale: "1.5",
          isNumBold: false,
          label: "網站",
          content:
            "：本公司網站為www.goingf.hk或其他本公司可能不時通知客戶的網站。"
        },
        {
          NumScale: "2",
          isNumBold: true,
          label: "委任、代理範圍及授權",
          content: ""
        },
        {
          NumScale: "2.1",
          isNumBold: false,
          label: "開戶",
          content:
            "：客戶應以本公司不時指定之方式開立及維持有關帳戶，以進行交易。"
        },
        {
          NumScale: "2.2",
          isNumBold: false,
          label: "本公司作為客戶代理人：",
          content:
            "除非本協議或本公司另有說明，客戶委任本公司，而本公司同意作為客戶的代理代表客戶進行交易。本文所載的任何內容，概不構成本公司作為客戶的受託人或受信人士或本公司與客戶之間的合夥關係。"
        },
        {
          NumScale: "2.3",
          isNumBold: false,
          label: "本公司作為主事人與結算所交易：",
          content:
            "除非本協議或本公司另有規定，就本公司或任何高盈證券成員於任何結算所存置的任何帳戶不論該帳戶是否全部或部分就本公司代表客戶進行的任何交易存置，及不論客戶是否已向該結算所支付款項，在本公司或任何高盈證券成員與該結算所之間，本公司或該高盈證券成員（視乎情況而定）作為主事人進行交易。"
        },
        {
          NumScale: "2.4",
          isNumBold: false,
          label: "本公司拒絕的權利：",
          content:
            "儘管有任何相反之規定，本公司可全權酌情在毋須提供任何原因的情況下拒絕接納任何指示及／或拒絕向客戶提供其在本協議項下的任何服務。本公司將不會就其不接納或不按此指示行事或不發出不接納任何指示的通知以及上述拒絕所產生或有關的任何損失向客戶負責。"
        },
        {
          NumScale: "2.5",
          isNumBold: false,
          label: "本公司的指派：",
          content:
            "本公司可全權酌情決定透過任何高盈證券成員、任何交易所或結算所的成員或參與者或有關市場的經紀執行客戶的交易。本公司可委任任何其他人士為其代名人、託管人、經紀、存託代理或其他代理，旨在或有關向客戶提供服務，並可根據本協議指派任何職責予該名人士。所有該等第三方均享有客戶賦予本公司的全部權力及酌情權。本公司獲客戶授權，向本公司根據本第2.5條委任的任何人員披露有關客戶、其授權人士、帳戶及交易的任何個人資料及其他資料。在適用法規許可的最大範圍內，本公司將不就該等第三方的行為或不作為向客戶負責。"
        },
        {
          NumScale: "2.6",
          isNumBold: false,
          label: "授權人士發出的指示：",
          content:
            "客戶授權本公司接受授權人士就本協議發出或旨在發出的指示。但是，除非本公司同意或本協議另有指明，有關向第三方轉讓現金及/或證券的交收指示，必須以書面作出及按開戶表格所指定的方式（如有指定）作出。本公司有權以任何理由拒絕執行客戶就任何一項交易發出的指示。有關授權人士的委任或變更（受本公司的批准所限）須在本公司實際收到有關通知起不時生效。本公司有權（但無義務）執行授權人士代表客戶發出或旨在發出的任何指示，但毋須對客戶因此可能遭致的任何損失承擔任何責任。本公司無任何義務核證代表客戶發出或旨在發出的指示的真實性，亦無義務核實發出指示人士之身份。"
        },
        {
          NumScale: "2.7",
          isNumBold: false,
          label: "無職責詢查目的或適當性：",
          content:
            "本公司無任何職責或義務詢查客戶或任何授權人士發出或聲稱發出的任何指示或指令的目的或適當性，亦無任何職責或義務監督根據本協議由任何帳戶所支出的任何資金使用。"
        },
        {
          NumScale: "2.8",
          isNumBold: false,
          label: "授權書︰",
          content:
            "客戶同意及謹此不可撤銷地委任本公司並賦予其全面的權力及權限作為客戶的真正及合法受權人（在法律許可的全面範圍內）為客戶及代表客戶執行本協議的條款，並於本公司認為在履行本條款的目的有所需要或合宜之時，以客戶或本公司本身的名義採取任何行動及簽立任何文件或文書，包括但不限於下列目的："
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(a)",
          content: "就任何押記資產執行任何轉讓或轉移；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(b)",
          content: "完成其對任何押記資產的所有權；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(c)",
          content:
            "請求、要求、索求、收取、了結及徹底清償在押記資產項下或因押記資產而引起的到期或將到期的任何及所有款項及申索的款項；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(d)",
          content:
            "提供有效的收據和解除書，並加簽與任何押記資產有關的任何支票或其他文書或指令；及"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(e)",
          content:
            "提出任何申索或採取其認為必要和合宜的任何法律行動或法律程序，以保障在本協議項下設定的擔保。"
        },
        {
          NumScale: "2.9",
          isNumBold: false,
          label: "限制:",
          content:
            "本公司可於不時認為適當時，訂立與任何帳戶有關及給予指示之有關限制，該等限制包括但不限於每日進行交易之最多次數、每筆交易中可處理的不同投資產品的數量和類型、交易中投資產品的最低價值或金額、客戶可以購買或出售投資產品的價格、未平倉合約的持倉限制及基金贖回限額。"
        },
        {
          NumScale: "2.10",
          isNumBold: false,
          label: "非委託帳戶：",
          content:
            "客戶確認，本公司不會就為客戶作出投資決定及執行交易行使酌情權，除非本公司另行通知客戶，在此情況下，客戶可能須訂立委託帳戶協議、授權書及/或本公司可能要求的其它文件，惟不得據此解釋為本公司的作為、不作為、指示、允許、默許、批准、安排或同意。"
        },
        {
          NumScale: "2.11",
          isNumBold: false,
          label: "無建議：",
          content:
            "根據第24.1條（一般）所載為確保合理合適性外，除非本公司與客戶另有約定，本公司並未提供投資諮詢服務，因此概不承擔任何招攬出售或建議投資產品的諮詢謹慎責任或義務。如本公司向客戶提供與某些金融產品有關的廣告、市場營銷或推廣材料、營銷資料或其他資料訊，該等材料或資訊不會單獨構成對該投資產品的招攬或建議。客戶基於該等材料或資料採取或不採取任何行動前，應取得獨立專業意見。客戶亦確認︰"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(a)",
          content:
            "在投資諮詢服務過程中提及的任何目標或預期收益不代表對任何投資產品的性能的任何保證，估算或預測；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(b)",
          content:
            "完成其對任何押記投資於任何投資產品均有其風險；資產的所有權；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(c)",
          content: "本公司可就投資顧問服務不時全權及絕對酌情收取費用。"
        },
        {
          NumScale: "3",
          isNumBold: true,
          label: "常設授權",
          content: ""
        },
        {
          NumScale: "3.1",
          isNumBold: false,
          label: "常設授權：",
          content:
            "客戶同意按照本公司指定的形式給予本公司不時要求的常設授權，包括但不限於以下各項："
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(a)",
          content:
            "《證券及期貨（客戶證券）規則》（香港法例第571H章）（包括為附件I（保證金融資）第5.1條（常設授權）之目的所必需的內容）；及"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(b)",
          content: "《證券及期貨（客戶款項）規則》（香港法例第571I章）。"
        },
        {
          NumScale: "3.2",
          isNumBold: false,
          label: "有效期：",
          content:
            "常設授權自出具之日起生效。客戶的授權書必須指明有效期，而該段有效期不得超過12個月。若客戶是專業投資者，則有關限制並不適用。除非及直至客戶以書面形式明確撤回該授權，否則任何常設授權一經授予，將一直有效。"
        },
        {
          NumScale: "3.3",
          isNumBold: false,
          label: "撤銷:",
          content:
            "在沒有任何尚未清償的負債的情況下，客戶可在不少於10個營業日前通知公司撤回該常設授權。客戶確認，常設授權被撤銷或未續期可能導致本公司無法向客戶提供服務。"
        },
        {
          NumScale: "3.4",
          isNumBold: false,
          label: "續期：",
          content:
            "本公司將於常設授權屆滿前14天通知客戶，述明除非客戶於該授權屆滿前提出反對，否則該常設授權將被視為已按最後一次授權的相同條款及條件獲續期。"
        },
        {
          NumScale: "4",
          isNumBold: true,
          label: "指示",
          content: ""
        },
        {
          NumScale: "4.1",
          isNumBold: false,
          label: "發出指示：",
          content:
            "客戶可就有關交易、帳戶或本公司的服務以電話、傳真、電子方式（包括電子服務）或本公司不時指定的其他通訊方式發出指示。所有指示都必須遵照本公司和客戶之間的安排以書面形式發出並（如須簽署）符合於開戶表格向本公司提供的相關式樣簽署，或以其他方式通知本公司并受本公司接受（「協議簽署安排」）。在任何情況下，客戶均須遵守該等驗證程序並滿足本公司不時規定的其他要求。"
        },
        {
          NumScale: "4.2",
          isNumBold: false,
          label: "截止時間：",
          content:
            "本公司有權全面地或就任何指定性質或種類的指示，指定收取指示的任何截止時間，可能與任何市場或任何交易所或結算所指定的任何通常截止時間不同。客戶確認及同意，本公司概不會就執行本公司於適用截止時間後收取的任何指示的任何延誤或未能執行有關指示承擔責任。"
        },
        {
          NumScale: "4.3",
          isNumBold: false,
          label: "授權人：",
          content:
            "任何一名授權人士獲客戶授權代表客戶就帳戶發出指示並簽署有關帳戶及其運作的一切協議及相關文件，直到本公司收到客戶內容相反的書面通知為止。客戶向本公司承諾將不時及隨時追認並確認任何授權人士代表客戶或聲稱代表客戶發出或簽署的任何指示或協議或文件，包括但不限於任何授權人士於被撤銷授權至本公司實際收到撤銷授權通知期間代表客戶或聲稱代表客戶發出或簽署的任何指示、協議或文件。客戶同意，如果本公司在收到任何授權人士代表客戶或聲稱代表客戶發出或簽署的任何指示、協議或文件時尚未實際收到該授權人士被撤銷授權的通知，則該授權人士在被撤銷授權之後代表客戶或聲稱代表客戶發出或簽署的任何指示、協議或文件對本公司的利益而言為有效及有作用的指示、協議或文件。上述由任何授權人士簽署或發出或聲稱簽署或發出的所有文件或指示（不論口頭或書面）一律被視為在該授權人士權限內簽署或發出的，對客戶具有絕對及不可推翻的約束力。客戶有責任確保所有授權人士均遵守本協議，並在任何情況下對所有指示負責，即使該等指示是由授權人士或其他第三方發出。"
        },
        {
          NumScale: "4.4",
          isNumBold: false,
          label: "本公司對指示的信賴：",
          content:
            "本公司有權視按照此等條款發出的指示為獲客戶全權授權的指示處理。本公司有權（但不受約束）就本公司真誠認為適當按照該指示執行交易的情況下根據或依據指示行事或採取有關步驟（不論為收購、購買、出售、轉移、處置或在其他情況下買賣投資產品），並獲授權約束客戶遵守與本公司或任何其他人士訂立的任何協議或其他安排，或促使客戶為執行該指示進行任何其他種類交易或安排，不論交易或安排的性質、或涉及的投資產品的價值、種類及數量。除與協議簽署安排核對客戶及／或授權人士各自的簽署（倘指示由客戶及／或授權人士簽署）或核對有關客戶及／或任何授權人士（倘指示以任何其他方式發出）身份的指定號碼、密碼及／或任何其他資料，本公司將無義務核對以任何方式發出任何指示的人士的身份或授權或該指示的真實性。本公司可依賴及按本公司真誠地相信為真實的指示行事，而本公司按此基準代表客戶進行的任何交易將對客戶具約束力，不論該指示是否就該交易作出或由客戶授權。"
        },
        {
          NumScale: "4.5",
          isNumBold: false,
          label: "與非面對面通訊有關的風險：",
          content:
            "客戶確認以電話、傳真、電郵或其他電子方式（包括電子服務）發出指示的風險，包括未獲授權或由未獲授權人士發出或由第三者截獲指示的風險。客戶接納所有風險，並授權本公司按照透過該方式接獲的任何指示行事。本公司並不就傳送或傳達指示或價格資訊的任何延誤、故障、失誤、中斷，或暫停傳送或傳達指示或價格資訊或向任何其他方錯誤傳達指示或資訊，或為客戶因使用任何特定收發指示方式或本公司按該指示行事而可能蒙受或產生的任何申索、負債或損失承擔任何責任，除非由於本公司或其任何主管人員或僱員的嚴重疏忽、欺詐或蓄意失責所致，及只限於直接及合理預見直接及純粹由上述行為造成的損失及賠償（如有）。"
        },
        {
          NumScale: "4.6",
          isNumBold: false,
          label: "取消或修改指示：",
          content:
            "一旦指示由客戶或其代表發出，除非本公司同意，該指示不可予以修訂、撤銷或撤回。倘客戶所修訂、撤銷或撤回的指示已全部或部分執行，客戶同意就有關交易承擔全部責任。就客戶或其代表已向本公司發出的任何指示，本公司將無義務就其取消、修訂或修改任何指示行事，而倘原本指示已由本公司真誠地完成，或本公司不能合理可行地按指示取消、修訂或修改原本指示，則毋須就客戶蒙受或產生的任何損失或開支承擔責任或負責。"
        },
        {
          NumScale: "4.7",
          isNumBold: false,
          label: "概無責任促使作為受信人士合規：",
          content:
            "本公司不負責促使客戶遵守規管客戶作為受信人士（如適用）的行為的任何法律或規例。"
        },
        {
          NumScale: "4.8",
          isNumBold: false,
          label: "優先次序：",
          content: "本公司可全權決定在執行客戶的指示時的優先次序。"
        },
        {
          NumScale: "4.9",
          isNumBold: false,
          label: "合併訂單：",
          content:
            "在任何適用規例的規限下，本公司可毋須向客戶發出通知，將客戶的訂單與客戶或與本公司關連的人士或與本公司的其他客戶的訂單合併。合併在某些情況下可能對客戶不利，而在其他情況下對客戶有利。"
        },
        {
          NumScale: "4.10",
          isNumBold: false,
          label: "香港以外發出指示：",
          content:
            "如客戶在香港以外的地方發出任何指示，客戶承諾將遵照外地的所有適用法規發出該等指示，如有疑問，客戶應取得獨立法律意見。如客戶的居住地不在香港，則客戶確認按照適用法規可交易在香港的投資產品，本公司並無職責就此進行核實。"
        },
        {
          NumScale: "4.11",
          isNumBold: false,
          label: "賣空交易：",
          content:
            "倘若本公司自行全權決定客戶已符合所有適用法規，本公司可執行賣空指令。特別是，對於在聯交所或通過聯交所交易的賣空指令，本公司必須獲滿足（i）已符合證券及期貨條例第170條和第171條的規定（總的來説，要求客戶具有一項即時可行使及無條件的權利，以將該等證券轉歸於其購買人名下）及（ii）相關證券列於聯交所不時發佈並更新的可進行賣空的指定證券名單。"
        },
        {
          NumScale: "5",
          isNumBold: true,
          label: "執行交易",
          content: ""
        },
        {
          NumScale: "5.1",
          isNumBold: false,
          label: "指示經紀商：",
          content:
            "客戶授權本公司指示本公司全權酌情視為合適的執行經紀商、代理、託管人、代名人、海外經紀商及交易商（包括本公司的分行或有聯繫者）執行任何交易，並確認該等人士的業務條款以及執行及結算交易的任何相關交易所、結算所及／或結算系統的適用規則將適用於該等交易。客戶理解並同意，由於本公司需根據協議或其他方式向客戶提供服務，本公司可能因客戶的投資產品或與客戶的投資產品有關而欠第三方義務。該等第三方可能對客戶的投資產品和押記資產擁有權利及權益，並可能影響（a）本公司解除對此類投資產品對客戶的義務的能力（例如，將某些投資產品或押記資產退還給客戶），及/或（b）客戶行使與該投資產品或押記資產有關或與之相關的任何權利（包括但不限於其對股票的投票權）的能力。"
        },
        {
          NumScale: "5.2",
          isNumBold: false,
          label: "相關法律：",
          content:
            "本公司按照客戶指示進行的所有交易，均應按照所有適用法規進行。本公司按照適用法規採取的所有行動均對客戶具有約束力。"
        },
        {
          NumScale: "5.3",
          isNumBold: false,
          label: "「按最佳條件」或「按市場條件」執行指示：",
          content:
            "客戶確認，基於任何市場的市場條件或物理限制，以及投資產品價格的迅速轉變及／或貨幣匯率的波動，在某些情況下，及即使本公司、執行經紀商或交易商（不論於香港或其他地方）合理盡力，本公司未必能完全或按客戶指定的價格或時間或「按最佳條件」或「按市場條件」執行客戶的指示。倘因市況或本公司未能控制的任何其他原因，本公司未能完全執行任何指示，本公司概不負責，客戶接受本公司進行的交易並受其約束。"
        },
        {
          NumScale: "5.4",
          isNumBold: false,
          label: "履行部分訂單及限價單：",
          content:
            "當本公司或獲本公司指示的任何人士未能完全執行客戶的任何指示，本公司或該等人士有權在不事先諮詢客戶或徵得其同意的情況下僅執行部分指示。在不影響上文所述一般性的情況下，除非就投資產品於發出指示之時，客戶明確指示本公司立即於有關市場送出整個訂單（而本公司接受該指示），否則經考慮當時市況及市場常規後，尤其是當本公司合理認為訂單根據當時的市況不能即時執行時，本公司有權拒絕如此行事。"
        },
        {
          NumScale: "5.5",
          isNumBold: false,
          label: "交易日：",
          content:
            "除非客戶向本公司發出任何明確的相反指示（而本公司接受該等指示），否則客戶確認本公司於某交易日收到的所有指示僅於該交易日（或本公司不時決定縮短或延長的時間）（「交易時段」）有效，而以未履行的任何指示為限，該等指示均就發出買賣盤的市場的最後交易日正式交易時段（在交易時段內）結束後失效。"
        },
        {
          NumScale: "5.6",
          isNumBold: false,
          label: "一直有效的訂單：",
          content:
            "一直有效的訂單將持續有效以待執行，直至任何下述情況發生爲止：（i）訂單被客戶取消；（ii）訂單預先確定的有效期已過；或（iii）本公司自行全權決定取消該訂單。該訂單可在取消之前的任何時間執行，而客戶同意就該等交易承擔一切責任。"
        },
        {
          NumScale: "5.7",
          isNumBold: false,
          label: "利息:",
          content:
            "客戶應按本公司不時通知客戶的利率及其他條款，支付任何帳戶內的所有逾期結餘、未清金額、借方結餘及於任何時候結欠本公司的任何款項的利息（包括對客戶的債項取得判決後產生的利息），若本公司並無發出該等通知，則按本公司不時釐定的利率支付利息。利息應從相關到期日或在其他情況下由提出要求之日計起，直至本公司全數收到實際及無條件付款之日（包括該日在內），按日計算。逾期未付利息將每月按複利計算及利息本身將產生新的利息。"
        },
        {
          NumScale: "5.8",
          isNumBold: false,
          label: "錄音和錄音帶：",
          content:
            "客戶確認，客戶與本公司之間的所有電話對話可能在沒有自動語音警告提示的情況下被錄音，以便本公司核實客戶的指示。客戶同意，相關錄音帶上的錄音或者錄音的文字記錄可以用作指示內容的最終及不可推翻的證據。"
        },
        {
          NumScale: "5.9",
          isNumBold: false,
          label: "本公司之記錄不可推翻：",
          content:
            "客戶確認，本公司之簿冊、數據及記錄，如無明顯錯誤，均為有關事項的最終定論及在所有法庭及就一切目的而言，均為不可推翻的證據。"
        },
        {
          NumScale: "5.10",
          isNumBold: false,
          label: "個人操作帳戶：",
          content:
            "客戶確認，客戶將自行（或通過其授權人士）操作本公司就本協議為客戶開立的任何帳戶。倘客戶擬委任第三方就本協議以任何方式代表客戶行事，客戶應向本公司提供本公司自行全權決定的可能需要的信息以委任該第三方，而約束該委任的條款及條件將附加於本協議之上，及視為本協議的一部分。"
        },
        {
          NumScale: "5.11",
          isNumBold: false,
          label: "價格:",
          content:
            "任何交易的實際買入及賣出價應在進行交易時釐定，而本公司或其代表於任何時間向客戶報價或提供的任何數字（其中一些數字可能是由第三方資訊或服務提供者提供給本公司）僅供參考，以及並不對本公司或客戶約束力。為免生疑，本公司有權按客戶的任何指示進行交易，即使相關投資產品的價格在接收指示之時至本公司或其代理人實際進行交易之時已變得對客戶不利。"
        },
        {
          NumScale: "5.12",
          isNumBold: false,
          label: "所有權：",
          content:
            "本公司無義務審查或核實任何投資產品的擁有權或所有權的有效性。"
        },
        {
          NumScale: "6",
          isNumBold: true,
          label: "交收",
          content: ""
        },
        {
          NumScale: "6.1",
          isNumBold: false,
          label: "交收:",
          content:
            "除非另有約定或倘本公司已代表客戶持有足夠的投資產品、現金或其他資產以交收交易，否則客戶應在本公司就有關交易通知客戶的時間、地點、金額及方式："
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(a)",
          content:
            "向本公司支付或提供清算資金，或以交收交易所需的可交付形式向本公司交付相關投資產品；及"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(b)",
          content:
            "確保本公司將於適用交收日期或本公司就交收交易可能知會客戶的時間接獲清算資金或可交付的投資產品。"
        },
        {
          NumScale: "6.2",
          isNumBold: false,
          label: "客戶未能交收：",
          content:
            "倘客戶未能遵守第6.1條（交收），就交收任何交易之目的，本公司在不損害本公司任何其他權利或補救及毋須向客戶發出進一步通知或徵得同意的情況下，有權全權酌情："
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(a)",
          content:
            "就買入或認購投資產品的交易，按本公司認為合理的價格，賣出或轉讓該交易所涉及的投資產品及／或賣出或轉讓任何帳戶中的任何其他投資產品以履行客戶的交收義務，並於任何帳戶收取或扣除任何相關成本、費用及開支；或"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(b)",
          content:
            "就賣出投資產品的交易，按本公司認為合理的價格，借入及／或買入相等於該交易所涉及的投資產品價值的投資產品以履行客戶的交收義務；而在第6.1條（交收）以外或作為替代，對本協議下的合併及抵銷權利或任何其他權利享有追索權。"
        },
        {
          NumScale: "6.3",
          isNumBold: false,
          label: "不執行交易的權利：",
          content:
            "儘管本協議任何其他條文有所規定，本公司有權針對以下用途不執行任何指示："
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(a)",
          content:
            "買入投資產品，除非客戶已向本公司提供清算資金，而本公司認為金額足以結清有關買入交易的相關買入價、費用及支出；及"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(b)",
          content:
            "賣出投資產品，除非客戶已向本公司存入有關投資產品以供交收該賣出交易。"
        },
        {
          NumScale: "6.4",
          isNumBold: false,
          label: "短欠：",
          content:
            "客戶以全面彌償基準就有關根據第6.2條（客戶未能交收）買入及/或賣出投資產品所發生的任何短欠及本公司產生的任何成本、費用或開支（包括法律費用）負責。"
        },
        {
          NumScale: "6.5",
          isNumBold: false,
          label: "股票借貸：",
          content:
            "為方便客戶按時交收，本公司可全權酌情向客戶借出投資產品，或代表客戶借入投資產品，以交收客戶的賣出指示。本公司亦可按其全權決定的條款代表客戶或為客戶利益向或從第三方（僅為本條之目的，「第三方」）借出或借入投資產品，不論是以本公司、任何高盈證券成員還是以其他名義。客戶應彌償本公司及任何高盈證券成員根據上述證券借貸安排所需的任何保證金、擔保、證券、或抵押品維持及開支。本公司不保證或擔保任何賣空交易的可用性或持續可用性。本公司可全權決定或應第三方要求終止任何該等借貸安排，並立即要求交付或歸還涉及的投資產品。客戶必須遵從有關交付或歸還相關投資產品的任何要求。"
        },
        {
          NumScale: "7",
          isNumBold: true,
          label: "付款和客戶款項",
          content: ""
        },
        {
          NumScale: "7.1",
          isNumBold: false,
          label: "向客戶付款：",
          content:
            "就本公司支付客戶之全部款項而言，將按開戶表格所載帳戶詳情將款項轉入客戶之銀行帳戶，或依本公司選擇以其他方式支付。上述任一方式的付款均構成對本公司所承擔之付款責任之完全解除。"
        },
        {
          NumScale: "7.2",
          isNumBold: false,
          label: "獨立帳戶：",
          content:
            "本公司從客戶或任何其他人士收到的所有款項或其他財產（除非適用法規容許，或根據客戶的書面指示，或根據客戶不時給予本公司的常設授權，而該等指示或常設授權已為本公司所接受）均與本公司的自有資產分開，及支付予獨立帳戶。"
        },
        {
          NumScale: "7.3",
          isNumBold: false,
          label: "客戶款項利息：",
          content:
            "本公司將以《證券及期貨（客戶款項）規則》（香港法例第571I章）允許的任何方式處理由本公司持有客戶款項（定義見於證券及期貨條例）而產生的任何利息，且客戶同意本公司（以公司款項）保留該等利息。"
        },
        {
          NumScale: "7.4",
          isNumBold: false,
          label: "香港以外執行的交易：",
          content:
            "儘管第7.2條（獨立帳戶）有所規定，就在香港以外執行的交易而言，客戶授權並指示本公司向本公司在香港境內或境外的任何金融機構（不論是否持牌銀行）維持的任何信託、客戶或其他帳戶，支付本公司為客戶及代表客戶從交易不時收取的所有款項（減所有經紀費用及應計的其他適當費用），儘管在符合或根據適用法規的情況下任何該等款額可為客戶或代表客戶再投資於其他交易。"
        },
        {
          NumScale: "8",
          isNumBold: true,
          label: "結單及記錄",
          content: ""
        },
        {
          NumScale: "8.1",
          isNumBold: false,
          label: "一般：",
          content:
            "本公司將按照適用法規向客戶提供與任何交易有關的成交單據或其他確認書，以及有關帳戶的戶口結單。"
        },
        {
          NumScale: "8.2",
          isNumBold: false,
          label: "月結單：",
          content:
            "除非適用法規允許或在特定月份內沒有與特定帳戶有關的交易，並且帳戶不存在任何未清餘額或持有任何持倉或投資產品，否則本公司亦將提供有關帳戶的月結單。"
        },
        {
          NumScale: "8.3",
          isNumBold: false,
          label: "終論性/客戶檢查：",
          content:
            "客戶應檢查本公司發出的每份帳戶結單及記錄。成交單據、交易確認書及戶口結單為當中所載事宜的不可推翻證據（明顯錯誤者除外），並將視為獲客戶接納及對客戶具約束力，除非本公司於成交單據或交易確認書或帳戶結單日期後5個營業日內實際從客戶接獲書面通知，指稱存在任何遺漏或錯誤，否則，此後客戶不得對該等結單的準確性提出異議。"
        },
        {
          NumScale: "8.4",
          isNumBold: false,
          label: "單方面修訂：",
          content:
            "即使有任何相反規定，本公司可在其認為適當的情況下單方面修訂任何該等結單或記錄。"
        },
        {
          NumScale: "8.5",
          isNumBold: false,
          label: "未收到：",
          content:
            "若（a）未收到本公司發出的任何戶口結單或交易記錄，或（b）客戶收到任何確認但並未發出有關指示，則客戶應在（a）的情況下於日常業務過程中通常收到戶口結單或記錄後2個營業日內，或在（b）的情況下在收到該等確認後立即以書面形式通知本公司。"
        },
        {
          NumScale: "8.6",
          isNumBold: false,
          label: "交付方式：",
          content:
            "在不影響本公司以其他任何方式向客戶送達成交單據、交易確認書、戶口結單及其他通知書（統稱「交易文件」）的情況下，客戶同意以電子方式（包括透過電子服務）收取交易文件。客戶可以通過向本公司發出不少於兩個月的書面通知（或公司可以接受的較短期限），撤銷其同意以電子形式接收交易文件。"
        },
        {
          NumScale: "8.7",
          isNumBold: false,
          label: "衍生產品：",
          content:
            "對於衍生產品，包括期權，公司應客戶要求向其提供（a）產品規格以及涉及此類產品的任何招股說明書或其他發行文件；及（b）保證金程序及未經客戶同意可能將客戶倉位平倉的情況的說明。"
        },
        {
          NumScale: "8.8",
          isNumBold: false,
          label: "客戶的確認：",
          content:
            "如果客戶同意並接受通過電子方式（「接收服務」）接收交易文件，則客戶確認其理解並接受以下安排："
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(a)",
          content:
            "使用接收服務需要客戶提供和指定的適當的硬件和軟件，互聯網接收服務以及特定電子郵件地址，移動電話號碼或其他電子地址，以接收本公司的電子郵件，短訊或其他電子通知；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(b)",
          content:
            "互聯網，電子郵件，短訊和其他電子信息服務可能會受到某些科技風險和干擾影響；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(c)",
          content:
            "撤銷對接收服務的同意應由客戶按照第8.6條（交付方式）規定的方式預先發出此類通知；和"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(d)",
          content: "客戶可能被要求為以下方面支付合理的費用："
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "    (i)",
          content:
            "獲取不再可通過電子方式（包括電子服務）接收和下載的任何交易文件的副本；或"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "    (ii)",
          content:
            "要求公司除提供接收服務的請求外，還通過其他方式向其提供交易文件。"
        },
        {
          NumScale: "9",
          isNumBold: true,
          label: "外幣",
          content: ""
        },
        {
          NumScale: "9.1",
          isNumBold: false,
          label: "貨幣兌換：",
          content:
            "在不影響上文第2.4條（本公司拒絕的權利）的一般性的情況下，本公司保留權利，在毋須給予任何原因下，拒絕客戶需要從一種貨幣轉為另一種貨幣以進行賣出或買入任何投資產品的任何指示，或在其他情況下拒絕為其他目的（包括為分派股息的目的）進行貨幣兌換。倘本公司接納客戶任何進行賣出或買入任何投資產品指示，或為任何其他目的進行任何貨幣兌換，本公司應全權決定按照當時現行貨幣市場匯率進行有關的貨幣兌換。此外，本公司可於任何帳戶按本公司全權釐定為當時現行貨幣市場匯率的匯率，兌換款項為任何貨幣及從任何貨幣兌換款項。在進行貨幣兌換交易時，本公司作爲主事人身份行事。該兌換可為下列目的進行︰（i）執行任何指示或交易，或（ii）計算、清償、收回應收客戶的任何借項結餘或應付客戶的貸項結餘，或（iii）與本協議有關的任何其他目的。"
        },
        {
          NumScale: "9.2",
          isNumBold: false,
          label: "人民幣：",
          content: "如有以人民幣計價的交易，客戶同意並確認："
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(a)",
          content: "人民幣受外匯管制且有可能不可兌換的風險；及"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(b)",
          content: "除非本公司另有規定，以人民幣計價的交易應以人民幣結算。"
        },
        {
          NumScale: "10",
          isNumBold: true,
          label: "投資產品的保管",
          content: ""
        },
        {
          NumScale: "10.1",
          isNumBold: false,
          label: "一般：",
          content:
            "在不影響上文第2.客戶確認及同意，根據本協議通過結算系統或在結算系統中不時獲得和/或持有的投資產品將在適用法規規限下及按照適用法規持有。"
        },
        {
          NumScale: "10.2",
          isNumBold: false,
          label: "保管：",
          content:
            "本公司或本公司的任何有聯繫實體根據本協議持作保管的任何投資產品可由本公司全權及在適用法規規限下︰"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(a)",
          content:
            "（如為可註冊投資產品）以客戶或本公司或本公司代名人名義註冊；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(b)",
          content:
            "以保管方式記存於本公司在有關市場於本公司的有聯繫實體或任何其他合資格為投資產品及相關文件提供保管安排的機構持有並指定為信託或客戶帳戶的獨立帳戶；或"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(c)",
          content:
            "且在任何上述情況下，概不構成本公司作為無力償債或清盤用途的資產的部分，惟應於委任臨時清盤人、清盤人或類似人員處理本公司全部或任何部分業務或資產後儘快退回予客戶。"
        },
        {
          NumScale: "10.3",
          isNumBold: false,
          label: "託管人：",
          content:
            "客戶委任本公司作為客戶在本協議規限下向本公司或其任何分託管人或代名人交付並獲本公司接納的所有現金及投資產品的託管人。本公司有權按其酌情認為適當的條款將該等現金或投資產品存入其他公司或機構。該等現金或投資產品可能與本公司的其他客戶的現金或投資產品一併組合存託（但不會與本公司本身帳戶持有的現金或投資產品一併組合存託）。"
        },
        {
          NumScale: "10.4",
          isNumBold: false,
          label: "組合：",
          content:
            "客戶確認並同意,當客戶的資產與其他人士的資產組合及共同持有時，客戶的個人權益不可以獨立文件、記錄或擁有權或所有權證據予以識別。"
        },
        {
          NumScale: "10.5",
          isNumBold: false,
          label: "向客戶轉讓：",
          content:
            "受限於第10.7條（完全清償責任）的規定，本公司在合理可行的情況下將盡快在客戶指示後："
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(a)",
          content:
            "促使不時於帳戶的任何投資產品以客戶或客戶書面通知本公司作為其代名人的人士的名義註冊，或倘如此指示，向客戶或代名人交付陳述或證明投資產品的文件，據此投資產品將不再於帳戶持有；及"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(b)",
          content:
            "從帳戶將客戶指示指定的任何金額轉撥至客戶指示的客戶銀行帳戶，而該轉撥將視為充分解除本公司向客戶作出付款的義務。"
        },
        {
          NumScale: "10.6",
          isNumBold: false,
          label: "轉授/分託管人：",
          content:
            "受限於適用法規，客戶不可撤銷地授權本公司按第2.5條款（公司轉授）所述方式，委任一名或多名轉授/分託管人，不論在香港以內或以外，在任何期間內都要履行本公司的托管和保管職責。"
        },
        {
          NumScale: "10.7",
          isNumBold: false,
          label: "完全清償責任：",
          content:
            "本公司在第10.5條款（向客戶轉讓）中的義務應受限於本協議的其他規定，特別是第16條款（押記）的規定，以及本公司要求在客戶提取任何款項之前全面清償所有責任的權利。本公司可在不通知客戶的情況下，在根據第10.5條款（向客戶轉讓）進行登記或轉讓前，以帳戶結餘金額清償任何或所有負債，或以其它方式要求客戶在根據第10.5條款（向客戶轉讓）進行登記或轉讓前支付有關款項。"
        },
        {
          NumScale: "10.8",
          isNumBold: false,
          label: "表決權等：",
          content:
            "客戶在此授權本公司按照其與客戶投資產品有關的指示行事，包括行使投票權及投資產品所附帶的其他權利。儘管有上述規定，本公司可完全自行以其絕對酌情權決定拒絕根據任何指示行事，而無須給予任何理由。本協議的任何規定均不得以任何方式使本公司承擔通知客戶或就出席會議採取任何行動和在該等會議上表決的任何責任。除適用法規另有規定外，本公司無義務就其收到的與投資產品相關的通知、通訊、轉授書及其他文檔，或向客戶發送該等文檔或發出收到該等文件的任何通知。本公司有權就其根據客戶指示採取的任何行動向客戶收取服務費。"
        },
        {
          NumScale: "10.9",
          isNumBold: false,
          label: "股息等：",
          content:
            "本公司將向相關帳戶支付客戶與投資產品相關的所有股息、分紅、利息、息票或利益。"
        },
        {
          NumScale: "10.10",
          isNumBold: false,
          label: "無義務通知或行使權利：",
          content:
            "在不影響第10.8條款（表決權等）的一般性效力的前提下，如果客戶的投資產品以本公司或本公司指定的任何其他人士的名義（但非以其他方式）註冊，則本公司可以但並無義務："
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(a)",
          content:
            "將本公司收到的與該等投資產品相關的資訊、通知及其他通訊通知客戶（但無義務在就投資產品中提及的任何事項向本公司發出指示的充足時間內將該等資訊、通知及其他通訊轉發給客戶，亦無義務調查或參與或採取任何積極行動，但根據客戶發出的具體指示（本公司接受該等指示），並根據本公司可能要求的條件、賠償及合理費用撥備進行的除外），在未收到或延遲收到客戶發出的具體指示的情況下，不得採取行動，並且就相關事項的任何違約選擇權應適用；及"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(b)",
          content:
            "行使、認購、採用或以其他方式處置與客戶投資產品相關的公司認為合適的、對客戶具有約束力的權利或新事項，除非本公司已實際收到客戶的相反指示（且本公司接受該等指示），但根據適用法規，本公司不會採取可能導致本公司或其指定人有義務披露權益的任何行動。"
        },
        {
          NumScale: "10.11",
          isNumBold: false,
          label: "進一步行動：",
          content:
            "客戶授權本公司及其代名人在提供託管服務時，採取一切為遵守任何適用法規所需的行動，包括就帳戶內的現金或投資產品代扣代繳及/或支付應付的稅款或稅項。客戶確認，對於本公司或其指定人士持有的與投資產品相關的任何催繳、分期付款或其他付款，本公司及其代名人均不承擔任何責任。"
        },
        {
          NumScale: "10.12",
          isNumBold: false,
          label: "投資產品的返還：",
          content:
            "無論因何種原因終止安全託管服務，本公司有權將客戶託管的全部資產返還給客戶（風險和費用由客戶自行承擔），包括將與本公司最初託管或接受的投資產品序號或標識不一致的投資產品返還給客戶。"
        },
        {
          NumScale: "10.13",
          isNumBold: false,
          label: "無託管：",
          content:
            "提供安全託管服務並不使本公司成為客戶或任何客戶資產的受託人，除非任何該等資產以本公司或本公司的代名人的名義登記，在這種情況下，本公司僅作為被動受託人行事。除本協議規定的義務外，本公司就客戶資產不承擔任何其他義務。"
        },
        {
          NumScale: "10.14",
          isNumBold: false,
          label: "客戶責任：",
          content:
            "任何投資產品轉讓時，客戶應負責安排第三方將投資產品交付給客戶或由客戶接收，且任何手續費、轉帳費或託管費等均由客戶自行承擔。"
        },
        {
          NumScale: "10.15",
          isNumBold: false,
          label: "相同類別和面額：",
          content:
            "本公司代表客戶購買或取得的投資產品的交付、在安全保管下或以客戶名義登記的任何義務應通過以客戶或其指定人的名義交付、持有或登記與本公司最初代表客戶存儲、轉讓或取得的投資產品的面額和名義金額相同的同類投資產品的方式履行。"
        },
        {
          NumScale: "10.16",
          isNumBold: false,
          label: "客戶風險：",
          content:
            "本公司和/或其代名人根據本協議為客戶或代表客戶存放或持有的投資產品應由客戶自行承擔風險，本公司無義務就任何種類的風險為任何該等產品投保，該等義務應由客戶自行承擔。"
        },
        {
          NumScale: "10.17",
          isNumBold: false,
          label: "處置：",
          content:
            "根據《證券及期貨（客戶證券）規則》（香港法例第571H章）第6（3）條的規定，本公司獲授權為處置或促使本公司的有聯繫實體處置客戶的任何證券或押記資產，以解決客戶或代表客戶欠本公司、有聯繫實體或第三方的任何債務（且公司有絕對的酌情權決定要處置的證券或押記資產）。"
        },
        {
          NumScale: "11",
          isNumBold: true,
          label: "佣金、收費和支出",
          content: ""
        },
        {
          NumScale: "11.1",
          isNumBold: false,
          label: "佣金及收費：",
          content:
            "客戶應就本公司在本公司提供的收費表中指明或不時另行通知客戶的本公司服務（包括提供電子服務），支付佣金、費用、收費、經紀佣金、溢價或其它報酬。本公司保留不時修改其費用表及該等其他告示的權利。"
        },
        {
          NumScale: "11.2",
          isNumBold: false,
          label: "維護費：",
          content:
            "本公司可能會向不時指定的任何期間內就沒有交易活動的任何帳戶上按月收取維護費，本公司將通知客戶該相關收費。"
        },
        {
          NumScale: "11.3",
          isNumBold: false,
          label: "費用及開支：",
          content:
            "客戶須就本公司就交易、帳戶及/或提供服務而招致的所有費用及開支，包括應付予任何經紀人、託管人、代理人及代名人的費用、印花稅、過戶費、登記費、稅項、股票結算費、有關交易所、結算所或市場徵收的征費、利息及其它手續費或開支，負上全面彌償責任。"
        },
        {
          NumScale: "11.4",
          isNumBold: false,
          label: "資金轉帳手續費：",
          content:
            "客戶同意，如因任何由客戶發起的任何資金轉帳而引致需要向客戶收取行政費、匯款手續費及銀行代理費，將由客戶承擔。客戶亦同意，如有任何向本公司支付的款項或當客戶將資金轉帳到帳戶時，必須先扣除所有收費及應收費用。客戶授權本公司代表支付上述收費及應收費用（如適用）。"
        },
        {
          NumScale: "11.5",
          isNumBold: false,
          label: "從帳戶中扣款：",
          content:
            "本公司獲客戶授權，可隨時向任何帳戶收取或扣除任何佣金、費用、收費、經紀佣金、酬金、征費、稅項及客戶須支付的其他費用及開支，而無須事先通知客戶。"
        },
        {
          NumScale: "11.6",
          isNumBold: false,
          label: "全額支付：",
          content:
            "客戶應在到期日以本公司指定的方式以立即可用的資金（或公司自行確定並可接受的其他資金）並以本公司自行要求的貨幣向本公司支付款項，不得進行任何扣除、抵銷、反訴、預扣或設定任何種類的條件，但如果法律強制客戶進行該等預扣，則客戶應支付的金額應予以增加，以使本公司實際收到的淨額等於如未預扣則本應收到的金額。"
        },
        {
          NumScale: "12",
          isNumBold: true,
          label: "稅項",
          content: ""
        },
        {
          NumScale: "12.1",
          isNumBold: false,
          label: "客戶責任：",
          content:
            "客戶全權負責處理並履行所有適用法規項下的所有稅務問題、責任和義務。客戶應向其稅務顧問尋求獨立稅務專業意見，據以確定自己的納稅立場、責任和義務。本公司不對客戶的任何稅務問題、責任或義務提供諮詢或處理。"
        },
        {
          NumScale: "12.2",
          isNumBold: false,
          label: "提供資訊要求：",
          content:
            "經本公司合理要求或任何相關司法轄區的稅務機關和/或任何其他機關要求，客戶應簽署並提交公司可能要求的任何表格、證明或文檔，並提供本公司可能要求的必要資訊和協助（包括與共同報告標準相關的資訊和協助）。"
        },
        {
          NumScale: "12.3",
          isNumBold: false,
          label: "外國帳戶稅務合規法案（FATCA）：",
          content:
            "在不影響第12.2條款（提供資訊要求）的情況下，客戶承諾向本公司提供公司要求的資訊、文檔和證明，以履行適用的跨司法轄區稅務合規規則規定的義務。這包括但不限於："
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(a)「外國帳戶稅務合規法案（FATCA）」",
          content: "指："
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(i)",
          content:
            "《1986年美國國內收入法》（及其修訂）第1471條至第1474條或其任何修訂或後續版本；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(ii)",
          content:
            "政府與監管機構就第（i）段達成的任何政府間協議、諒解備忘錄、承諾及其他安排，包括香港政府簽訂的協議；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(iii)",
          content:
            "本公司與美國國稅局或其他監管機構或政府機構根據第（i）段或與第（i）段相關簽訂的協議；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(iv)",
          content:
            "美國、香港或其他地方根據任何上述規定通過的任何法律、規則、法規、解釋或慣例；及"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(b)",
          content:
            "稅務資訊共用安排，指任何本地或外國法律、法規和規則，包括但不限於外國帳戶稅務合規法案及相關規章制度項下的義務，以及影響本公司的其他國際交流安排。"
        },
        {
          NumScale: "12.4",
          isNumBold: false,
          label: "彌償：",
          content:
            "在不限制客戶提供的任何其他彌償的原則下，客戶應按要求就因客戶指示、帳戶或本公司向客戶提供服務（包括因客戶未能遵守本第12條款的規定）而引致的任何責任、合理損失或開支（包括稅款及征費）向本公司、高盈證券成員及其代理人作出賠償。"
        },
        {
          NumScale: "13",
          isNumBold: true,
          label: "金錢和非金錢利益",
          content: ""
        },
        {
          NumScale: "13.1",
          isNumBold: false,
          label: "金錢利益：",
          content:
            "客戶確認，本公司或與本公司有關連的任何人士可從經紀商、產品發行人或其他第三方處獲得金錢利益。"
        },
        {
          NumScale: "13.2",
          isNumBold: false,
          label: "不可量化：",
          content:
            "本公司可獲得金錢利益，該等金錢利益的金額在交易達成之前或交易達成之時不可量化。"
        },
        {
          NumScale: "13.3",
          isNumBold: false,
          label: "非金錢利益：",
          content:
            "客戶確認並同意，公司或與其有關聯的任何人士可能從經紀商、產品發行人或其他第三方獲得公司認為適當的非金錢利益，包括但不限於服務、贊助、廣告、研究分析、差旅、住宿和娛樂。"
        },
        {
          NumScale: "13.4",
          isNumBold: false,
          label: "獨立性：",
          content: "除非本協議或公司另有規定，公司不是獨立的中介人，理由如下："
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(a)",
          content:
            "本公司將收取由其他人士（可能包括產品發行人）就其向客戶分銷投資產品而提供的費用、佣金或任何其他金錢收益。有關詳情，客戶應參閲本公司在任何投資產品交易達成之前或達成之時針對金錢利益的進一步披露；及/或"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(b)",
          content:
            "本公司將從其他人士處取得非金錢利益，或與本公司可能分銷給客戶的投資產品的發行人有緊密聯繫或其他法律或經濟關係。"
        },
        {
          NumScale: "13.5",
          isNumBold: false,
          label: "向第三方付款：",
          content:
            "客戶同意授權本公司在適用法規允許的範圍内向第三方提供和支付佣金、回扣、商品、服務和/或其他利益，以交換該第三方推廣本公司的服務、推薦客戶給本公司及開展其他類似活動。"
        },
        {
          NumScale: "14",
          isNumBold: true,
          label: "電子服務",
          content: ""
        },
        {
          NumScale: "14.1",
          isNumBold: false,
          label: "電子服務：",
          content:
            "公司可不時全權酌情決定向客戶提供某些電子服務。如若如此，則本第14條應適用。"
        },
        {
          NumScale: "14.2",
          isNumBold: false,
          label: "正確輸入及依賴：",
          content:
            "客戶同意本公司有權依賴正確輸入的登入識別碼及密碼，以確定給予本公司的任何指示是否為客戶的指示，並依據該假設行事。客戶應對透過電子服務輸入所有資料及透過使用電子服務向本公司發出的所有指示承擔全部責任，即使該等資料或指示可能是由經授權或未經授權代表客戶發出該等指示的第三方發出。客戶承諾，如在使用登錄識別碼和密碼登錄時有任何困難，將立即通知本公司。"
        },
        {
          NumScale: "14.3",
          isNumBold: false,
          label: "個人：",
          content: "客戶應為其登錄識別碼和密碼的唯一授權使用者。"
        },
        {
          NumScale: "14.4",
          isNumBold: false,
          label: "保管：",
          content:
            "客戶對其登錄識別碼和密碼的保密性、安全性和保管負全部責任。客戶承諾，若客戶懷疑該登入識別碼或密碼已被洩露、遺失、被盜或未經授權使用，將立即通知本公司。"
        },
        {
          NumScale: "14.5",
          isNumBold: false,
          label: "禁止性規定：",
          content: "客戶使用電子服務時不得有下列行為："
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(a)",
          content:
            "未經本公司明示書面同意，以任何方式翻錄、轉發、散播、出售、發布、刊登、廣播、傳閱、利用（無論是為商業利益還是其他目的）從電子服務獲得的或通過電子服務獲得的數據及/或報告，且不得將資訊用於任何不正當或非法目的或違反適用法規；/或"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(b)",
          content:
            "進行任何添加，修改，調整或變更以篡改任何部分或破壞於電子服務上或通過電子服務可獲得的任何資訊或服務；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(c)",
          content:
            "允許將任何設備或軟件以任何方式連結或通信，或與任何其他服務或系統結合使用，使得從本公司獲得的任何資訊和/或報告可能被該等設備或軟件取用，使用，存儲或重新分發；及/或/或報告，且不得將資訊用於任何不正當或非法目的或違反適用法規；/或"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(d)",
          content:
            "使用除協議規定或公司可能不時發布的其他指示所規定的電子服務下可用的設施。"
        },
        {
          NumScale: "14.6",
          isNumBold: false,
          label: "暫停和終止：",
          content: "公司可根據其完全及絕對酌情權不時在不通知客戶的情況下："
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(a)",
          content:
            "修訂、修改、暫停或終止電子服務的運行和/或該等電子服務的使用條款；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(b)",
          content: "暫停或終止客戶進入或使用電子服務；及/或"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(c)",
          content:
            "停用登入識別碼及密碼，並無須對客戶負責就客戶因上述任何行動而可能蒙受的任何損失、損害、費用、收費或開支。"
        },
        {
          NumScale: "14.7",
          isNumBold: false,
          label: "固有漏洞：",
          content:
            "客戶接受並確認，電子系統和技術（包括電子服務及本公司使用的該等其他系統和技術）在本質上容易出現黑客攻擊、中斷、延誤或故障等現象。如電子服務未能為客戶提供時，客戶必須自行採取替代方案以執行指示。"
        },
        {
          NumScale: "14.8",
          isNumBold: false,
          label: "責任限制：",
          content:
            "本公司對客戶不論如何使用電子服務所引致或引起的任何損失，損害，成本，收費或開支概不負責，包括但不限於："
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(a)",
          content: "丟失或未經授權的使用登錄識別碼或密碼的；"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(b)",
          content: "未經授權使用或進入電子服務；或"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(c)",
          content:
            "無論出於何種原因，電子服務的任何延誤、錯誤、失敗或無法進入或不可用。"
        },
        {
          NumScale: "14.9",
          isNumBold: false,
          label: "知識產權",
          content: ""
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(a)",
          content:
            "除非另有說明，本公司或某些其他第三方（包括但不限於經紀，合作夥伴或保薦人）（合稱為「權利持有人」）是通過電子服務提供和電子服務上發布的材料的所有知識產權的擁有人或被授權人。這些內容受到全球版權法和條約的保護。所有此類權利一律保留。"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(b)",
          content:
            "在使用電子服務時，客戶同意不作出任何會違反、侵犯、損害或以任何方式影響權利持有人的知識產權，包括但不限於本公司網站及軟件的所有部份（「知識產權」）的事情，並應采取所有必要措施以保障及保護此等知識產權。由電子服務提供或產生的數據或報告中的所有知識產權（不論是版權或其他形式的知識產權）均純粹歸屬於及將保留為權利持有人的專有財產。"
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "(c)",
          content:
            "如未事先獲得相關權利持有人許可，客戶不得上傳，發表，翻錄，轉發，傳播，出售，發布，廣播，傳閱，利用或分發通過電子服務提供而受版權或其他知識產權（以及公開權和私隱權）保護的任何數據，軟件或其他材料，也不得將其或其任何部分用於個人使用或其日常業務以外用途。"
        },
        {
          NumScale: "15",
          isNumBold: true,
          label: "留置權",
          content: ""
        },
        {
          NumScale: "",
          isNumBold: false,
          label: "",
          content:
            "在不影響在本協議項下授予公司的任何其他權力、許可權、權利和補償的情況下，在欠公司、其代名人和高盈證券或任何關聯公司的所有款項均已被全額支付、清償或解除之前，公司有權以留置權的形式保留並預留所有款項、投資產品（包括但不限於為客戶或代表客戶購買的或客戶擁有帳戶權益的任何及所有投資產品）以及公司、其代名人或任何高盈證券成員不時持有的客戶的其他財產，無論是為安全保管還是為其他目的持有，還是根據本協議或以其他方式持有，公司有權以本公司認" +
            "為合適的價格收取、出售或變現該等款項、投資產品和財產的全部或任何部分，並在扣除費用後使用收益清償客戶欠公司、其代名人或任何高盈證券成員的任何款項。經公司要求，客戶應自行承擔費用和支出，向公司或公司指定的任何其他主體執行將該等金錢、投資產品和財產的法定所有權歸屬於公司或公司指定的任何其他主體的所有轉讓並開展所有必要事項。"
        },
        {
          NumScale: "16",
          isNumBold: true,
          label: "押記",
          content: ""
        }
      ]
    },
    customer_agreement1: {
      page_title: "證券及/或期貨客戶協議",
      // h: "一般條款和條件",
      p1: [
        "高盈證券有限公司",
        "香港尖沙咀港威大廈 6 座 31 樓 3102 室",//---
        "中央編號BPS863，根據《證券及期貨條例》獲發牌進行第1類（證券交易），第2類（期貨合約交易）及第5類（就期貨合約提供意見）受規管活動",
        "客戶協議書",
        "一般條款和條件"
      ],
      main: [
        "1 定義和詮釋",
        "1.1 定義：於此等條款內，除非文義另有所指，下列詞語具有以下涵義：" +
          "「帳戶」指以客戶名義於相關公司不時開立和維持的任何一個或多個任何性質的帳戶，包括但不限" +
          "於證券現金帳戶、股票期權帳戶、證券保證金帳戶和期貨帳戶，以按本協議條款規定取得服務及/或" +
          "進行交易；",
        "「開戶表格」指客戶不時按本公司規定或接納之形式填妥的任何及所有開戶表格、客戶資料表格及" +
          "文件，包括與任何開戶表格或文件相關或隨附的任何附註和聲明，這可能按照本協議不時作出修訂；",
        "「協議」包括此等條款、此等條款之附件、開戶表格及其他文件；",
        "「反洗錢條例」指《打擊洗錢及恐怖分子資金籌集條例》（香港法例第 615 章）;",
        "「適用法規」指香港或其他地方本公司、客戶或其他相關人士受其規限的任何監管機構、稅務機構、" +
          "政府機構、交易所、結算所、結算系統或專業團體的任何法律、規例或指令，或任何規則、指示、指" +
          "引、守則、常規、程序或慣例（不論是否具有法律效力）;",
        "「有聯繫實體」具有證券及期貨條例所賦予之涵義；",
        "「授權人士」對個人客戶而言，指該客戶及開戶表格中指明為授權人士的任何人士，對公司客戶而" +
          "言，則指開戶表格中指明為授權人士的任何人士，而在兩種情況下均包括由客戶不時以書面聲明通" +
          "知本公司的受委任替換或增補授權人士的任何其他人士，上述委任（受本公司的批准所限）由本公" +
          "司實際收到通知時起生效；",
        "「營業日」指香港公司辦公的日子（星期六及星期日，以及香港於上午九時正至下午五時正任何時" +
          "間懸掛黑色暴雨警告或八號或以上颱風訊號的日子除外）；",
        "「中央結算系統」指香港結算營運的中央結算及結算系統；",
        "「結算系統」就任何市場而言，指不時用於進行證券或合約交易的交易結算系統（包括中央結算系" +
          "統、衍生工具結算系統及場外衍生產品結算系統）;",
        "「結算所」就任何市場而言，指不時為有關買賣的任何證券或合約提供結算及／或交收服務的實體" +
          "（包括香港結算、聯交所期權結算所、香港期貨結算及場外結算公司）;",
        "「客戶」或「你」或「閣下」指已開立及維持帳戶的人士，並且在文義許可的情況下包括授權人士。",
        "「你的」須據此解釋;及",
        "(a) 在客戶是自然人的情況下，不論他是否破產，應包括其遺產代理人、財產接管人或受託人;",
        "(b) 在客戶是獨資經營機構的情況下，不論他是否破產，應包括獨資經營者、其遺產代理人、財產" +
          "接管人或受託人、以及該商號的繼任者；",
        "(c) 在客戶是合伙經營的情況下，不論他是否破產，應包括於維持帳戶期間不時擔任該商行合夥人" +
          "之合夥人，以及其各自之遺產代理人、財產接管人或受託人、以及該商號的繼任者;及",
        "(d) 在客戶是公司的情況下，應包括該公司、及其繼任者和受讓人；",
        "「操守準則」指由證監會發出，並可不時被修訂或替代的《證券及期貨事務監察委員會持牌人或註" +
          "冊人操守準則》；",
        "「押記資產」指：",

        "(a) 不時在帳戶內的一切投資產品、應收賬項、款項及任何其他財產；",
        "(b) 客戶現在或將來由本公司、其代名人或任何高盈證券成員不時管有、保管或控制及作任何用途" +
          "的一切其他資產品、應收賬項、款項及任何財產；",
        "(c) 所有附加或替代的投資產品；以及",
        "(d) 以上任何一项或與其有關並透過贖回、紅利、優先、選擇或其他形式於任何時間累計或提供的" +
          "一切已付或應付股息、利息、權利、權益、款項或財產;",
        "「抵押品」指任何：",
        "(a) 客戶在本協議下設立的產權負擔；及",
        "(b) 客戶授予的其他現存或未來的產權負擔，" +
          "並以本公司、其代名人及/或任何高盈證券成員作為受益人以擔保債務的清償或解除；",
        "「本公司」或「我方」或「我們」（個別或統稱）指：",
        "高盈證券有限公司（中央編號 BPS863），一間在香港註冊成立並獲證監會發牌進" +
          "行第一類（證券交易）、第二類（期貨合約交易）及第五類（就期貨合約提供意見）受規管活動的公" +
          "司，及其繼任者和受讓人，包括（如文義所指）其代理、代名人、代表、主管人員及僱員" +
          "如文義所指乃第一類、第二類及第五類受規管活動，「本公司」或「我方」或「我們」應指" +
          "高盈證券有限公司。",
        "如需進一步了解詳情以及本公司的最新註冊狀況，請參閱本公司網站。",
        "此外，「我方的」將按此詮釋；",
        "「商品」指香港期交所規則、規例及程序界定的商品及／或本公司就本協議而言接納的任何商品，" +
          "不論是否能夠交付，包括但不限於農業商品、金屬、貨幣、股份、利率、指數（不論股市指數或其" +
          "他）或其他金融合約、能源、權利或權限，而如文義所指，包括上述任何一項的合約，而「多種商" +
          "品」將按此詮釋；",
        "「複雜產品」具有操守準則所賦予之涵義；",
        "「合約」視乎文義指任何在附件 III（期權交易）描述的期權合約、期貨合約（定義見於附件 IX（期" +
          "貨交易））及/或期權合約（定義見於附件 IX（期貨交易））中按上下文可能要求所描述的期權合約，" +
          "多份合約將按此詮釋；",
        "「法團專業投資者」屬於《證券及期貨（專業投資者）規則》（香港法例第 571D 章）第 4、6 或 7 條" +
          "所指的信託法團、法團或合夥；",
        "「衍生工具結算系統」指香港期交所結算所和聯交所期權結算所營運的衍生產品結算及交收系統；",
        "「短欠」指任何帳戶不時的負結餘，不論以任何方式及不論如何產生；",
        "「解散」，就一名人士而言，亦包括該名人士解散、結業、清盤或破產，以及根據註冊成立、成立、" +
          "或駐在或經營業務或擁有資產的任何司法管轄區法律進行的任何同等或類似程序，而「已解散」將" +
          "按此詮釋；",
        "「電子服務」指本公司及/或其代表為向客戶提供服務之目的而提供的任何電腦或電子服務、系統或" +
          "設施（包括但不限於短訊服務（俗稱短訊）、本公司網站/手機應用程式以及演算交易服務），包括但" +
          "不限於使客戶能在香港或其它地方發出執行交易的電子指示及接收資訊及通訊的服務；",

        "「產權負擔」指任何按揭、押記、質押、債券、留置權、以擔保方式轉讓、財務租賃、遞延購買、售" +
          "後購回或售後回租安排、押貨預支、賣方保留所有權、第三方權利或權益，或就任何資產而給予或" +
          "招致的其他產權負擔或抵押權益，或讓任何債權人或任何協議對任何其他債權人或協議享有優先權" +
          "的任何安排，並包括就設立或授予上述任何一項而訂立的任何協議或義務；",
        "「違約事件」指本協議中描述的任何事件，包括但不限於第 21.1 條（違約）中所列的任何事件以及" +
          "附件 I（保證金融資）第 3.5 條（未能滿足追收保證金要求）中所列的事件；",
        "「交易所」，就任何市場而言，指進行投資產品買賣的交易所；",
        "「交易所買賣衍生產品」，指屬於香港或證監會不時指定的司法管轄區的交易所內買賣的衍生產品的" +
          "複雜產品；",
        "「金融糾紛調解中心」指金融糾紛調解中心有限公司;",
        "「基金」指透過本公司分銷或提供的任何單位信託、投資基金、互惠基金或其他集體投資計劃；",
        "「期貨帳戶」指於本公司開設以主要用作購入、投資、沽售、買賣、達成、交易、收購、持有、轉" +
          "讓、訂立、結算、交收、處置或以其他方式處理商品及／或合約之用途（不時由客戶指示本公司執" +
          "行）的帳戶；",
        "「香港期交所結算所」指香港期貨結算有限公司及其繼任人和受讓人，包括，如文義所指，其代理" +
          "人、代名人、代表、主管人員及僱員；",
        "「香港交易所」指香港交易及結算所有限公司；",
        "「香港期交所」指香港期貨交易所有限公司及其繼承人和受讓人，包括，如文義所指，其代理、代" +
          "名人、代表、主管人員及僱員；",
        "「香港結算」指香港中央結算有限公司（香港交易所全資子公司）以及其繼任人和受讓人，包括，" +
          "如文義所指，其代理、代名人、代表、主管人員及僱員；",
        "「香港」指中華人民共和國香港特別行政區；",
        "「香港監管機構」指聯交所（包括有關結算所）、證監會及／或於香港對本公司或交易擁有司法管轄" +
          "權的任何其他監管機構；",
        "「高盈證券」指高盈證券有限公司，其子公司、關聯公司及有聯繫實體；「高盈金" +
          "融成員」將按此詮釋；",
        "「個人專業投資者」屬於《證券及期貨（專業投資者）規則》（香港法例第 571D 章）第 5 條所指的" +
          "個人；",
        "「機構專業投資者」屬於證券及期貨條例附表 1 第 1 部第 1 條「專業投資者」的定義第（a）至（i）" +
          "段所指的人士；",
        "「指示」指任何由客戶（無論是本人或通過任何授權人士）以任何方式（包括但不限於口頭、電話、" +
          "傳真、電郵、互聯網或任何其他電子方式（包括通過電子服務）或任何書面形式）給予或傳達予本" +
          "公司的授權、要求、申請、指示或指令（以任何形式及任何方式發送），或者是本公司合理地認為是" +
          "客戶的授權、要求、申請、指示或指令，並包括任何撤銷、駁回或修改任何過往的授權、要求、指示" +
          "或指令的授權、要求、指示或指令；",
        "「投資者賠償基金」指根據證券及期貨條例第 236 條成立的投資者賠償基金；",
        "「投資諮詢服務」指本公司就任何投資產品不時向客戶提供的任何投資意見或資產策略配置建議；",
        "「投資產品」指證券、合約及其他金融或投資產品（不論如何描述）；",

        "「負債」指客戶有關任何帳戶及本協議欠負、結欠本公司、其代名人或任何高盈證券成員或產生的" +
          "所有款項、債項、負債及義務，不論實際或或然，現在或未來、當事或附帶、有抵押或無抵押，或客" +
          "戶於任何帳戶或不論以任何方式或貨幣成為或可能向本公司負責（不論作為主要債務人或保證人，" +
          "亦不論單獨或聯同任何其他人士，及不以任何名義、身份、形式或格式），包括因貨幣、股票經紀、" +
          "保證金證券交易及其他金融交易產生的所有金錢義務，連同利息（由適用到期日起或在其他情況下，" +
          "由請求日期起至本公司全數接獲實際及無條件付款日期（包括該日在內））、法律費用及本公司、其" +
          "代名人或任何高盈證券成員有關該款項、負債及義務產生的所有其他成本、收費及開支（包括但不" +
          "限於收回或嘗試收回該款項、債項、負債及／或義務或強制執行本公司在本協議下的權利及權力索" +
          "償產生的任何匯兌虧損及開支）；",
        "「登錄識別碼」指為接達電子服務而與密碼結合使用的某些資訊；",
        "「市場」指場外市場或任何交易所、適用交易商協會或本公司為投資產品提供的任何市場，不論於" +
          "香港或境外；",
        "「重大不利影響」指以下各項發生的重大不利影響：",
        "(a) 客戶整體的業務，運營，財產，財務及其他狀況或發展前景；",
        "(b) 客戶履行其在本協議或其與公司或任何高盈證券成員簽訂的任何其他協議項下義務的能力；",
        "(c) 任何該等協議的有效性、合法性或可執行性，或本公司在該等協議項下的權利；或",
        "(d) 客戶根據該等協議授予的任何抵押的有效性、合法性或可執行性，或任何該等抵押的優先權和排序；",
        "「其他文件」指客戶或本公司就有關本協議產生或預計進行的任何事宜簽署、接納或向另一方發出" +
          "的表格、函件、通知、結單、確認書及其他文件，以不時經修訂或補充者為準；",
        "「場外交易結算及交收系統」指場外結算公司為支持其結算服務而開發的場外交易結算及交收系統；",
        "「場外結算公司」指聯交所成立的香港場外結算有限公司，作為中央交易對手為場外衍生產品交易" +
          "提供結算及交收服務；",
        "「密碼」指客戶密碼以及與登錄識別碼結合使用的其他加密和安全措施，以使客戶能夠接達電子服務；",
        "「個人資料（私隱）條例」指《個人資料（私隱）條例》（香港法例第 486 章）及根據該條例作出的" +
          "所有附屬法例、規則、守則和指引；",
        "「中國」指中華人民共和國，但不包括香港、澳門特別行政區以及中華民國（台灣）；",
        "「專業投資者」具有證券及期貨條例附表 1 第 1 部第 1 條所賦予之涵義；",
        "「人民幣」指中國的法定貨幣；",
        "「規則」，就任何市場而言，指有關交易所、結算所或結算系統的一般規則、運作程序及其他適用規" +
          "則、慣例、常規、程序及規例，以及其不時之修訂或補充；",
        "「證券」指（a）證券及期貨條例所界定的證券；及（b）任何機構（不論已註冊成立或非註冊成立）" +
          "或任何政府機構不論任何形式或如何發行於市場買賣及就本協議獲本公司接納的任何股份、股票、" +
          "債權證、借貸股份、基金、債券、票據、單位信託、場外交易衍生產品、存款證或其他商業票據或證" +
          "券或其他類似工具，並且按本公司的絕對酌情權，可包括（i）上述任何一項的權利、選擇權或權益" +
          "（不論以單位或其他方式說明）；（ii）上述任何一項的權益或分享權證書、臨時或中期證書、收據或" +
          "認購或購買權證；或（iii）通常稱為證券的任何工具；",

        "「證券現金帳戶」指於本公司的帳戶，以主要進行及記錄本公司按照客戶的指示進行的證券交易；",
        "「證券保證金帳戶」指於本公司的帳戶，以主要用於執行及記錄本公司按照客戶指示利用信貸融資" +
          "（定義見於附件 I（保證金融資））進行的交易；",
        "「證券交易」指本公司按客戶指示進行的任何交易，以買入、投資、認購、賣出、交換或以其他方式" +
          "買賣或處置任何證券，包括以本公司或本公司代名人的名義持有證券；",
        "「聯交所」指香港聯合交易所有限公司及其繼任人及承讓人，包括，如文義所指，其代理、代名人、" +
          "代表、主管人員及僱員；",
        "「聯交所期權結算所」指香港聯合交易所期權結算所有限公司及其繼任人及承讓人，包括，如文義" +
          "所指，其代理、代名人、代表、主管人員及僱員；",
        "「證監會」指香港證券及期貨事務監察委員會及其繼任人和受讓人；",
        "「證券及期貨條例」指《證券及期貨條例》（香港法例第 571 章）及根據該條例作出的所有附屬法例、" +
          "規則、守則和指引；",
        "「賣空指令」，就在聯交所交易的證券而言，具有證券及期貨條例賦予的涵義，以及在其他所有情況" +
          "下，是指代表客戶賣空任何投資產品的指令；",
        "「股票期權帳戶」指於本公司的帳戶，以按照客戶指示進行期權交易，並主要受附件 III（期權交易）" +
          "所載條款的管轄；",
        "「此等條款」指可能不時修訂或補充的一般條款和條件（不包括其附件）；",
        "「交易時段」具有第 5.5 條（交易日）所賦予之涵義；",
        "「交易」指根據本協議預計進行、提供或作出、生效或進行的任何交易、買賣、協議、行動、服務；",
        "「美國」指美利堅合眾國（爲避免歧義，包括其各州、領土、屬地以及哥倫比亞區）；及",
        "「美籍人士」包括",
        "(a) 身為美國公民或居民的任何自然人；",
        "(b) 根據美國或其任何政治分部法律組成或註冊成立的法團、合夥商號或其他業務機構；",
        "(c) 身為上述美國人士的執行人或受託人管理，或收入（不論來源）受美國聯邦所得稅規限的任何遺產或信託；",
        "(d) 交易商或受信人士為上述人士的實益持有的任何帳戶（任何遺產或信託除外）；及",
        "(e) 根據任何司法管轄區的法律組成及註冊成立的任何合夥商號或法團，為由上述人士組成，主要" +
          "用於投資於並非根據一九三三年美國證券法註冊的證券," +
          "但不包括於美國以外為有效業務原因作為當地從事銀行或保險業務及並非主要為投資於根據並非一" +
          "九三三年美國證券法註冊的證券的受規管分行或代理的美國銀行或保險公司任何分行或代理。",
        "1.2 釋義：於此等條款及本協議內：",
        "(a) 「包括」指包括但不限於；",
        "(b) 「控股公司」及「子公司」將分別具有《公司條例》（香港法例第 622 章）賦予的涵義；",
        "(c) 提述條、分條或附表，為此等條款的條、分條或附表，而提述開戶表格指客戶或其代表填妥的" +
          "開戶表格，而倘該資料於其後以向本公司發出通知予以修訂，指經該通知修訂的開戶表格；",
        "(d) 提述條例指不時經修訂、補充、延伸、規範或重新頒佈的香港法例或法律及相關的任何附屬法例；",
        "(e) 提述男性稱謂包括女性及中性，而提述單數包括眾數，反之亦然，而提述人士包括個人、公司、" +
          "機構、商號、法團、法人團體、政府、國家或國家實體、組織、合夥商號或其他實體或機構（不" +
          "論是否為註冊成立，亦不論是否具有法人資格）或前述任何兩者或以上；",
        "(f) 條款的標題僅供參考，並不影響其詮釋；及",
        "(g) 附件構成本協議整體的一部分，除非另有明確說明，否則附件應與本條款及本協議其他部分一起閱讀。",
        "1.3 歧異：倘有任何歧異，有關服務、投資產品、安排或交易的條款將按以下次序適用：（i）有關客戶由" +
          "其提供或接納的任何額外或特定表格或文件（除下述（ii）和（iii）所述部分）；（ii）管轄該表格或文" +
          "件的相關附件，及（iii）適用於該表格或文件的任何一般條款及條件（包括此等條款）。",
        "1.4 適用法規：除本協議外，所有服務、產品、安排及交易將受適用法規規限。",
        "1.5 網站：本公司網站為 www.goingf.hk 或其他本公司可能不時通知客戶的網站。",
        "2 委任、代理範圍及授權",
        "2.1 開戶：客戶應以本公司不時指定之方式開立及維持有關帳戶，以進行交易。",
        "2.2 本公司作為客戶代理人：除非本協議或本公司另有說明，客戶委任本公司，而本公司同意作為客戶" +
          "的代理代表客戶進行交易。本文所載的任何內容，概不構成本公司作為客戶的受託人或受信人士或" +
          "本公司與客戶之間的合夥關係。",
        "2.3 本公司作為主事人與結算所交易：除非本協議或本公司另有規定，就本公司或任何高盈證券成員於" +
          "任何結算所存置的任何帳戶不論該帳戶是否全部或部分就本公司代表客戶進行的任何交易存置，及" +
          "不論客戶是否已向該結算所支付款項，在本公司或任何高盈證券成員與該結算所之間，本公司或該" +
          "高盈證券成員（視乎情況而定）作為主事人進行交易。",
        "2.4 本公司拒絕的權利：儘管有任何相反之規定，本公司可全權酌情在毋須提供任何原因的情況下拒絕" +
          "接納任何指示及／或拒絕向客戶提供其在本協議項下的任何服務。本公司將不會就其不接納或不按" +
          "此指示行事或不發出不接納任何指示的通知以及上述拒絕所產生或有關的任何損失向客戶負責。",
        "2.5 本公司的指派：本公司可全權酌情決定透過任何高盈證券成員、任何交易所或結算所的成員或參與" +
          "者或有關市場的經紀執行客戶的交易。本公司可委任任何其他人士為其代名人、託管人、經紀、存" +
          "託代理或其他代理，旨在或有關向客戶提供服務，並可根據本協議指派任何職責予該名人士。所有" +
          "該等第三方均享有客戶賦予本公司的全部權力及酌情權。本公司獲客戶授權，向本公司根據本第 2.5" +
          "條委任的任何人員披露有關客戶、其授權人士、帳戶及交易的任何個人資料及其他資料。在適用法" +
          "規許可的最大範圍內，本公司將不就該等第三方的行為或不作為向客戶負責。",
        "2.6 授權人士發出的指示：客戶授權本公司接受授權人士就本協議發出或旨在發出的指示。但是，除非" +
          "本公司同意或本協議另有指明，有關向第三方轉讓現金及/或證券的交收指示，必須以書面作出及按" +
          "開戶表格所指定的方式（如有指定）作出。本公司有權以任何理由拒絕執行客戶就任何一項交易發" +
          "出的指示。有關授權人士的委任或變更（受本公司的批准所限）須在本公司實際收到有關通知起不" +
          "時生效。本公司有權（但無義務）執行授權人士代表客戶發出或旨在發出的任何指示，但毋須對客" +
          "戶因此可能遭致的任何損失承擔任何責任。本公司無任何義務核證代表客戶發出或旨在發出的指示" +
          "的真實性，亦無義務核實發出指示人士之身份。",

        "2.7 無職責詢查目的或適當性：本公司無任何職責或義務詢查客戶或任何授權人士發出或聲稱發出的任" +
          "何指示或指令的目的或適當性，亦無任何職責或義務監督根據本協議由任何帳戶所支出的任何資金使用。",
        "2.8 授權書︰客戶同意及謹此不可撤銷地委任本公司並賦予其全面的權力及權限作為客戶的真正及合法" +
          "受權人（在法律許可的全面範圍內）為客戶及代表客戶執行本協議的條款，並於本公司認為在履行" +
          "本條款的目的有所需要或合宜之時，以客戶或本公司本身的名義採取任何行動及簽立任何文件或文" +
          "書，包括但不限於下列目的：",
        "(a) 就任何押記資產執行任何轉讓或轉移；",
        "(b) 完成其對任何押記資產的所有權；",
        "(c) 請求、要求、索求、收取、了結及徹底清償在押記資產項下或因押記資產而引起的到期或將到" +
          "期的任何及所有款項及申索的款項；",
        "(d) 提供有效的收據和解除書，並加簽與任何押記資產有關的任何支票或其他文書或指令；及",
        "(e) 提出任何申索或採取其認為必要和合宜的任何法律行動或法律程序，以保障在本協議項下設定的擔保。",
        "2.9 限制：本公司可於不時認為適當時，訂立與任何帳戶有關及給予指示之有關限制，該等限制包括但" +
          "不限於每日進行交易之最多次數、每筆交易中可處理的不同投資產品的數量和類型、交易中投資產" +
          "品的最低價值或金額、客戶可以購買或出售投資產品的價格、未平倉合約的持倉限制及基金贖回限額。",
        "2.10 非委託帳戶：客戶確認，本公司不會就為客戶作出投資決定及執行交易行使酌情權，除非本公司另" +
          "行通知客戶，在此情況下，客戶可能須訂立委託帳戶協議、授權書及/或本公司可能要求的其它文件，" +
          "惟不得據此解釋為本公司的作為、不作為、指示、允許、默許、批准、安排或同意。",
        "2.11 無建議：根據第 24.1 條（一般）所載為確保合理合適性外，除非本公司與客戶另有約定，本公司並" +
          "未提供投資諮詢服務，因此概不承擔任何招攬出售或建議投資產品的諮詢謹慎責任或義務。如本公" +
          "司向客戶提供與某些金融產品有關的廣告、市場營銷或推廣材料、營銷資料或其他資料訊，該等材" +
          "料或資訊不會單獨構成對該投資產品的招攬或建議。客戶基於該等材料或資料採取或不採取任何行" +
          "動前，應取得獨立專業意見。客戶亦確認︰-",
        "(a) 在投資諮詢服務過程中提及的任何目標或預期收益不代表對任何投資產品的性能的任何保證，估算或預測；",
        "(b) 投資於任何投資產品均有其風險；及",
        "(c) 本公司可就投資顧問服務不時全權及絕對酌情收取費用。",
        "3 常設授權",
        "3.1 常設授權：客戶同意按照本公司指定的形式給予本公司不時要求的常設授權，包括但不限於以下各項：",
        "(a) 《證券及期貨（客戶證券）規則》（香港法例第 571H 章）（包括為附件 I（保證金融資）第 5.1" +
          "條（常設授權）之目的所必需的內容）；及",
        "(b) 《證券及期貨（客戶款項）規則》（香港法例第 571I 章）。",
        "3.2 有效期：常設授權自出具之日起生效。客戶的授權書必須指明有效期，而該段有效期不得超過 12 個" +
          "月。若客戶是專業投資者，則有關限制並不適用。除非及直至客戶以書面形式明確撤回該授權，否" +
          "則任何常設授權一經授予，將一直有效。",

        "3.3 撤銷：在沒有任何尚未清償的負債的情況下，客戶可在不少於 10 個營業日前通知公司撤回該常設授" +
          "權。客戶確認，常設授權被撤銷或未續期可能導致本公司無法向客戶提供服務。",
        "3.4 續期：本公司將於常設授權屆滿前 14 天通知客戶，述明除非客戶於該授權屆滿前提出反對，否則該" +
          "常設授權將被視為已按最後一次授權的相同條款及條件獲續期。",
        "4 指示",
        "4.1 發出指示：客戶可就有關交易、帳戶或本公司的服務以電話、傳真、電子方式（包括電子服務）或本" +
          "公司不時指定的其他通訊方式發出指示。所有指示都必須遵照本公司和客戶之間的安排以書面形式" +
          "發出並（如須簽署）符合於開戶表格向本公司提供的相關式樣簽署，或以其他方式通知本公司并受" +
          "本公司接受（「協議簽署安排」）。在任何情況下，客戶均須遵守該等驗證程序並滿足本公司不時規定" +
          "的其他要求。",
        "4.2 截止時間：本公司有權全面地或就任何指定性質或種類的指示，指定收取指示的任何截止時間，可" +
          "能與任何市場或任何交易所或結算所指定的任何通常截止時間不同。客戶確認及同意，本公司概不" +
          "會就執行本公司於適用截止時間後收取的任何指示的任何延誤或未能執行有關指示承擔責任。",
        "4.3 授權人：任何一名授權人士獲客戶授權代表客戶就帳戶發出指示並簽署有關帳戶及其運作的一切協" +
          "議及相關文件，直到本公司收到客戶內容相反的書面通知為止。客戶向本公司承諾將不時及隨時追" +
          "認並確認任何授權人士代表客戶或聲稱代表客戶發出或簽署的任何指示或協議或文件，包括但不限" +
          "於任何授權人士於被撤銷授權至本公司實際收到撤銷授權通知期間代表客戶或聲稱代表客戶發出或" +
          "簽署的任何指示、協議或文件。客戶同意，如果本公司在收到任何授權人士代表客戶或聲稱代表客" +
          "戶發出或簽署的任何指示、協議或文件時尚未實際收到該授權人士被撤銷授權的通知，則該授權人" +
          "士在被撤銷授權之後代表客戶或聲稱代表客戶發出或簽署的任何指示、協議或文件對本公司的利益" +
          "而言為有效及有作用的指示、協議或文件。上述由任何授權人士簽署或發出或聲稱簽署或發出的所" +
          "有文件或指示（不論口頭或書面）一律被視為在該授權人士權限內簽署或發出的，對客戶具有絕對" +
          "及不可推翻的約束力。客戶有責任確保所有授權人士均遵守本協議，並在任何情況下對所有指示負" +
          "責，即使該等指示是由授權人士或其他第三方發出。",
        "4.4 本公司對指示的信賴：本公司有權視按照此等條款發出的指示為獲客戶全權授權的指示處理。本公" +
          "司有權（但不受約束）就本公司真誠認為適當按照該指示執行交易的情況下根據或依據指示行事或" +
          "採取有關步驟（不論為收購、購買、出售、轉移、處置或在其他情況下買賣投資產品），並獲授權約" +
          "束客戶遵守與本公司或任何其他人士訂立的任何協議或其他安排，或促使客戶為執行該指示進行任" +
          "何其他種類交易或安排，不論交易或安排的性質、或涉及的投資產品的價值、種類及數量。除與協" +
          "議簽署安排核對客戶及／或授權人士各自的簽署（倘指示由客戶及／或授權人士簽署）或核對有關" +
          "客戶及／或任何授權人士（倘指示以任何其他方式發出）身份的指定號碼、密碼及／或任何其他資" +
          "料，本公司將無義務核對以任何方式發出任何指示的人士的身份或授權或該指示的真實性。本公司" +
          "可依賴及按本公司真誠地相信為真實的指示行事，而本公司按此基準代表客戶進行的任何交易將對" +
          "客戶具約束力，不論該指示是否就該交易作出或由客戶授權。",
        "4.5 與非面對面通訊有關的風險：客戶確認以電話、傳真、電郵或其他電子方式（包括電子服務）發出" +
          "指示的風險，包括未獲授權或由未獲授權人士發出或由第三者截獲指示的風險。客戶接納所有風險，" +
          "並授權本公司按照透過該方式接獲的任何指示行事。本公司並不就傳送或傳達指示或價格資訊的任" +
          "何延誤、故障、失誤、中斷，或暫停傳送或傳達指示或價格資訊或向任何其他方錯誤傳達指示或資" +
          "訊，或為客戶因使用任何特定收發指示方式或本公司按該指示行事而可能蒙受或產生的任何申索、" +
          "負債或損失承擔任何責任，除非由於本公司或其任何主管人員或僱員的嚴重疏忽、欺詐或蓄意失責" +
          "所致，及只限於直接及合理預見直接及純粹由上述行為造成的損失及賠償（如有）。",
        "4.6 取消或修改指示：一旦指示由客戶或其代表發出，除非本公司同意，該指示不可予以修訂、撤銷或" +
          "撤回。倘客戶所修訂、撤銷或撤回的指示已全部或部分執行，客戶同意就有關交易承擔全部責任。" +
          "就客戶或其代表已向本公司發出的任何指示，本公司將無義務就其取消、修訂或修改任何指示行事，" +
          "而倘原本指示已由本公司真誠地完成，或本公司不能合理可行地按指示取消、修訂或修改原本指示，" +
          "則毋須就客戶蒙受或產生的任何損失或開支承擔責任或負責。",
        "4.7 概無責任促使作為受信人士合規：本公司不負責促使客戶遵守規管客戶作為受信人士（如適用）的" +
          "行為的任何法律或規例。",

        "4.8 優先次序：本公司可全權決定在執行客戶的指示時的優先次序。",
        "4.9 合併訂單：在任何適用規例的規限下，本公司可毋須向客戶發出通知，將客戶的訂單與客戶或與本" +
          "公司關連的人士或與本公司的其他客戶的訂單合併。合併在某些情況下可能對客戶不利，而在其他" +
          "情況下對客戶有利。",
        "4.10 香港以外發出指示：如客戶在香港以外的地方發出任何指示，客戶承諾將遵照外地的所有適用法規" +
          "發出該等指示，如有疑問，客戶應取得獨立法律意見。如客戶的居住地不在香港，則客戶確認按照" +
          "適用法規可交易在香港的投資產品，本公司並無職責就此進行核實。",
        "4.11 賣空交易：倘若本公司自行全權決定客戶已符合所有適用法規，本公司可執行賣空指令。特別是，" +
          "對於在聯交所或通過聯交所交易的賣空指令，本公司必須獲滿足（i）已符合證券及期貨條例第 170" +
          "條和第 171 條的規定（總的來説，要求客戶具有一項即時可行使及無條件的權利，以將該等證券轉" +
          "歸於其購買人名下）及（ii）相關證券列於聯交所不時發佈並更新的可進行賣空的指定證券名單。",
        "5 執行交易",
        "5.1 指示經紀商：客戶授權本公司指示本公司全權酌情視為合適的執行經紀商、代理、託管人、代名人、" +
          "海外經紀商及交易商（包括本公司的分行或有聯繫者）執行任何交易，並確認該等人士的業務條款" +
          "以及執行及結算交易的任何相關交易所、結算所及／或結算系統的適用規則將適用於該等交易。客" +
          "戶理解並同意，由於本公司需根據協議或其他方式向客戶提供服務，本公司可能因客戶的投資產品" +
          "或與客戶的投資產品有關而欠第三方義務。該等第三方可能對客戶的投資產品和押記資產擁有權利" +
          "及權益，並可能影響（a）本公司解除對此類投資產品對客戶的義務的能力（例如，將某些投資產品" +
          "或押記資產退還給客戶），及/或（b）客戶行使與該投資產品或押記資產有關或與之相關的任何權利" +
          "（包括但不限於其對股票的投票權）的能力。",
        "5.2 相關法律：本公司按照客戶指示進行的所有交易，均應按照所有適用法規進行。本公司按照適用法" +
          "規採取的所有行動均對客戶具有約束力。",
        "5.3 「按最佳條件」或「按市場條件」執行指示：客戶確認，基於任何市場的市場條件或物理限制，以" +
          "及投資產品價格的迅速轉變及／或貨幣匯率的波動，在某些情況下，及即使本公司、執行經紀商或" +
          "交易商（不論於香港或其他地方）合理盡力，本公司未必能完全或按客戶指定的價格或時間或「按" +
          "最佳條件」或「按市場條件」執行客戶的指示。倘因市況或本公司未能控制的任何其他原因，本公" +
          "司未能完全執行任何指示，本公司概不負責，客戶接受本公司進行的交易並受其約束。",
        "5.4 履行部分訂單及限價單：當本公司或獲本公司指示的任何人士未能完全執行客戶的任何指示，本公" +
          "司或該等人士有權在不事先諮詢客戶或徵得其同意的情況下僅執行部分指示。在不影響上文所述一" +
          "般性的情況下，除非就投資產品於發出指示之時，客戶明確指示本公司立即於有關市場送出整個訂" +
          "單（而本公司接受該指示），否則經考慮當時市況及市場常規後，尤其是當本公司合理認為訂單根據" +
          "當時的市況不能即時執行時，本公司有權拒絕如此行事。",
        "5.5 交易日：除非客戶向本公司發出任何明確的相反指示（而本公司接受該等指示），否則客戶確認本公" +
          "司於某交易日收到的所有指示僅於該交易日（或本公司不時決定縮短或延長的時間）（「交易時段」）" +
          "有效，而以未履行的任何指示為限，該等指示均就發出買賣盤的市場的最後交易日正式交易時段（在" +
          "交易時段內）結束後失效。",
        "5.6 一直有效的訂單：一直有效的訂單將持續有效以待執行，直至任何下述情況發生爲止：（i）訂單被客" +
          "戶取消；（ii）訂單預先確定的有效期已過；或（iii）本公司自行全權決定取消該訂單。該訂單可在取" +
          "消之前的任何時間執行，而客戶同意就該等交易承擔一切責任。",
        "5.7 利息：客戶應按本公司不時通知客戶的利率及其他條款，支付任何帳戶內的所有逾期結餘、未清金" +
          "額、借方結餘及於任何時候結欠本公司的任何款項的利息（包括對客戶的債項取得判決後產生的利" +
          "息），若本公司並無發出該等通知，則按本公司不時釐定的利率支付利息。利息應從相關到期日或在" +
          "其他情況下由提出要求之日計起，直至本公司全數收到實際及無條件付款之日（包括該日在內），按" +
          "日計算。逾期未付利息將每月按複利計算及利息本身將產生新的利息。",

        "5.8 錄音和錄音帶：客戶確認，客戶與本公司之間的所有電話對話可能在沒有自動語音警告提示的情況" +
          "下被錄音，以便本公司核實客戶的指示。客戶同意，相關錄音帶上的錄音或者錄音的文字記錄可以" +
          "用作指示內容的最終及不可推翻的證據。",
        "5.9 本公司之記錄不可推翻：客戶確認，本公司之簿冊、數據及記錄，如無明顯錯誤，均為有關事項的" +
          "最終定論及在所有法庭及就一切目的而言，均為不可推翻的證據。",
        "5.10 個人操作帳戶：客戶確認，客戶將自行（或通過其授權人士）操作本公司就本協議為客戶開立的任" +
          "何帳戶。倘客戶擬委任第三方就本協議以任何方式代表客戶行事，客戶應向本公司提供本公司自行" +
          "全權決定的可能需要的信息以委任該第三方，而約束該委任的條款及條件將附加於本協議之上，及" +
          "視為本協議的一部分。",
        "5.11 價格：任何交易的實際買入及賣出價應在進行交易時釐定，而本公司或其代表於任何時間向客戶報" +
          "價或提供的任何數字（其中一些數字可能是由第三方資訊或服務提供者提供給本公司）僅供參考，" +
          "以及並不對本公司或客戶約束力。為免生疑，本公司有權按客戶的任何指示進行交易，即使相關投" +
          "資產品的價格在接收指示之時至本公司或其代理人實際進行交易之時已變得對客戶不利。",
        "5.12 所有權：本公司無義務審查或核實任何投資產品的擁有權或所有權的有效性。",
        "6 交收",
        "6.1 交收：除非另有約定或倘本公司已代表客戶持有足夠的投資產品、現金或其他資產以交收交易，否" +
          "則客戶應在本公司就有關交易通知客戶的時間、地點、金額及方式：",
        "(a) 向本公司支付或提供清算資金，或以交收交易所需的可交付形式向本公司交付相關投資產品；及",
        "(b) 確保本公司將於適用交收日期或本公司就交收交易可能知會客戶的時間接獲清算資金或可交付的投資產品。",
        "6.2 客戶未能交收：倘客戶未能遵守第 6.1 條（交收），就交收任何交易之目的，本公司在不損害本公司" +
          "任何其他權利或補救及毋須向客戶發出進一步通知或徵得同意的情況下，有權全權酌情：",
        "(a) 就買入或認購投資產品的交易，按本公司認為合理的價格，賣出或轉讓該交易所涉及的投資產" +
          "品及／或賣出或轉讓任何帳戶中的任何其他投資產品以履行客戶的交收義務，並於任何帳戶收" +
          "取或扣除任何相關成本、費用及開支；或",
        "(b) 就賣出投資產品的交易，按本公司認為合理的價格，借入及／或買入相等於該交易所涉及的投" +
          "資產品價值的投資產品以履行客戶的交收義務；而在第 6.1 條（交收）以外或作為替代，對本" +
          "協議下的合併及抵銷權利或任何其他權利享有追索權。",
        "6.3 不執行交易的權利：儘管本協議任何其他條文有所規定，本公司有權針對以下用途不執行任何指示：",
        "(a) 買入投資產品，除非客戶已向本公司提供清算資金，而本公司認為金額足以結清有關買入交易" +
          "的相關買入價、費用及支出；及",
        "(b) 賣出投資產品，除非客戶已向本公司存入有關投資產品以供交收該賣出交易。",
        "6.4 短欠：客戶以全面彌償基準就有關根據第 6.2 條（客戶未能交收）買入及/或賣出投資產品所發生的" +
          "任何短欠及本公司產生的任何成本、費用或開支（包括法律費用）負責。",
        "6.5 股票借貸：為方便客戶按時交收，本公司可全權酌情向客戶借出投資產品，或代表客戶借入投資產" +
          "品，以交收客戶的賣出指示。本公司亦可按其全權決定的條款代表客戶或為客戶利益向或從第三方" +
          "（僅為本條之目的，「第三方」）借出或借入投資產品，不論是以本公司、任何高盈證券成員還是以" +
          "其他名義。客戶應彌償本公司及任何高盈證券成員根據上述證券借貸安排所需的任何保證金、擔保、" +
          "證券、或抵押品維持及開支。本公司不保證或擔保任何賣空交易的可用性或持續可用性。本公司可" +
          "全權決定或應第三方要求終止任何該等借貸安排，並立即要求交付或歸還涉及的投資產品。客戶必" +
          "須遵從有關交付或歸還相關投資產品的任何要求。",
        "7 付款和客戶款項",
        "7.1 向客戶付款：就本公司支付客戶之全部款項而言，將按開戶表格所載帳戶詳情將款項轉入客戶之銀"+
        "行帳戶，或依本公司選擇以其他方式支付。上述任一方式的付款均構成對本公司所承擔之付款責任"+
        "之完全解除。",
        "7.2 獨立帳戶：本公司從客戶或任何其他人士收到的所有款項或其他財產（除非適用法規容許，或根據" +
          "客戶的書面指示，或根據客戶不時給予本公司的常設授權，而該等指示或常設授權已為本公司所接" +
          "受）均與本公司的自有資產分開，及支付予獨立帳戶。",
        "7.3 客戶款項利息：本公司將以《證券及期貨（客戶款項）規則》（香港法例第 571I 章）允許的任何方式"+
        "處理由本公司持有客戶款項（定義見於證券及期貨條例）而產生的任何利息，且客戶同意本公司（以"+
        "公司款項）保留該等利息。",
        "7.4 香港以外執行的交易：儘管第 7.2 條（獨立帳戶）有所規定，就在香港以外執行的交易而言，客戶授"+
        "權並指示本公司向本公司在香港境內或境外的任何金融機構（不論是否持牌銀行）維持的任何信託、"+
        "客戶或其他帳戶，支付本公司為客戶及代表客戶從交易不時收取的所有款項（減所有經紀費用及應"+
        "計的其他適當費用），儘管在符合或根據適用法規的情況下任何該等款額可為客戶或代表客戶再投資"+
        "於其他交易。",
        "8 結單及記錄",
        "8.1 一般：本公司將按照適用法規向客戶提供與任何交易有關的成交單據或其他確認書，以及有關帳戶" +
          "的戶口結單。",
        "8.2 月結單：除非適用法規允許或在特定月份內沒有與特定帳戶有關的交易，並且帳戶不存在任何未清" +
          "餘額或持有任何持倉或投資產品，否則本公司亦將提供有關帳戶的月結單。",
        "8.3 終論性/客戶檢查：客戶應檢查本公司發出的每份帳戶結單及記錄。成交單據、交易確認書及戶口結" +
          "單為當中所載事宜的不可推翻證據（明顯錯誤者除外），並將視為獲客戶接納及對客戶具約束力，除" +
          "非本公司於成交單據或交易確認書或帳戶結單日期後 5 個營業日內實際從客戶接獲書面通知，指稱" +
          "存在任何遺漏或錯誤，否則，此後客戶不得對該等結單的準確性提出異議。",
        "8.4 單方面修訂：即使有任何相反規定，本公司可在其認為適當的情況下單方面修訂任何該等結單或記錄。",
        "8.5 未收到：若（a）未收到本公司發出的任何戶口結單或交易記錄，或（b）客戶收到任何確認但並未發" +
          "出有關指示，則客戶應在（a）的情況下於日常業務過程中通常收到戶口結單或記錄後 2 個營業日內，" +
          "或在（b）的情況下在收到該等確認後立即以書面形式通知本公司。",
        "8.6 交付方式：在不影響本公司以其他任何方式向客戶送達成交單據、交易確認書、戶口結單及其他通" +
          "知書（統稱「交易文件」）的情況下，客戶同意以電子方式（包括透過電子服務）收取交易文件。客" +
          "戶可以通過向本公司發出不少於兩個月的書面通知（或公司可以接受的較短期限），撤銷其同意以電" +
          "子形式接收交易文件。",
        "8.7 衍生產品：對於衍生產品，包括期權，公司應客戶要求向其提供（a）產品規格以及涉及此類產品的" +
          "任何招股說明書或其他發行文件；及（b）保證金程序及未經客戶同意可能將客戶倉位平倉的情況的說明。",
        "8.8 客戶的確認：如果客戶同意並接受通過電子方式（「接收服務」）接收交易文件，則客戶確認其理解" +
          "並接受以下安排：",

        "(a) 使用接收服務需要客戶提供和指定的適當的硬件和軟件，互聯網接收服務以及特定電子郵件地" +
          "址，移動電話號碼或其他電子地址，以接收本公司的電子郵件，短訊或其他電子通知；",
        "(b) 互聯網，電子郵件，短訊和其他電子信息服務可能會受到某些科技風險和干擾影響；",
        "(c) 撤銷對接收服務的同意應由客戶按照第 8.6 條（交付方式）規定的方式預先發出此類通知；和",
        "(d) 客戶可能被要求為以下方面支付合理的費用：",
        "(i) 獲取不再可通過電子方式（包括電子服務）接收和下載的任何交易文件的副本；或",
        "(ii) 要求公司除提供接收服務的請求外，還通過其他方式向其提供交易文件。",
        "9 外幣",
        "9.1 貨幣兌換：在不影響上文第 2.4 條（本公司拒絕的權利）的一般性的情況下，本公司保留權利，在毋" +
          "須給予任何原因下，拒絕客戶需要從一種貨幣轉為另一種貨幣以進行賣出或買入任何投資產品的任" +
          "何指示，或在其他情況下拒絕為其他目的（包括為分派股息的目的）進行貨幣兌換。倘本公司接納" +
          "客戶任何進行賣出或買入任何投資產品指示，或為任何其他目的進行任何貨幣兌換，本公司應全權" +
          "決定按照當時現行貨幣市場匯率進行有關的貨幣兌換。此外，本公司可於任何帳戶按本公司全權釐" +
          "定為當時現行貨幣市場匯率的匯率，兌換款項為任何貨幣及從任何貨幣兌換款項。在進行貨幣兌換" +
          "交易時，本公司作爲主事人身份行事。該兌換可為下列目的進行︰（i）執行任何指示或交易，或（ii）" +
          "計算、清償、收回應收客戶的任何借項結餘或應付客戶的貸項結餘，或（iii）與本協議有關的任何其" +
          "他目的。",
        "9.2 人民幣：如有以人民幣計價的交易，客戶同意並確認：",
        "(a) 人民幣受外匯管制且有可能不可兌換的風險；及",
        "(b) 除非本公司另有規定，以人民幣計價的交易應以人民幣結算。",
        "10 投資產品的保管",
        "10.1 一般：客戶確認及同意，根據本協議通過結算系統或在結算系統中不時獲得和/或持有的投資產品將" +
          "在適用法規規限下及按照適用法規持有。",
        "10.2 保管：本公司或本公司的任何有聯繫實體根據本協議持作保管的任何投資產品可由本公司全權及在" +
          "適用法規規限下︰",
        "(a) （如為可註冊投資產品）以客戶或本公司或本公司代名人名義註冊；",
        "(b) 以保管方式記存於本公司在有關市場於本公司的有聯繫實體或任何其他合資格為投資產品及" +
          "相關文件提供保管安排的機構持有並指定為信託或客戶帳戶的獨立帳戶；或",
          "(c) 且在任何上述情況下，概不構成本公司作為無力償債或清盤用途的資產的部分，惟應於委任臨" +
          "時清盤人、清盤人或類似人員處理本公司全部或任何部分業務或資產後儘快退回予客戶。",
        "10.3 託管人：客戶委任本公司作為客戶在本協議規限下向本公司或其任何分託管人或代名人交付並獲本" +
          "公司接納的所有現金及投資產品的託管人。本公司有權按其酌情認為適當的條款將該等現金或投資" +
          "產品存入其他公司或機構。該等現金或投資產品可能與本公司的其他客戶的現金或投資產品一併組" +
          "合存託（但不會與本公司本身帳戶持有的現金或投資產品一併組合存託）。",
        "10.4 組合：客戶確認並同意,當客戶的資產與其他人士的資產組合及共同持有時，客戶的個人權益不可以" +
          "獨立文件、記錄或擁有權或所有權證據予以識別。",
        "10.5 向客戶轉讓：受限於第 10.7 條（完全清償責任）的規定，本公司在合理可行的情況下將盡快在客戶指示後：",

        "(a) 促使不時於帳戶的任何投資產品以客戶或客戶書面通知本公司作為其代名人的人士的名義註" +
          "冊，或倘如此指示，向客戶或代名人交付陳述或證明投資產品的文件，據此投資產品將不再於" +
          "帳戶持有；及",
        "(b) 從帳戶將客戶指示指定的任何金額轉撥至客戶指示的客戶銀行帳戶，而該轉撥將視為充分解除" +
          "本公司向客戶作出付款的義務。",
        "10.6 轉授/分託管人：受限於適用法規，客戶不可撤銷地授權本公司按第 2.5 條款（公司轉授）所述方式，" +
          "委任一名或多名轉授/分託管人，不論在香港以內或以外，在任何期間內都要履行本公司的托管和保" +
          "管職責。",
        "10.7 完全清償責任：本公司在第 10.5 條款（向客戶轉讓）中的義務應受限於本協議的其他規定，特別是" +
          "第 16 條款（押記）的規定，以及本公司要求在客戶提取任何款項之前全面清償所有責任的權利。本" +
          "公司可在不通知客戶的情況下，在根據第 10.5 條款（向客戶轉讓）進行登記或轉讓前，以帳戶結餘" +
          "金額清償任何或所有負債，或以其它方式要求客戶在根據第 10.5 條款（向客戶轉讓）進行登記或轉" +
          "讓前支付有關款項。",
        "10.8 表決權等：客戶在此授權本公司按照其與客戶投資產品有關的指示行事，包括行使投票權及投資產" +
          "品所附帶的其他權利。儘管有上述規定，本公司可完全自行以其絕對酌情權決定拒絕根據任何指示" +
          "行事，而無須給予任何理由。本協議的任何規定均不得以任何方式使本公司承擔通知客戶或就出席" +
          "會議採取任何行動和在該等會議上表決的任何責任。除適用法規另有規定外，本公司無義務就其收" +
          "到的與投資產品相關的通知、通訊、轉授書及其他文檔，或向客戶發送該等文檔或發出收到該等文" +
          "件的任何通知。本公司有權就其根據客戶指示採取的任何行動向客戶收取服務費。",
        "10.9 股息等：本公司將向相關帳戶支付客戶與投資產品相關的所有股息、分紅、利息、息票或利益。",
        "10.10 無義務通知或行使權利：在不影響第 10.8 條款（表決權等）的一般性效力的前提下，如果客戶的投" +
          "資產品以本公司或本公司指定的任何其他人士的名義（但非以其他方式）註冊，則本公司可以但並無義務：",
        "(a) 將本公司收到的與該等投資產品相關的資訊、通知及其他通訊通知客戶（但無義務在就投資產" +
          "品中提及的任何事項向本公司發出指示的充足時間內將該等資訊、通知及其他通訊轉發給客戶，" +
          "亦無義務調查或參與或採取任何積極行動，但根據客戶發出的具體指示（本公司接受該等指示），" +
          "並根據本公司可能要求的條件、賠償及合理費用撥備進行的除外），在未收到或延遲收到客戶" +
          "發出的具體指示的情況下，不得採取行動，並且就相關事項的任何違約選擇權應適用；及",
        "(b) 行使、認購、採用或以其他方式處置與客戶投資產品相關的公司認為合適的、對客戶具有約束" +
          "力的權利或新事項，除非本公司已實際收到客戶的相反指示（且本公司接受該等指示），但根" +
          "據適用法規，本公司不會採取可能導致本公司或其指定人有義務披露權益的任何行動。",
        "10.11 進一步行動：客戶授權本公司及其代名人在提供託管服務時，採取一切為遵守任何適用法規所需的" +
          "行動，包括就帳戶內的現金或投資產品代扣代繳及/或支付應付的稅款或稅項。客戶確認，對於本公" +
          "司或其指定人士持有的與投資產品相關的任何催繳、分期付款或其他付款，本公司及其代名人均不" +
          "承擔任何責任。",
        "10.12 投資產品的返還：無論因何種原因終止安全託管服務，本公司有權將客戶託管的全部資產返還給客" +
          "戶（風險和費用由客戶自行承擔），包括將與本公司最初託管或接受的投資產品序號或標識不一致的" +
          "投資產品返還給客戶。",
        "10.13 無託管：提供安全託管服務並不使本公司成為客戶或任何客戶資產的受託人，除非任何該等資產以" +
          "本公司或本公司的代名人的名義登記，在這種情況下，本公司僅作為被動受託人行事。除本協議規" +
          "定的義務外，本公司就客戶資產不承擔任何其他義務。",
        "10.14 客戶責任：任何投資產品轉讓時，客戶應負責安排第三方將投資產品交付給客戶或由客戶接收，且" +
          "任何手續費、轉帳費或託管費等均由客戶自行承擔。",

        "10.15 相同類別和面額：本公司代表客戶購買或取得的投資產品的交付、在安全保管下或以客戶名義登記" +
          "的任何義務應通過以客戶或其指定人的名義交付、持有或登記與本公司最初代表客戶存儲、轉讓或" +
          "取得的投資產品的面額和名義金額相同的同類投資產品的方式履行。",
        "10.16 客戶風險：本公司和/或其代名人根據本協議為客戶或代表客戶存放或持有的投資產品應由客戶自行" +
          "承擔風險，本公司無義務就任何種類的風險為任何該等產品投保，該等義務應由客戶自行承擔。",
        "10.17 處置：根據《證券及期貨（客戶證券）規則》（香港法例第 571H 章）第 6（3）條的規定，本公司獲" +
          "授權為處置或促使本公司的有聯繫實體處置客戶的任何證券或押記資產，以解決客戶或代表客戶欠" +
          "本公司、有聯繫實體或第三方的任何債務（且公司有絕對的酌情權決定要處置的證券或押記資產）。",
        "11 佣金、收費和支出",
        "11.1 佣金及收費：客戶應就本公司在本公司提供的收費表中指明或不時另行通知客戶的本公司服務（包" +
          "括提供電子服務），支付佣金、費用、收費、經紀佣金、溢價或其它報酬。本公司保留不時修改其費" +
          "用表及該等其他告示的權利。",
        "11.2 維護費：本公司可能會向不時指定的任何期間內就沒有交易活動的任何帳戶上按月收取維護費，本" +
          "公司將通知客戶該相關收費。",
        "11.3 費用及開支：客戶須就本公司就交易、帳戶及/或提供服務而招致的所有費用及開支，包括應付予任" +
          "何經紀人、託管人、代理人及代名人的費用、印花稅、過戶費、登記費、稅項、股票結算費、有關交" +
          "易所、結算所或市場徵收的征費、利息及其它手續費或開支，負上全面彌償責任。",
        "11.4 資金轉帳手續費：客戶同意，如因任何由客戶發起的任何資金轉帳而引致需要向客戶收取行政費、" +
          "匯款手續費及銀行代理費，將由客戶承擔。客戶亦同意，如有任何向本公司支付的款項或當客戶將" +
          "資金轉帳到帳戶時，必須先扣除所有收費及應收費用。客戶授權本公司代表支付上述收費及應收費" +
          "用（如適用）。",
        "11.5 從帳戶中扣款：本公司獲客戶授權，可隨時向任何帳戶收取或扣除任何佣金、費用、收費、經紀佣" +
          "金、酬金、征費、稅項及客戶須支付的其他費用及開支，而無須事先通知客戶。",
        "11.6 全額支付：客戶應在到期日以本公司指定的方式以立即可用的資金（或公司自行確定並可接受的其" +
          "他資金）並以本公司自行要求的貨幣向本公司支付款項，不得進行任何扣除、抵銷、反訴、預扣或" +
          "設定任何種類的條件，但如果法律強制客戶進行該等預扣，則客戶應支付的金額應予以增加，以使" +
          "本公司實際收到的淨額等於如未預扣則本應收到的金額。",
        "12 稅項",
        "12.1 客戶責任：客戶全權負責處理並履行所有適用法規項下的所有稅務問題、責任和義務。客戶應向其" +
          "稅務顧問尋求獨立稅務專業意見，據以確定自己的納稅立場、責任和義務。本公司不對客戶的任何" +
          "稅務問題、責任或義務提供諮詢或處理。",
        "12.2 提供資訊要求：經本公司合理要求或任何相關司法轄區的稅務機關和/或任何其他機關要求，客戶應" +
          "簽署並提交公司可能要求的任何表格、證明或文檔，並提供本公司可能要求的必要資訊和協助（包" +
          "括與共同報告標準相關的資訊和協助）。",
        "12.3 外國帳戶稅務合規法案（FATCA）：在不影響第 12.2 條款（提供資訊要求）的情況下，客戶承諾向" +
          "本公司提供公司要求的資訊、文檔和證明，以履行適用的跨司法轄區稅務合規規則規定的義務。這" +
          "包括但不限於：",
        "(a) 「外國帳戶稅務合規法案（FATCA）」指：",
        "(i) 《1986 年美國國內收入法》（及其修訂）第 1471 條至第 1474 條或其任何修訂或後續版本；",
        "(ii) 政府與監管機構就第（i）段達成的任何政府間協議、諒解備忘錄、承諾及其他安排，包" +
          "括香港政府簽訂的協議；",
        "(iii) 本公司與美國國稅局或其他監管機構或政府機構根據第（i）段或與第（i）段相關簽訂的協議；",
        "(iv) 美國、香港或其他地方根據任何上述規定通過的任何法律、規則、法規、解釋或慣例；及",
        "(b) 稅務資訊共用安排，指任何本地或外國法律、法規和規則，包括但不限於外國帳戶稅務合規法" +
          "案及相關規章制度項下的義務，以及影響本公司的其他國際交流安排。",
        "12.4 彌償：在不限制客戶提供的任何其他彌償的原則下，客戶應按要求就因客戶指示、帳戶或本公司向" +
          "客戶提供服務（包括因客戶未能遵守本第 12 條款的規定）而引致的任何責任、合理損失或開支（包" +
          "括稅款及征費）向本公司、高盈證券成員及其代理人作出賠償。",
        "13 金錢和非金錢利益",
        "13.1 金錢利益：客戶確認，本公司或與本公司有關連的任何人士可從經紀商、產品發行人或其他第三方" +
          "處獲得金錢利益。",
        "13.2 不可量化：本公司可獲得金錢利益，該等金錢利益的金額在交易達成之前或交易達成之時不可量化。",
        "13.3 非金錢利益：客戶確認並同意，公司或與其有關聯的任何人士可能從經紀商、產品發行人或其他第" +
          "三方獲得公司認為適當的非金錢利益，包括但不限於服務、贊助、廣告、研究分析、差旅、住宿和娛樂。",
        "13.4 獨立性：除非本協議或公司另有規定，公司不是獨立的中介人，理由如下：",
        "(a) 本公司將收取由其他人士（可能包括產品發行人）就其向客戶分銷投資產品而提供的費用、佣" +
          "金或任何其他金錢收益。有關詳情，客戶應參閲本公司在任何投資產品交易達成之前或達成之" +
          "時針對金錢利益的進一步披露；及/或",
        "(b) 本公司將從其他人士處取得非金錢利益，或與本公司可能分銷給客戶的投資產品的發行人有緊" +
          "密聯繫或其他法律或經濟關係。",
        "13.5 向第三方付款：客戶同意授權本公司在適用法規允許的範圍内向第三方提供和支付佣金、回扣、商" +
          "品、服務和/或其他利益，以交換該第三方推廣本公司的服務、推薦客戶給本公司及開展其他類似活動。",
        "14 電子服務",
        "14.1 電子服務：公司可不時全權酌情決定向客戶提供某些電子服務。如若如此，則本第 14 條應適用。",
        "14.2 正確輸入及依賴：客戶同意本公司有權依賴正確輸入的登入識別碼及密碼，以確定給予本公司的任" +
          "何指示是否為客戶的指示，並依據該假設行事。客戶應對透過電子服務輸入所有資料及透過使用電" +
          "子服務向本公司發出的所有指示承擔全部責任，即使該等資料或指示可能是由經授權或未經授權代" +
          "表客戶發出該等指示的第三方發出。客戶承諾，如在使用登錄識別碼和密碼登錄時有任何困難，將" +
          "立即通知本公司。",
        "14.3 個人：客戶應為其登錄識別碼和密碼的唯一授權使用者。",
        "14.4 保管：客戶對其登錄識別碼和密碼的保密性、安全性和保管負全部責任。客戶承諾，若客戶懷疑該" +
          "登入識別碼或密碼已被洩露、遺失、被盜或未經授權使用，將立即通知本公司。",
        "14.5 禁止性規定：客戶使用電子服務時不得有下列行為：",

        "(a) 未經本公司明示書面同意，以任何方式翻錄、轉發、散播、出售、發布、刊登、廣播、傳閱、" +
          "利用（無論是為商業利益還是其他目的）從電子服務獲得的或通過電子服務獲得的數據及/或報" +
          "告，且不得將資訊用於任何不正當或非法目的或違反適用法規；",
        "(b) 進行任何添加，修改，調整或變更以篡改任何部分或破壞於電子服務上或通過電子服務可獲得" +
          "的任何資訊或服務；",
        "(c) 允許將任何設備或軟件以任何方式連結或通信，或與任何其他服務或系統結合使用，使得從本" +
          "公司獲得的任何資訊和/或報告可能被該等設備或軟件取用，使用，存儲或重新分發；及/或",
        "(d) 使用除協議規定或公司可能不時發布的其他指示所規定的電子服務下可用的設施。",
        "14.6 暫停和終止：公司可根據其完全及絕對酌情權不時在不通知客戶的情況下：",
        "(a) 修訂、修改、暫停或終止電子服務的運行和/或該等電子服務的使用條款；",
        "(b) 暫停或終止客戶進入或使用電子服務；及/或",
        "(c) 停用登入識別碼及密碼，並無須對客戶負責就客戶因上述任何行動而可能蒙受的任何損失、損" +
          "害、費用、收費或開支。",
        "14.7 固有漏洞：客戶接受並確認，電子系統和技術（包括電子服務及本公司使用的該等其他系統和技術）" +
          "在本質上容易出現黑客攻擊、中斷、延誤或故障等現象。如電子服務未能為客戶提供時，客戶必須" +
          "自行採取替代方案以執行指示。",
        "14.8 責任限制：本公司對客戶不論如何使用電子服務所引致或引起的任何損失，損害，成本，收費或開" +
          "支概不負責，包括但不限於：",
        "(a) 丟失或未經授權的使用登錄識別碼或密碼的；",
        "(b) 未經授權使用或進入電子服務；或",
        "(c) 無論出於何種原因，電子服務的任何延誤、錯誤、失敗或無法進入或不可用。",
        "14.9 知識產權",
        "(a) 除非另有說明，本公司或某些其他第三方（包括但不限於經紀，合作夥伴或保薦人）（合稱為" +
          "「權利持有人」）是通過電子服務提供和電子服務上發布的材料的所有知識產權的擁有人或被" +
          "授權人。這些內容受到全球版權法和條約的保護。所有此類權利一律保留。",
        "(b) 在使用電子服務時，客戶同意不作出任何會違反、侵犯、損害或以任何方式影響權利持有人的" +
          "知識產權，包括但不限於本公司網站及軟件的所有部份（「知識產權」）的事情，並應采取所有" +
          "必要措施以保障及保護此等知識產權。由電子服務提供或產生的數據或報告中的所有知識產權" +
          "（不論是版權或其他形式的知識產權）均純粹歸屬於及將保留為權利持有人的專有財產。",
        "(c) 如未事先獲得相關權利持有人許可，客戶不得上傳，發表，翻錄，轉發，傳播，出售，發布，" +
          "廣播，傳閱，利用或分發通過電子服務提供而受版權或其他知識產權（以及公開權和私隱權）" +
          "保護的任何數據，軟件或其他材料，也不得將其或其任何部分用於個人使用或其日常業務以外用途。",
        "15 留置權",
        "在不影響在本協議項下授予公司的任何其他權力、許可權、權利和補償的情況下，在欠公司、其代" +
          "名人和高盈證券或任何關聯公司的所有款項均已被全額支付、清償或解除之前，公司有權以留置權" +
          "的形式保留並預留所有款項、投資產品（包括但不限於為客戶或代表客戶購買的或客戶擁有帳戶權" +
          "益的任何及所有投資產品）以及公司、其代名人或任何高盈證券成員不時持有的客戶的其他財產，" +
          "無論是為安全保管還是為其他目的持有，還是根據本協議或以其他方式持有，公司有權以本公司認" +
          "為合適的價格收取、出售或變現該等款項、投資產品和財產的全部或任何部分，並在扣除費用後使" +
          "用收益清償客戶欠公司、其代名人或任何高盈證券成員的任何款項。經公司要求，客戶應自行承擔" +
          "費用和支出，向公司或公司指定的任何其他主體執行將該等金錢、投資產品和財產的法定所有權歸" +
          "屬於公司或公司指定的任何其他主體的所有轉讓並開展所有必要事項。",
        "16 押記",
        "16.1 押記：鑑於公司向客戶提供的服務，客戶作為實益擁有人，特此以第一固定押記的方式將其目前和" +
          "未來在所有押記資產中的所有權利、權屬、利益、權利主張和權益作押記，以作為客戶妥善和準時" +
          "支付並履行所有負債及客戶不時履行所有其他義務的持續擔保。如果設定的擔保由於任何原因作為" +
          "第一固定押記無效，則該擔保應作為第一浮動押記生效。本第 16.1 條設立的任何浮動押記應在任何" +
          "違約事件發生時自動轉換為特定的固定押記（在一般法律項下發生浮動押記的情況之外且在不影響" +
          "該等情況的情況下）。在不影響上述規定的前提下，公司可在任何時間且不時通過書面通知客戶的方" +
          "式，就該等通知中指定的全部或任何部分押記資產將任何浮動押記轉換為固定押記。",
        "16.2 無責任：公司和公司的代名人不應以任何方式對為強制執行抵押品之目的而採取的任何行動所造成" +
          "的任何損失承擔任何責任，無論該等損失是否已經造成或產生，無論該等行動是否可以或本可獲得" +
          "更好的價格，亦無論該等損失是否可以通過推遲或提前採取該等行動的日期而減少或避免。",
        "16.3 損失和責任（集團内部出售）：本公司在按照屆時的市場價格向任何高盈證券成員使用、出售或處置" +
          "押記資產或其任何部分時，不應：",
        "(a) 以任何方式對以任何方式產生的任何損失承擔責任；也不應",
        "(b) 對公司、其任何代名人或高盈證券成員的任何利潤承擔責任，除非公司另行通知客戶（無論是" +
          "在相關的撥款或止贖之前還是之後），否則不得將其視為對抵押資產的絕對占用或喪失抵押品" +
          "贖回權，以排除客戶以及其在其中的權益。在此情況下，任何該等佔用或喪失抵押品贖回權應" +
          "被視為按公允市場價值出售押記資產，負債應減去相當於該等出售收益的金額。",
        "16.4 持續擔保：抵押品應為持續抵押品，即使帳戶有任何中期付款或結算，或全部或部分債務已獲清償，" +
          "及即使任何帳戶結束及其後重開，或任何帳戶其後由客戶單獨或與其它人士共同開立帳戶。在不影" +
          "響前述規定的情況下，即使本協議終止，抵押品仍應存在並繼續具有充分效力，直至客戶已完全清償所有負債為止。",
        "16.5 附加權利：第 16.1 條（押記）中設立的押記應作為公司目前或將來就責任可能持有或採取的任何其" +
          "他擔保、保證或賠償的補充，不影響也不受其影響，並可由公司在不事先追索任何該等其他擔保、" +
          "保證或賠償的情況下強制執行。",
        "16.6 暫記帳戶：根據抵押品變現的任何款項可存入公司開立的暫記帳戶的貸方，公司或代名人可全權決" +
          "定但無任何義務的情況下同時將該等款項或款項的任何部分用於或用於清償債務。",
        "16.7 解散無效：抵押品不得因本協議的任何修訂或變更或因客戶的解散、破產或無力償債而解除。如客" +
          "戶為商號，而商號已拆夥時，在收到拆夥實際通知前，抵押品對以該商號名義所欠商號之一切債務，" +
          "應繼續有效；如商號拆夥僅因引入一名或多名合夥人而引致者，則除當時已拆夥之商號之債務及責" +
          "任外，抵押品亦對由新合夥人所組成之商號同樣適用，一如商號之組織無任何變更。",
        "16.8 客戶承諾：客戶向本公司承諾：",
        "(a) 其不會在任何押記資產或任何帳戶上設立或允許存在任何產權負擔（但依法產生的任何產權負" +
          "擔除外）或處置任何押記資產或任何帳戶，但本協議中規定的除外；",
        "(b) 客戶應將押記資產的所有證書、文書和所有權證明（在適當的情況下）連同本公司可能不時要" +
          "求的所有必要的轉讓形式存放於公司或其指定的銀行；",
        "(c) 客戶應簽署並交付公司為完善其所有權或歸屬公司或使公司能夠將押記資產的全部利益授予",
        "公司之目的而可能不時要求的進一步轉讓、押記、授權及其他文件；",

        "(d) 未經公司事先同意，客戶不得提取或試圖提取全部或任何部分的押記資產；及",
        "(e) 客戶不得採取或不採取可能損害抵押品效力的任何行動。",
        "16.9 無限制：任何適用法規對任何直接或其他出售權、收益運用或對任何其他權利或抵押或其他產權負" +
          "擔的合併施加的任何限制不適用於抵押品、公司或客戶向公司提供的任何其他擔保。",
        "16.10 授權書：客戶以擔保方式，不可撤銷地委任本公司及其任何代表或附屬代表為客戶的真實合法的代" +
          "理人（有全權委任替代人及再委任人，包括有權授權如此委任的人就抵押品作出進一步委任），以客" +
          "戶的名義或以其他方式，簽署、蓋章、交付、行使及以其他方式完善及作出下列所有協議、法令及事情：",
        "(a) 客戶就抵押品本身所能做的事；",
        "(b) 客戶在抵押品下有義務或可能有義務；及/或",
        "(c) 否則，在公司看來，可能被要求或被視為適當或適當的，或與抵押品授予的所有或任何權利的" +
          "充分行使及其有權充分行使抵押品條款的權利。",
        "本授權書隨附權益並不可撤銷的，在任何債務存續期間將保持不可撤銷。客戶追認並確認，並同意" +
          "追認並確認根據本第 16.10 條指定的任何代理人（或任何替代或轉委託人）可合法簽署、蓋章、交" +
          "付、行使或進行的任何協議、行為或事項。",
        "16.11 不得撤銷：抵押品的任何撤銷、解除或結算應以客戶或任何其他人士因任何原因撤銷、減少、命令" +
          "退還或償還有關債務的任何擔保、處置、付款或清償為條件，如果該等條件未獲滿足，本公司有權" +
          "強制執行抵押品，如同該等撤銷、解除或結算未發生一般。",
        "16.12 復原：如果本公司認為客戶或任何其他人支付的款項能夠被宣告無效或以其他方式（在客戶清算時" +
          "或以其他方式）劃撥，則該款項不應被視為已支付。此外，本公司可根據其酌情權就任何付款、擔" +
          "保或其他處置有可能被宣告無效、減少或償還的任何權利主張作出讓步或妥協。",
        "16.13 良好擁有權：客戶陳述並保證，押記資產由客戶實益擁有，客戶將擁有良好權利和權屬投資產品存" +
          "放於公司、其代名人或高盈證券成員，該等資產目前及將來均不附帶任何種類的任何留置權、押記" +
          "或產權負擔，目前及將來均不受限於任何選擇權，抵押品中包含的任何股票、股份及其他投資產品" +
          "目前及將來均已被全額支付。",
        "16.14 權利的行使：在公司執行其在任何擔保項下的任何權利之前，（i）公司有權（僅在向客戶發出通知的" +
          "前提下）行使與押記資產相關的投票權及其他權利，以保護押記資產的價值；及（ii）除非此等條款" +
          "另有規定，客戶可指示行使附加於押記資產或與押記資產相關的其他權利，但此舉不得與客戶在本" +
          "協議其他義務有所矛盾，或在任何形式下可能影響本公司就抵押品的權利。",
        "16.15 抵押品的保護：如果任何人就本協議所載的任何事項或全部或任何部分抵押品或就本協議所載的任" +
          "何事項或全部或任何部分抵押品針對公司提起任何訴訟或程序或提出任何權利主張或要求，本公司" +
          "有權採取其認為必要或適當的合理措施，包括拒絕向客戶支付或交付構成抵押品一部分的全部或任" +
          "何部分的任何款項，以及取消或不遵守客戶就全部或任何部分抵押品可能發出或可能發出的任何指" +
          "令或指示。本第 16.15 條的任何規定均不應被解釋為公司就與本協議或抵押品相關的任何行動、程" +
          "序、權利主張或要求採取任何措施的義務。",
        "16.16 股息：客戶可收取的構成抵押品全部或一部份的任何股息、分派、利息、款項、權益，客戶須以信託" +
          "形式代本公司持有，並須在本公司要求時支付予本公司。",
        "16.17 不得放棄和無效：抵押品不得因本公司未取得任何擔保或本公司取得的任何擔保的無效性、非法性" +
          "或不可強制執行性，或因本公司就向客戶已作出或將作出的任何預付款的用途而訂立的任何現有或" +
          "未來協議而受到影響。",
        "16.18 延長期：如果客戶根據本協議或任何其它協議所聲稱的任何義務或責任（如有效或可強制執行，該" +
          "等義務或責任將由第 16.1 條款（押記）所設定的押記所擔保，該等義務或責任因任何原因全部或部" +
          "份對客戶無效或不可強制執行，包括客戶權力的任何缺陷或不足或欠缺，或任何不正常或不當行使" +
          "權力，或任何聲稱代表客戶行事的人士違反或缺乏授權，或任何法定限制（不論根據《時效條例》" +
          "（香港法例第 347 章）還是其他方式）或其他無行為能力，或任何其他事實或情況（無論是否為公" +
          "司所知悉），或如果客戶由於任何其他原因沒有或不再有法律責任解除其在本協議或任何其他協議中" +
          "承擔或聲稱承擔的任何義務或責任，則可終止本協議或任何其他協議中約定的客戶的義務或責任。" +
          "第 16.1 條款（押記）中設立的押記應適用於擔保該義務或責任或聲稱的義務或責任，如同該等義務" +
          "或責任完全有效並可強制執行。",
        "16.19 客戶重組：客戶或其作為抵押品的人或其他組織的組成在任何時候發生變更，均不影響抵押品的有" +
          "效性或解除擔保。如果客戶為合夥企業，在公司解散的情況下，抵押品應適用於擔保該公司或以該" +
          "公司的名義發生的所有債務和負債，直至公司收到實際解散通知。但如商號拆夥僅因新合夥人或新" +
          "合夥人加入而引致者，除舊商號之債務及責任外，其抵押品仍應繼續有效，而「負債」之定義，亦適" +
          "用於由新商號所欠下或引致之所有款項及所欠債務，猶如商號之組織維持原狀一樣。",
        "16.20 未生效的抵押品：在不影響上述規定的一般性的情況下，抵押品及其擔保的金額不會以任何方式受" +
          "到以下各項的影響：",
        "(a) 本公司、其代名人或任何高盈證券成員目前或將來在本協議項下或與本協議相關持有的任何其" +
          "他擔保、保證或賠償或任何其他責任；",
        "(b) 對任何擔保、保證或賠償或其他文件的任何其他變更、修訂、放棄或解除；",
        "(c) 本公司、其代名人或任何高盈證券成員強制執行或不強制執行或解除任何擔保、保證或賠償或" +
          "其他檔（包括第 16.1 條（押記）中設立的押記）;",
        "(d) 本公司、其代名人或任何高盈證券成員給予客戶或任何其他主體的任何時間、寬限、棄權或同意；",
        "(e) 由本公司或任何其他人士向客戶提出或未提出任何要求，要求支付本協議項下應付的任何款項；",
        "(f) 客戶資不抵債、破產、死亡或精神失常；",
        "(g) 本公司可能與任何其他人實現的任何合併、兼併或重組，或將公司的業務、財產或資產的全部" +
          "或任何部分出售或轉讓給任何其他人；",
        "(h) 客戶在任何時候針對本公司或任何其他人士可能享有的任何權利主張、抵銷或其他權利的存在；",
        "(i) 本公司與客戶或任何其他人士達成的任何安排或妥協；",
        "(j) 本協議的任何規定或任何擔保、保證或賠償（包括第 16.1 條（押記）中設立的押記）或任何一" +
          "方在本協議項下或與之相關的任何權利或義務或任何擔保、保證或賠償（包括第 16.1 條（押" +
          "記）中設立的押記）的不合法、無效或不可強制執行或存在任何缺陷，無論是基於越權、不符" +
          "合相關主體的利益、未由任何主體正式授權、簽署或交付，還是由於任何其他原因；",
        "(k) 根據有關破產、無力償債或清盤的任何法律可予撤銷或受其影響的任何協議、擔保、保證、賠" +
          "償、付款或其他交易，或客戶以誠信態度作出的任何該等協議、擔保、保證、賠償、付款或其" +
          "他交易的解除、和解或清償，而任何該等解除、和解或清償應被視為相應地受到限制；或",
        "(l) 本公司或任何其它人士所做或遺漏或疏忽的任何其它事情，或任何其它交易、事實、事情或事" +
          "情，若無本條款規定，可能會損害或影響客戶在本協議下的責任。",
        "17 客戶的陳述、保證和承諾",
        "在客戶於本公司維持任何帳戶及向本公司發出每項指示期間，客戶作出本第 17 條所載的陳述、保證及承諾。",

        "17.1 法人客戶等：若客戶為法人團體、合夥或信託（不論是否為法團）,客戶聲明及保證其為依其成立地" +
          "法律正式成立或組成（視乎情況而定）及有效存續之法人團體，並有充分權力及法律能力根據客戶" +
          "成立或組成之公司章程之條款簽訂本協議及履行其於本協議項下之義務；且客戶提供予本公司同意" +
          "簽署本協議之決議（或其他類似文件）之核證副本，是於本協議簽署日或之前依其公司章程之規定，" +
          "在其董事或其他職員（視乎情況而定）正式召集及召開之會議上正式通過，且具全面效力和全面生效。",
        "17.2 個人利益：除非本公司另行明確准許，否則客戶為每項交易發出指示的最終責任人，並將獲得每項" +
          "交易的商業或經濟利益和/或承擔其商業或經濟風險，並以相關投資產品和帳戶的主事人和實益擁有" +
          "人的身份自行交易，除客戶外，任何人對相關投資產品或帳戶均不享有任何權利或利益。",
        "17.3 能力：客戶擁有並將擁有完全的權力和能力訂立本協議、與公司或高盈證券成員訂立的任何其他協" +
          "議，並根據該等協議履行其義務，開立並運營每個帳戶，發出指示，並進行每項交易。",
        "17.4 真實資訊：由客戶或其代表在開戶表格或其他方面不時提供的與本協議相關的資訊在所有方面均真" +
          "實、完整和正確。客戶承諾，倘若相關信息發生變更，其將立即通知本公司。",
        "17.5 良好擁有權：客戶作為實益擁有人對於客戶向本公司交付的所有投資產品及其他資產（不論為任何" +
          "目的）、指示本公司根據本協議出售或以其他方式處置的所有投資產品及其他資產擁有不受產權負擔" +
          "約束的所有權。本公司無義務檢查或核實任何該等投資產品和資產的所有權，本公司對該等所有權" +
          "的任何欠妥不承擔任何責任。",
        "17.6 同意：客戶為簽署本協議、在任何市場進行任何交易及履行其在本協議項下的義務而可能需要的所" +
          "有同意或可授權均已獲得並具全面效力和全面生效。",
        "17.7 有效且具有約束力的義務：本協議構成對客戶有效且具有法律約束力的義務，並可根據其條款執行。",
        "17.8 適用法規：本協議及其履行和本協議包含的義務目前和將來均不會違反任何適用法規、客戶備忘錄" +
          "和章程細則或細則（如適用）的任何規定，亦不會構成對約束客戶的任何協議或安排的違反或違約。",
        "17.9 協議及風險披露聲明：客戶確認已向其提供一份其選擇的語言（英文或中文）的協議的副本，並應" +
          "邀閱讀本協議的條款。客戶聲明已充分理解本協議全部內容，已經閱讀並理解本公司附件 X（風險" +
          "披露聲明）及其他提供給客戶使用其選擇語言（英文或中文）的相關風險披露聲明，已獲邀請提問，" +
          "及明白在有需要時可尋求獨立意見並充分接受有關投資產品與交易的風險。",
        "17.10 客戶資料：經本公司要求，客戶應向本公司提供本公司不時為開立、維持、操作及/或關閉任何帳戶" +
          "之目的而要求的有關客戶及各獲授權人士之身份、客戶之財務狀況及資金來源或其它相關事項之資" +
          "料及文檔。客戶同意，在本公司收到客戶有關開戶表格更改的通知之前，本公司可依賴於在開戶表" +
          "格中提供的資料。如客戶或其代表根據本協議或根據本協議訂立的任何協議或與任何帳戶有關的任" +
          "何協議提供的資訊發生任何重大變更，客戶應及時書面通知本公司。",
        "17.11 進一步保證：客戶向本公司承諾將按本公司合理認為與履行及執行本協議相關所必要或可取而要求" +
          "客戶進行或簽立的任何行動、契約、文檔或事情，包括客戶簽署一份不可撤銷的授權書以委任本公" +
          "司為客戶的法定代理人，以代表客戶執行及簽署所有該等行動、契約、文檔或事情。",
        "17.12 批准：客戶同意採取必要或本公司合理認為可取的行動或事情及簽立必要或本公司合理認為可取的" +
          "文件，以追認或確認公司，其代名人或任何高盈證券成員，或任何他們中的任何人指示的另一實體" +
          "適當行使協議或根據該協議訂立的或與帳戶有關的任何協議賦予他們的任何權利或權力所作出的任何事情。",
        "17.13 無力償債：如客戶為個人，客戶無破產或提出破產申請；亦無根據《破產條例》（香港法例第 6 章）" +
          "提出或獲批准有關客戶的自願安排或臨時命令。客戶為公司或合夥企業時，客戶無清盤、破產、解" +
          "散、管理或其他類似事項的命令、呈請、通過的決議或會議。",
        "18 客戶資料、個人資料及披露",

        "18.1 資訊提供：客戶同意因應公司合理要求立即（i）向公司提供客戶的財務報表；（ii）向公司披露客戶" +
          "財務狀況的任何重大變更；（iii）向公司提供公司可能合理要求的其他關於客戶的資訊（包括個人資" +
          "料）;（iv）在客戶就本協議向公司作出的任何陳述或保證在任何方面不再真實、完整、最新或準確" +
          "時書面通知公司；及（v）在違約事件發生時書面通知公司。",
        "18.2 依法披露：客戶確認，任何相關司法管轄區的適用法規、監管機構及/或交易所可能要求或要求披露" +
          "與客戶、其授權人士及/或帳戶有關的個人及其他資料。客戶不可撤銷地授權本公司及高盈證券成員，" +
          "無須經客戶通知或同意，即可根據適用規例，向有關機關或人士（包括香港監管機構）披露及提供" +
          "所有有關客戶、其授權人士及/或帳戶的資料及文檔。在不影響前述規定的一般性原則下，客戶同意，" +
          "若本公司收到任何有關監管機構的查詢，客戶應依本公司要求（該要求應包括有關監管機構的聯絡" +
          "詳情），於該等監管機構或本公司規定的期限內，直接向本公司或該等監管機構提供任何有關客戶及" +
          "/或任何最終受益人的資料。客戶不能要求本公司或高盈證券成員對該等披露所產生的任何後果承擔" +
          "責任，客戶應按要求償還本公司及高盈證券成員為滿足披露要求而產生的所有費用和支出（包括在" +
          "全額彌償的基礎上發生的法律費用）。",
        "18.3 一般披露：受限於第 18.2 條（依法披露）的規定，本公司將對關於客戶和賬目的資訊保密，但客戶" +
          "授權可（i）向公司認為適合對客戶進行信用查詢和/或核實所提供信息的任何主體披露相關信息，（ii）" +
          "向本公司的審計師，法律顧問或其他專業顧問，或本公司任命的任何經紀人，交易商或其他服務提" +
          "供商披露相關信息，（iii）向任何高盈證券成員或本公司的代名人和轉授人披露相關信息，（iv）向本" +
          "公司所有或任何權利或義務（無論是根據協議還是其他方式）的任何實際或潛在受讓人披露相關信" +
          "息，（v）向任何相關市場數據服務或交易所披露相關信息，以使本公司能夠遵守其與相關市場數據" +
          "服務提供商或交易所之間關於市場數據使用的許可協議，（vi）根據不時向客戶提供的個人資料收集" +
          "聲明披露相關信息，及（vii）根據本公司不時修改的公司私隱政策披露相關信息。對於根據本第 18.3" +
          "條進行的任何披露而引起的任何後果，本公司不對客戶承擔任何責任。",
        "18.4 私隱政策：客戶確認其已閱讀並完全接受公司私隱政策聲明，該聲明可在本公司的網站獲得。",
        "18.5 不披露要求：如果不披露、保密、機密、資料私隱或其他類似的適用法規就本協議項下要求客戶披" +
          "露或提供任何有不披露義務的資訊，但允許客戶放棄該等要求或尋求同意該等披露，則應視為客戶" +
          "已放棄該等要求，且客戶應盡最大努力取得該等同意。",
        "18.6 客戶身份規則：",
        "(a) 客戶須應本公司要求立即告知本公司（i）最終負責發出與交易有關的指示的個人或實體（法人" +
          "或其他組織）的身份、地址、職業和聯繫方式，（ii）有可能獲得交易的商業或經濟利益和/或承" +
          "擔其商業和經濟風險的個人或實體（法人或其他組織）的身份、地址、職業和聯繫方式，以及" +
          "（iii）第（i）項中提及個人或實體的指示。",
        "(b) 對於一個集體投資計劃或委託帳戶，（a）段中所指的「實體」是指一個集體投資計劃或帳戶，" +
          "且該集體投資計劃或帳戶的管理人不是指那些對該集體投資計劃或帳戶擁有實益權的人（如單" +
          "位信託的份額持有人）。",
        "(c) 如果客戶是為集體投資計劃、委託帳戶或委託信託進行交易，而客戶在其全權代表該計劃、賬" +
          "戶或信託進行投資的權力已予撤銷時須盡快可行的情況下通知本公司。在客戶全權代客投資的" +
          "權力已予撤銷的情況下，客戶須按本公司要求，立即知會有關該名/或多名曾向客戶發出指示的" +
          "人士的身份、地址、職業及聯絡資料。",
        "(d) 如果客戶知道其客戶正在充當其基礎客戶的中介人或為該基礎客戶的利益行事，而客戶並不了" +
          "解其交易的基礎客戶的身份、地址、職業和聯繫方式，客戶確認存在以下情形：",
        "(i) 已與其基礎客戶訂立了安排，使客戶有權要求立即從其基礎客戶處獲得（a）段和（b）段" +
          "所述的資訊，或促使客戶獲得該等資訊；及",
        "(ii) 如本公司就某項交易提出要求，其將立即向執行交易指示的基礎客戶索要（a）及（b）段" +
          "所載有的資料，並在從其基礎客戶處收到資料後儘快向本公司提供或促致該等資料被提供。",

        "(e) 客戶確認，在必要時，其已從其基礎客戶、集體投資計劃、委託帳戶或委託信託（如與客戶/最" +
          "終受益人不同）處取得所有相關同意或豁免，以便向相關監管部門披露基礎客戶、集體投資計" +
          "劃、委託帳戶或全權委託信託的身份資訊、聯絡資訊，以及上述交易的最終受益人，和帳戶發" +
          "起人的身份資訊",
        "(f) 客戶授權本公司在相關監管機構提出要求時向相關監管機構提供本第 18.6 條所列的資料。",
        "(g) 即使本協議終止，本第 18.6 條應持續有效。",
        "19 指明中介人",
        "19.1 指明中介人的承諾：如果客戶是反洗錢條例附表 2 第 18（3）條涵義內的「指明中介人」，並同意根" +
          "據反洗錢條例附表 2 第 18（1）（a）條為本公司執行任何相關的盡職調查措施而成為本公司的中介人" +
          "（「指明中介人」），客戶承諾：",
        "(a) 維持打擊洗錢及恐怖分子資金籌集法律、法規和準則的規定，內部政策、流程和控制制度，包" +
          "括對客戶及其交易進行持續監控；",
        "(b) 履行及遵守反洗錢條例附表 2 第 2 條中客戶盡職調查措施；及",
        "(c) 經海外或本地監管機構或本公司要求，立即提供在開展客戶盡職調查措施的過程中獲得的任何" +
          "文檔或任何資料或資訊的記錄。",
        "19.2 本公司的依賴：指明中介人確認，本公司依賴指明中介人開展相關客戶盡職調查措施。指明中介人" +
          "同意賠償本公司與指明中介人履行其在本第 19.2 條項下的義務的任何作為或不作為相關或由該等作" +
          "為或不作為引起的所有實際或或有負債、權利主張、要求、損失、損害、稅項、費用、收費和支出，" +
          "並使本公司免受損害。",
        "20 客戶對權益披露的責任",
        "20.1 披露：客戶確認，客戶須自行負責解除任何適用規例對客戶施加的向任何適用交易所、監管機構或" +
          "其他人士披露任何性質的權益（不論個人、公司、家族或其他）的任何義務。客戶需特別注意證券" +
          "及期貨條例第 XIII 部、XV 部與《證券及期貨（合約限量及須申報的持倉量）規則》（香港法例第 571" +
          "章）之規定。謹提醒客戶，客戶應負責遵守或確保遵守在證券及期貨條例下產生的、與公司代表客" +
          "戶開展的任何事項或客戶要求代表客戶開展的任何事項相關的任何責任或義務。客戶確認，其知悉" +
          "證券及期貨條例中包含的規定，客戶將始終遵守或確保遵守該等規定，從而確保公司根據或擬根據" +
          "客戶的指示或指示採取的任何行動不會導致違反或侵犯證券及期貨條例的任何行為。",
        "20.2 對於披露並無責任提供意見：客戶確認並同意，本公司無責任告知客戶任何披露義務，無論該等義" +
          "務是普遍產生的還是由於本公司為客戶實施的任何交易或持有投資產品或以其他方式由客戶或代表" +
          "客戶實施的任何交易而導致的。該等披露義務為客戶的個人義務。除本協議明文規定由本公司發出" +
          "的任何通知或聲明外，本公司無義務以任何形式或通過任何時限發出由客戶或客戶代表發出的持股" +
          "通知。因客戶或其他人士未能或延遲根據任何適用規例披露權益而引致客戶的任何損失、費用或開" +
          "支，本公司概不負責。如因客戶未能或延遲根據任何適用規例披露權益而引致本公司蒙受或引致的" +
          "任何損失、費用或開支，客戶須向本公司作出賠償。",
        "20.3 美國人士：如果客戶（a）為美國人士，或（b）收購或持有由美國人士實益擁有的任何投資產品，或" +
          "為美國人士經營任何帳戶，或（c）違反任何適用法規，客戶必須立即告知公司。如果客戶是美國主" +
          "體或成為美國主體，本公司有權暫停或終止其在本協議下就任何投資產品向客戶提供的任何或所有" +
          "服務。本公司亦有權暫停或終止相關帳戶。對於客戶可能就該等中止或終止發生或遭受的任何種類" +
          "的任何損失、費用、收費或支出，本公司不承擔任何責任。此外，本公司有權代表客戶進行或辦理" +
          "與該投資產品有關的任何稅務申報。",
        "21 本公司的權利和補償",

        "21.1 違約：下列每一事件均構成一違約事件：",
        "(a) 客戶或客戶在本協議項下義務的任何保證人或擔保人因無力償還到期債務而破產或無力償還" +
          "債務，或自願或強制進入清算程序，或就其全部或部分資產委任接管人，或就其清盤或類似行" +
          "動提出或蒙受申請，或（自願或非自願地）成為任何法律項下的任何同等或類似程序的當事人；",
        "(b) 客戶（如為個人）死亡，或被司法宣告為精神錯亂或喪失行為能力，或（如為公司或合夥企業）" +
          "解散，或為其債權人的利益達成協議或和解，或停止或威脅停止償還其債務；",
        "(c) 當公司認為客戶違反本協議的任何條款或該客戶與公司或任何高盈證券的成員簽訂的任何其他協議；",
        "(d) 客戶或客戶在本協議或其他任何與本公司或任何高盈證券成員之間的協議項下有義務的任何" +
          "保證人或擔保人未能履行其在任何交易項下的義務或責任（包括未能支付應向公司或任何高盈" +
          "金融成員支付的任何款項）；",
        "(e) 客戶向公司提供的任何資訊或提供的任何陳述或保證在作出或重複作出時在任何方面不完整或不真實；",
        "(f) 就任何客戶資產或帳戶發出扣押或扣押令或同等或類似命令，或作出任何判決，或執行或已執行任何判決；",
        "(g) 就客戶的業務、資產或收入的任何部分，產權負擔持有人接管或委任接管人、受託人或其他類" +
          "似人員，或就客戶的任何財產實施、執行或起訴扣押、執行或其他法律程序，且未在 7 天內全" +
          "部移除、解除或支付；或",
        "(h) 就客戶或客戶的全部或任何部分資產或業務委任管理人、清算人或類似人員，或作出行政命令；",
        "(i) 未經本公司事前書面同意，客戶之任何帳戶有借方結餘；",
        "(j) 客戶違反任何適用法規，包括任何交易所的細則、規則或規例；",
        "(k) 客戶簽署本協議所需的任何同意、授權或董事會決議被全部或部分撤銷、暫停、終止或不再完全有效；",
        "(l) 發生（本公司自行認為）以下任一情況：（a）可能損害或合理預計將損害本公司在本協議項下" +
          "的任何權利、任何利益或客戶利益的任何事件，（b）對本公司利益或客戶利益不利的任何市場" +
          "情況的存在或延續，（c）任何與本公司相關擾亂任何市場公平與秩序的行爲，及（d）任何與本" +
          "公司相關關乎任何市場或投資產品的任何市場不當行為（或本公司認爲此等市場不當行爲逼切）、；",
        "(m) 本公司自行認為具有或可能具有重大不利影響的任何事件或一系列事件；",
        "(n) 本協議或其任何部分根據第 27 條款（終止）或本協議的任何其他條款終止；",
        "(o) 客戶轉讓或聲稱轉讓本協議任何部分的全部或任何部分的利益；",
        "(p) 就客戶在本協議下的負債、義務或責任而設立的任何證券或其任何部分被宣告無效、停止有效、" +
          "受到危害或受到不利影響，或任何人士就該等證券所包括的任何資產或財產而提出任何訴訟或" +
          "提出任何申索，或該等資產或財產的市值惡化、下降或貶值；",
        "(q) 任何第三方就任何帳戶中的任何金錢、資金、投資產品或其他資產主張權利、權利或權益；",
        "(r) 客戶出售其全部或絕大部分業務或資產；",
        "(s) 本公司對客戶的公司結構、業務、資產、財務或生成狀況或前景的唯一和絕對意見發生任何不利變化；",

        "(t) 客戶不同意本公司根據第 36.2 條款（修訂）對本協議所作之修訂，或本公司及客戶未能解決客" +
          "戶根據第 36.2 條款（修訂）所提出之異議；",
        "(u) 客戶履行其在任何投資產品和/或本協議或與本公司或任何高盈證券成員的任何其他協議項下" +
          "的任何義務是或變得不合法；",
        "(v) 本公司在本協議項下提供任何服務是或變得不合法；及",
        "(w) 儘管未發生違約事件，本公司認為有必要行使其在違約事件發生的情況下可能擁有的任何權力，" +
          "以獲得自身的保護。",
        "21.2 補償：在不影響本公司可能享有的任何其他權利或補償的前提下，如果發生任何違約事件，則在沒" +
          "有事先要求、請求或通知客戶的情況下：",
        "(a) 客戶欠本公司的所有款項應按要求立即支付，並按第 5.7 條（利息）規定的方式，不時支付未" +
          "償還的款項的利息；",
        "(b) 本公司進一步履行其在本協議項下對客戶未履行的任何義務（無論是為付款還是其他目的）應" +
          "以客戶已全面履行其在本協議項下對本公司承擔的所有義務為前提；及",
        "(c) 本公司有權在任何時間以任何方式，在沒有進一步通知，要求或徵得客戶同意的情況下，根據" +
          "其絕對酌情權下：",
        "(i) 終止本協議的全部或任何部分；",
        "(ii) 強制執行抵押品；",
        "(iii) 關閉或暫停任何或所有帳戶；",
        "(iv) 挪用、出售、變現、贖回、清算、轉讓、抵銷、處置或以其他方式處理本公司絕對酌情權" +
          "的所有或任何款項、擔保資產、任何帳戶中的投資產品及本公司持有客戶的其他財產，並" +
          "由客戶自行承擔風險和費用，且本公司無需就客戶發生的任何損失或損害承擔任何責任；",
        "(v) 抵銷、合併或整合客戶在本公司（包括帳戶）或任何高盈證券成員開立的任何性質的帳戶，" +
          "以及將本公司在本協議項下欠客戶的任何責任和義務與客戶的任何責任相抵銷或合併。" +
          "本公司被授權用任何該等帳戶的結餘金額購買為實現該等抵銷或使用而可能需要的任何其他貨幣；",
        "(vi) 暫停或終止本公司的所有或任何服務；",
        "(vii) 取消客戶所有或任何未完成或未執行的指示；",
        "(viii) 修改、變更、撤回、停止或取消分別給予或授予客戶的任何授信、預付款、信用或貸款或其任何部分；",
        "(ix) 要求支付、償還、清償、滿足、履行或履行客戶欠本公司或任何高盈證券成員的金額、利息、金額、款項或基金；",
        "(x) 取消任何或所有未完成訂單或代表客戶作出的任何其他承諾；",
        "(xi) 關閉本公司與客戶之間的任何或所有合同，並代表客戶收取貨物；",
        "(xii) 代表客戶行使本公司持有的任何合同；",
        "(xiii) 通過購買和/或借用投資產品彌補任何淡倉；",

        "(xiv) 在適用的情況下，從任何帳戶買入之前賣空的投資產品；",
        "(xv) 通過出售，變現，贖回，轉讓或處置投資產品在公司清算任何長倉；和/或",
        "(xvi) 以公司絕對酌情決定的任何價格或條款，平倉或清算客戶在任何帳戶中任何投資產品中的部分或全部未平倉持倉。",
        "21.3 收益的使用：本公司有絕對酌情權將本公司實際收到的淨收益（在扣除行使本協議授予其的權力所" +
          "發生的所有費用、成本和支出（包括但不限於本第 21 條款（公司的權利和補償）））以本公司認為適" +
          "當的順序或方式用於清償客戶屆時未履行的責任。",
        "21.4 絕對酌情權：公司對行使本協議授予其的權利（包括但不限於本第 21 條款（公司的權利和補償））" +
          "的所有相關事項擁有絕對酌情權，並且可以在公司認為合適的任何時間和任何方式，以單獨或共同" +
          "方式，適當地出售，變現，贖回，清算，轉讓，抵銷，處置或以其他方式處理客戶的任何投資產品或其他資產。",
        "21.5 短欠：客戶應對本公司行使其在本協議項下的權利後可能存在的任何短欠以及本公司發生的任何相" +
          "關費用和支出承擔責任（包括在全額彌償的基礎上發生的法律費用）。經要求，客戶應立即向本公司" +
          "支付等於該等短欠的金額以及本公司為該等金額提供資金的費用，以及自要求之日起至本公司收到" +
          "實際無條件全額付款之日止，按公司不時規定的利率計算的利息（包括在任何判決之前和之後）。",
        "21.6 債務催收代理人：本公司有權隨時及不時聘用債務催收代理人收取客戶就本協議應付但未付的任何" +
          "款項，而客戶授權本公司向該等代理人披露有關客戶、其被授權人、帳戶及交易的任何或所有個人" +
          "及其他資料，而公司無須就該等披露或該等代理人的任何違約、疏忽、行動、行為、不當行為及/或" +
          "作為承擔任何責任（不論是在合約或侵權方面）。客戶須就本公司及其高級職員、雇員及代理人在聘" +
          "用債務催收代理人及關閉任何帳戶的過程中可能合理招致的一切合理費用及開支作出全面彌償。",
        "21.7 平倉：就第 21.2 條款（補償）或協議其他條款中的任何平倉或清算客戶的持倉而言：-",
        "(a) 無論以何種方式發生，本公司均不承擔任何相關損失的任何責任；",
        "(b) 本公司有權向本公司或任何高盈證券成員出售或處置證券或其他任何部分，對任何相關損失不" +
          "承擔任何責任（無論以何種方式發生），或對本公司和/或任何高盈證券成員獲得的利益作出任何說明；及",
        "(c) 如平倉所得款項不足以彌補客戶對本公司之欠款，客戶應立即清償所欠本公司之全部剩餘款項。",
        "22 責任和彌償",
        "22.1 責任免除：客戶同意，對於客戶可能因交易或本協議或與交易或本協議相關而發生的任何權利主張、" +
          "訴訟、起訴、程序、損失、損害、義務、責任、費用、收費及開支（包括因本公司委任的任何經紀人" +
          "及交易商所進行的交易，因第 5.1 條（指示經紀商）中列明的任何第三方的行使的任何權利，或因本" +
          "協議第 5.3 條款（「按最佳條件」或「按市場條件」執行指示）或第 28 條（不可抗力）），除因本公司" +
          "或高盈證券成員或其各自的任何董事、管理人員、或雇員的重大疏忽、欺詐或故意違約外，本公司" +
          "或高盈證券或其各自的任何董事、雇員或代理人均不承擔任何責任。在不影響上述規定的一般性效" +
          "力的前提下，本公司無須就任何交易或本協議引起的或與之相關的任何稅項（包括任何預扣稅）、關" +
          "稅、徵稅或徵稅承擔責任。",
        "22.2 一般彌償：客戶應彌償公司、高盈證券及其各自的董事、管理人員、員工和代理與履行其在本協議" +
          "項下的服務相關或由於客戶違反或違背其在本協議的任何規定項下的義務而可能針對公司、任何高" +
          "盈证券成員其各自的任何董事、管理人員、員工和代理施加、發生或聲稱的任何種類或性質的任何" +
          "和所有責任、義務、損失、損害、處罰、訴求、權利主張、程序、判決、訴訟、費用、法律費用（在" +
          "全額彌償的基礎上）及其他支出和支出，但由公司、高盈證券成員或其各自的任何董事、管理人員" +
          "或員工的重大過失、欺詐或故意違約導致的除外，並且僅限於由該等重大過失、欺詐或故意違約直" +
          "接且單獨引起的直接且合理可預見的損失和損害（如有）。",

        "22.3 進一步彌償：在不影響第 22.2 條款（一般彌償）的一般性效力的前提下，（i）公司不承擔任何責任，" +
          "並且（ii）客戶應按要求對本公司和高盈證券及其各自的董事、管理人員、員工和代理可能承擔的、" +
          "發生的或聲稱的與下列各項相關的任何種類或性質的任何和所有責任、義務、損失、損害、罰款、" +
          "訴求、權利主張、程序、判決、訴訟、費用、法律費用（在全額彌償的基礎上）及其他支出和雜費作出賠償及：",
        "(a) 買方或任何其他主體由於客戶對任何投資產品或其他資產的所有權存在任何缺陷而提出的任何索賠；",
        "(b) 本公司代表客戶購買、出售、持有或以其他方式處理的任何投資產品的所有權或權屬方面的任何欠妥；",
        "(c) 本公司接受、依靠和/或根據第 2.6 條款（被授權人士發出的指示）中提及的指示行事；",
        "(d) 本公司根據客戶選擇的任何方式，按照客戶給出或據稱由客戶給出或指示給出的指示行事；",
        "(e) 本公司在第 5.11 條款（價格）所述的情況下按照實現交易的任何指示行事；",
        "(f) 客戶未能在相關結算日履行其結算交易的義務或未能支付本協議項下應向本公司支付的任何其他款項；和/或",
        "(g) 本公司對本協議授予其的任何權利和權力的行使，無論是關於該等權利或權力的行使時間或方式還是其他方面；",
        "(h) 任何申請（定義見附件 II（申購新發行證券））;",
        "(i) 向客戶追討債務；",
        "(j) 關閉帳戶；",
        "(k) 客戶作出的任何陳述或保證不真實；或",
        "(l) 依法到期但尚未存入帳戶的投資性產品。",
        "22.4 資訊的可靠性：在適用法規允許的最大範圍內，所有資訊，無論是由本公司還是第三方服務提供者" +
          "（如市場資料和報價服務）根據本協議向客戶提供，無論是通過電子方式（包括電子服務）還是其" +
          "他方式，均按「現狀」和「可獲得」的基礎提供及僅供一般參考。客戶同意，在本公司盡力確保該等" +
          "資訊的準確性和可靠性的同時，本公司不保證任何該等資訊的準確性、可靠性、及時性、完整性或" +
          "正確排序，本公司不對資訊的任何不準確、遺漏或不完整或對該等資訊的任何依賴所導致的任何損失承擔任何責任。",
        "22.5 投資者賠償基金：如果本公司或其任何管理人員、員工未能履行其在本協議項下對客戶承擔的義務，" +
          "客戶確認並接受，其（i）在根據證券及期貨條例設立的投資者賠償基金項下要求賠償的權利受限於" +
          "證券及期貨條例的規定，及（ii）在香港以外的任何市場要求賠償的權利受限於相關市場的適用法規。",
        "22.6 金融糾紛調解中心：如果客戶合理地認為公司未能在合理的時間內糾正客戶的投訴，則建議客戶有" +
          "權將糾紛轉介給金融糾紛調解中心。",
        "22.7 違法排除：儘管本協議有任何相反規定，但如果這是違法時，公司無法以任何方式排除或限制其對客戶的責任。",
        "23 公司權益",
        "23.1 公司在交易中的重大權益：在為客戶進行任何交易時，本公司、其代名人和/或高盈證券成員可能擁" +
          "有與交易或相關投資產品相關的重大權益、關係或安排，在遵守任何適用法規的前提下，本公司或" +
          "其代名人或任何高盈證券成員均無義務向客戶披露該等權益、關係或安排（包括其性質或範圍）。客" +
          "戶同意，儘管有任何該等權益、關係或安排，本公司可為客戶與其任何代名人或高盈證券成員或通" +
          "過其任何代名人或高盈證券成員實現交易，本公司或其任何代名人或高盈證券成員可：",

        "(a) 在為客戶進行的任何交易中，以其本身帳戶且以主事人身份作為交易對手方；",
        "(b) 在投資產品中持倉或擔任相關投資產品的承銷機構、保薦人或其他角色時實施交易；",
        "(c) 可建立與客戶指令相反的倉位，不管是出於自己本身或代其他客戶作出之決定；或",
        "(d) 配對客戶與其他客戶的買賣盤。",
        "23.2 不會對利潤提出申索：在本公司或其任何指定人員或高盈證券成員不存在欺詐或故意不當行為的情" +
          "況下，對於客戶就第 23.1 條款（本公司在交易中的重大權益）中提及的任何交易針對本公司或其任" +
          "何代名人或高盈證券成員提出的任何權利主張，包括就本公司或其任何代名人或高盈證券成員與該" +
          "等交易相關賺取或收到的任何薪酬、佣金、利潤或任何其他利益提出的任何權利主張，本公司對客" +
          "戶不承擔任何責任。",
        "23.3 以自己帳戶進行交易：本協議的任何規定均不得被視為禁止或阻止本公司（a）以任何身份為任何其" +
          "他主體行事，（b）購買、持有或為自身利益交易任何投資產品，即使帳戶中可能包含類似投資產品，" +
          "（c）或為本公司自身利益購買本公司為自身帳戶持有的投資產品，或為本公司自身帳戶購買構成賬" +
          "戶一部分的投資產品，但前提是，在任何情況下，該等購買條款對客戶的優惠程度均不遜於屆時交" +
          "易公平進行時本應優惠程度。客戶確認，受限於任何適用的監管要求，本公司、其董事和/或員工可" +
          "為其自身帳戶或其任何高盈證券成員的帳戶的利益進行交易。",
        "23.4 無披露職責：本協議中的任何規定均不使本公司承擔向客戶披露其在以任何身份為任何其他人行事" +
          "過程中注意到的任何事實或事情的任何職責，除非適用法規要求進行該等披露。",
        "23.5 公司的其他權益：客戶同意，本公司在世界任何地方的交易所或市場代表客戶執行賣出或買入指令" +
          "時，本公司、其董事、管理人員、雇員、代名人和/或任何場內經紀可為任何該等人士擁有直接或間" +
          "接權益的帳戶進行買入或賣出，但須遵守當時有效的交易所或市場的章程、規則、規定、慣例、裁" +
          "決和解釋中所包含的限制和條件（如有），並須遵守該等交易所或市場合法頒佈的任何適用法規中所" +
          "包含的限制和條件（如有）。",
        "23.6 潛在衝突：本公司（及部分高盈證券的成員）有或可能從事範圍廣泛的金融服務及其他相關業務。" +
          "因此，本公司可能與另一方有重大利益或任何安排或任何類型的關係，而這可能會導致其對客戶的" +
          "責任發生衝突。客戶確認存在該等潛在的利益衝突，並同意本協議不會妨礙本公司按上述規定開展" +
          "業務。本公司應採取合理措施，確保在涉及潛在利益衝突的任何交易中公平對待客戶。",
        "24 合適性及專業投資者狀態",
        "24.1 一般：如果本公司向客戶招攬銷售任何投資產品或向客戶建議任何投資產品，該等投資產品必須在" +
          "考慮客戶的財務狀況、投資經驗和投資目標（「客戶財務資訊」）的情況下合理適合客戶。此等條款" +
          "或任何其他文件中本公司可能要求客戶簽署的任何其他規定，以及本公司可能要求客戶作出的減損" +
          "本第 24.1 條款的任何聲明均不會減損本第 24.1 條款的規定。",
        "24.2 未經任何招攬或建議：如果客戶未經本公司任何招攬或建議或與本公司的任何建議不一致而進行買" +
          "和/或賣投資產品的交易，本公司無任何義務或責任（適用法規要求的若干有限情況除外）評估，或" +
          "確保該投資產品適合客戶，在該等情況下，客戶確認及同意其會自行評估並確認交易對其的合適性。",
        "24.3 未經任何招攬或建議下的免責：本公司概不會就客戶或任何其它人士就 24.2 條款（未經任何招攬或" +
          "建議）所述的任何該等交易招致或蒙受的任何損失（包括間接或結果性損失）、費用或損害負責。",
        "24.4 最新的客戶資訊：在進行買賣投資產品交易時，客戶確認其向本公司提供的任何資訊（包括客戶財" +
          "務資訊）均為完整、準確及最新。本公司在評估合適性時，將依賴於客戶的確認。",
        "24.5 客戶的考量因素：客戶在進行該等買和/或賣投資產品交易之前，應：",
        "(a) 考慮自身情況及了解投資產品的性質、期限及風險，如對投資產品有任何疑問，客戶應聯繫本公司；",
        "(b) 知悉本公司不承擔確保其招攬或建議的該等投資產品仍然適合客戶的任何持續責任；",
        "(c) 知悉如果客戶、該等投資產品或該等投資產品的發行人或一般市場條件所涉及的情形發生變化，" +
          "該等投資產品可能不再適合該客戶；及",
        "(d) 知悉本公司不會就客戶的投資提供法律、稅務或會計建議，因此，客戶應在必要時考慮就投資" +
          "產品獨立地徵求專業意見（包括法律、稅務和會計建議）。",
        "24.6 衍生品：客戶了解並確認衍生品投資一般不適合對衍生產品並未具有知識的客戶。如本公司將客戶" +
          "歸類為對衍生產品並未具有知識的客戶：",
        "(a) 如客戶決定購買在交易所交易的衍生產品，客戶確認本公司已以口頭或書面形式（包括電子方" +
          "式）向客戶解釋有關產品的風險；及",
        "(b) 如客戶購買未在交易所交易的衍生產品且本公司并未招攬或建議該爭議衍生產品，客戶確認，" +
          "特別考慮到客戶是對衍生產品並未具有知識的投資者，本公司已就相關交易向其發出警告。",
        "24.7 專業投資者",
        "(a) 如果客戶是專業投資者，則取決於專業投資者的類型，在滿足若干條件後，本公司可（在處理" +
          "該專業投資者時）無需根據操守準則對其履行其他情況下本公司要遵守的義務。",
        "(b) 關於個人專業投資者和法團專業投資者，爲了讓本公司評估其是否可以和/或可以將（或繼續將）" +
          "客戶視爲專業投資者，客戶必須填寫「專業投資者評估表和通知」並向本公司提供本公司不時要求的此類資訊。",
        "(c) 關於機構專業投資者，本公司可能在向該機構專業投資者發出機構專業投資者通知時將其視爲機構專業投資者。",
        "(d) 如果（i）「專業投資者評估表和通知」或上述（c）段提及的通知的條款與（ii）本協議的任何" +
          "其他條款與不一致，則以前者的條款為准。",
        "25 聯名帳戶",
        "25.1 聯名帳戶：若帳戶為聯名帳戶，即帳戶以多於一人名義開立：",
        "(a) 「客戶」應包括上述各類人員（「聯名客戶」），聯名客戶在本協議中的責任為連帶責任；",
        "(b) 就任何一名或多名聯名客戶提出的任何付款要求應被視為對每一名及所有聯名客戶的有效付款要求；",
        "(c) 本公司可免除或解除任何一名或多名聯名客戶在本協議項下的責任，或與任何聯名客戶達成和" +
          "解，或接受任何聯名客戶的成分，或與任何聯名客戶作出任何其他安排，而不免除或解除或以" +
          "其他方式損害或影響公司針對任何其他聯名客戶的權利和補償；",
        "(d) 任何聯名客戶的死亡、喪失行為能力或解散不得影響本協議；",
        "(e) 任何一位或多位聯名客戶或其個人代表根據第 27 條（終止）終止本協議不影響其他聯名客戶的持續責任；",
        "(f) 公司對每一聯名客戶的財產享有留置權。公司的留置權應作為公司根據本協議享有的權利和補償的補充；",
        "(g) 每一聯名客戶單獨及分別地有權根據本協議向公司發出指示或行使客戶的所有權利、權力及酌" +
          "情權，並代表其他聯名客戶與公司交易，如同每一聯名客戶為唯一帳戶持有人，並對所有聯名" +
          "客戶具約束力。公司被授權按照任何一名聯名客戶的指示行事，不得被要求就該等指示向其他聯名客戶發出通知或從其他聯名客戶取得授權；",

        "(h) 公司無任何責任查詢或監察任何聯名客戶在任何帳戶內的任何款項或財產的運用或處置；",
        "(i) 聯名客戶以具有倖存權的聯權共有人而非分權共有人訂立協議；",
        "(j) 如果任何聯名客戶身故，該聯名客戶在帳戶中的全部權益應根據本協議規定的相同條款歸屬於" +
          "存續的聯名客戶，在本公司實際收到該聯名客戶死亡通知之前，已故人士對本公司承擔之任何" +
          "責任並不予解除，且本公司有權對其遺產強制執行本公司的權利。已在本公司實際收到該聯名" +
          "客戶死亡通知之前，已故人士對本公司承擔之任何責任並不予解除，且本公司有權對其遺產強" +
          "制執行本公司的權利。已故聯名客戶或存續的聯名客戶的遺產應立即書面通知公司相關聯名客" +
          "戶的死亡以及該等死亡導致的被授權人身份的任何變更。公司應根據本協議的條款按照存續的" +
          "聯名客戶的順序持有客戶的資產，但前提是，存續的聯名客戶出示並交付令公司滿意的相關聯" +
          "名客戶身故證明，以及遵守法律項下所有適用要求的證明（包括關於繳納或清繳遺產稅的所有" +
          "義務），公司可採取並要求公司為保護公司在任何適用法律項下與任何稅項、責任、罰款或損" +
          "失相關的利益而可能合理指定的措施和文件及/或彌償；",
        "(k) 各聯名客戶應受本協議約束，而不論聯名客戶之間的任何安排或協議，亦不論本協議可能對任" +
          "何一名或多名聯名客戶無效或不可強制執行（不論本公司是否知悉該等缺陷）；",
        "(l) 任何客戶向本公司發出的任何通知或通訊應對公司生效，本公司向任何聯名客戶發出的任何通" +
          "知或通訊應對所有聯名客戶生效；",
        "(m) 向任何一名聯名客戶支付的任何款項應構成本公司對每一名聯名客戶有效和完全的義務解除，" +
          "無論該等款項是在任何一名或多名聯名客戶死亡之前還是之後支付。",
        "26 單項及連續協議",
        "本協議及其所有修訂應為持續性的，並應單獨及共同適用於每一及所有帳戶及交易。",
        "27 終止",
        "27.1 客戶提出的終止：客戶可以通過填寫本公司規定的終止表格、將其交付給本公司並完成所有本公司" +
          "可能要求的其他程序來終止協議（或其任何部分），包括終止在本公司開立的帳戶。本公司將在接受" +
          "客戶提出的終止後通知客戶。",
        "27.2 本公司提出的終止：即使有任何相反規定，本公司保留在任何時間中止或終止本協議及其所有或任" +
          "何服務（包括帳戶）的權利，而無需給予任何通知或理由。經監管機構或其他機構要求，公司也可能被要求採取上述行動。",
        "27.3 終止的影響：在本協議因任何原因終止時，客戶應立即向本公司支付的所有款項。公司不再有代表" +
          "客戶進行任何交易的任何義務，並有權取消客戶的所有或任何未執行的指示，即使客戶有任何相反" +
          "的指示。終止不得影響本公司、高盈證券成員或任何第三方在終止前在本協議項下採取的行動。",
        "27.4 客戶資產的返還：客戶在清償所有負債後的剩餘現金收入及款項，應在可行的情況下盡快歸還客戶，" +
          "風險和費用由客戶自行承擔。客戶未能變現或未處置的投資產品及其他資產，應當與其所擁有的權" +
          "利憑證一同向客戶交付，風險和費用由客戶自行承擔。對於客戶因該等退貨和交付而發生的任何損" +
          "失或損害，本公司不承擔任何責任。客戶可通過通知公司，選擇放棄任何該等現金收入、款項、投資產品及其他資產。",
        "27.5 權利累積：本公司的任何服務或本協議的暫停或終止，不應影響本公司就客戶的任何義務或責任所" +
          "享有的權利及補償，包括本公司在該等暫停或終止前根據本協議結算客戶或客戶代表客戶所進行的" +
          "任何交易或發生的任何債務的權利，亦不應影響本公司對本公司所擁有或控制的客戶財產的任何權" +
          "利，不論該等財產是以保管方式保管、保證金或其它目的而持有，亦不論該等財產是根據本協議（特" +
          "別是第 21 條（本公司的權利及補救））或其它規定而持有，只要客戶對本公司負有任何尚未清償的責任。",
        "27.6 客戶的持續義務：即使公司的任何服務或本協議暫停或終止，客戶應繼續受本協議規定的約束，但" +
          "前提是，該等規定涉及仍有待履行或解除的任何義務或責任。終止不得終止或影響客戶在本協議項" +
          "下或與任何投資產品相關作出的任何保證、允諾、聲稱、聲明、承諾和彌償。",
        "28 不可抗力",
        "因政府限制、有關交易所或市場實施緊急程序、交易中斷、內亂、恐怖主義行為或恐嚇行為、自然" +
          "災害、戰爭、罷工或其他非本公司所能控制的情況而直接或間接導致客戶受損，本公司不承擔任何直接或間接責任。",
        "29 合併、併入和抵銷",
        "29.1 合併及綜合帳戶：在不影響本公司或任何高盈證券成員之任何其他權利，或本公司或任何高盈證券" +
          "成員與客戶之間不時存在的任何其他協議享有之權利的情況下，本公司可毋需事先通知客戶，隨時" +
          "將客戶在本公司或任何高盈證券成員開設之任何戶口（不論是否在香港開設，及不論是何種貨幣）" +
          "之全部或任何資金、投資產品或其他財產（不論是個人或與任何其他人士共同持有，及不論是否已" +
          "到期或受通知所限）進行抵銷、轉讓或運用，且客戶亦授權每一高盈證券成員按本公司或其他相關" +
          "高盈證券成員要求向其轉讓或發放上述資金、投資產品或其他財產，以清償客戶之債務。當此種結" +
          "合、合併、抵銷或轉移要求將一種貨幣兌換為另一種貨幣時，應當使用本公司以當時相關市場通行" +
          "的匯率為基礎確定的匯率。出於上述目的，客戶授權公司及高盈證券成員彼此共享有關此類帳戶的任何和所有數據。",
        "29.2 提款：如果客戶指示公司向客戶提取或轉移任何款項、投資產品或其他財產，公司可從在公司或任" +
          "何高盈證券成員開立的任何帳戶中提取或轉移任何該等款項、投資產品或其他財產。",
        "30 通訊和通知",
        "30.1 致客戶的通訊（以書面形式）：除非本協議另有規定，本公司致客戶的任何通訊或通知應以書面形式" +
          "發出或作出至客戶最後已知的地址、傳真號碼或電郵地址（視乎情況而定）或透過電子方式（包括" +
          "電子服務）發出或作出，而（i）如以郵寄方式交付，則於投遞後 72 小時後，即足以證明該通訊或通" +
          "知已正確填寫地址並投遞，且已被客戶收到或（ii）如以傳真、電郵或透過電子方式（包括電子服務）" +
          "交付，則立即被視為已被客戶收到。",
        "30.2 致客戶的通訊（電話）：除非本協議另有規定，本公司亦可通過電話向客戶發出任何通訊或通知，並" +
          "應在通過電話發出通訊或通知後立即被視為已被客戶收到。",
        "30.3 致公司的通訊（書面）:客戶致本公司的任何通訊或通知應採用書面形式，並發送至本公司最後已知" +
          "的地址、傳真號碼或電子郵寄地址，並應僅在本公司實際收到並確認該等通訊或通知時被視為已由本公司收到。",
        "30.4 致公司的通訊（電話）：除本協議另有約定外，客戶亦可以以電話方式向本公司發出任何通訊或通知，" +
          "經本公司向客戶確認後，方視為本公司已收到該通訊或通知。",
        "31 關鍵時間",
        "時間是客戶履行與本協議有關的所有義務的關鍵因素。如果客戶向本公司寄送的任何有關帳戶或本",
        "公司發出的任何指令的文件因任何原因未注明日期，則本公司在收到該等文件時加蓋在該等文件上",
        "的時間戳記記所示的時間和日期即為該等文件日期的結論性。",
        "32 自動順延",
        "各方同意，如果本公司同意或有義務採取、採取或進行任何事項、行動或交易的任何日期（「行動日」）",
        "為非營業日，則行動日應自動順延至下一個營業日。",

        "33 可分割性",
        "本協議的每一條規定均可分割且與其他規定不同。本協議的任何條款如因任何原因在任何司法轄區" +
          "不合法、無效或不可強制執行，僅在該等不合法、無效或不可強制執行的範圍內無效，不得影響其" +
          "餘條款的合法性、有效性或可強制執行性或該等條款在任何其他司法轄區的合法性、有效性或可強制執行性。",
        "34 轉讓",
        "未經本公司事先書面同意，客戶不得出讓或轉讓其在本協議或任何投資產品項下的權利和/或義務。" +
          "本公司可在不獲得客戶事先同意的情況下出讓或轉讓其在本協議項下的任何權利和/或義務。",
        "35 繼任者和受讓人",
        "35.1 繼任者和受讓人：即使本公司被任何其他主體吸收合併或與任何其他主體合併，本協議應及於本公" +
          "司、其繼任者和受讓人之利益。本協議應對客戶及其繼承人、執行人、管理人、遺產代理人、繼任者" +
          "和獲准受讓人（視具體情況而定）具有約束力。",
        "35.2 獨資或合夥企業的承繼：協議在客戶業務發生變更或承繼後繼續有效，在合夥企業或商號情形下，" +
          "對合夥人及其個人代表具有約束力，在個人情形下，對其個人代表、接管人或受託人不論是否破產，均具有約束力。",
        "36 雜項條文",
        "36.1 變更通知：如果與本公司或本公司的服務相關的名稱、位址或許可資訊、利息收費、費用及本協議",
        "中規定的或與本協議相關的其他費用發生任何重大變更，本公司應立即通知客戶。該等事項的示例如下：",
        "(a) 本公司的全名及地址，包括其在證監會的牌照狀態及其中央編號（由證監會指定的唯一識別碼）；",
        "(b) 公司向客戶提供或呈現的服務的性質；",
        "(c) 客戶應支付給本公司的報酬（及支付的依據）；",
        "(d) 在公司向客戶提供保證金或賣空安排的情況下，保證金要求的詳情、利息費用、追收保證金以" +
          "及未經客戶同意可能將客戶倉位平倉的情況。",
        "36.2 修訂：本公司可以其酌情權決定並通過通知客戶修訂、刪除或替代本協議的任何條款或在本協議增" +
          "加新條款，並說明該等修訂、刪除、替代或增加。該等變更應被視為已納入本協議，並在（a）客戶" +
          "繼續使用本協議項下提供的任何服務，及（b）本公司可能通知客戶的日期（以較早發生者為准）對" +
          "客戶具有約束力。如果客戶不同意該等變更，客戶不得使用本協議項下提供的任何服務，並應在（b）" +
          "中所述日期前以書面形式向本公司提出異議。",
        "36.3 投訴：針對本公司的任何投訴均應以書面形式向本公司提出。",
        "36.4 欺詐：如果客戶懷疑存在欺詐或未經授權進入任何帳戶的情況，客戶應立即通知本公司。",
        "36.5 英文文本優先：如果英文文本和中文文本存在任何不一致，應以英文文本為准。",
        "36.6 權利累積：任何一方在本協議項下的權利、權力、補償和特權是累積的，不排除法律或其他方面規" +
          "定的任何其他權利、權力、補償和特權。",
        "37 遵守規章制度",
        "37.1 一般規定：在有關交易所、結算所或市場執行的每項交易，均須繳付該交易所、結算所或市場不時",
        "徵收的任何交易手續費、稅款、征費或其它費用，而客戶須負責繳付。",

        "37.2 適用法規：本協議應受限於證券及期貨條例及任何其他適用法規。",
        "37.3 香港聯合交易所：就在香港聯合交易所達成的交易而言：",
        "(a) 香港聯合交易所、香港中央结算有限公司和聯交所期權結算所的規則應對客戶和本公司具有約" +
          "束力，如果規則和本協議之間有任何衝突，則以規則為准；",
        "(b) 在聯交所進行的每項交易均需收取交易費用，該費用應由客戶承擔；及",
        "(c) 在香港聯合交易所執行的每項交易須繳付香港聯合交易所不時徵收的其他稅項，而該等其他稅項須由客戶承擔。",
        "37.4 場外衍生品交易：就場外衍生品交易而言，場外結算規則對客戶和本公司均有約束力（如適用），若" +
          "規則與本協議有任何衝突，則以規則為准。",
        "37.5 外地市場：凡在香港以外任何市場進行的交易，有關交易所、結算所或市場的規則對客戶和本公司" +
          "均有約束力，並在規則與本協議有任何抵觸時，以規則為准。",
        "37.6 報告職責:當本公司有合理理由懷疑客戶違反適用規例的任何重大違反、侵犯或不合規規定時，本公" +
          "司有責任立即向有關機關或人士（包括香港監管機構）報告，提供涉嫌違反、侵犯或不合規的詳情" +
          "及有關資料及文件。客戶不得要求公司或其高盈證券對該等報告所產生的任何後果承擔責任。",
        "38 確認和獨立意見",
        "38.1 確認：客戶確認其已閱讀並理解本協議，且客戶同意受本協議約束。",
        "38.2 獨立意見：客戶同意，就任何交易向其認為適當的顧問尋求獨立意見（包括法律意見）是客戶的責" +
          "任，特別是為附件 II（申購新發行證券）之目的，客戶確認，本公司已邀請客戶就每份申請尋求獨立" +
          "的法律及其他專業意見，客戶僅有責任獲得其認為適當的建議。",
        "39 通融",
        "39.1 通融：本公司方面未有行使或延遲行使本公司可能擁有的任何權力、權利或補償不得構成對該等權" +
          "力、權利或補償的放棄。本公司在任何時間未堅持嚴格遵守本協議或本協議的任何條款或本公司繼" +
          "續進行該等行為在任何情況下均不得構成或被視為本公司對其任何權利或特權的一般或具體放棄，" +
          "除非該等放棄以書面形式作出並由本公司簽署。",
        "39.2 事先要求：在本協議規定的任何時間，本公司的事先投標、對原始或額外保證金的要求或任何種類" +
          "的催繳、或本公司的先前未完成的要求或催繳、或關於該等出售或購買的時間和地點的通知不應被" +
          "視為本公司放棄出售、購買或平倉任何持倉或變現任何客戶的投資產品或被抵押資產的權利。",
        "40 適用法律、司法管轄區和爭議解決",
        "40.1 適用法律：本協議及各方的所有權利、義務和責任應受香港法律管轄，並依其進行解釋。",
        "40.2 司法管轄區：香港法院對因本協議產生的或與之相關的任何爭議（包括關於本協議的存在、效力或" +
          "終止的任何爭議）（「爭議」）具有專屬司法管轄權。各方同意，香港法院是解決爭議的最適當和最合" +
          "宜的法院，因此，任何一方不得提出相反主張。儘管有上述規定，仍不得阻止本公司在任何其他有" +
          "管轄權的法院就爭議提起訴訟。在適用法規允許的範圍內，本公司可在任何數量的司法轄區同時提起法律程序。",
        "40.3 法律程序文件的通知：如果客戶在香港沒有營業地或不是香港居民，本公司可要求客戶在香港委任" +
          "一人為本公司的客戶法律程序文件代理人，代表客戶接收及確認在香港送達的任何法律程序文件通" +
          "知。客戶同意，任何法律程序文件如按照客戶指定的位址交付至該法律程序文件代理人，則應被視" +
          "為已充分送達該法律程序文件。如果客戶須委任法律文件接收代理人，而任何人士因任何原因不再" +
          "擔任法律文件接收代理人，客戶應立即委任繼任的法律文件接收代理人，並書面通知本公司該委任。" +
          "如果客戶未能提供其法律程序文件代理人的詳情，客戶不可撤銷地授權本公司代表其指定該代理人。" +
          "本公司應立即將該等委任通知客戶，並提供該等代理人的詳情。",
        "40.4 第三方的權利：本協議的任何規定均無意為《合約（第三者權利）條例》（香港法例第 623 章）之目" +
          "的授予任何第三方強制執行本協議的任何條款或授予任何第三方在本協議項下的任何利益的任何權利，下述範圍除外：",
        "(a) 本協議另有明確説明；",
        "(b) 獲准的繼任者和受讓人可享有並强制執行該等權利或利益；",
        "(c) 任何高盈證券成員均可強制執行本協議的任何條款並享有本協議授予其的任何利益。",

        "附件 I：保證金融資",
        "本附件 I 適用於本公司提供的與證券保證金融資貸款有關的服務。本附件為本協議的補充條款並應與以及可" +
          "能不時修訂的適用於公司提供的服務的任何其他條款和條件一同閱讀。它是本協議的組成部分。",
        "1 定義和詮釋：",
        "在本附件 I 中，除非文義另有所指，下列詞語具有下列涵義：",
        "「合資格證券」是指本公司全權酌情決定為形成保證金之目的可接受的投資產品；",
        "「保證金」是指在現時或其後任何時間本公司全權酌情決定要求或根據適用法規要求，向本公司或" +
          "其代名人或高盈證券成員支付、存託、轉讓或促使轉讓或持有以作為證券保證金融資貸款擔保的款" +
          "項及合資格證券；",
        "「追收保證金通知」具有本附件第 3.1 條（追收保證金通知）中規定的涵義；",
        "「保證金比率」是指客戶獲准以保證金從本公司借取（或以其他方式自本公司取得其他方式的財務" +
          "通融）的合資格證券市值（由本公司全權酌情決定）的百分率；及",
        "「證券保證金融資貸款」是指本公司根據本協議的規定以及本公司與客戶不時約定的指定條款不時" +
          "向客戶提供的循環信貸額度，包括從證券保證金帳戶中借記的所有金額。",
        "2 證券保證金融資貸款",
        "2.1 目的：證券保證金融資貸款的目的是為客戶通過其證券保證金帳戶不時取得或持有的投資產品（本" +
          "公司接納的）提供資金。",
        "2.2 上限和酌情權：證券保證金融資貸款的貸款上限應為本公司不時釐定的金額。公司可全權酌情決定" +
          "在任何時間增加或減少證券保證金融資貸款的貸款上限，提高或降低保證金比率，取消或終止證券" +
          "保證金融資貸款，拒絕在證券保證金融資貸款下支付或墊支任何款項（無論是否已超過客戶的貸款" +
          "上限），並有權要求客戶立即支付欠本公司的與證券保證金融資貸款相關的所有金錢和款項，無論是" +
          "本金、利息還是其他結欠。",
        "2.3 到期金額：在無明顯錯誤的情況下，公司簽發的說明客戶在任何特定時間在證券保證金融資設施項" +
          "下到期應付給公司的金額的文件應為決定性的，並對客戶具有約束力。",
        "2.4 結算：本公司獲授權動用證券保證金融資額度，以結算因客戶購買投資產品及任何相關佣金、費用" +
          "及開支而應付本公司的任何款項。",
        "3 保證金",
        "3.1 追收保證金通知：客戶應於所有時候監控並維持足夠的保證金，以滿足任何保證金要求（無論是由" +
          "交易所，結算所或監管機構根據適用法規以及由公司實施的保證金要求），並應本公司要求，以本公" +
          "司完全酌情權認為有必要的金額、形式、方式和時限支付或存入額外保證金，以就保證金比率和證" +
          "券保證金融資提供充分的擔保（“追收保證金通知”）。",
        "3.2 金額：以保證金形式要求的金額不應低於但可超過適用法規可能要求的金額。",
        "3.3 通知：客戶同意，在本公司根據本條款第 30 條（通訊及通知）向客戶發出該保證金要求的通知後，" +
          "保證金催繳應被視為適當追繳。儘管有上述規定，本公司並無義務通知客戶其未能維持足夠的保證" +
          "金，並且在發生這種情況的情況下，無須另行通知或要求客戶就有權採取本附件 I 第 3.5 條（未能滿" +
          "足追收保證金要求）中指定的任何措施。",
        "3.4 保證金的支付和存入：保證金的支付和存入必須：",
        "(a) 就款項而言，應根據本條款第 11.6 款（全額支付）的規定進行支付；及",

        "(b) 就合資格證券而言，為客戶合法及實益擁有，及客戶對存放證券擁有良好的權利及所有權，且" +
          "目前及將來均不附帶任何種類的任何留置權、押記或產權負擔。",
        "3.5 未能滿足追收保證金要求：客戶同意，任何時候未能滿足保證金要求或維持足夠的保證金將構成違" +
          "約事件，並且在發生此類事件時，公司有權自行決定且無需另行通知，可採取本條款第 21.2 條（補" +
          "償）中指定的任何一項或多項措施，包括在任何時候，在任何時間，公司確定的方式和價格或條款。客戶進一步同意：",
        "(a) 對於本公司根據本條款第 21.2 條（補償）採取的清算或採取行動可能引起的任何虧損，並應根" +
          "據本條款第 21.5 條（短欠）向本公司支付等於該短欠的金額以及公司根據本條款而採取的任何" +
          "行動或進行的交易產生的任何其他費用和支出；",
        "(b) 公司，任何高盈證券成員或其任何董事，僱員或代理商均不對客戶因公司根據本條款採取的行" +
          "動或進行的交易而蒙受的任何損失承擔責任（無論採取何種方式發生），包括公司最初延遲執" +
          "行但隨後影響到此類平倉或清算的情況；和",
        "(c) 在適用的範圍內，本條款的第 21.7 條（平倉）應適用於本條。",
        "3.6 持續擔保：保證金應構成擔保抵押品的一部分，作為以公司為受益人的持續擔保抵押品，用於支付" +
          "和清償客戶在證券保證金融資額度項下或以其他方式到期或欠公司的所有負債。",
        "4 證券保證金融資設施的運營",
        "4.1 抵押品：為避免疑義，在公司向客戶授予任何證券保證金融資貸款的情況下，抵押品還應擔保由該" +
          "等證券保證金融資貸款產生的或與之相關的責任（無需客戶簽署任何其他文檔）。",
        "4.2 利息：應根據條款第 5.7 條（利息）的規定對證券保證金融資項下的所有未付款項計收利息。",
        "4.3 拒絕提取：只要客戶對本公司仍有任何未償債務，公司有權拒絕提取任何或所有保證金。",
        "4.4 終止：證券保證金融資設施將在以下任何一項或多項事件發生時終止：",
        "(a) 本附件 I 第 5.1 款（常設授權）中提及的客戶常設授權的撤銷；或",
        "(b) 該常設授權在期滿時或被要求續期時未續期；或",
        "(c) 根據條款進行的任何終止，以及為此目的發出的任何終止通知應被視為證券保證金融資設施的終止通知。",
        "5 處理保證金",
        "5.1 常設授權：《證券及期貨（客戶證券）規則》（香港法例第 571H 章）規定，本公司不得因任何用途的" +
          "貸款或墊款而存入或出借保證金，但經客戶書面特別授權的除外。根據本條款第 3.1 條（常設授權）" +
          "的規定，客戶已同意給予本公司該等特定書面授權。",
        "5.2 一般例外情況：儘管有本附件 I 第 5.1 條（常設授權）的規定，客戶授權本公司根據條款第 10 條（投" +
          "資產品的安全托管）的規定將客戶保證金存入任何相關結算系統、本公司的指定人或其他實體並為" +
          "強制執行本附件 I 項下設立的保證金之目的以本公司認為適當的任何方式處理客戶保證金（包括出" +
          "售本附件 I 允許的任何抵押品以根據本協議的規定變現客戶應向本公司支付的任何款項）。",
        "5.3 再抵押：客戶確認並同意，本公司可在獲得客戶書面授權後，將該保證金再抵押給任何其他人，作" +
          "為該其他人向本公司提供財務融資的抵押品。",
        "5.4 第三方留置權：如果保證金被出借給第三方或存放在第三方，該第三方將對保證金享有留置權或押" +
          "記。儘管本公司對在客戶授權下出借或存入的該等保證金對客戶負責，但第三方的違約行為可能導致該等保證金的損失。",

        "5.5 證券保證金帳戶與證券現金帳戶：與證券保證金帳戶不同，證券現金帳戶不涉及證券保證金融資設" +
          "施。如果客戶不需要證券保證金融資融資，或不希望本公司出借或追再抵押保證金，客戶不應簽署" +
          "相關的常設授權文檔，也不應要求本公司開立證券保證金帳戶。",
        "6 風險披露聲明",
        "客戶確認其已經閱讀並理解本公司就提供證券保證金融資貸款相關服務載於附件 X（風險披露聲明）" +
          "或以其他方式提供予客戶並的使用客戶選擇語言（英文或中文）風險披露聲明，客戶已受邀閲讀該" +
          "等風險披露聲明、發出提問及在有需要時尋求獨立意見並充分接受有關證券保證金融資貸款的風險。",
        "附件 II：申購新發行證券",
        "本附件 II 適用於本公司提供與申購新發行證券和相關貸款有關服務。本附件為本協議的補充條款並應與以及" +
          "可能不時修訂的適用於公司提供的服務的任何其他條款和條件一同閱讀。它是協議的組成部分。",
        "1 定義和詮釋",
        "在本附件 II 中，除非文義另有所指，下列詞語具有下列涵義：",
        "「獲分配證券」指每份受理認購申請所涉及的全部證券；",
        "「申購」指公司或其指定人士作為代理代表客戶根據本附件 II 第 2 條（申購）的規定就發售證券的" +
          "認購提出的任何和每項申請；",
        "「申購貸款」指公司根據本附件 II 第 7 條（申購融資）為客戶提供的每一項申購相關融資安排；",
        "「申購金額」就每份申購而言，指等於申購的發售證券的價值總額，加上客戶就申購應付的所有費" +
          "用、收費和支出（包括交易征費、佣金、開戶手續費及適用的其他費用）;",
        "「手續費」就每筆申購貸款而言，指公司可能不時通知客戶的與申購貸款相關的手續費金額（如有）;",
        "「發行人」：指其證券在交易所公開發行募集的公司或其他法人。",
        "「發行」指發行人發行新股或公開發售證券的任何行為；",
        "「發售證券」指每一次發行證券，發行人向公眾募集並公開發行的證券；及",
        "「相關主體」就每一要約而言，指發行人、保薦人、承銷商、配售代理人、登記處、中央託管人、收" +
          "款銀行及該要約涉及的其他中間機構、聯交所、證監會、結算所、任何其他相關監管機構和/或主體。",
        "2 申購",
        "2.1 申購：客戶要求並授權公司或其代名人作為客戶代理，不時根據本附件 II 提出申請，但須經客戶與" +
          "公司就以下各項達成協議有關申購的：",
        "(a) 發售證券的數量；",
        "(b) 發行人的名稱；及",
        "(c) 申購金額",
        "2.2 拒絕申購的決定權：本公司保留絕對酌情權以任何理由拒絕任何申購，包括在相關時間客戶的帳戶" +
          "中沒有足夠的資金來結算申請金額和手續費或為此目的預先安排。",
        "2.3 客戶代理人：如果公司或其指定人士提交申請，公司或其指定人士為申購發售證券之目的作為客戶" +
          "的代理人提交申請，除非公司或其指定人士（視具體情況而定）並非發行人或相關要約涉及的其他" +
          "方的代理人，但通過要約的發售文檔另行明示或通過要約文檔另行通知客戶除外。",
        "2.4 申購要求：客戶必須確保每份申請符合相關要約的發行人規定的任何最低、最高、面值和/或其他要" +
          "求（無論是關於發售證券的數量還是價值還是申請的數量）。公司將不會處理未完全符合所有該等要求的任何申請。",
        "2.5 批量申購：若申請構成本公司或其代名人批量申請的一部分，不論是以本人名義還是以其他客戶名" +
          "義提交，客戶確認並同意如下事項：",
        "(a) 該等批量申購可能因與客戶和申購無關的原因而被拒絕，在不存在欺詐、重大過失或故意違約" +
          "的情況下，公司及其指定人士不因該等拒絕而對客戶或任何其他人士承擔任何責任；",

        "(b) 如果由於客戶未能遵守其在本協議項下的任何義務或以其他方式與申購（包括客戶作出的任何" +
          "陳述和保證不真實或變得不真實）或與客戶相關的任何其他因素而導致批量申請被拒絕，客戶" +
          "應賠償公司及其代名人可能遭受或發生的或針對公司或其代名人提出的所有損失、損害、費用、" +
          "收費、支出（包括全部彌償的法律費用）、權利主張或要求。客戶確認，客戶亦可能須就受該等" +
          "未能履約或受其他因數影響的其他人士所蒙受的損害負責；及",
        "(c) 在批量申購僅被部分接受的情況下，客戶同意公司或其指定人有權自行決定在公司或其指定人" +
          "中分配獲分配證券，包括在批量申購項下在公司及其指定人的客戶之間平均分配獲分配證券，" +
          "並且客戶不得就批量申購向公司或其指定人的另一客戶主張獲分配證券或主張優先權。",
        "2.6 不得撤回：客戶確認並同意，一旦公司或其指定人士代表客戶提交任何申購，或以其他方式由公司" +
          "或其指定人士處理任何申購，該等申購可能無法被撤回、取消或修改。",
        "3 公司的責任",
        "3.1 無認許：公司及其指定人士對於任何招股說明書、發行文件、申請表和/或與任何要約相關的其他檔" +
          "的內容不承擔任何責任，不對該等內容負責，未曾且不得被視為已授權、認許或核實該等內容。",
        "3.2 不是投資顧問：除非另行書面委任，公司及其指定人士不是客戶就任何發行或申購的投資顧問，對" +
          "於客戶因任何發行或申購而可能遭受的任何損失不承擔任何責任。客戶確認，每項申購均由客戶自行判斷及自行承擔風險。",
        "3.3 無陳述：公司及其指定人士對於任何要約中發售證券的配售結果不作出任何承諾、保證或陳述，在" +
          "任何情況下，公司及其指定人士對分配結果或因任何原因全部或部分拒絕任何申請的任何行為不承擔任何責任。",
        "4 通知和批准",
        "4.1 申購的批准：發行人應全權負責批准或不批准申購，並公佈發售證券的分配結果。分配結果的具體" +
          "公佈安排可能與其他要約存在差異，客戶應當通過閱讀相關招股說明書了解具體安排。公司或其指" +
          "定人將以公司認為適當的方式將申請的結果通知客戶。",
        "4.2 獲分配證券的處置：除非公司或其指定人收到客戶發出的相反通知，並就任何申請支付客戶欠公司" +
          "或其指定人的所有款項（在公司或其指定人在向客戶發出的配售通知中可能指定的時間內（在不影" +
          "響客戶要求時還款的權利或任何其他權利或補償的情況下）），公司及其指定人有權但無義務，在未" +
          "通知客戶或獲得客戶同意的情況下，以其認為適當的方式、按其認為適當的價格、不受任何限制和" +
          "權利主張約束且不承擔任何損失的情況下，出售或以其認為適當的優先順序將該等出售或處置的收" +
          "益用於清償任何負債，包括與獲分配證券的出售或處置相關發生的費用，以及公司及其指定人與申" +
          "請相關發生的所有其他費用、手續費、客戶就申購貸款應付的利息、申購貸款的未償還本金金額和" +
          "申請額，剩餘的金額（如有）應支付給客戶或按客戶指令支付。獲分配證券所得資金或處置證券發" +
          "生虧損時，客戶應負責彌補，並按要求向本公司或其名義持有人進行支付。",
        "4.3 付款和解除：如果客戶根據本附件 II 第 4.2 條（獲分配證券的處置）的規定向公司或其指定人士發" +
          "出任何通知，客戶應在發出此類通知時按要求向公司或其代名人付款，或應要求以其他方式向客戶" +
          "支付與相關申請有關的所有欠公司或其代名人的款項（包括任何相關人士指定的所有費用、收費和" +
          "開支）。公司沒有義務發行或促使其代名人向客戶發行與已分配證券有關的證書，或促使其將貸記至" +
          "客戶指定帳戶的入賬，除非並且直到本公司及其代名人完全滿意地收到了客戶欠其的所有款項。",
        "5 退款",
        "5.1 不成功申購：如果申購已提交但全部或部分未獲批准，受限於本附件 II 第 5.4 條（融資費用）和第" +
          "7 條（申購融資）的規定，公司或其指定的人士將安排在發行人公佈的退款日以本條所述的相同方式" +
          "退還申請金額（或適用餘額，視具體情況而定）。",
        "5.2 較低的發行價格：如果發售證券的發行價格（由發行人最終確定）低於客戶最初支付的申購金額，" +
          "公司或其指定人將安排根據相關要約的條款和條件向客戶退還申購金額的剩餘部分，但須遵守本附" +
          "件 II 第 5.4 條（融資費用）和第 7 條（申購融資）的規定。",
        "5.3 費用：與申請有關的所有手續費及所有其它費用均不可退還，即使相關發行方的上市被延遲或取消也不可退還。",
        "5.4 融資費用：如果公司已就申請向客戶提供申購貸款，客戶不可撤銷地同意並確認，公司或其指定人" +
          "（視具體情況而定）有權將任何退款金額用於結算客戶欠公司的任何款項，具體方式見本附件 II 第" +
          "4.2 條（獲分配證券的處置）。",
        "6 客戶的承諾和責任",
        "6.1 不禁止：客戶向公司及其任何指定人士並為公司及其任何指定人士的利益保證，客戶不是被任何相" +
          "關人士或任何適用規例禁止提出申請或擁有發售證券的人士，客戶以主事人身份而非代表受該等禁" +
          "止的任何人士或任何其他人士提出每份申請。",
        "6.2 發售文件：就每份申請而言，客戶明白及應接受及遵守相關申請表、招股說明書及/或發售文件及與" +
          "該等發售有關的任何其他文件所載有關發售的所有條款及條件。客戶同意受公司或其指定人士提出" +
          "的申請所涉及的每項要約的條款和條件（並根據要求作出所有陳述、保證、確認和承諾）的約束。" +
          "客戶應當以招股說明書等招股文檔為依據作出投資決定。公司無義務向客戶提供該等招股說明書及其他發行文檔。",
        "6.3 多項申請：客戶向公司及其代名人陳述並保證，就任何申請（a）（在不允許多項申請認購要約證券" +
          "的情況下）而言，客戶過去和將來均未作出、目前和將來均未作出、目前和將來均不會促使：多於" +
          "一份認購發售證券的申請，不論為本身或任何其他人士的利益，及（b）客戶並未被分配（不論為本" +
          "身或任何其他人士的利益）與申請書中申請的股份或認股權證或權益屬同一類別或類型的任何股份" +
          "或認股權證或權益。客戶確認，客戶違反本條規定的任何陳述和保證或本條規定的任何陳述和保證" +
          "不準確，除申請被拒絕之外，還可能導致公司或其指定人士代表其自身或其他客戶提交的其他申請" +
          "被拒絕。經要求，客戶應賠償公司及其指定人士由於該等違約或不準確而遭受的所有損失。客戶確" +
          "認並接受，公司、其指定人及相關人士就相關申請將依賴本條中載明的陳述和保證。",
        "6.4 一般陳述：就每份申請而言，客戶向公司及其指定人士陳述並保證：",
        "(a) 客戶為獨立第三方，不涉及發行人和/或其各自的任何子公司的任何董事、首席執行官、大股東" +
          "或任何該等子公司的緊密聯繫人（定義見《聯交所證券上市規則》），亦未與前述主體一致行動。" +
          "此外，客戶的認購並未由任何該等人士直接或間接提供資金或支持；",
        "(b) 客戶在認購發售證券前未持有發行人的任何權益；及",
        "(c) 客戶不是美國人士，且客戶認購不會要求發行人和/或公司或其指定人士遵守香港以外任何區" +
          "域的任何法律或法規項下的任何要求。",
        "6.5 其他陳述：除客戶就每份申購向公司或其指定人士作出或將作出的其他陳述、保證和承諾之外，客" +
          "戶向公司及其指定人士作出就申購發售證券的申請人必須作出的所有陳述、保證和承諾（無論是向" +
          "任何主體還是向所有相關主體作出的陳述、保證和承諾）。",
        "6.6 進一步保證：客戶確認並理解，與每份發行或申請相關的法律和監管要求及市場慣例可能會不時發" +
          "生變化。客戶承諾根據公司或其指定人士可能不時決定的法律和監管要求與市場慣例向公司及其指" +
          "定人士提供相關的資訊，作出相關的披露，採取步驟，並作出相關的陳述、保證與承諾。客戶還應遵守該等要求和慣例。",
        "6.7 公司的陳述：如果公司或其指定人（視具體情況而定）就任何發行或申購被要求就客戶或任何其他" +
          "事項向任何一名或多名相關主體作出任何承諾、陳述和保證，客戶授權公司及其指定人僅依賴客戶" +
          "向公司或其指定人作出的任何相應承諾、陳述和保證而去作出該等承諾、陳述和保證。客戶應受任" +
          "何相關人士作出的所有適用公告及適用於每項發行或申購及發行獲分配證券的所有適用規例的約束。",
        "6.8 公司代表客戶行事：在不影響條款第 2.8 條（授權書）的情況下，客戶授權公司及其指定人士代表客" +
          "戶簽署為提出任何申購之目的而需要簽署的所有檔並開展的所有事項。客戶接受公司和/或其指定人" +
          "作為代理人代表客戶就每份申購所做的所有事情。在本公司或代名人作為客戶代理人的情況下，客" +
          "戶應接受每次申購中所申購的發售證券或更少的數量會分配到本公司或代名人。客戶賠償本公司及" +
          "其代名人在任何與本申請相關的任何損失或索賠。",

        "6.9 披露：如果適用法規要求或與相關發行或申請相關要求或要求披露，客戶授權公司及其指定人士向" +
          "任何相關主體披露關於客戶和相關申請的所有資訊。",
        "7 申購融資",
        "7.1 申購融資：客戶可申請並要求公司不時向客戶提供用於申購的申購貸款，但須受限於本附件 II 的規" +
          "定，並受限於客戶和公司就相關申購就下列事項達成的協議：",
        "(a) 申購貸款本金；",
        "(b) 利率；",
        "(c) 印花稅及所有其他收費；及",
        "(d) 手續費。",
        "7.2 公司絕對酌情權：任何申購貸款的提供和提取由公司自行決定，並受限於本協議。公司可在任何時" +
          "候拒絕提供申購貸款，而無需給予任何理由。",
        "7.3 保證金：如果客戶以保證金形式向本公司支付任何款項，本公司可將該款項存入客戶的相關帳戶，" +
          "並可在申購被接受時將該款項用於支付應付的保證金。客戶同意，公司實際收到的任何該等保證金" +
          "應在申購貸款的任何金額被如此使用之前用於清償申請金額。",
        "7.4 費用和支出：客戶將在公司要求時立即向公司支付申購貸款、相關利息、手續費、與申購貸款相關 的所有費用、收費和支出。",
        "7.5 申購貸款用途：申購貸款僅供客戶申購使用。儘管申購由公司或其指定人代表客戶提交，客戶對申" +
          "購貸款的任何金額或將申購貸款用於相關申購以外的任何目的不享有任何性質的任何權利、權屬、權益或權利主張。",
        "7.6 提取：如果公司向客戶提供申購貸款，公司將申購貸款金額貸記至相關帳戶。如果任何貸款申請將" +
          "由公司的指定人士提出，公司的指定人士應始終為公司託管相關申購貸款的金額，以待向發行人付" +
          "款或按發行人的指令付款。",
        "7.7 償還：申購貸款應連同相關配售和公開發行文檔中規定的所有利息及任何其他未償還金額在相關配" +
          "售和公開發行文件中規定的退款日全額償還。",
        "7.8 提前還款：除非公司另行同意，客戶無權在相關配售和公開發行文檔中規定的還款日之前部分或全" +
          "部償還申購貸款及任何其他相關債務。",
        "7.9 優先權：儘管有本附件 II 的任何其他規定，公司有優先權在任何時間要求立即償還任何申購貸款的" +
          "任何未償還金額，並取消任何申購貸款。",
        "7.10 押記：考慮到公司根據相關申請向客戶提供申購貸款，在向公司分配並發行獲分配證券時（公司或" +
          "代名人作為客戶的代理人），作為實益擁有人的客戶特此押記（以第一固定押記方式）、轉讓、抵押" +
          "和/或質押，並同意向公司押記、轉讓、抵押和/或質押客戶對獲分配證券的所有權利、權屬和權益，" +
          "作為客戶就申購貸款和申請應向公司或其指定人支付的所有款項以及客戶向公司或其指定人履行的" +
          "任何其他義務的持續擔保。本押記設立的擔保應延伸並涵蓋任何及所有股息、權證、股份、股票、" +
          "權利、利益、利息、分配、增值及其他金錢和財產，該等金錢和財產在任何時間通過與獲分配證券" +
          "有關的替代、贖回、紅利、優先權、期權或其他方式產生或提供。",
        "7.11 向第三方進一步押記：受限於本附件 II 第 7.10 條（押記）構成的擔保，客戶授權公司在任何及所有" +
          "獲分配證券上以任何第三方為受益人押記、質押或以其他方式授予任何性質的擔保權益，作為公司" +
          "向第三方提供的為申購貸款的全部或部分提供資金的任何信貸安排的擔保。",
        "7.12 進一步擔保：考慮到公司向客戶提供申購貸款，作為實益擁有人的客戶以第一固定押記的方式向公" +
          "司押記、出讓、抵押和質押，並同意以向公司押記、出讓、抵押和質押的方式向公司押記、出讓、抵" +
          "押和質押客戶在公司開立的每個帳戶的結餘（包括帳戶的任何續期或重新指定）中不時擁有的所有" +
          "權利、權屬和權益，作為客戶就申購貸款和申請應向公司及其指定人支付的所有款項的持續擔保。",
        "7.13 擔保的性質：由本附件 II 第 7.10 條（押記）和第 7.12 條（進一步擔保）構成的每項擔保均為持續性" +
          "擔保，並擔保客戶不時欠公司的所有負債的最終餘額，即使所有或任何該等負債在任何中期得到償" +
          "還或清償。每份擔保是對公司持有的任何其他擔保的補充，不應受到公司持有的任何其他擔保的影" +
          "響，並可強制執行。對合併擔保權益權利的任何限制不適用於本附件 II 第 7.10 條（押記）或第 7.12" +
          "條（進一步擔保）構成的任何擔保。",
        "7.14 進一步保證：客戶應自費簽署所有轉讓文檔、授權書、委託書和/或其他文檔，並開展公司或其指定" +
          "人為完善公司或其指定人對獲分配證券的所有權和/或為歸屬或使公司或其指定人能夠以公司的名" +
          "義或以公司指定人和/或任何買方的名義歸屬該等獲分配證券，或為獲得、提交並強制執行本附件 II" +
          "中授予公司的擔保物和/或權利和補償的全部利益之目的而可能要求的所有行動和事項。公司及其提" +
          "名人有權行使本附件 II 中授予公司或其提名人的所有權利和權力，包括出售獲分配證券的權利。",
        "7.15 付款的用途：就任何申購貸款或用途向公司或其指定人士支付的任何款項可用於清償該等貸款或用" +
          "途，或存入公司或其指定人士為保留其證明客戶的全部負債的權利而決定的帳戶的貸方。",

        "附件 III：期權交易",
        "本附件 III 適用於本公司提供的與期權交易有關的服務。本附件為本協議的補充條款並應與以及可能不時修訂" +
          "的適用於公司提供的服務的任何其他條款和條件一同閱讀。它是協議的組成部分。",
        "1 定義和詮釋：在本附件中，除非上下文另有要求，下列表述應具有以下涵義：",
        "「工作日」是指相關交易所開市交易的任何日期，除卻星期六、星期日、公共假期以及相關交易所" +
          "宣佈為非交易日的任何其他日期；",
        "「行使價」亦稱為「履約價」，是指在期權合約中指定的每單位價格的目標證券，在行使該期權時可" +
          "以購買或出售目標證券；",
        "「到期日」是指可以在合約到期日前可以行使該期權合約的最後一天。如果該到期日並非工作日，" +
          "除非另有說明，否則該到期日會自動順延至下一個工作日；",
        "「價內期權」是指具有正內在價值的期權。具體而言，如在在美國交易所進行交易的期權的內在價" +
          "值最少等於$0.01 美元，則該期權便視為價內；",
        "期權的「內在價值」是指由本公司所確定的標的股票的內在價值超過（在認購期權的情況下）或低" +
          "於（在認沽期權的情況下）行使價；",
        "「保證金」指作為客戶在本附件項下對公司的義務擔保的現金、投資產品及或公司可接受的其他資產；",
        "「期權金」指持有人就期權合約的簽訂應支付給期權合約的發行人的金額；",
        "「聯交所客戶合約」具有聯交所期權交易規則中所定義的「客戶合約」的涵義；",
        "「聯交所合約」具有期權交易規則中所定義的「合約」的涵義；",
        "「聯交所綜合帳戶」具有期權交易規則中所定義的「綜合帳戶」的涵義；",
        "「聯交所期權合約」具有期權交易規則中所定義的「期權合約」的涵義；",
        "「聯交所期權交易所參與者」具有聯交所期權交易規則中所定義的「期權交易所參與者」的涵義；",
        "「聯交所期權系統」是指香港聯合交易所、聯交所期權結算所為香港聯合交易所期權業務交易提供" +
          "的期權交易系統、期權結算系統等；",
        "「聯交所期權買賣交易所參與人」具有聯交所期權交易規則中所定義的「期權買賣交易參與人」的涵義；",
        "「聯交所期權交易規則」指《香港聯合交易所期權交易規則》及其不時修訂或補充；",
        "「聯交所標準合約」指《香港聯合交易所期權交易規則》第六附件所載的香港聯合交易所不時指定" +
          "的適用於聯交所期權合約的標準條款和條件；",
        "「聯交所期權交易業務」，具有《期權交易規則》中所定義的「香港聯合交易所期權交易業務」；及",
        "「聯交所期權結算所抵押品」具有《聯交所期權結算所結算規則》中定義的涵義。",
        "2 法律法規",
        "2.1 法律等規定：所有期權交易均應遵守交易所在地的法律、規則、法規、交易所、市場和結算所（如" +
          "有）的慣例和使用。客戶不得單獨或者與他人共同違反交易所、市場和結算所可能不時規定的持倉" +
          "或者行權限制。本公司或交易所、市場或結算所採取的所有行動對客戶均有約束力。",
        "2.2 遵守法律：客戶應遵守有關交易所，市場和票據交換所有關所有期權交易的所有適用法規。",
        "2.3 交易限制：為有助於維護期權合約市場的公平有序，或者為保護投資者之目的，交易所或任何其他" +
          "相關監管機構、政府機構或專業機構，以其酌情權並不時限制特定期權的交易或執行期權合約。",
        "2.4 放棄/行權限制：",
        "(a) 就任何聯交所期權合約而言，客戶不能在合約到期日前行使該期權合約或放棄該期權合約，除" +
          "非客戶以書面方式指示本公司並獲接受；和",
        "(b) 就任何聯交所期權合約以外的期權合約而言，客戶不能放棄該期權合約，除非客戶以書面方式指示本公司並獲接受。",
        "2.5 截止時間：相關交易所、市場和結算所執行交付行權指示的截止時間，該等時間對客戶具有約束力。",
        "2.6 保密：本公司將對與帳戶相關的資訊保密，但可根據本公司的私隱政策聲明和/或本協議的其他適用",
        "條款向相關方和/或證監會、香港聯合交易所、香港交易所和任何交易所或任何其他相關監管機構提" +
          "供任何該等資訊，以遵守其要求或資訊要求。",
        "2.7 限制：本公司可對客戶在任何時候可能擁有的未平倉合約或交割義務設置限制。",
        "3 期權交易（一般性）",
        "3.1 客戶的利益：客戶確認，（i）帳戶僅為客戶的帳戶及利益而設，而非為任何其他人士的利益而設；或" +
          "（ii）客戶已以書面形式向本公司披露帳戶為其利益而設的人士的姓名；或（iii）就香港聯合交易所",
        "期權交易業務而言，客戶已要求本公司將帳戶作為香港聯合交易所的綜合帳戶運作，並將應本公司",
        "的要求立即通知本公司其在聯交所期權合約中擁有最終實益權益的任何人士的身份。",
        "3.2 執行：在不違反本公司規定的截止時間的前提下及本附件 III 的第 2.4 條（放棄/行權限制）：在執行" +
          "期權交易的交易所設定的交易時間內，可以接受在工作日當天執行的執行指示；及在任何特定期權" +
          "合約到期日前的營業日，公司將按照執行期權交易的交易所設定的交易時間接受行權指示。",
        "3.3 無到期通知：本公司無義務事先通知客戶期權到期日，客戶僅有責任採取行動執行期權合約。客戶" +
          "應知曉執行期權的交易時間和任何非交易日，以確保期權能夠及時行權。如果客戶未在相關機構和" +
          "交易所規定的時間內向本公司提供任何行權指示（本公司無義務通知）,客戶應放棄並免除本公司、" +
          "其管理人員、雇員和代理人因任何期權合約未被行權而令客戶蒙受損失的任何及所有索償。",
        "3.4 相關證券：本公司無義務向客戶傳達與期權涵蓋的相關證券或與之相關的任何證券相關的任何資訊，" +
          "或與期權相關的任何資訊，無論該等資訊屆時或之後已知或可用。客戶須自行負責以適當及適時的" +
          "方式行使客戶的任何認沽期權或認購期權的任何權利、特權或義務。",
        "3.5 證券保證金帳戶期權：若客戶在證券保證金帳戶賣出或買入期權，則：",
        "(a) 就認購期權而言，如對客戶行使認購期權，則客戶須將該等證券存放於證券保證金帳戶，直至" +
          "期權期屆滿，且不得出售或撤回該等證券。如期權被行使，本公司可向買方交付該等證券而無須事先通知客戶；及",
        "(b) 就任何認沽期權而言，如對客戶行使該等認沽期權，則客戶須在證券保證金帳戶內持有足夠的" +
          "資金以支付買入的證券，直至期權期屆滿為止，且不得提取該等資金或將其用作任何其他用途。" +
          "如期權被行使，本公司可使用該等資金購買該等證券，而無須事先通知客戶。",
        "3.6 本公司自身帳戶：本公司及高盈證券成員可為其自身帳戶交易期權以及與該等期權相關的證券。該" +
          "等交易可每日連續進行，並可在帳戶進行任何期權交易之前、同時或之後進行。在該等交易中，本" +
          "公司及高盈證券成員可進行與（a）客戶在帳戶中可能持有的倉位，或（b）本公司及高盈證券成員向" +
          "客戶推薦的交易，或（c）本公司及高盈證券成員可為客戶實施的交易類似或不同的期權倉位或其相" +
          "關證券。客戶明白此類交易可能會對客戶的利益產生不利影響。",

        "3.7 期權長倉截止期限：如果客戶執行一份期權長倉合約，客戶同意支付期權合約規定的全部執行價格。" +
          "客戶的期權長倉有機會到期及變得一文不值。如客戶未能在相應的行使截止期限前發出指示，則其" +
          "每一價內值期權長倉將會自動于到期日時行權。因此，如客戶不希望行使任何此類價內期權長倉，" +
          "則客戶必須在該未平倉的期權合約到期日前自行平倉。",
        "3.8 行使指定分配通知：公司應公平分配期權合約的行權指定分配通知。",
        "3.9 期權合約的義務:客戶應根據其所參與的每一份期權合約支付相對應的費用及交付，並履行其名義下" +
          "的所有義務。客戶在任何時候須自行承擔因遵守或未遵守該期限合約的後果所帶來的風險。具體而" +
          "言，如客戶的期權頭寸已被行使或轉讓，則必須承擔相應義務（包括結算義務）及承擔任何由此而生的損失（如有）。",
        "4 保證金和擔保",
        "4.1 擔保：任何帳戶中持有的所有證券和資金應根據條款第 16 條款（押記）進行押記。",
        "4.2 保證金：客戶同意向本公司提供保證金。該等保證金應按照本公司不時提出的要求支付或交付，保" +
          "證金所要求的金額不應低於或需要超過適用法規要求的金額（特別是關於客戶未平倉合約和交割義" +
          "務的規則），並可能要求提供進一步的保證金，以反映市值的變化及/或管理公司的信貸風險和其他風險。",
        "4.3 交付許可權：經要求，客戶應向本公司提供本公司在規則項下可能要求的許可權，以授權本公司直" +
          "接或通過香港聯合交易所期權買賣交易所參與人向聯交所期權結算所交付該等證券，作為與聯交所" +
          "期權交易業務相關的聯交所期權結算所擔保品，而該等授權是由客戶向本公司或本公司自行不時決" +
          "定的其他相關人士發出的指示所導致的；僅就期權交易而言，公司無權從客戶那裡進一步借入或借" +
          "出客戶的證券，或者以其他方式（根據客戶的指示或客戶的指示除外）佔有客戶的任何證券，以用於任何其他目的。",
        "4.4 隨時有足夠的資產：客戶在發出交易期權合約的指示時必須先確保其帳戶內已有足夠的資產，並且" +
          "客戶在整個期權合約期內須一直保持有足夠資產，直至該期權合約到期或被行使為止。",
        "5 期權金和佣金",
        "就根據客戶指示而生效的所有期權合約而言，客戶須在本公司通知的期限內，向本公司繳付期權金、" +
          "本公司的佣金及香港聯合交易所或有關交易所、市場或結算所徵收的任何其他收費及適用的征費；" +
          "本公司可從任何帳戶扣除該等期權金、佣金、押記及征費。",
        "6 香港聯合交易所期權交易相關的具體規則",
        "在不影響並補充本附件 III 的其他條款的情況下，本第 6 條款應在本公司為客戶或為客戶之利益開展" +
          "聯交所期權交易業務時適用。",
        "6.1 現狀：倘若本公司是已登記的聯交所期權經紀交易所參與者和香港結算的直接結算參與者，本公司" +
          "將通知客戶這一事實。本條款所述的主要負責客戶事務的期權員工或期權代表的全名應是帳戶開立" +
          "流程提及人士或是本公司可不時通知客戶指定的其他人士。",
        "6.2 適用規則：所有香港聯合交易所交易期權業務應根據適用於本公司的規則實施，包括但不限於香港" +
          "聯合交易所期權交易規則、聯交所期權結算所結算規則和香港結算的規則；特別是，聯交所期權結" +
          "算所在規則項下有權調整聯交所合約的條款，本公司應通知客戶任何影響客戶為一方的聯交所客戶" +
          "合約的該等調整，本公司、香港聯合交易所、聯交所期權結算所或香港結算根據該等規則採取的所" +
          "有行動應對客戶具有約束力。",
        "6.3 香港聯合交易所標準合約：相關期權系列的聯交所標準合約的條款應適用於本公司與客戶之間的每" +
          "份聯交所客戶合約，所有聯交所客戶合約應根據規則設立、行使、結算和解除。",
        "6.4 平倉/放棄：客戶確認：",
        "(a) 本公司可能會被要求平倉或放棄聯交所客戶合約，如本公司認為行使該聯交所期權合約會有可" +
          "能導致客戶短倉的情況出現及該客戶未能在該期權到期日前至少 2 個工作日前平倉或增加持倉。",
        "(b) 本公司可能被要求平倉或放棄聯交所客戶合約，以遵守香港聯合交易所施加的持倉限制；及",
        "(c) 如果本公司（或本公司經其開展聯交所期權交易業務的聯交所期權交易所參與者）違約，香港" +
          "聯合交易所的違約程序有可能導致客戶與其他聯交所期權交易所參與者之間聯交所客戶合約" +
          "被平倉、放棄或者由聯交所客戶合約替代。",
        "6.5 對發行人的變更：如果某一期權類別的標的證券的發行人的資本結構或構成發生變更，或在任何其" +
          "他異常情況下，聯交所期權結算所可在其認為必要和可取的情況下對該期權類別的條款和條件進行" +
          "調整，以確保香港聯合交易所期權類別未平倉合約的所有當事人得到公平對待。所有該等調整應對客戶具有約束力。",
        "6.6 替換：根據客戶的要求，本公司可以同意根據規則，將自己與客戶之間的聯交所客戶合同替換為客" +
          "戶與另一家聯交所期權交易所參與者之間的聯交所客戶合同。",
        "6.7 義務：客戶行使或針對客戶行使聯交所客戶合同》時，客戶應根據聯交所標準合同並在公司已通知" +
          "客戶的情況下，根據相關合同履行客戶的交付義務。",
        "6.8 主事人：儘管所有聯交所期權合約都將在聯交所行使，但客戶和本公司應根據聯交所客戶合同作為主事人訂立合同。",
        "6.9 產品規格：本公司同意在客戶要求時向客戶提供聯交所期權合約的產品規格。",
        "6.10 投資者賠償基金：若本公司未按本附件 III 的規定履行對客戶的賠償義務，受投資者賠償基金不時條" +
          "款的限制，客戶有權向根據證券及期貨條例設立的投資者賠償基金索賠。",
        "6.11 公司的業務：公司應將可能會影響公司根據本第 6 條向客戶提供的服務的公司業務重大變化通知客戶。",
        "6.12 長倉到期日：在相關到期日，且僅在到期日，香港聯合交易所期權系統將為價內或高於聯交所期權" +
          "結算所訂明的價內值的所有開放長倉自動生成行權指令。客戶可指示本公司根據聯交所期權結算所" +
          "的運行結算程式在系統關閉到期日前取代該等「自動生成的行權指令」。",
        "6.13 協議：客戶要確認其已閱讀並同意本附件 III 的條款，該等條款已以客戶選擇的語言向客戶解釋。",
        "6.14 持倉報告：如果持有或控制的倉位達到須報告水平，客戶須自行全權負責通知聯交所。如果客戶決" +
          "定通過本公司通知聯交所，客戶必須告知本公司其在其他代理或經紀處持有的全部持倉，以便本公" +
          "司能夠代表客戶向聯交所提交通知。或者，客戶也可要求本公司向聯交所單獨報告其在本公司持有" +
          "帳戶的持倉，即使客戶在該帳戶中的持倉未超過須報告水平。",
        "6.15 彌償：在不限制客戶提供任何其他彌償的原則下，客戶同意彌償本公司及其雇員及代理人因客戶違" +
          "反其於本附件下的任何義務而引致的所有損失及開支，包括向客戶追收債款及關閉有關帳戶的合理費用。",
        "7 違約",
        "如果客戶未能遵守客戶的任何義務和/或履行責任，包括未能提供保證金，在不影響本公司可能享有" +
          "的任何其他權利的情況下，本公司可：",
        "(a) 拒絕接受客戶就聯交所期權交易業務或其他期權合約的進一步指令；",
        "(b) 平倉、放棄或行使香港聯合交易所客戶合約或與公司簽訂的其他期權合約的部分或全部",

        "(c) 訂立任何期權合約或投資產品的任何交易，以清償產生的義務或對沖本公司因客戶未能履行義務而面臨的風險；",
        "(d) 處置部分或全部保證金，並用其收益清償債務；及",
        "(e) 所有債務清償後的剩餘收益應支付給客戶。",
        "8 風險披露聲明",
        "客戶確認已經閱讀並理解本公司就提供期權交易相關服務的風險披露聲明，見於附件 X（風險披露" +
          "聲明）及其他本公司提供給客戶的使用其選擇語言（英文或中文）的相關風險披露聲明，客戶已受" +
          "邀閲讀該等風險披露聲明、提問，在有需要時尋求獨立意見並充分接受有關期權交易的風險。",
        "附件 IV：基金銷售服務",
        "本附件適用於本公司提供的基金銷售服務。本附件為本協議的補充條款並應與以及可能不時修訂的適用於公" +
          "司提供的服務的任何其他條款和條件一同閱讀。它是協議的組成部分。",
        "1 定義和詮釋：",
        "在本附件中，除非上下文另有要求，本協議中定義的術語在本文中使用時應具有相同涵義。在本附件中：",
        "「交易流程」指公司與基金或相關基金的基金經理就基金份額的認購、轉換、贖回及其他附帶事項" +
          "不時約定的任何程式；",
        "「基金銷售服務」指本公司根據客戶之指示，就任何基金之任何單位之購買、認購、轉換、轉讓、贖" +
          "回或出售，以及有關款項或款項之處理，所提供之服務；及",
        "「單位」指基金中的任何股份或單位。",
        "2 認購和贖回申請及付款",
        "2.1 一般性指示：認購、購買、贖回、出售或轉換任何單位的任何指示（無論是全部還是部分）必須按公" +
          "司規定的方式作出，並隨附公司可能不時要求的任何必要文檔。",
        "2.2 公司的酌情權：所有與單位認購、轉換或贖回相關的指示以及由此產生的交易和支付均應遵守交易" +
          "流程及或公司不時規定的任何其他要求。公司有權無須通知客戶，亦無須給予任何理由，無視任何" +
          "未能符合交易程序的指示或公司的其他要求，或執行該等指示及為符合交易程序或公司不時規定的" +
          "其他要求而對該等指示作出的必要修改。",
        "2.3 公司的執行：公司將儘快執行任何指示，但該等指示的執行可能與基金相關發售文檔中規定的時間" +
          "不一致。客戶確認，公司可每日或不時地將客戶向公司下達的訂單與公司其他客戶下達的訂單合併" +
          "計算，以便公司向相關基金經理、基金或產品發行人下達該等訂單以供執行。",
        "2.4 截止時間：受限於帳戶的持續運作，如果本公司在其不時全權決定的相關基金的交易截止時間前收" +
          "到有效及完整的指示（連同所有款項、所需的資料及文檔），一般將於本公司收到該等指示之日處理" +
          "該等指示。若在本次交易截止後或香港出現 8 號（或以上）颱風信號或黑色暴雨警告信號當日收到" +
          "指令（及資金），通常按基金發售文檔的約定（或基金管理人、基金或產品發行人等另行確定）於基" +
          "金的下一交易日執行。如果公司合理地認為有理由延遲或拒絕處理或接受任何指示，公司保留延遲" +
          "或拒絕處理或接受任何指示的權利。",
        "2.5 僅供參考的價格：基金的實際買入價（“實際買入價”）和賣出價應在交易生效和結算時確定，本公司" +
          "或其代表在指示時可能向客戶報價或提供的任何數值（“報價”）僅供參考，對本公司不具有約束力。" +
          "基金的實際買入價可以高於或低於報價。",
        "2.6 不代表基金行事：公司無權代表任何基金管理人、基金或產品發行人接受認購、轉換或贖回任何單" +
          "位的指示（或申請）。公司收到該等指示、必要的付款及任何其他文件並不構成相關基金管理人、基" +
          "金或產品發行人接受該等指示。",
        "2.7 第三方：客戶確認，任何從本公司收到指令的基金經理、基金或產品發行人均無義務接受該指令的" +
          "部分或全部。本公司不對基金管理人、基金及產品發行人拒絕或者拖延接受指令而給客戶造成的損" +
          "失（包括投資機會損失）承擔保證責任。",
        "2.8 交收：客戶確認：（a）客戶就每筆購買或認購單位的指令應向本公司（或本公司指定的其他人士）支" +
          "付的購買價款、認購款項或費用，應從證券現金帳戶（或由客戶不時另行指定並通知本公司的其他" +
          "帳戶）中扣除；及（b）本公司就每筆出售、贖回或以其他方式處置單位的指令而收到的贖回款項，" +
          "在任何情況下均應按照有關基金募集文件（或基金管理人、基金或產品發行人不時另行決定）規定" +
          "的交收期，支付或存入證券現金帳戶。",

        "2.9 資金不足：客戶進一步同意，對於單位的購買或認購，如果帳戶中指定支付的資金不足，或者在公" +
          "司規定的時間內未收到已清算資金（不含任何扣除或預扣款項），公司保留拒絕或延遲處理任何訂單的權利。",
        "3 投資的權屬和登記",
        "3.1 一般：如果客戶認購基金單位，該等單位將以公司的名義或以公司的名義與客戶的名義共同登記，" +
          "或僅以客戶的名義登記（視具體情況而定）。本公司將不會是閣下在基金的任何投資的受益人。",
        "3.2 單位證書：不會向客戶簽發單位證書。客戶將被發送一份其認購/獲得（或處置）任何單位的確認。",
        "4 終止",
        "在與公司的帳戶終止或基金銷售服務終止時，客戶將被視為已向公司發出指示，且根據其酌情權：",
        "(a) 促使託管人為客戶帳戶持有的任何單位在基金帳戶終止生效日被贖回或以其他方式處理，或者" +
          "如果該日不是客戶帳戶的交易日或在該等基金的發售檔中規定的最晚交易時間之後，則在下一" +
          "個交易日（“生效日”）贖回或交易收益（在結清欠公司和高盈證券的任何未償還債務、成本和" +
          "費用後）的任何單位匯給客戶和/或結清客戶、公司或任何託管人發生的任何負債；",
        "(b) 促使託管人為客戶帳戶當時持有的任何單位於生效日直接劃撥至客戶名下（如適用）；及",
        "(c) 取消任何未執行的交易。",
        "附件 V:債券交易",
        "1 申請",
        "本附件 V 適用於本公司提供的與債券交易有關的服務。本附件為本協議的補充條款並應與以及可能" +
          "不時修訂的適用於公司提供的服務的任何其他條款和條件一同閱讀。它是協議的組成部分。",
        "2 債券交易",
        "2.1 酌情權：公司有絕對酌情權拒絕向客戶提供債券交易服務和/或附加與基金帳戶或向客戶提供債券交" +
          "易服務有關的任何條件。",
        "2.2 不能成功執行或延遲執行：本公司對於任何不能成功執行或延遲執行的客戶債券交易指示，並不負" +
          "有任何責任。所有未執行的訂單將在交易期結束時失效。",
        "2.3 代理人：除非另有規定，本公司在所有債券交易中都是以代理人身份行事。",
        "2.4 託管人：客戶委任本公司（或任何實體，包括香港以外的實體，並由本公司指定）為客戶的託管人，" +
          "並為客戶所投資的債券登記於託管人名下，由託管人代表客戶購入及持有。",
        "2.5 價格：債券的實際買入和賣出價須在交易進行時確定，而本公司或其代表可隨時向客戶報價或提供" +
          "價位，均屬參考性質，對本公司並不具約束力。",
        "2.6 約束性：債券交易的所有指示於提交時已是最終的決定並對客戶有約束性，但取決於是否被本公司" +
          "接納及視乎最終交易而定。",
        "2.7 派息日：債券的實際派息日可能與其原定派息日有所不同，要視乎不同因素，包括並不限於要視乎" +
          "發行人、及本公司所委託的託管機構/信託機構所行使的酌情權，及相關銀行的轉帳程序和其他因素。",
        "3 客戶聲明",
        "客户聲明他或她:",
        "3.1 非存款:完全明白債券不是銀行存款，及不會受到本公司或高盈證券所保證，或構成任何責任；",
        "3.2 風險披露聲明：客戶確認已經閱讀並理解本公司就提供債券交易相關服務的風險披露聲明，見於附" +
          "件 X（風險披露聲明）及其他本公司提供給客戶的使用其選擇語言（英文或中文）的相關風險披露" +
          "聲明，客戶已受邀閲讀該等風險披露聲明、提問，在有需要時尋求獨立意見並充分接受有關債券交易的風險；",
        "3.3 相關資訊：已獲得，並已細閱債券說明書及/或其最新產品銷售文件或資訊及/或查閱最新產品銷售文" +
          "件或資訊（視乎何種情況而定，「有關資訊」），並同意所載的條款。客戶完全知悉及理解有關資訊所" +
          "載的條款，包括但不限於有關投資債券的風險和限制。本公司已呈請客戶細閱有關資訊，如需要，" +
          "可提出問題或資詢獨立意見。",
        "3.4 不提供意見：完全明白上述的有關資訊不擬提供，亦不可賴以作為稅務、法律或會計意見、或有關" +
          "債券的信用或其他評估，也不得構成任何債券預期回報的保證或擔保。客戶應諮詢其稅務、法律、" +
          "會計、投資、財務及/或其他顧問；",
        "3.5 沒有被禁止：並非為或代表銷售文件所訂明被禁止購買或持有該債券的個人或團體；",
        "3.6 地域限制：並非為銷售文件所訂明被禁止投資國家的公民或居民；",
        "3.7 有限流動性：明白債券的流動性可能有限，及可能無活躍交易，及/或沒有經紀在市場提供報價，因" +
          "此（i）債券的參考買入/賣出價不可以在任何時間均能被提供，因其將取決於市場的流動性和情况；" +
          "（ii）可能需要較長時間或無法於市場上出售債券；及（iii）所執行的賣出價可能與本公司提供的參"+
        "考買入價有很大的差別；",

        "3.8 損失：全部承擔及負責投資債券損失的風險；和",
        "3.9 資訊準確性：明白本公司就債券交易服務中提供的任何資訊是按「現狀」、「可提供」的狀態提供，" +
          "且僅供一般資訊使用。客户同意此類資訊，如市場數據和報價均由第三方提供，而本公司並不保證" +
          "此類資訊的準確性、可靠性、時效性、完整性或順序。本公司毋須就因此類資訊的任何不準確、遺" +
          "漏或不完整而產生的任何損失負責或承擔責任，無論該資訊是由本公司還是第三方提供。",
        "3.10 波動的市場狀况：明白由於市場狀况、任何市場的實質限制及證券價格急速變動，即使本公司、執" +
          "行經紀和交易商（無論是在香港或其他地方）作出合理的努力，透過本公司作為代理人進行交易，" +
          "本公司可能無法完全執行客戶的指示，交易指示未必可以於任何特定時間、於客戶指定的時間、「最" +
          "佳價」或「市場價」執行。客戶同意在任何情況下均接納代客戶進行的交易，並受其約束，亦同意本" +
          "公司毋須就因未能或無法遵守客戶指示的任何條款而產生的任何損失負責。",

        "附件 VI:中華通條款及細則",
        "本附件 VI 適用於通過中華通進行的中華通證券交易。本附件為本協議的補充條款並應與以及可能不時修訂的" +
          "適用於公司提供的服務的任何其他條款和條件一同閱讀，並構成本協議不可分割的一部分。",
        "1 定義和詮釋：",
        "在本附件 VII 中，除非上下文另有要求，下列表述應具有以下涵義：",
        "「中國創業板證券」指於中國深圳交易所創業板市場交易之任何證券；",
        "「市場要求」指所有不時適用於滬港通（“滬港通”）或深港通（“深港通”）服務和透過使用該等服務" +
          "所進行的任何交易的一切相關法律、法規和規則及監管機構或政府機構、交易所、市場、結算所及" +
          "其他主管機構的要求及請求（包括但不限於聯交所、上交所、深交所、證監會、中國證券監督管理" +
          "委員會以及其各自的子公司及聯屬人、）；",
        "「上交所」指上海證券交易所；及",
        "「深交所」指深圳證券交易所。",
        "2 滬港及深港通服務",
        "2.1 藉繼續使用本公司提供的滬港或深港通服務，客戶向本公司確認其已詳閱、明白並同意此等特別條" +
          "款以及接受所有與使用該等服務及透過該等服務進行交易的相關風險如下：",
        "(a) 客戶須遵守並獨自承擔責任以遵守所有市場要求。除非法律另有規定，本公司無須應市場要求" +
          "之改變而更新此等特別條款。",
        "(b) 尤其是，客戶須充分了解並遵守所有不時在內地適用的市場要求，特別是有關短線交易利潤、" +
          "限制進行場外交易及轉移、持股限制及披露責露責任的市場要求，包括但不限於關於在上交所" +
          "或深交所上市的 A 股的規定（該規定被修改時，本公司恕不另行通知）：",
        "(i) 有關持有或控制中國內地上市公司已發行股份達 5％的投資者須於三個工作天內作出權" +
          "益披露及於該三個工作天內不得買賣該公司股份的要求；且對其持有的股份的任何變動" +
          "作出披露的要求及遵守有關買賣限制;及",
        "(ii) 適用於香港及/或海外投資者的單一境外投資者的 10％持股限制（中國內地上市公司已發" +
          "行股份的 10％）及所有境外投資者的 30％總持股權限制（中國內地上市公司已發行股份" +
          "的 30％）及相關強制出售的安排。",
        "(c) 客戶承認除在市場要求容許的情況下，在交易日買入的上交所證券或深交所證券不能於同一天" +
          "賣出，而且如客戶擬於個別交易日出售上交所證券或深交所證券，則須於該交易日開市前確保" +
          "客戶在本公司設立的戶口內存有足夠的上交所證券或深交所證券。客戶不可對上交所證券或深" +
          "交所證券進行無備兌賣空活動。",
        "(d) 客戶承認設有交易前檢查：如客戶擬於個別交易日出售股份，須於該交易日開市前將股份轉移" +
          "至公司的相應中央結算系統戶口。",
        "(e) 客戶承認所有上交所證券及深交所證券交易必須在上交所及深交所進行，不設場外交易或非自動對盤交易。",
        "(f) 除本公司另行許可外，客戶同意不會透過使用滬港或深港通服務進行孖展交易、股票借貸及/或" +
          "賣空活動，而客戶就任何上交所證券或深交所證券向本公司發出的任何買賣盤均被視為已向本" +
          "公司聲明及確認，該買賣盤不涉及孖展交易、股票借貸或賣空。當客戶透過使用滬港或深港通" +
          "服務進行孖展交易、股票借貸及/或賣空活動，客戶必須充分了解適用於該等活動的限制、要求" +
          "及條件。特別是，客戶承認該等活動的交易服務可能在市場要求所訂立的情況下被暫停、限制" +
          "或停止（例如交易的活動量超出於市場要求所規定的限額或發生或懷疑發生任何不正常的交易" +
          "活動），而且客戶只可對合資格的上交所證券或深交所證券進行孖展交易及賣空活動。客戶可" +
          "參考不時在聯交所之網頁（www.hkex.com.hk）公佈的合資格上交所證券或深交所證券名單。",

        "(g) 客戶承認唯機構專業投資者方可進行中國創業板證券交易。客戶向本公司保證不會進行中國創" +
          "業板證券交易，除非其為機構專業投資者，或直至此進行中國創業板證券交易的限制解除為止。" +
          "如客戶為一中介人作為代理代表其相關客戶向本公司發出落盤指示，客戶向本公司承諾，其將" +
          "確保透過客戶進行中國創業板證券交易的該等相關客戶均是機構專業投資者，直至此進行中國" +
          "創業板證券交易的限制解除為止。如（i）客戶或，如客戶為一中介人，其相關客戶違反此進行" +
          "中國創業板證券的交易限制；或（ii）客戶違反任何於此之承諾，本公司可全權酌情取消客戶的" +
          "落盤或賣出客戶的中國創業板證券而無須另行通知客戶。本公司將毋須就本公司行使其於此所" +
          "賦予的權利及權力產生的任何損失負責，除非基於本公司或其任何主管人員、僱員或聯屬人的" +
          "嚴重疏忽、欺詐或蓄意失責所致，及只限於直接及合理預見直接及純粹由上述行為造成的損失" +
          "及賠償（如有）。儘管上文有所規定，在符合巿場要求下，如一非機構專業投資者客戶因任何權" +
          "利（包括認購配股或公開要約的權利）或權益分配、換股、收購、其他公司行動或特殊情況而" +
          "取得中國創業板證券，本公司可全權酌情決定是否接納該非機構專業投資者客戶的指示出售相" +
          "關中國創業板證券。",
        "(h) 客戶承認聯交所、上交所或深交所及其各別的子公司及聯屬人有權在市場要求所訂立的情況下" +
          "拒絕提供與滬港或深港通服務有關之服務（如客戶、本公司及/或其代理人之中任何一方違反任" +
          "何市場要求或作出任何不正常交易行為），而且本公司可按其絕對酌情權或會應上交所或深交" +
          "所要求拒絕接受客戶的任何指示或停止提供所有或部分之滬港或深港通服務，而無須另行任何事前通知。",
        "(i) 客戶同意（i）本公司為確保遵從或促使遵從市場要求及避免或減輕本公司可能因此而招致或蒙" +
          "受的損失;（ii）在客戶違反任何市場要求或本協議之條款的情況下或（iii）在發生任何超出本" +
          "公司或其代理人的合理控制能力的任何緊急或不可抗力的事故（如香港懸掛八號颱風訊號）時，" +
          "本公司可按其絕包括但不限於強制出售有關證券，限定、限制或拒絕交易，取消交易或由客戶" +
          "發出的其他指示及暫停、限制或停止提供所有或部分之滬港或深港通服務，而無須另行任何事前通知。",
        "(j) 客戶同意，為執行客戶的指示或行使本公司在此等特別條款下或在客戶的任何帳戶下的權利為" +
          "目的之情況下，本公司可（在任何時候按其獨有及絕對酌情權及並無責任的情況下）將客戶任" +
          "何帳戶內或客戶所結存的任何幣別的任何金額兌換成任何其他貨幣。匯兌損失和兌換成本須由客戶承擔。",
        "(k) 客戶承認監管機構、上交所、深交所、聯交所以及上交所、深交所及聯交所各自的子公司及聯" +
          "屬人有權在市場要求被違反或懷疑被違反時進行調查，並同意本公司可按該等機構之要求提供" +
          "資料及材料（包括但不限於與客戶、客戶帳戶及其他與最初負責發出交易的指示及從該宗交易" +
          "取得商業或經濟利益及/或承擔其商業或經濟風險的人士（不論是否為法律實體）有關的資料、" +
          "身份及個人資料，以及有關該等人士下單或交易的資料），及向客戶發出警告，以作配合調查、" +
          "監察及遵從市場要求之用。",
        "(l) 客戶同意與客戶有關的或由客戶所提供之個人資料可按照本公司向客戶提供的收集個人資料" +
          "聲明及本協議其他適用條款使用及轉移至香港以外地區，而且客戶承諾及表述其已經就所述使" +
          "用和轉移個人資料事宜取得其所需要的一切有關人士的同意，以及遵守《個人資料（私隱）條例》。",
        "(m) 客戶承認客戶或任何其他方面因為滬港或深港通服務或透過使用該等服務進行任何交易而直" +
          "接或間接蒙受或招致任何損失、損害或責任，聯交所、上交所、深交所及其各別的子公司、聯" +
          "屬人、董事、僱員及代理人概不負責。",
        "(n) 客戶可以最少七個營業日前通知本公司終止使用滬港或深港通服務。本公司可隨時終止客戶使" +
          "用滬港或深港通服務，而無需提前通知客戶。",
        "(o) 客戶同意以主事人的身份負責承擔涉及客戶使用滬港或深港通服務或者涉及透過使用該等服" +
          "務所進行的交易的一切有關義務和責任，無論在何種情況下，本公司及其代理人都不須對可能" +
          "委託客戶作為其代理人代其行事的任何人士承擔任何責任。客戶同意本公司可處置或促使本公" +
          "司的有聯繫實體處置任何不時代客戶收取或持有的證券或證券抵押品，以解除由客戶或代客戶" +
          "對本公司、其有聯繫實體或第三者所負的法律責任。",
        "(p) 儘管以上所述，本公司可以按其絕對酌情權自行決定是否為確保或者促使遵守任何市場要求或" +
          "者為本公司認為適當的其他任何目的，而不時增加或修改與滬港或深港通服務有關的任何條款。" +
          "此外，客戶也同意，滬港或深港通服務是針對中國內地的某些特定的市場或交易所而提供的，" +
          "並受本公司不時附加及在有關的市場附件中載明的條款所約束。上述附加條款及修訂後的條款" +
          "均構成本協議不可分割的組成部分，並且應與本協議一起閱讀。倘客戶繼續使用滬港或深港通" +
          "服務，即被視為構成客戶已經接受該等附加條款及修訂後的條款。本公司可以將該等附加條款" +
          "及/或修訂後的條款在本公司的網站上發佈，也可以採用本公司認為適當的其他任何方式通知客戶。",
        "(q) 客戶承認已獲邀仔細閱讀和考慮本公司不時提供給客戶的有關風險披露聲明書中的條款，該等" +
          "風險披露聲明書載明與使用滬港或深港通服務有關的風險，同時，本公司也已經邀請客戶就該" +
          "等風險披露聲明書提出問題並徵求獨立的意見（如適用）。",
        "(r) 就客戶使用滬港或深港通服務，客戶同意補償和向本公司及其代理人支付客戶不時與本公司約" +
          "定或者本公司或其代理人按任何市場要求規定所招致的一切佣金及費用、收費、開支、徵費、" +
          "稅款、罰金和其他各種稅費。客戶同意本公司及其代理人無須就任何與客戶或代客戶進行的交" +
          "易或業務所獲取的或向任何人士提供的佣金、報酬、回佣或其他利益向客戶作出任何交代。",
        "(s) 倘由於（i）任何政府或監管機構、交易所、市場、結算所或其他主管機構的限制、失誤、違約" +
          "或行為;（ii）交易所提供的任何服務被暫停、限制或停止;（iii）結算所中斷或未能結算和清算" +
          "任何交易;（iv）發生騷亂、騷動、戰爭、水災、颱風、地震、火災或爆炸;（v）第三者電子傳" +
          "輸系統或其他電子系統被中斷、延遲、失誤、暫停或錯誤;或（vi）超過本公司或其代理人的合" +
          "理控制能力的其他任何原因而直接或間接地導致本公司及其代理人未能履行其對滬港或深港" +
          "通服務分別應當承擔的義務，則本公司及其代理人不需要對該等未能履行的義務承擔任何責任。" +
          "本公司保留權利，在發生任何上述事件以後，按其絕對酌情權決定暫停、限制或者停止提供全" +
          "部或者部分之滬港或深港通服務，而毋須作出任何通知，並且如訂單經已配對及執行，客戶仍須承擔交收責任。",
        "(t) 對於涉及滬港或深港通服務的無論何種間接的、因此而產生的、附帶的、特別的或懲罰性的損" +
          "害、損失、負債、費用或開支（包括但不限於任何利潤損失）而言，本公司不需要向客戶承擔任何責任。",
        "(u) 在客戶開始及繼續使用滬港或深港通服務時，本附件 VI 即生效並構成本協議不可分割的一部" +
          "分。本附件 VI 條款為約束客戶及本公司之間的帳戶關係的條款及條件的附加條款，而且如兩" +
          "者有歧異，以本附件 VI 條款為準。",

        "3 免責聲明",
        "甲部：",
        "有關滬港通服務的免責聲明",
        "上海證券交易所盡力保證所提供資訊的準確和可靠度，但不能確保其絕對準確和可靠，亦不對因資訊不準確或" +
          "遺漏而導致的任何損失或損害承擔責任。",
        "及",
        "香港聯合交易所有限公司、其控股公司及／或該等控股公司的任何子公司均盡力保證所提供資訊的準確和可" +
          "靠度，但不能確保其絕對準確和可靠，亦不對因資訊不準確或遺漏而導致的任何損失或損害承擔責任。",
        "乙部：",
        "有關深港通服務的免責聲明",
        "深圳證券交易所盡力保證所提供資訊的準確和可靠度，但不能確保其絕對準確和可靠，亦不對因資訊不準確或" +
          "遺漏而導致的任何損失或損害承擔責任。",
        "及",
        "香港聯合交易所有限公司、其控股公司及／或該等控股公司的任何子公司均盡力保證所提供資訊的準確和可" +
          "靠度，但不能確保其絕對準確和可靠，亦不對因資訊不準確或遺漏而導致的任何損失或損害承擔責任。",
        "附件 VII：上市前交易",
        "本附件 VII 適用於本公司就上市前交易提供的服務。本附件為本協議的補充條款並應與以及可能不時修訂的" +
          "適用於公司提供的服務的任何其他條款和條件一同閱讀。它是協議的組成部分。",
        "1 定義和詮釋：",
        "在本附件 VII 中，除非上下文另有要求，下列表述應具有以下涵義：",
        "「獲分配證券」指有關申請首次公開招股而被接納的證券；",
        "「香港結算規則」指香港結算不時生效之一般規則、運作程序及其他適用的規則、程序及規例；",
        "「首次公開招股」指聯交所新上市及/或發行的證券之公開發售；",
        "「獲配對指令」具有本附件 VII 中第 3.4 條（獲配對指令）所定義的意思；",
        "「平台營運者」指本公司可不時通知客戶的平台營運者；",
        "「上市前平台」指由平台營運者營運而透過本公司提供上市前交易服務的電子交易平台；",
        "「上市前交易」指任何獲分配證券的交易或購買、投資、出售、收購、清算、結算或以其他方式處置" +
          "任何獲分配證券的協議，及獲分配證券在聯交所正式上市前的一般交易；",
        "「上市前交易時段」指交易日當天可於上市前平台進行上市前交易的交易時段，亦即下午 4:15 開始" +
          "至下午 6:30 的時段或其他由平台營運者不時指定的交易時段；及",
        "「交易日」指，就任何獲分配證券而言，在聯交所正式上市前一工作日或由平台營運者可不時指定的其他交易日。",
        "2 適用規則及規例",
        "2.1 適用規則及規例：本公司代表客戶作出或簽訂的所有上市前交易指示及任何上市前交易指示均應遵" +
          "守，且客戶應受下列指示約束：",
        "(a) 本協議；",
        "(b) 不時有效的平台營運者條例、規章、程式和政策；",
        "(c) 聯交所的組織章程大綱及章程細則、聯交所規則、香港結算規則及聯交所的常規、慣例、裁定及程序；及",
        "(d) 其他適用法規（包括證券及期貨條例）。",
        "2.2 衝突：如果本協議的任何規定與本附件 VII 第 2.1 條（適用規則及規例）第（b）、（c）和（d）段中" +
          "包含的任何內容發生任何衝突或不一致，本公司可自行決定採取或拒絕採取任何行動，或要求客戶" +
          "採取或不採取任何行動以確保遵守後者。",
        "3 上市前交易",
        "3.1 一般：客戶承認並同意，就上市前交易：",
        "(a) 本公司作爲客戶的代理人行事；",
        "(b) 本公司自身並不經營上市前交易的灰色市場，而是通過上市前平台處理指令；",
        "(c) 客戶只可在交易日的上市前交易時段內發出指示；",

        "(d) 客戶的指示可由本公司及／或平台營運者全權酌情決定部分執行或完全不執行。",
        "3.2 平台營運者的酌情權：即使存在任何相反規定，平台營運者可隨時自行決定在不通知或提及客戶的" +
          "情況下，在不限制且不向客戶承擔任何責任的情況下進行以下任何操作，該等行爲應對客戶具有約束力：",
        "(a) 調整上市前交易時段的交易時間；",
        "(b) 限制或停止任何交易日的上市前交易；",
        "(c) 以任何方式限制、更改、暫停或終止上市前平台；",
        "(d) 就與上市前交易有關的任何指示設定任何限制；及/或",
        "(e) 拒絕處理或接受與上市前交易有關的指示。",
        "3.3 本公司的酌情權：本公司可隨時自行決定在不通知或提及客戶的情況下，在不限制且不向客戶承擔" +
          "任何責任的情況下就與上市前交易有關的任何指示設定任何限制；及/或拒絕處理或接受與上市前交易有關的指示。",
        "3.4 獲配對指令：受限於本附件 VII 第 3.6 條（取消/推遲上市）的規定，公司和平台營運者接受並經上" +
          "市前平台匹配的所有上市前交易指令（“匹配指令”）將由平台營運者完成。",
        "3.5 未獲配對的指令：在上市前交易完結時，所有未獲配對或只有部份未獲配對的上市前交易指示及指令將被取消。",
        "3.6 取消/推遲上市：如果相關獲分配證券未能上市，所有與該等獲分配證券（包括獲配對指令）相關的" +
          "所有上市前交易指示將自動取消，該等指示不會被處理。如果該等獲分配證券的正式上市被推遲，" +
          "獲配對指令將持續有效，但將由平台營運者在推遲後的上市日或其認爲適當的其他時點實施。",
        "3.7 無陳述或保證：公司未就客戶的上市前交易指示或上市前平台作出任何性質的任何陳述或保證。",
        "4 結算",
        "4.1 交付及支付：當客戶賣出獲分配證券時，客戶應向本公司交付該等獲分配證券，且該等證券已足額" +
          "繳付及無產權負擔，且客戶對該等證券擁有良好及有效的所有權。客戶購買獲分配證券的，應當向" +
          "客戶支付。每項該等交付和付款應以公司或平台營運者不時指示的方式進行。",
        "4.2 未能交付或支付：在不影響公司在本協議項下的任何權利的前提下，如果客戶未能按照本附件 VII 第",
        "4.1 條（交付和付款）規定的方式進行交付或付款，則公司有權在不進一步通知或要求的情況下：",
        "(a) 以本公司絕對酌情權決定的價格借入及/或購買交付所需的獲分配證券，向客戶的任何帳戶收" +
          "取相關費用，交付獲分配證券以履行客戶的義務，並將收到的交付款項存入任何帳戶；及/或",
        "(b) 作為第（a）段的補充或替代，行使本協議條款第 29 條（合併、併入和抵銷）所載的合併及抵" +
          "銷權，以結算上市前交易。",
        "4.3 短欠：客戶應按全面彌償基準賠償公司根據本附件 VII 購買和出售獲分配證券所發生的損失和任何" +
          "費用或支出（包括法律費用）所導致的任何短欠。",
        "4.4 交易對手風險：客戶知曉並接受，所有上市前交易均為場外交易，如果交易對手方不能履行結算義" +
          "務，將面臨交易對手風險。",
        "4.5 結算風險：公司未就任何匹配訂單的結算作出任何陳述、保證或擔保。公司或平台營運者可能認為" +
          "不宜採取任何行動以避免匹配訂單的任何結算失敗的情況，在該等情況下：",
        "(a) 如客戶是獲分配證券的買家，客戶只有權取回已支付的結算資金",
        "(b) 如客戶是獲分配證券的賣家，客戶只有權取回為該等出售而交付的獲分配證券；及在每種情況" +
          "下，客戶都將負責所有因交易對手不能履行結算責任而產生的損失及開支。",
        "5 責任限制",
        "5.1 責任免除：客戶同意，公司、平台營運者及其各自的任何董事、員工或代理均不對客戶由於任何下" +
          "列各項或與任何下列各項相關而可能發生的任何權利主張、訟案、訴訟、程序、損失、損害、義務、" +
          "責任、費用、收費和支出承擔責任，由於此類人員的重大過失、欺詐或故意違約的情況除外：",
        "(a) 上市前平台的任何干擾、攔截、中止、延遲、損失、不可用、毀壞、故障、中斷或其他故障，",
        "包括但不限於任何通訊網路或電腦故障、任何第三方資訊或服務提供者的作為或不作為、內務" +
          "管理、電腦病毒、任何主體（包括駭客）未經授權的訪問、升級或預防或補救維護活動、機械" +
          "故障、停電、故障或設備、安裝或設施不足，或任何法律、法規、規章、準則、指令、監管指" +
          "引或政府命令（無論是否具有法律效力）;",
        "(b) 客戶通過任何通訊網路提供商的任何系統、設備或工具或在任何通訊網路提供商的任何系統、" +
          "設備或工具中傳輸、張貼和/或存儲關於客戶、上市前平台和/或上市前交易的任何資訊和/或資料；",
        "(c) 未能結算獲配對指令；",
        "(d) 公司或平台營運者不接受、進行、不執行、也不行使客戶的上市前交易指令;",
        "(e) 公司或平台營運者根據本附件 VII 採取的任何行動，包括任何使用、收入、利潤、儲蓄或機會" +
          "的損失或任何其他附帶的、後果性的、特殊的或間接的損失或損害。",

        "附件 VIII：電子直接付款授權服務",
        "本附件 VIII 適用於公司向客戶提供的將使客戶能夠進行轉讓（定義見下文）的電子直接付款授權服務（電子" +
          "直接付款授權）。本附件 VIII 補充並應與一般條款和適用於公司提供的服務的任何其他條款和條件及其可能不" +
          "時的修訂一起閱讀。它是客戶協議的其中一個組成部分。",
        "1 定義和詮釋：在本附件 VIII 中，除非上下文另有規定，下列表述應具有以下含義：",
        "「銀行」指根據《銀行條例》（香港法例第 155 章）獲授權在其處開立及保有指定帳戶的銀行、受限" +
          "牌照銀行或接受存款公司；",
        "「指定帳戶」指客戶以其名義在銀行開立的帳戶，根據客戶指示從該帳戶進行轉帳；",
        "「電子直接付款授權」指客戶發起的電子直接付款授權，使用結算公司快速支付系統授權公司根據" +
          "客戶指示以指示銀行從相應的指定帳戶向帳戶轉帳，詳見本附件 VIII 第 2.1 條（申請）;",
        "「電子直接付款授權服務」指結算公司提供的服務，作為結算公司快速支付系統的一部分，以促進" +
          "參與者的客戶建立並使用電子直接付款授權;",
        "「結算公司」指香港銀行同業結算有限公司及其繼承人及受讓人；",
        "「結算公司快速支付系統」或「快速支付系統」指結算公司為（a）處理直接借記和貸記、轉帳及其" +
          "他支付交易；及（b）交換並處理與電子直接付款授權服務相關的指令而不時提供、管理並運行的更" +
          "快支付系統及相關設施和服務；",
        "「指示」指客戶向銀行發出或獲其授權，指示銀行辦理轉帳之指示；",
        "「參與者」，是指結算公司快速支付系統的參與者，可以是銀行或其他金融機構、零售支付系統運營" +
          "者、儲值支付工具持牌人，也可以是結算公司不時接受的其他結算公司快速支付系統的參與者；及",
        "「轉帳」指根據電子直接付款授權項下的一項或多項指示不時從指定帳戶向帳戶進行的資金轉帳。",
        "2 電子直接付款授權",
        "2.1 申請：客戶可通過公司向銀行（由公司選定）申請電子直接付款授權服務。公司將協助向該行轉交" +
          "電子直接付款授權設置申請指示、資料和資訊。申請經銀行核准後，客戶可以直接向公司發出指示" +
          "以進行轉帳。客戶可能有一個或多個指定帳戶來進行轉帳。如果貴行拒絕電子直接付款授權設置申" +
          "請，公司將通知客戶結果，也不承擔任何責任。",
        "2.2 信息：客戶應以公司不時規定的形式和方式提供該等資訊並完成該等程序，以便公司協助客戶向銀" +
          "行申請電子直接付款授權設置。每個用作設置電子直接付款授權的指定帳戶的持有人必須與帳戶持" +
          "有人相同。聯名銀行帳戶將不被接受。",
        "2.3 取消：如果客戶已設立電子直接付款授權，但在一段時間內未根據該授權進行任何轉帳（由公司決" +
          "定），則公司有權在任何時間取消電子直接付款授權，而無需事先通知客戶，即使該授權尚未到期或" +
          "不受限於到期日或終止日。相關銀行亦可隨時自行決定取消電子直接付款授權。如客戶對銀行就電" +
          "子直接付款授權、任何指示或任何轉帳所採取的任何行動有任何查詢或爭議，客戶必須直接與相關" +
          "銀行解決該等查詢或爭議。",
        "2.4 默認設置：在設置電子直接付款授權時，任何指示的默認設置如下：「轉帳週期」將設置為「每筆付" +
          "款」，「轉帳限額」將設置為「無上限」，「到期日」將設置為「無期限」。如果客戶不接受這些預設設" +
          "置，客戶不應通過公司繼續進行電子直接付款授權設置申請。",
        "2.5 修改默認設置：客戶可不時直接指示銀行修改本附件 VIII 第 2.4 條（默認設置）所載的指示的預設，" +
          "但須符合銀行不時訂明的程序和要求。",
        "2.6 有效期：指示將持續有效，直至（a）被客戶修改或取消；或（b）在指示中指明的日期到期（如有），" +
          "以先發生者為准。客戶可根據銀行不時規定的程序和要求取消指示。",
        "3 指令不可撤銷",
        "就任何轉帳而言，一旦客戶確認及提交指示，該指示及隨之而來的轉帳不可撤銷，並對客戶具約束力。",
        "4 確認",
        "4.1 時間期間：客戶同意，每筆指示所載之轉帳款項將於有關銀行不時指定之時間期間內存入帳戶。",
        "4.2 指示的更改：如客戶欲更改任何指示，客戶須立即通知本行作出該等更改。",
        "4.3 費用：客戶對電子直接付款授權服務的使用受限於公司或相關銀行可能不時向客戶收取的任何費用和收費（如有）。",
        "4.4 其他條款和條件：客戶理解，電子直接付款授權服務也可能受限於相關銀行和/或參與者的條款和條" +
          "件，客戶在使用電子直接付款授權服務之前應閱讀並同意該等條款和條件。公司不承擔因該等銀行" +
          "和/或參與者的條款和條件而產生的任何責任。",
        "4.5 無陳述：公司將盡合理努力確保電子直接付款授權服務可以提供，但對於電子直接付款授權服務的" +
          "任何種類的運行、功能和可靠性，本公司不作出任何陳述、認可或保證。此外，公司不保證相關銀" +
          "行和/或參與者將能夠實現電子直接付款授權項下的指示或轉帳，因為這取決於該等銀行和/或參與者" +
          "的系統、運行以及公司無法控制的其他條件或情況的功能和可靠性。",
        "4.6 免責：對於客戶或任何其他主體可能發生或蒙受（無論是直接地還是間接地）的與電子直接付款授" +
          "權服務的任何使用或公司對任何指示或轉帳的執行相關的任何種類的損失、損害、費用或支出，本公司不承擔責任。",
        "4.7 終止：本公司保留在無理由的情況下取消、終止或中止全部或部分電子直接付款授權服務的權利。" +
          "客戶同意，對於客戶或任何其他人士因本公司行使上述權利而可能招致或蒙受的任何種類的任何損" +
          "失、損害、費用或開支，本公司概不負責。",
        "4.8 有效性：客戶應確保帳戶、每個指定帳戶和每個電子直接付款授權在其使用電子直接付款授權服務" +
          "的整個期間保持有效。",
        "5 客戶資訊的收集和使用",
        "5.1 資訊提供：為使用電子直接付款授權服務之目的，客戶可能被要求向本公司提供其被授權人的個人" +
          "資料及其他資訊（「客戶資訊」）。",
        "5.2 客戶資訊的使用：客戶同意，本公司可為電子直接付款授權服務之目的收集、使用、處理、保留或" +
          "轉移任何客戶資訊。此等用途包括但不限於下列一項或多項：",
        "(a) 為客戶提供電子直接付款授權服務，維護和運行電子直接付款授權服務；",
        "(b) 處理並執行與電子直接付款授權服務相關的不時的指示和請求；",
        "(c) 為經營電子直接付款授權服務之目的，向任何銀行、結算公司及其他參與者披露或轉帳客戶資料以供使用；",
        "(d) 符合任何適用法規項下的披露要求；及",
        "(e) 上述各項附帶的或與之相關的目的。",
        "5.3 進一步傳播：客戶理解並同意，結算公司、本公司、任何銀行或任何其他參與者均可為提供和運營" +
          "電子直接付款授權服務之目的，向其客戶及使用結算公司快速支付系統的任何其他第三方進一步披" +
          "露或轉移客戶資訊。",

        "5.4 同意：若客戶資料包括除客戶以外的任何人士（例如任何被授權人士）的個人資料或其他資料，客" +
          "戶確認其將就結算公司、本公司、有關銀行及本第 4 條款列明的其他參與者使用（包括披露及轉移）" +
          "其個人資料及其他資料的事宜，而取得該等人士的同意。",
        "6 責任限制",
        "6.1 一般限制：本公司對客戶或任何其他主體可能發生或遭受的由使用電子直接付款授權服務或處理或" +
          "執行客戶發出的電子直接付款授權服務相關的指示或請求引起或與之相關的任何種類的任何損失、" +
          "損害或支出不承擔責任，但發生或遭受的任何損失、損害或支出是直接且可合理預見的，並且僅由" +
          "本公司的重大過失或故意違約或其管理人員、員工或代理的重大過失或故意違約直接引起的除外。" +
          "在任何情況下，對於任何利潤損失或任何特殊、間接、偶然、後果性或懲罰性損失或損害（無論該" +
          "等損失或損害是否可預見或可能發生），本公司、高盈證券成員或許可方及其各自的管理人員、員工" +
          "和代理人均不對客戶或任何其他主體承擔責任。",
        "6.2 具體限制：就電子直接付款授權服務或電子直接付款授權服務而言，本公司不對客戶或任何其他主" +
          "體可能發生或遭受的由任何下列事項引起或與任何下列事項相關的任何種類的損失、損害或費用承擔責任：",
        "(a) 結算公司快速支付系統、任何銀行和/或參加人或因公司合理控制之外的任何情況造成的任何" +
          "延遲、無法使用、中斷、故障、錯誤；及",
        "(b) 客戶由於任何指示不明確或不完整和/或由於電子直接付款授權服務的任何錯誤或故障而無法行事。",

        "附件 IX：期貨交易",
        "本附件 IX 適用於期貨合約和期權合約的交易。本附件補充並應與一般條款和適用於公司提供的服務的任何其" +
          "他條款和條件及其可能不時的修訂一起閱讀。它是客戶協議的其中一個組成部分。",
        "1 定義和詮釋：",
        "在本附件 IX 中，除非上下文另有要求，下列詞語應具有以下含義：",
        "「核淮債務證券」指由香港特別行政區政府為外匯基金而發行之外匯基金票據、美利堅合眾國政府" +
          "發行之國庫券（美國財政部可通知贖回之債券本金（TCAL）及獨立交易之證券註冊利息及本金" +
          "（STRIPS）除外），以及由香港期交所不時批准作為保證金的其他債務證券或票據；",
        "「核准證券」指盈富基金單位及由香港期交所不時批准作為保證金之該等其他證券；",
        "「董事會」指香港期交所不時之董事會，或（按文義所指）於正式召開並已有足夠法定人數的董事" +
          "會會議上出席及投票的大多數董事，或董事會任何正式委任的委員會；",
        "「工作日」是指香港期貨交易所或外國期貨交易所（視具體情況而定）開市交易的任何日期，但星" +
          "期六、星期日、公共假期以及香港期貨交易所或外國期貨交易所（視具體情況而定）宣佈為非工作" +
          "日的任何其他日期除外；",
        "「結算所」指香港期貨結算有限公司；",
        "「結算所規則」指結算所的規則和適用程序，以及不時有效的對其作出的任何修訂、補充、變更或修改；",
        "「合約」是指一份期貨合約和/或期權合約，根據上下文的要求，「合約」應作相應的解釋；",
        "「外國結算所」指結算或交收所、公司、組織或機構（由外國期貨交易所指定、授權或聘請或成立" +
          "或經營,為該外國期貨交易所提供結算和交收服務）,包括其代理人、代名人、代表、職員和僱員；",
        "「外國結算系統」指由有關外國結算所不時經營的結算和交收系統；",
        "「外國期貨交易所」指香港以外國家或地區之法例容許，在該等國家或地區經營之任何期貨市場；",
        "「外國規則」具有本附件第 3.3 條款（外國法規）中規定的涵義；",
        "「外國交易」是指與將在外國期貨交易所執行的合約相關的任何交易；",
        "「期貨合約」指相關交易所規則所定義的期貨合約和/或在任何交易所執行的合約，其效力為：",
        "(a) 一方同意在約定的未來時間以約定的價格向另一方交付約定的商品或數量的商品；或",
        "(b) 當事人約定在將來某一時間根據約定商品的價值是高是低或高於或低於訂立合約時約定的水" +
          "平進行調整，差額部分由訂立合約的交易所的規則確定；",
        "「指示」具體而言是指與合約有關的指示；",
        "「追收保證金通知」具有本附件第 8.1 條款（追收保證金通知）中規定的涵義；",
        "「市場」指香港期貨交易所根據規則第 201 條款不時設立及營運的其中一個市場；",
        "「期權合約」指有關交易所規則所定義的期權合約及/或一方（「第一方」）與另一方（「第二方」）在" +
          "交易所簽訂的合約，根據該合約：",
        "(a) 第一方授予第二方在約定的將來某一日或之前或在約定的將來某一日（視情況而定）以約定價" +
          "格向第一方購買約定商品或某一商品數量的權利，但不是義務；如果第二方行使其購買權利，則： ",

        "(i) 第一方有義務按照約定的價格交付商品；或",
        "(ii) 第二方收到商品價值高於約定價格的款項（如有），該款項應根據合約訂立所在的相關交" +
          "易所的規則確定；或",
        "(b) 第一方授予第二方在約定的未來某一日或之前或在約定的未來某一日（視情況而定）按約定價" +
          "格向第一方出售約定商品或商品數量的權利，但並無義務；如果第二方行使其出售權利，則：",
        "(iii) 第一方有義務按照約定的價格收取商品；或",
        "(iv) 第二方收到一筆可參照約定價格高於商品價值的金額（如有）的款項，該筆款項應根據訂" +
          "立合約的相關交易所的規則確定；",
        "「法規」指董事會為監管市場活動不時訂明的任何名稱及包含於任何條文之內的規例，或按文義所" +
          "指，適用於某特定市場的規例；",
        "「規則」指香港期貨交易所的規則、規例以及不時有效的對規例的任何修訂、補充、變更或修改；",
        "「盈富基金單位」指根據（1）美國道富環球金融資產（香港）有限公司作為經理人、（2）美國道富" +
          "銀行及信託公司作為受託人及（3）外匯基金投資有限公司作為發起人於一九九九年十月二十三日訂" +
          "立之信託契據（可不時予以修改或補充）所設立名為「香港盈富基金」之單位信託計劃而發行之單位；及",
        "「變價調整」就香港期貨交易所成交的合約而言，指由結算所及/或本公司代客戶按結算所規則第 408" +
          "至 411 條款的規定每日計算的應付及/或應收予結算所及/或本公司的款項。",
        "2 開戶",
        "2.1 帳戶開立：客戶指示並授權本公司為簽訂和/或交易合約之目的開立和維持一個期貨帳戶。",
        "2.2 公司的酌情權：本公司同意，其將不時應客戶的要求，酌情允許客戶開立期貨帳戶，並將為客戶訂" +
          "立和/或交易合約之目的，維持該帳戶的名稱、號碼或其他。",
        "2.3 現狀：倘若本公司是已登記的期交所參與者和香港期交所結算所的直接結算參與者，本公司將通知" +
          "客戶這一事實（及入圍期交所參與者名錄）。",
        "2.4 主要負責人員：主要負責客戶在期交所合約訂立事務人員的全名（及其執照和註冊資料）應是帳戶" +
          "開立流程中指定的人士或是本公司可不時通知客戶指定的其他人士。",
        "3 條款及條件之適用範圍",
        "3.1 適用：本附件適用於本公司代客戶於香港期交所或任何外國期貨交易所簽立或將簽立之一切合約，" +
          "並視為收納於（不論是口頭或書面）本公司與客戶之間所訂立之每份合約內。客戶以書面或其他方" +
          "式（不論是明示、暗示或按慣例或於交易過程表明）建議或提述之任何其他條款及條件，或本公司" +
          "與客戶先前已據此訂立合約，均不包括於此適用範圍內。",
        "3.2 受限於規則：於香港期交所訂立之所有合約及本公司與客戶之間之所有交易，均對雙方具約束力，" +
          "並須依據香港期交所之程序、香港期交所之組織章程大綱及細則之條文以及規則履行並受其規限。",
        "3.3 外國規則：外國交易應當遵守有關市場、外國期貨交易所、外國結算系統、外國結算所等制定的規" +
          "章制度、規則、附例、憲法和程序（以下統稱外國規則）。對於不同市場和交易所的交易，客戶可能" +
          "有不同水平和類別的保護。在不影響上述規定的一般效力的前提下，所有外國交易應受限於下列其他規定：",

        "(a) 每筆外國交易均收取交易費用，相關費用應當由客戶自行負擔。",
        "(b) 每筆海外交易均受限於外國期貨交易所可能不時徵收的稅項；",
        "(c) 客戶確認本公司受《外國規則》的約束,該規則允許相關外國期貨交易所採取措施限制未平倉," +
          "或代表該外國期貨交易所認為正在累積對任何特定市場有或可能不利於或可能對任何市場的" +
          "公平和有序運作產生不利影響的客戶平倉;",
        "(d) 客戶確認，如果本公司作為外國結算所的交易所成員或參與者的權利被暫停或撤銷,有關外國" +
          "結算所可採取一切必要措施,將本公司代表客戶持有的任何未平倉合約及其在本公司帳戶內的" +
          "資金和證券，轉移給另一外國期貨交易所的一個會員或參與者;和",
        "(e) 客戶承認並接受,如果本公司超過根據《外國規則》施加的任何交易限額或持倉限制,相關機構" +
          "有權要求本公司平倉或將該等數量的未平倉進行轉移至另外一名成員（可能包括客戶的全部或" +
          "部分未平倉），直至相關機構認為本公司遵守持倉限制。",
        "4 先决和一般事項",
        "4.1 發行文件：對於在香港期貨交易所交易的合約，本公司將在客戶要求下向客戶提供合約說明書及關" +
          "於該等產品之任何章程或其他發行文件。",
        "4.2 授權：客戶應確保獲得適用於任何合約的任何政府或其他監管機構或部門的所有必要授權、批准和" +
          "同意，並確保該等授權、批准和同意的條款和所有適用法規。",
        "4.3 實際履行：客戶經本公司簽訂的每份合約均是客戶已清楚理解其實際表現下所訂立。客戶應被視為" +
          "必履行該合約的義務。",
        "4.4 酌情權：本公司可全權決定在不給予任何理由的情況下，拒絕代表客戶執行任何指示，或與客戶簽訂任何合約。",
        "4.5 投資者賠償基金：就香港期交所之合約而言，客戶承認，如本公司作出失責行為，令客戶於香港期" +
          "交所之交易中蒙受金錢損失，投資者賠償基金之責任僅限於證券及期貨條例及有關附屬法例所規定" +
          "之有效索償，並受證券及期貨（投資者賠償－賠償限額）規則所訂明之金額上限所規限，故此不能" +
          "保證因該等失責行為而招致之任何金錢損失可從投資者賠償基金中獲得悉數或部份補償，或必定獲任何補償。",
        "4.6 限制：就香港期交所之交易而言，客戶承認，本公司須受規則之約束，該等規則容許香港期交所採" +
          "取措施，在香港期交所認為客戶正累積對某一個或多個特定市場或可能造成損害或對某個或多個市" +
          "場之公平及有秩序運作造成不利影響（視情況而定）之持倉時，限制或要求本公司結清其代該等客" +
          "戶訂立之有關合約平倉。",
        "4.7 利息：客戶無權因客戶在期貨帳戶中的任何貸方餘額而獲得本公司可能收到的任何利息。根據第 5.7" +
          "條款（利息），客戶須就期貨帳戶的所有借方結餘支付利息。",
        "4.8 作為主事人交易：就香港期交所之交易而言，客戶承認，本公司在結算所持有之任何戶口，不論代" +
          "表客戶進行商品期貨交易而持有該戶口的全部或一部分，亦不論由客戶繳付或存放之款項或核准債" +
          "務證券或核准證券是否已繳付或存放於結算所，在本公司與結算所之間，本公司乃以主事人身份進" +
          "行買賣，故此該戶口並非表示以客戶為受益人之任何信託或其他衡平法權益，繳付或存放於結算所" +
          "之款項、核准債務證券及核准證券乃不受本條中所述信託之約束。",
        "4.9 獲批准證券/獲批准的債務證券：就香港期交所交易之合約而言，本公司從客戶或任何其他人士（包" +
          "括結算所）收取之所有款項、核准債務證券或核准證券，乃根據操守準則附表 4 第 7 至 12 段所述方" +
          "式而持有。客戶授權本公司按照操守準則附表 4 第 14 至 15 段所指定方式運用任何該等款項、核准" +
          "債務證券或核准證券。尤其是本公司可運用該等款項、核准債務證券或核准證券以履行本公司因代" +
          "客戶進行商品期貨交易所引致或附帶其對任何方面人士之責任。",

        "4.10 相反之倉盤：受限於證券及期貨條例的規定及任何適用法規，本公司可就任何合約採取與客戶指示" +
          "相反之倉盤，不論是為本公司自身還是為高盈證券成員或本公司的其他客戶，但該項買賣須透過香" +
          "港期交所設施，根據任何其他商品、期貨或期權交易所之規則或設施，依照該等其他交易所之規則" +
          "及規例，以具競爭力方式進行。",
        "4.11 延遲：客戶確認，在若干情況下，本公司會因香港期交所或其他外國期貨交易所之實際環境限制及" +
          "商品價格急劇變動而延遲作價或延遲買賣，而本公司可能於付出合理努力後仍未能於任何指定時間" +
          "按所報價格進行買賣。客戶同意，本公司無須因未能遵照客戶指示之任何條款（包括由於客戶試圖" +
          "撤回或修改指示而重複執行指示）而引致之任何損失承擔責任。",
        "4.12 部分履行：客戶確認，倘若本公司於付出合理努力後仍未能全面地執行任何指示，本公司有權只履" +
          "行部分指示，無須事先徵詢客戶給予確認。當客戶提出執行指令之要求後，客戶即須接受指示已予" +
          "履行、部分履行或不履行之任何後果，並受其約束。",
        "4.13 截止：任何客戶指示如未能於有關交易所收市或有關交易所規定之其他屆滿日期或客戶與本公司同" +
          "意之其他較後時間之前獲得執行，則視作自動取消。",
        "4.14 最優價：客戶確認，鑒於執行交易之香港期交所或其他外國期貨交易所之買賣慣例，或許不能永遠" +
          "按「最佳」或「市場」價格執行指令，客戶同意，在任何情況下均受本公司按照客戶指示所執行交易之約束。",
        "4.15 信用調查：客戶特此授權本公司對客戶進行資信查詢（如為個人客戶，則為個人信用調查）及其他" +
          "調查，以確定客戶的財務狀況和投資目的。客戶應使本公司了解其財務狀況，並應立即向本公司報" +
          "告表明其（a）資不抵債，（b）可能資不抵債，或（c）有任何違規或瀆職行為的任何資訊。應按本公" +
          "司要求，客戶應當提供與前述事項相關的所有資料和文件，包括資產證明、收入來源證明等。",
        "4.16 合併/分拆：客戶授權本公司，於任何時間及由本公司全權決定，為取得更佳之執行價及／或減少作" +
          "出指示之次數，將客戶有關代為買／賣合約之指示，與本公司自其他客戶接獲之類似指示合併及／" +
          "或分拆處理。客戶同意，假若可供買賣之合約數目不足以滿足合併處理之買賣指令，實際作出買／" +
          "賣之合約數目將按本公司接獲指令之次序歸於有關客戶。",
        "4.17 優先權：在適用法律及規例及市場情況之規限下，本公司經考慮接獲指令之先後次序下，有全權決" +
          "定執行其客戶指令之次序，客戶不得對有關本公司執行任何收到客戶指示的優先次序，提出異議。",
        "4.18 大額未平倉合約：當客戶經其在本公司的戶口持有/控制商品期貨合約，及倘若香港期交所董事會根" +
          "據規則第 628 條決定該戶口的未平倉總額為「大額未平倉合約」，本公司有責任向香港期交所申報。" +
          "然而，客戶在任何時候就進行與商品期貨合約有關的交易,而在本公司以外，在其他香港期交所參與" +
          "者開立一個或多個戶口，及該戶口的未平倉總額為「大額未平倉合約」，客戶應即時向香港期交所申" +
          "報該「大額未平倉合約」，並向香港期交所提供其所規定的與該「大額未平倉合約」有關的資料（包" +
          "括客戶及最終實益擁有人的名稱，或（如屬公司或團體）該公司或團體股本的最終實益擁有人個人" +
          "的名稱，包括透過代名人或信託形式持有利益的受益人），及向香港期交所提供其所要求的任何其他" +
          "資料。客戶確認及承認本公司根據規則在某些情況下有責任向香港期交所申報從客戶取得與其「大" +
          "額未平倉合約」相關的資料，及客戶特此同意本公司向香港期交所提供該等資料。",
        "4.19 報告：客戶應履行所有適用及不時生效的所有通報、持倉申報及大額持倉申報要求（包括但不限於" +
          "香港法例第 571Y 章《證券及期貨（合約限量及須申報的持倉量）規則》下的要求），及不應超過根" +
          "據相關市場及交易所訂明關於合約限量及須申報的持倉量規則所載之有關期貨類別及種類的限額" +
          "（如有）。客戶有責任了解不時適用的該等要求。客戶承認本公司對客戶未能遵守該等要求概不負責" +
          "（適用法例或法規要求除外）。",
        "4.20 交割：在不損害本協議下本公司權利的前提下,如本公司認為存在變動或預期變動,本公司可在未經客" +
          "戶同意的情況下將客戶戶口內所有或任何持倉平倉:（a）由於國家或國際貨幣、金融、經濟或政治條" +
          "件或外匯管制，已經導致或認為可能導致香港和/或海外股票市場、商品或期貨市場出現重大或不利" +
          "波動;或。（b）已經或可能在性質上影響本公司或客戶的狀況與操作。",

        "5 許可權",
        "5.1 披露：經香港期貨交易所或證監會或任何司法轄區的任何其他交易所、政府或監管部門（合稱「相" +
          "關監管機構」）要求，本公司應披露相關監管機構可能要求的客戶的姓名、實益身份及其他資訊。客" +
          "戶承諾在本公司指定的時間內向本公司披露為本公司遵守規則、外國規則、證監會和/或相關監管機" +
          "構的要求而可能要求的關於客戶自身的其他資訊。客戶不可撤銷地授權公司作出任何該等披露。就" +
          "於香港期交所之交易而言，假若本公司未能遵照香港期交所規則第 606（a）或 613（a）條之披露規" +
          "定，香港期交所行政總裁可要求代客戶平倉或就該客戶所持倉盤收取附加保證金。",
        "5.2 酌情權行動：本公司可在任何時間採取下列一項或多項經本公司酌情權決定的行動，以確保本公司" +
          "遵守適用法規：（a）扣除或扣起帳戶內部份應繳付帳戶的金額；（b）立即終止帳戶及停止本公司與" +
          "客戶的全部或部份關係，而不作另行通知；（c）提供（不論司在帳戶終止之前及或之後）客戶的稅務" +
          "資料予任何其他司法管轄區的機構，以確保本公司遵守有關法律及條例",
        "5.3 結算所：就於香港期交所交易的合約而言，客戶確認，假若本公司作為香港期交所之交易所參與者" +
          "之權利遭暫停或撤銷，結算所可作出一切所需行動，以便將本公司代客戶持有之任何未平倉盤及存" +
          "放於其在本公司持有之戶口之任何款項及證券移轉往香港期交所另一參與者。",
        "5.4 代理人：客戶同意，除非本公司在有關交易的合同說明或建議中以其他方式通知客戶，否則本公司" +
          "僅在執行客戶指示時充當客戶的代理人。",
        "6 一般留置權：在不影響條款第 15 條款（留置權）的情況下：",
        "6.1 一般留置權：客戶授予本公司對所有或任何代客戶不時持有（不論是為了安全保管或其他目的而持" +
          "有）的款項（包括保證金）、核准證券，核准債務證券及其它資產（統稱為「資產」）擁有一般留置" +
          "權，以用作解除客戶就本公司代客戶進行買賣合約而所須承擔的責任。",
        "6.2 固定收費：客戶特此同意，把客戶的所有資產以第一固定押記方式作為客戶支付或清償閣下虧欠本" +
          "公司的任何債項的持續抵押。",
        "6.3 清算：客戶特此授權本公司可無須事先通知並按其絕對酌情權厘定的價格和方式出售任何資產，以" +
          "解除客戶對本公司的債項。本公司有權決定終止哪些合約或相關合約。在所有債項被全數支付或清" +
          "償後，本公司可應客戶之要求及在客戶支付有關費用的情況下，發還所有資產的權利、所有權及利益給客戶。",
        "7 交付",
        "客戶應根據本公司發出的任何指示，迅速交付其在任何合約項下可交付的任何款項、證券、金融票" +
          "據、文件或其他商品或財產，以應付保證金催繳及適用於香港期貨交易所交易的任何合約的變更調" +
          "整要求，或滿足適用於任何外國期貨交易所的保證金要求。",
        "8 保證金及存入",
        "8.1 追收保證金通知：客戶須應本公司不時酌情權決定之要求向本公司繳付或存入本附件第 7 條（交付）" +
          "擬議的金額和/或其他證券，作為保證金和/或為客戶在本公司的一個或多個帳戶進行的變更調整，以" +
          "便行使其與之相關的權利（「追收保證金通知」）。就在香港期貨交易所交易的合約而言，本公司可能" +
          "被要求向香港期貨交易所和證監會報告在本公司指定的期限內未滿足連續兩次保證金催繳及變更調" +
          "整要求的所有未平倉合約的詳情。本公司可以要求客戶繳交比香港期交所及／或結算所指定更多之" +
          "保證金及變價調整要求，以及可就本公司指定期間內未能履行追收保證金通知及變價調整要求或未" +
          "能在作出該等追收保證金通知或要求時繳付保證金之所有未平倉合約平倉。",
        "8.2 聯繫客戶方式：本公司發出保證金通知後，將以最大的努力及時與客戶聯繫。客戶同意，在本公司" +
          "根據本合約條款第 30 條款（通訊及通知）向客戶發出該等追收保證金通知後，保證金催繳應被視為適當進行。",
        "8.3 帳戶間的劃撥：在適用法例及規則之規限下，本公司可於無須事先知會客戶，不時將本公司代客戶" +
          "持有之所有或任何部分款項或其他抵押品，在客戶於本公司之不同戶口之間轉撥，或轉撥往設於香" +
          "港期交所結算或非結算會員之任何戶口內，由本公司全權決定認為必需或適合者，以符合客戶之任" +
          "何保證金要求。本公司於作出任何該等轉撥時將知會客戶。",

        "8.4 質押：本公司將以質押方式持有作為客戶對本公司之任何保證金、存款或其他責任之抵押品之任何" +
          "檔或其他財產，除非明文表示其持有之抵押品乃受制於若干其他抵押安排，則作別論。",
        "9 費用及收費",
        "9.1 費用及收費：客戶須向本公司繳付不時厘定及知會客戶之香港期交所或任何外國期貨交易所就商品" +
          "期貨合約訂明之佣金及交易費用，以及本公司附加收費。請另行參閱載列於本公司網站向客戶收取" +
          "之佣金及費用之詳情。",
        "9.2 投資者賠償基金的徵收：每份香港期交所合約均須繳付投資者賠償基金征費及根據證券及期貨條例" +
          "徵收之費用，該兩項征費均須由客戶承擔。",
        "10 交易通知及報告",
        "10.1 交易通知及報告：本公司將於交易執行後兩個工作日內，給予交易確認書及對賬單予客戶的方式，" +
          "向客戶報告執行商品期貨交易之情況，包括購入或出售的合約的數目、相關資產、到期月份、行使" +
          "價、期權形式（認沽或認購）、版號，以及該等合約屬平倉合約或開倉合約；及該等合約內載每手所" +
          "包括的資產單位及有關價格。",
        "10.2 責任：客戶同意，本公司無須就因客戶延遲向本公司報告錯漏而引致之任何損害或市場波動承擔責任。",
        "10.3 超額支付：假如戶口中出現多付款項或合約，客戶同意於獲悉時立即知會本公司，並同意不會轉移" +
          "有關款項或合約（或如已轉移，須立即退還）。",
        "11 違約事件",
        "11.1 違約：為本協定之目的，下列每一事件也應構成違約事件：",
        "(a) 就任何合約而言，客戶違反或未能遵守或在其適當的時間和日期履行其任何規定（在不影響前" +
          "述規定的一般性原則下，包括本協議的任何規定），或客戶轉讓或聲稱轉讓任何合約的全部或部分利益；",
        "(b) 客戶未能符合追收保證金通知（無論是初始、維持或附加）的要求,或未能或拒絕遵守公司根據" +
          "本協定提出的任何請求、通知或要求,或公司至少嘗試要求客戶進行追收保證金通知,且任何原" +
          "因無法直接與客戶溝通;",
        "(c) 本公司以酌情權認定客戶存放作為保證金之任何款項或抵押品，就客戶所訂立或擬訂立之合約" +
          "價值而言並不足夠；或",
        "(d) 客戶履行其在任何合約項下的任何義務屬於或成為不合法；及/或",
        "(e) 在公司或任何高盈證券成員目前或將來承擔香港期貨交易所、外國期貨交易所、結算所或任何" +
          "適用法規規定的採取本附件第 11.2 條（補償）中提及的任何行動的任何義務的任何時間。",
        "11.2 補償：在不影響本公司可能享有的任何其他權利或補償的前提下，若發生任何違約事件，則在不事" +
          "先向客戶發出要求的情況下：",
        "(a) 本公司無義務（於採取補救方法之前）就任何合約向客戶支付作為擔保而持有的任何款項或交付任何資產；",
        "(b) 本公司有權暫停履行其以任何方式產生的對客戶承擔的任何義務，無論是在任何合約項下還是" +
          "在其他項下，包括支付屆時到期或其後可能到期的任何一筆或多筆款項；",
        "(c) 本公司有權認為就必需或適宜之方式結清所有或任何現有合約（儘管合約尚未到期結算），並" +
          "採取其認為必需之其他步驟以保障其利益，但在任何情況下，本公司均無責任行使任何該等權" +
          "利，或在對客戶有利之時間或以有利於客戶之方式行使該等權利；",
        "(d) 本公司有權將帳戶內任何未平倉合約平倉，履行或維持有關未平倉合約；及就這目的交付或接" +
          "受交付合約之相關商品、沽出或平倉任何合約、訂立長倉或短倉之跨價期或馬鞍式組合，或作" +
          "出以上任何專案的組合",
        "(e) 本公司可以行使因本公司代表客戶持有的任何現有合約而產生的任何選擇（即沽出或認購）；",
        "(f) 本公司可採取該行為,並作出其唯一及絕對酌情權認為必要或可取的行為、事項或事項,以遵守" +
          "或履行、取消或履行本公司對客戶的任何義務,或客戶和/或本公司對香港期貨交易所、結算所" +
          "或任何外國期貨交易所的任何義務；",
        "(g) 本公司可以將任何屬於客戶在本公司保管或控制下的資產（以直接或通過擔保或擔保方式）以" +
          "履行客戶對本公司承擔的任何義務；及/或",
        "(h) 本公司可要求或強制執行可能為公司或任何高盈證券成員簽發、製造或創建的或有利於本公司的任何抵押品；",
        "12 終止",
        "12.1 終止：儘管有第 27.1（客戶提出的終止）條款的規定，客戶只能在期貨帳戶中沒有未完成的合約情況下終止本附件。",
        "12.2 終止的後果：本附件的終止：",
        "(a) 不得影響本公司於終止前依據本協議而訂立之任何交易；及",
        "(b) 不得影響任何一方就未平倉合約或對本公司有尚未完成責任之合約之權利或責任，亦不得影響" +
          "本公司對其持有之一切存款、保證金及其他款項之權利，而本協議將繼續適用於以上各項。",
        "13 轉讓",
        "未經本公司事先書面同意，客戶不得轉讓、委託、分包、轉移或以其他方式處置本協議或任何合約" +
          "項下的任何權利。客戶在每一合約項下的權利應受限於因本協議適用於每一合約項下的每項交易以" +
          "及客戶與本公司簽訂的每一合約而產生的所有權利、責任和義務。",
        "14 綜合帳戶",
        "14.1 總帳戶：客戶是總合帳戶，且不是香港期貨交易所交易參與人的，對其在香港期貨交易所成交的合約，客戶應當：",
        "(a) 於客戶與客戶就綜合戶口而接獲指示之一名人士（多名人士）進行買賣時，遵從及強制執行規" +
          "則及結算所規則訂明之保證金及變價調整規定及程式，猶如客戶乃香港期交所一名交易所參與" +
          "者，而為其戶口或利益而發出指示之該名（等）人士乃為客戶；",
        "(b) 促使為履行有關指示而訂立交易所合約（定義見規則），從而在任何情況下，按指示進行的任" +
          "何買賣的形式，均不會構成香港或任何其他適用的司法管轄區的法例所指的非法買賣商品市場" +
          "的報價差額，或有關的買賣方式亦不會構成或涉及投注、打賭、博彩或就該等項目而進行的賭" +
          "博，從而違反香港法例或任何適用法律;及",
        "(c) 確保客戶從其接獲指示之人士遵從規則訂明之保證金及變價調整規定，令致在香港期交所與本" +
          "公司之間，本公司應負責確保該等規定已獲綜合戶口中透過其傳達指示之所有人士遵從，猶如" +
          "各人均為該綜合戶口之客戶。",
        "15 其他規定",
        "15.1 不一致：倘若本協議內任何條款與香港期交所、結算所或對本協定目標事項具司法管轄權之任何當" +
          "局之任何現行或未來法例、規則或規例有抵觸，該項條文將視作已根據任何該等法例、規則或規例" +
          "而撤銷或修改。而本協議於所有其他方面將繼續維持十足效力及作用。",
        "15.2 風險披露：客戶確認，（a）附件 X（風險披露聲明）中的風險披露聲明是以客戶選擇的語言（英文或" +
          "中文）提供的，（b）如客戶認為有必要，客戶可以閱讀風險披露，向專業顧問提出問題並接受獨立" +
          "諮詢意見，以及（c）客戶已經理解風險披露。客戶承認，這些風險披露聲明可能會不時發生變化。",

        "附件 X：風險披露聲明",
        "客戶務須細閱此等風險披露聲明。此等聲明為本協議及開戶表格的組成部份。客戶執行開戶表格，即表示確認" +
          "其已閱讀並細閱其選擇語言版本（英文或中文）的此等風險披露聲明，並獲邀閱讀該聲明、提出問題及在有此" +
          "意願的情況下徵求獨立的意見，以及確認其明白與帳戶有關的投資及交易可能產生的風險。",
        "此等風險披露聲明沒有亦不旨在披露與帳戶有關的所有投資及交易的一切風險及相關考慮因素。客戶於全面" +
          "了解所涉及的風險，並從客戶本身的顧問取得客戶認為適當的獨立意見前，應避免作出任何投資或交易。本公" +
          "司並非客戶的財務顧問，亦不應被視作客戶的財務顧問。",
        "1 證券交易的風險",
        "投資附帶風險，過往業績並非未來表現的指標。證券價格有時可能會非常波動。證券價格可升可跌，甚至變成" +
          "毫無價值。買賣證券未必一定能夠賺取利潤，反而可能會招致損失。",
        "2 期貨及期權交易的風險",
        "2.1 買賣期貨合約或期權的虧蝕風險可以極大。在若干情況下，客戶所蒙受的虧蝕可能會超過最初存入的保證金數額。",
        "2.2 即使客戶設定了備用指示，例如「止蝕」或「限價」等指示，亦未必能夠避免損失。市場情況可能使該等指示無法執行。",
        "2.3 客戶可能會在短時間內被要求存入額外的保證金。假如未能在指定的時間內提供所需數額，客戶的" +
          "未平倉合約可能會被平倉。然而，客戶仍然要客戶的帳戶內任何因此而出現的短欠數額負責。",
        "2.4 因此，客戶在買賣前應研究及理解期貨合約及期權，以及根據本身的財政狀況及投資目標，仔細考" +
          "慮這種買賣是否適合自己。",
        "2.5 如果客戶買賣期權，便應熟悉行使期權及期權到期時的程序，以及客戶在行使期權及期權到期時的權利與責任。",
        "2.6 期權涉及高風險，未必適合所有投資者。投資者應確保在參與期權市場之前了解這些風險。",
        "2.7 有些期權在到期日方可行使（歐式期權的行使），其他期權可於到期前的任何時間行使（美式期權的" +
          "行使）。有些期權在行使時須以正股交收，而其他期權在行使時則須支付現金。",
        "2.8 客户知悉期權乃損耗性資產，期權持有人可能會損失該期權的全部期權金。作為期權持有人，如欲" +
          "賺取利潤，必須行使期權或在市場將期權長倉平倉。在某些情況下，因市場流通量不足，買賣期權會出現困難。",
        "2.9 作為期權沽出人，客户隨時可能要繳付額外的按金。期權沽出人與期權持有人不同，正股價的起跌" +
          "可令沽出人蒙受無限損失，而期權金乃沽出人的唯一回報。",
        "2.10 此外，美式認購（認沽）期權的沽出人可能需要在到期前的任何時候交收正股或支付現金代價，該" +
          "價格為行使價乘以正股數目的積，上述責任可能與沽出期權所收到的期權金的價值完全不成比例，" +
          "而有關的通知期亦可能甚短。",
        "3 買賣創業板股份的風險",
        "3.1 創業板股份涉及很高的投資風險。尤其是該等公司可在無需具備盈利往績及無需預測未來盈利的情" +
          "況下在創業板上市。創業板股份可能非常波動及流通性很低。",
        "3.2 客戶只應在審慎及仔細考慮後，才作出有關的投資決定。創業板市場的較高風險性質及其他特點，" +
          "意味著這個市場較適合專業及其他熟悉投資技巧的投資者。",

        "3.3 現時有關創業板股份的資料只可以在香港聯合交易所有限公司所操作的互聯網網站上找到。創業板" +
          "上市公司一般毋須在憲報指定的報章刊登付費公告。",
        "3.4 假如客戶對本風險披露聲明的內容或創業板市場的性質及在創業板買賣的股份所涉風險有不明白之" +
          "處，應尋求獨立的專業意見。",
        "4 在香港以外地方收取或持有的客戶資產的風險",
        "4.1 本公司在香港以外地方收取或持有的客戶資產，是受到有關海外司法管轄區的適用法律及規例所監" +
          "管的。這些法律及規例與《證券及期貨條例》（第 571 章）及根據該條例制訂的規則可能有所不同。",
        "4.2 因此，有關客戶資產將可能不會享有賦予在香港收取或持有的客戶資產的相同保障。",
        "5 在香港聯合交易所有限公司買賣納斯達克–美國證券交易所證券的風險",
        "5.1 按照納斯達克–美國證券交易所試驗計劃（「試驗計劃」）掛牌買賣的證券是為熟悉投資技巧的投資者" +
          "而設的。客戶在買賣該項試驗計劃的證券之前，應先諮詢本公司的意見和熟悉該項試驗計劃。客戶" +
          "應知悉，按照該項試驗計劃掛牌買賣的證券並非以香港聯合交易所有限公司的主板或創業板作第一" +
          "或第二上市的證券類別加以監管。",
        "6 使用網上交易協議下之電子服務的風險",
        "6.1 如果客戶透過電子服務進行買賣，客戶便須承受該電子服務系統帶來的風險，包括有關系統硬體和" +
          "軟件可能會失靈的風險。系統失靈可能會導致客戶的買賣盤不能根據指示執行，甚或完全不獲執行。",
        "6.2 由於未可預計的流量擠塞和其他原因，電子服務可能並不可靠的，及存在通過電子服務進行的交易" +
          "在傳輸和接收客戶的指示或其他資訊過程中可能會被耽誤、延遲執行客戶的指示或有關指示以有別" +
          "於客戶發出指示時的市價執行、指示在傳輸時被中斷或停頓等風險。",
        "6.3 在通訊過程中也存在誤解或錯誤的風險，以及在發出了指示後，通常也不一定可以取消。由於此類" +
          "中斷、耽誤或被第三方入侵而使客戶遭受的任何損失，本公司概不承擔責任。如果客戶不準備接受" +
          "此類中斷或耽誤引致的風險，客戶不應透過電子服務來作出任何指示。",
        "6.4 通過電子服務向客戶提供的市場數據和其他資訊可能是本公司從第三者獲得的。雖然本公司相信這" +
          "些數據和資訊是可靠的，但本公司或該等第三者都不會保證這些數據和資訊的準確性、完整性和即 時性。",
        "7 保證金買賣的風險",
        "7.1 藉存放抵押品而為交易取得融資的虧損風險可能極大。客戶所蒙受的虧蝕可能會超過客戶存放於本" +
          "公司作為抵押品的現金及任何其他資產。",
        "7.2 市場情況可能使備用交易指示，例如「止蝕」或「限價」指示無法執行。",
        "7.3 客戶可能會在短時間內被要求存入額外的保證金款額或繳付利息。假如客戶未能在指定的時間內支" +
          "付所需的保證金款額或利息，客戶的抵押品可能會在未經客戶的同意下被出售。",
        "7.4 客戶應密切留意帳戶狀況，在市場波動下，本公司未必能聯絡客戶或提供足夠時間予客戶存錢，而" +
          "客戶的持倉將有可能被強制平倉。此外，客戶將要為客戶的帳戶內因此而出現的任何短欠數額及需繳付的利息負責。",
        "7.5 因此，客戶應根據本身的財政狀況及投資目標，仔細考慮這種融資安排是否適合客戶。",
        "8 提供將客戶的證券抵押品等再質押的授權書的風險",
        "8.1 本公司提供授權書，容許其按照某份證券借貸協議書使用客戶的證券或證券抵押品、將客戶的證券" +
          "抵押品再質押以取得財務通融，或將客戶的證券抵押品存放為用以履行及清償其交收責任及債務的抵押品，存在一定風險。",

        "8.2 假如客戶的證券或抵押品是由本公司收取或持有的，則上述安排僅限於客戶已就此給予書面同意的" +
          "情況下方行有效。此外，除非客戶是專業投資者，客戶的授權書必須指明有效期，該段有效期不得" +
          "超逾 12 個月。若客戶是專業投資者，則有關限制並不適用。",
        "8.3 此外，假如本公司在有關授權的期限屆滿前最少 14 日向客戶發出有關授權將被視為已續期的提示，" +
          "而客戶對於在有關授權的期限屆滿前以此方式將該授權延續不表示反對，則客戶的授權將會在沒有"+
        "客戶的書面同意下被視為已續期。",
        "8.4 現時並無任何法例規定客戶必須簽署這些授權書。然而，本公司可能需要授權書，以便例如向客戶" +
          "提供保證金貸款或獲准將客戶的證券或證券抵押品借出予第三方或作為抵押品存放於第三方。本公" +
          "司應向客戶解釋將為何種目的而使用授權書。",
        "8.5 倘若客戶簽署授權書，而客戶的證券或證券抵押品已借出予或存放予第三方，該等第三方將對客戶" +
          "的證券或證券抵押品具有留置權或作出押記。雖然本公司根據客戶的授權書而借出或存放屬於客戶" +
          "的證券或證券抵押品須對客戶負責，但若本公司的違責行為可能會導致客戶損失客戶的證券或證券抵押品。",
        "8.6 本公司提供不涉及證券借貸的證券現金帳戶。假如客戶毋需使用保證金貸款，或不希望本身證券或" +
          "證券抵押品被借出或遭抵押，則切勿簽署上述的授權書，並應要求開立該等證券現金帳戶。",
        "9 提供代存郵件或將郵件轉交第三方的授權書的風險",
        "假如你向本公司提供授權書，允許本公司代存郵件或將郵件轉交予第三方，那麼你便須盡速親身收" +
          "取所有關於你帳戶的成交單據及結單，並加以詳細閱讀，以確保可及時偵察到任何差異或錯誤。",
        "10 關於境外證券買賣，包括在中國内地上市股票的風險",
        "10.1 客戶在進行任何境外證券交易前，應先了解將境外證券交易的性質和客戶就此須承擔的風險程度。",
        "10.2 尤其是，儘管本公司是聯交所的交易所參與者，但境外證券買賣不受聯交所監管，也不受投資者賠償基金保護。",
        "10.3 客戶應就本身的投資經驗、投資目標、財政資源及其他相關條件，小心衡量自己是否適合參與該等" +
          "買賣。假如客戶存有疑問，應尋求獨立的專業意見。",
        "11 外幣交易的風險",
        "11.1 以外幣計算產品的買賣所帶來的利潤或招致的虧損（不論交易是否在客戶本身所在的司法管轄區或" +
          "其他司法管轄區進行），均會在需要將產品的單位貨幣兌換成另一種貨幣時受到匯率波動的影響。",
        "11.2 客戶明白若所買賣結構性產品的相關資產並非以港幣為單位，其尚要面對外匯風險。貨幣兌換率的" +
          "波動可對相關資產的價值造成負面影響，連帶影響結構性產品的價格。",
        '12 交易所交易票據（"ETNs"）的風險',
        "12.1 ETN 是一種由承銷銀行發行的無擔保、非次級債務證券，旨在為投資者提供各個市場基準的回報。" +
          "ETN 的回報通常與一個市場基準或策略的表現掛鈎，並扣除適用的費用。與其他債務證券類似，ETN" +
          "有到期日，且僅以發行人信用作為支持。",
        "12.2 客戶可以透過交易所買賣 ETN 或於預定到期日收取現金付款，或視乎基準指數的表現有機會直接向" +
          "發行人提早贖回 ETN（須扣除適用的費用）。然而，客戶於贖回時可能受 ETN 的提早贖回條件限制，例如最少贖回數量。",

        "12.3 本公司並不保證客戶於到期日或發行人提早回購時可收回投資本金或任何投資回報。對於 ETN，正" +
          "面表現的月份或無法抵銷其中某些極不利之月度表現。",
        "12.4 ETN 發行人有權隨時按回購價值贖回 ETN。",
        "12.5 若於任何時候 ETN 的回購價值為零，客戶的投資則變得毫無價值。ETN 可能流通性不足，不能保證" +
          "客戶可隨時按其意願，以目標價格買賣。",
        "12.6 儘管 ETF 與 ETN 均有追蹤基準指數的特性，但 ETN 屬於債務證券，並不實際擁有其追蹤的任何資" +
          "產，擁有的僅是發行人向投資者分配理論上存在的基準指數所反映的回報之承諾。ETN 對投資組合" +
          "的多元化程度有限，投資者須受集中於特定指數及指數成份的集中性風險。鑒於 ETN 屬無抵押品的" +
          "債務工具，若 ETN 發行商發生違約或破產，最大潛在損失可能是投資額的百分之一百及無法獲得任何利潤。",
        "12.7 即使受追蹤的相關指數沒有變化，發行人信用評級降级亦會導致 ETN 的價值下跌。因此，買賣 ETN" +
          "的客戶直接面臨發行人的信用風險，且在發行人宣佈破產的情況下僅擁有無擔保的破產索償權。",
        "12.8 本金金額須扣除定期收納的投資者費用或任何適用的費用，該等費用會對回報產生不利影響。",
        "12.9 個別 ETN 可能會採用槓桿，而 ETN 的價值會因應其對於相關資產的槓桿比率而迅速變化。客戶應" +
          "注意 ETN 的價值可能會跌至零，客戶可能損失所有的投資本金。",
        "13 違約風險及交易對手風險",
        "13.1 所有產品都具有違約風險及/或交易對手風險。違約風險是指發行商未能根據協定缴付。遇上經濟不" +
          "景，發行商未必能成功借貸繼續經營或償還舊債。信貸評级是評估结構性產品違約風險最常用的工" +
          "具。信貸評級代表信貸評級機構於某一持定時間内的意見，而信貸評級往往會因應發行商的財政狀" +
          "況或市場情況的改變而作出調整。",
        "13.2 交易對手風險指交易方無力履行其財務合約責任，雖然信貸評級的評級有一定的可靠性，客戶除了" +
          "要參考發行商的信貸評級外，更要仔细留意產品的结構本身是否涉及衍生工具，以免招致損失。",
        "14 集體投資計劃的風險",
        "14.1 集體投資計劃可廣泛地（最多 100%）投資於金融衍生工具，定息證券及/或結構性產品（包括但不限" +
          "於信用違約掉期、次等投資級別債務、按揭抵押證券及其他資產抵押證券）、並涉及不同的風險（包" +
          "括但不限於交易對手風險、流通性風險、信用風險及市場風險）。",
        "14.2 集體投資計劃可能使用衍生工具的交易策略可能招致損失的部份原因包括但不限於：市場狀況動盪、" +
          "衍生工具與取決其價格的證券走勢關連性不完美、市場缺乏流動性，以及交易對手方的違責風險。",
        "15 衍生產品和結構性產品交易的一般風險",
        "15.1 發行商失責風險：倘若結構性產品發行商破產而未能履行其對所發行證券的責任，客戶只被視為無" +
          "抵押債權人，對發行商任何資產均無優先索償權。因此，客戶須特別留意結構性產品發行商的財力及信用。",
        "15.2 非抵押產品風險：非抵押結構性產品並沒有資產擔保。倘若發行商破產，客戶可以損失其全數投資。" +
          "客戶須細閱上市文件以確定產品是否屬非抵押性質，及該產品是否適合自己。",
        "15.3 槓桿風險：衍生權證及牛熊證均是槓桿產品，其價值可按相對相關資產的槓桿比率而快速改變。客" +
          "戶須留意，衍生權證及牛熊證的價值可以跌至零，屆時當初投資的資金將會盡失。",
        "15.4 有效期的考慮：結構性產品設有到期日，到期後的產品即一文不值。客戶須留意產品的到期時間，" +
          "確保所選產品尚餘的有效期能配合其交易策略。",

        "15.5 特殊價格移動：結構性產品的價格或會因為外來因素（如市場供求）而有別於其理論價，因此實際" +
          "成交價可以高過亦可以低過理論價。",
        "15.6 流通量風險：聯交所規定所有結構性產品發行商要為每一隻個別產品委任一名流通量提供者。流通" +
          "量提供者的職責在為產品提供兩邊開盤方便買賣。若有流通量提供者失責或停止履行職責，有關產" +
          "品的客戶或就不能進行買賣，直至有新的流通量提供者委任出來止。",
        "16 買賣衍生權證的特定風險",
        "16.1 時間損耗風險：假若其他情況不變，衍生權證愈接近到期日，價值會愈低，因此不能視為長線投資。",
        "16.2 波幅風險：衍生權證的價格可隨相關資產價格的引申波幅而升跌，客戶須注意相關資產的波幅。",
        "16.3 非長期有效：與股票不同，衍生權證有到期日，並非長期有效。衍生權證到期時如非價內權證，則不會有價值。",
        "16.4 成交額：衍生權證成交額高不應被認作為其價值會上升。除了市場力量外，衍生權證的價值還受其" +
          "它因素影響，包括相關資產價格及波幅、剩餘到期時間、利率及預期股息。",
        "17 買賣牛熊證的特定風險",
        "17.1 強制收回風險：客戶買賣牛熊證，須留意牛熊證可以即日「取消」或強制收回的特色。若牛熊證的" +
          "相關資產值等同上市文件所述的強制收回價/水平，牛熊證即停止買賣。屆時，客戶只能收回已停止" +
          "買賣的牛熊證由產品發行商按上市文件所述計算出來的剩餘價值（注意：剩餘價值可以是零）。",
        "17.2 融資成本：牛熊證的發行價已包括融資成本。融資成本會隨牛熊證接近到期日而逐漸減少。牛熊證" +
          "的年期愈長，總融資成本愈高。若一天牛熊證被收回，客戶即損失牛熊證整個有效期的融資成本。" +
          "融資成本的計算程式載於牛熊證的上市文件。",
        "17.3 限定的有效期：牛熊證有一固定有效期，並於指定日期到期。有效期可以是 3 個月至 5 年不等。若" +
          "在到期前遭提早收回牛熊證的有效期將變得更短。期間牛熊證的價值會隨著相關資產價格的變動而" +
          "波動，於到期後或遭提早收回後更可能會變得沒有價值。",
        "17.4 相關資產的走勢：牛熊證的價格變動雖然趨向緊貼相關資產的價格變動，但在某些情況下未必與相" +
          "關資產價格的變動同步（即對沖值不一定等於 1）。牛熊證的價格受多個因素所影響，包括其本身的" +
          "供求、財務費用及距離到期的時限。此外，個別牛熊證的對沖值亦不會經常接近 1，特別是當相關資" +
          "產的價格接近收回價時。",
        "17.5 接近收回價時的交易：相關資產價格接近收回價時，牛熊證的價格可能會變得更加波動，買賣差價" +
          "可能會較闊，流通量亦可能較低。牛熊證隨時會被收回而交易終止。由於任何在強制收回事件後始" +
          "執行的交易將不被承認並會被取消，而強制收回事件發生的時間與牛熊證停止買賣之間可能有時差，" +
          "一些在強制收回事件發生後才達成的交易即使已被證券商確認最後亦會被取消，因此客戶買賣接近" +
          "收回價的牛熊證時需額外小心。",
        "17.6 海外資產發行的牛熊證：若屬海外資產發行的牛熊證，強制收回事件可能會於香港交易所交易時段以外的時間發生。",
        "18 交易所買賣基金的特定風險",
        "18.1 市場風險：交易所買賣基金主要為追蹤某些指數、行業/領域又或資產組別（如股票、債券或商品）" +
          "的表現。交易所買賣基金經理可用不同策略達至目標，但通常也不能在跌市中酌情採取防守策略。" +
          "客戶必須要有因為相關指數/資產的波動而蒙受損失的準備。",
        "18.2 追蹤誤差：這是指交易所買賣基金的表現與相關指數/資產的表現脫節，原因可以來自交易所買賣基" +
          "金的交易費及其他費用、相關指數/資產改變組合、交易所買賣基金經理的複製策略等等因素。（常見" +
          "的複製策略包括完全複製/選具代表性樣本以及綜合複製。）",

        "18.3 以折讓或溢價交易：交易所買賣基金的價格可能會高於或低於其資產淨值，當中主要是供求因素的" +
          "問題，在市場大幅波動兼變化不定期間尤其多見，專門追蹤一些對直接投資設限的市場/行業的交易" +
          "所買賣基金亦可能會有此情況。",
        "18.4 流通量風險：證券莊家是負責提供流通量、方便買賣交易所買賣基金的交易所參與者。儘管交易所" +
          "買賣基金多有一個或以上的證券莊家，但若有證券莊家失責或停止履行職責，客戶或就不能進行買賣。",
        "18.5 由衍生工具構成的 ETF 風險：",
        '(a) 交易所買賣基金（"ETF"）可投資於衍生工具。由衍生工具構成的 ETF 可投資於 CAAP、指數' +
          "期貨合約及其他金融衍生工具。",
        "(b) 投資於金融衍生工具不等同直接投資於組成基礎指數之相關資產。",
        "(c) 金融衍生工具乃一種合約。由衍生工具構成的 ETF 及其交易對手（即與由衍生工具構成的 ETF" +
          "達成協議之人士）根據衍生工具合約之條款同意在合約中列明之特定情況下或發生特定事件時" +
          "向對方支付若干款項。金融衍生工具之價值視乎或來自或參考相關資產之價值（例如證券或指數）而定。",
        "(d) 若干金融衍生工具可能產生槓杆效應，令由衍生工具構成的 ETF 承受更大風險及增加其成本。" +
          "金融衍生工具或會較容易受到影響有關投資價值之因素所影響。因此，金融衍生工具價格變化" +
          "幅度甚大，並偶爾會出現急速之大幅價格變動。故此，金融衍生工具出現相對較為輕微之價格" +
          "變動，有可能即時導致由衍生工具構成的 ETF 蒙受重大損失（或收益）。與只投資傳統證券相" +
          "比，由衍生工具構成的 ETF 可能會因投資金融衍生工具而蒙受大於或可能相等於金融衍生工具全部價值的損失。",
        "(e) 此外，不少金融衍生工具均不在證券交易所買賣，這意味著由衍生工具構成的 ETF 較難出售其" +
          "金融衍生工具投資以籌措現金及╱或已變現收益或損失或對該等金融衍生工具進行準確估值。" +
          "出售或購買不在證券交易所買賣之金融衍生工具均須私下協商，且一般並非由中央結算機構擔" +
          "保、每日盯市、結算及隔離帳戶審查機制、中介機構最低資本規定或政府機關監管，亦可能較" +
          "難找到自願之買方╱賣方，原因是並無監管規定要求市場作價者確保該等金融衍生工具有持續市場。",
        "18.6 衍生工具之交易對手風險：如有關衍生工具風險一節所述，金融衍生工具乃一種合約。根據多份金" +
          "融衍生工具合約將予支付之款項並非通過中央結算機構支付，亦非獲中央結算機構作擔保。因此，" +
          "由衍生工具構成的 ETF 因投資金融衍生工具而須承受其交易對手不願或未能根據合約履行付款（及" +
          "其他）責任之風險。倘金融衍生工具之交易對手涉及任何無力償還債務事件，金融衍生工具之價值" +
          "或會大幅下跌，甚至不具任何價值，由衍生工具構成的 ETF 或遲遲無法收回款項，原因是投資於金" +
          "融衍生工具不等同直接投資於組成基礎指數之相關資產。",
        "18.7 期貨買賣風險：期貨乃高度槓桿化，意指期貨合約價格的較小變動或會導致高於實繳保證金比例的" +
          "利潤或損失，及或會導致超過預繳任何保證金數額的不可估量的進一步損失。不少期貨合約買賣須" +
          "遵守每日價格波動限制，即禁止於特定日期按基於上一日收市價的規定價格範圍以外之價格進行期" +
          "貨交易。這或會產生流動性風險，原因是管理人於不斷變動的市場變現期貨持倉或會成本高昂或行不通。",
        "18.8 「CAAP」指以美元為單位之中國 A 股連接產品，即為（a）基礎指數所掛鈎或不掛鈎之 A 股；或" +
          "（b）基礎指數，掛鈎之金融衍生工具（例如認股權證、票據或參與證明）。",
        "19 槓桿及反向產品的主要風險",
        "19.1 投資風險：買賣槓桿及反向產品涉及投資風險及並非為所有投資者而設。不保證可取回投資本金。",
        "19.2 波動風險：槓桿及反向產品涉及使用槓桿和重新平衡活動，因而其價格可能會比傳統的交易所買賣基金（ETF）更波動。",

        "19.3 不同於傳統的 ETF：槓桿及反向產品與傳統的 ETF 不同，具有不同的特性及風險。",
        "19.4 長線持有的風險：槓桿及反向產品並非為持有超過重新平衡活動的間距，一般為一天而設。在每日" +
          "重新平衡及複合效應下，有關產品超過一天的表現會從幅度或方向上偏離相關指數同期的槓桿或相" +
          "反表現。在市況波動時有關偏離會更明顯。隨著一段時間受到每日重新平衡活動、相關指數波動，" +
          "以及複合效應對每日回報的影響，可能會出現相關指數上升或表現平穩，但槓桿產品卻錄得虧損。" +
          "同樣地亦有可能會出現相關指數下跌或表現平穩，但反向產品卻錄得虧損。",
        "19.5 重新平衡活動的風險：槓桿及反向產品不保證每天都可以重新平衡其投資組合，以實現其投資目標。" +
          "市場中斷、規管限制或市場異常波動可能會對產品的重新平衡活動造成不利影響。",
        "19.6 即日投資風險：槓桿及反向產品的槓桿倍數會隨交易日市場走勢而改變，但直至交易日完結都不會" +
          "重新平衡。因此槓桿及反向產品於交易日內的回報有可能會多於或少於相關指數的槓桿或相反回報。",
        "19.7 重整組合的風險：相對傳統的 ETF，每日重新平衡活動會令槓桿及反向產品的投資交易次數較頻密，" +
          "因而增加經紀佣金和其他買賣開支。",
        "19.8 關聯風險：費用、開支、交易成本及使用衍生工具的成本，可令有關產品的單日表現，與相關指數" +
          "的單日槓桿/反向表現的關聯度下降。",
        "19.9 終止運作風險：如所有證券莊家均辭任，槓桿及反向產品必須終止運作。槓桿及反向產品必須在最" +
          "後一名證券莊家辭任生效時同時終止運作。",
        "19.10 槓桿風險（僅適用於槓桿產品）：在槓桿效應下，當相關指數變動，或者當相關指數的計價貨幣不同" +
          "於有關槓桿產品的基準貨幣，而有關貨幣的匯價出現波動時，會令槓桿產品的盈利和虧損倍增。",
        "19.11 有別於傳統的回報模式（僅適用於反向產品）：反向產品旨在提供與相關指數相反的單日回報。如果" +
          "有關指數長時間上升，或者當相關指數的計價貨幣不同於有關反向產品的基準貨幣，而該計價貨幣" +
          "的匯價長時間上升時，反向產品可能會損失大部分或所有價值。",
        "19.12 反向產品與沽空（僅適用於反向產品）：投資反向產品並不等同於建立短倉。因為涉及重新平衡活動，" +
          "反向產品的表現可能會偏離短倉表現，特別是當市況波動和走勢經常搖擺不定的時候。",
        "20 供股權證的風險",
        "20.1 供股權證是公司向現有股東一次性發行股份，讓他們有機會通過在未來的某個日期以折扣價購買額" +
          "外的新股，來維持所有權的原有比例不被稀釋。",
        "20.2 直至購買新股的日期為止，客戶可以按照與普通股交易的方式進行供股權證交易。如果客戶不打算" +
          "行使認購權，可以在公開市場上出售。",
        "20.3 認購權一旦行使，便不能再次使用。如果客戶在這段時間內不行使認購權，認購權將會失效。",
        "20.4 面對有折扣提供的股票很容易受到誘惑，但客戶不應假設這是買平貨，而是應先了解資金籌集的背" +
          "後原因，才作出明智的決定。",
        "20.5 一家公司可能會使用供股來彌補債務，特別是當他們無法從其他來源借錢時。客戶應留意管理層有" +
          "否透露任何潛在的問題。",
        "20.6 如果客戶決定不行使新股認購權，則由於所發行股份數量的增加，客戶所持有公司的總股權將被攤薄。",
        "20.7 如果客戶在指定的時間範圍內不參與供股，客戶的未繳款供股權將會失效。公司將在扣除報價和費" +
          "用後，出售這些權利並分配任何淨收益。如果有的話，過期收益的金額將不會通知投資者，直到報" +
          "價關閉。因此不能保證客戶不會失去收益。",

        "20.8 由供股權證所產生的投資和收益的價值可能會下降，客戶可能會收回比原本投資更少的資金。",
        "21 買賣與股票掛釣的工具（「ELI」）的風險",
        "21.1 如客戶指示本公司用該戶口買賣與股票掛釣的工具，客戶確認 ELI 並不保本，而如 ELI 的參考資產" +
          "的價格與客戶的看法不同，則客戶可蒙受損失。",
        "21.2 在極端的情況下，客戶可損失全部投資。在若干情況下的損失風險甚大，除非客戶明白正在進行的" +
          "買賣的性質以及所須承擔的風險，否則不應買賣該等工具。客戶並須因應本身的環境及財政狀況，" +
          "審慎考慮究竟有關買賣是否適合。",
        "21.3 客戶明白雖然大部分 ELI 一般較普通定期存款或債券的利息為高，但客戶的 ELI 的潛在收益可以發" +
          "行人指定的預先釐定的水平為上限。",
        "21.4 在投資期間內，客戶於參考資產並無權利。該／該等參考資產的市價變動未必會導致 ELI 的市價及" +
          "／或潛在回報有相應的變動。",
        "21.5 客戶完全明白投資 ELI 令客戶承受股權風險。客戶承受正股及股市價格波動，以及股息、企業行動" +
          "及對手方風險的影響。倘相關工具的價格跌至低於轉換價，客戶將接納法律責任，以預先議定的轉" +
          "換價購入相關工具，而非收取與 ELI 的本金。因此，倘 ELI 的價值低於客戶原本的投資，則客戶將" +
          "收到一項價值下跌的工具，而倘相關工具變得毫無價值，則更可能會失去全部本金或存款。ELI 並非" +
          "以任何資產或抵押品擔保。",
        "21.6 客戶完全明白當購買 ELI 時，客戶倚賴發行商的信用可靠性。如發行商違約或資不抵債，則不論參" +
          "考資產的表現，客戶將須倚賴客戶的分銷商代表客戶採取行動，以發行商無抵押的債權人身份提出索償。",
        "21.7 發行商可為其 ELI 提供有限度的莊家安排。但是，如客戶嘗試於發行商提供的莊家安排下在到期前" +
          "終止 ELI，則客戶可收取一筆大幅低於客戶原本的投資金額的款項。與股票掛釣的工具或會「不能轉" +
          "讓」，客戶或許無法將有關工具平倉或變現。ELI 的發行商亦可擔當不同角色，如 ELI 的安排行、市" +
          "場代理及計算代理。ELI 的發行商、其子公司及聯營公司擔當不同角色亦可引致利益衝突。",
        "21.8 客戶應注意，正股的任何派息可影響其價格，而由於除息定價，可影響 ELI 到期時的回報。客戶亦" +
          "應注意，發行商可因正股的企業行動而對 ELI 作出調整。",
        "21.9 潛在孳息率：客戶應就買賣 ELI 相關的費用及開支以及到期時的付款／交付諮詢客戶的經紀。港交" +
          "所發佈的潛在孳息率並無將費用及開支計算在內。",
        "22 期貨 ETF 涉及的特定風險",
        "22.1 期貨合約轉倉風險：期貨合約是透過期貨交易所訂立的具約束力協議，於未來的特定時間買賣相關" +
          "資產。「轉倉」是指，當現有期貨合約即將到期，以代表同一相關資產但到期日較後的期貨合約取代。" +
          "當期貨合約轉倉（即賣出近期的期貨合約，再買入較長期的期貨合約）時，如較長期的期貨合約的" +
          "價格高於即將到期的現有期貨合約價格，轉倉可能會導致虧損（即負轉倉收益「negativerollyield」）。" +
          "在此情況下，出售近期期貨合約所得的收益，並不足以購買相同數量而到期日較後的期貨合約，因" +
          "後者的價格較高，這會對期貨 ETF 的資產淨值有不利影響。",
        "22.2 持有期貨合約數量的法定限制風險：在獲認可交易所上市的期貨合約受限於法定持倉限制，不能持" +
          "有多於某一特定數量之期貨合約。若期貨 ETF 的期貨合約持倉已增加至接近有關上限，則可能因無" +
          "法購買更多期貨合約而未能新增 ETF 單位，此情況可能令上市的 ETF 單位的交易價格偏離於其資產淨值。",
        "23 人民幣計價證券之風險",

        "23.1 人民幣不能自由兌換。人民幣與外幣（包括港元）之間的轉換，是受中國的監管限制，並會影響以" +
          "人民幣計價證券的流動性。",
        "23.2 人民幣計價的證券可能沒有定期交易或活躍市場。因此，客戶或許不能及時出售，或大幅折讓其產" +
          "品的價值以作出售。",
        "23.3 如人民幣貶值，以港元計價的投資亦會下降。",
        "24 有關透過滬港通及/或深港通交易之特別風險",
        "以下是一些通過本公司透過滬港通及/或深港通（下稱“中港通”）買賣上海證券交易所及/或深圳證券" +
          "交易所之風險。由於涉及風險，客戶只應在完全理解中港通之性質及客戶將承受之風險才進行有關" +
          "交易。客戶應按經驗、目的、財務資源及其他因素小心考慮（及在有需要時資詢客戶的顧問）該等" +
          "交易是否適合客戶。",
        "24.1 中國相關風險：中國是一新興市場。投資於中國涉及特別的考慮和風險，包括但不只限於較大的價" +
          "格波動性、較不發達的監管及法律架構，以及經濟、社會及政治不穩定性等。",
        "24.2 股票風險：投資中港通證券的回報率可能會高於短期和較長期債務證券。然而，投資中華通證券的" +
          "相關風險亦可能較高，原因在於投資中港通證券的表現取決於難以預測的因素，該等因素包括市場" +
          "突然或長期低迷的可能性以及與個別公司有關的風險。",
        "24.3 流通量風險：無法保證可以就中港通建立或維持一個活躍的交易市場。如果中港通證券的價差很大，" +
          "客戶以期望的價格出售中港通證券的能力可能會受到重大影響。",
        "25 深交所創業板市場風險",
        "25.1 參與深交所創業板市場只限於機構專業投資者。",
        "25.2 深交所創業板股票涉及高投資風險因為在深圳創業板上市的公司通常為初創公司，經營規模及股本" +
          "較小。由於市場上的股份流通量較小，其股票價格可能更容易受到操縱。因此，它們的股票價格和流動性波動較大。",
        "25.3 深交所創業板的公司上市規則和法規，不如深交所主機板那麼嚴格。在深交所創業板除牌的情況可" +
          "能更加普遍和更快。如果客戶投資的公司被除牌，這可能對客戶產生不利影響。投資於深交所創業" +
          "板上市的股票可能導致客戶的重大損失。",
        "26 上海交易所（上交所）科創板市場風險",
        "26.1 規管差異風險：上交所科創板市場與上交所主板市場在上市、交易、信息披露以及其他事項的規則" +
          "和指引方面都存在較大差異。例如，就上市條件而言，尋求在科創板市場上市的公司將適用更短的" +
          "盈利歷史、更低的淨利潤和營業收入，以及更低的經營活動產生的現金流量要求。科創板上市公司" +
          "較之主板和中小板公司對於股本總額的要求也更低。科創板上市公司的交易安排亦與主板上市公司" +
          "不同，例如價格限制、最小買賣盤和最大買賣盤。關於上交所科創板與主板的上市條件詳情，請參閱上交所網站。",
        "26.2 退市風險：科創板退市制度較主板不同，可能導致科創板市場上市公司退市的情形更多，退市速度更快。",
        "26.3 公司經營風險：科創板市場上市公司一般處於發展初期，經營歷史較短，規模較小，經營穩定性較" +
          "低，抵抗市場風險和行業風險的能力較弱。儘管它們可能擁有更大的發展潛力並可更多地借助於科" +
          "技創新，其未來表現（尤其是那些尚未有良好盈利記錄的公司）存在很大的不確定性。",
        "26.4 大幅股價波動：科創板市場上市公司股價可能隨市況變化、投資者投機行為或公司業績變動等情況" +
          "而頻繁發生大幅波動。流通股本較少的科創板市場上市公司可能較容易被主要股東操縱股價。不穩" +
          "定的公司業績亦令此類公司的估值較為困難。",

        "26.5 技術風險：科創板市場上市公司的新技術能否轉化為現實中的產品或服務具有不確定性。當其所在" +
          "的行業正經歷快速的技術更新換代時，其產品可能面臨被淘汰的危險而令其公司難以為繼。",
        "26.6 其他：投資者亦應參閱上海證券交易所科創板股票交易必備條款。每位內地投資者在交易上海科創" +
          "板股票之前都須認可該揭示書條款。",
        "27 單位信託基金交易的特定風險",
        "27.1 基金單位的價格會波動，甚至變成毫無價值。基金過往的表現並不代表將來表現。",
        "27.2 不同類別基金所附帶的風險有所不同。客戶在決定是否投資該產品前，應審慎閱讀相關產品的銷售" +
          "文件（包括基金說明書、產品資料概覽及基金單張等）所披露的細節及風險。主要風險包括但不限於：",
        "(a) 信貸風險：這風險通常適用於所有固定收入（即債券）以及貨幣市場工具的基金。債券附帶發" +
          "債機構違責的風險，即發行商有機會未能如期支付本金和利息。信貸評級機構給予的信貸評級" +
          "並非對發債機構信用可靠程度的保證。",
        "(b) 流動性風險：此風險在基金內某些證券（包括債券等）可能在巿場上較難買入或沽售出現。未" +
          "上市或未被評級的證券可能需較長時間或無法於市場上沽出，因此具有較高的流通性風險。這" +
          "些風險有可能導致投資者招致嚴重虧損。",
        "(c) 利率風險：如產品投資於債券，就較易受到利率波動的影響。一般來說，利率上升，債券價格" +
          "便會下跌。投資於債券的基金的價格便有可能下跌。",
        "(d) 市場風險：投資價值可能會因政治、法律、經濟條件及利率變化而有波動。這些變化在全部市" +
          "場及資產類別上都很普遍，客戶取回的投資金額有可能少於初次投放的資金。",
        "27.3 投資於高息債券的基金，除以上列舉的一般風險外，還須承受其他風險，例如：",
        "(a) 較高的信貸風險：高息債券的評級通常低於投資級別，或不獲評級，因此涉及的發債機構違責風險往往較高；",
        "(b) 受制於經濟周期的轉變：經濟下滑時，高息債券價值的跌幅往往會較投資級別債券為大，原因" +
          "是（i）投資者會較為審慎，不願承擔風險；（ii）違責風險加劇。",
        "(c) 資本增長風險：派息基金，特別是某些高息債券基金可能會以資本來支付費用及／或股息。此" +
          "舉有可能令基金可供日後投資的資金減少，削弱資本增長。",
        "(d) 股息分派風險：派息基金，特別是某些高息債券基金可能不會派息，取而代之的是將股息再投" +
          "資在基金上，又或投資經理可能有酌情權決定是否動用基金的收入及／或資本作分派之用。此" +
          "外，分派收益高並不意味投資者的總投資可取得正回報或高回報。",
        "(e) 其他主要風險：投資於債券，特別是高息債券的基金，可能尚涉及其他主要風險，包括投資集" +
          "中於某特定種類的專門性債項或某特定地區市場或主權證券。",
        "27.4 投資於「需具備衍生工具知識」基金的風險：",
        "「需具備衍生工具知識」的基金可廣泛地使用金融衍生工具達致其投資目的，可能含有槓桿效應。" +
          "使用金融衍生工具可令基金承受額外風險，包括但不限於波動性風險及對手風險。基金經理可投資" +
          "於結構性產品、衍生工具及可投資於非投資級別的債務證券，最高達基金總資產淨值 100%。在惡劣" +
          "情況下，投資可能招致重大損失。",
        "28 債券的特定風險",

        "28.1 債券只在到期日提供 100%本金保證，但要視乎其發行人及/或擔保人（如適用）的信貸風險。",
        "28.2 債券不應被視為一般或定期存款。",
        "28.3 債券的價格會波動，甚至變成毫無價值。",
        "28.4 產品主要風險：客戶在決定是否投資該產品前，應審慎閱讀相關產品認購書（如適用）所披露的細" +
          "節及風險。主要風險包括但不限於下頁所載：",
        "(a) 信貸風險：客戶須承擔發行人及擔保人（如適用）的信貸風險，他們的信貸評級如有任何變動" +
          "將會影響本債券的價格及價值。債券附帶發債機構違責的風險，即發行人有機會未能如期支付" +
          "本金和利息。在最壞的情況下如發行人及擔保人（如適用）破產，客戶可能會損失全部投資。" +
          "信貸評級機構給予的信貸評級並非對發行人信用可靠程度的保證。",
        "(b) 流動性風險：債券的流動性可能有限，及可能無活躍交易，及/或沒有經紀在市場提供報價，因此：",
        "(i) 不可以在任何時間均能提供債券的市值及/或參考買入/賣出價，因其將取決於市場的流動性和情况；",
        "(ii) 可能需要較長時間或無法於市場上出售債券；及",
        "(iii) 所執行的賣出價可能與本行參考買入價有很大的差別，對客戶不利。",
        "(c) 利率風險：債券較易受到利率波動的影響。一般來說，利率上升，債券價格便會下跌。",
        "(d) 市場風險：投資價值可能會因政治、法律、經濟條件及利率變化而有波動。這些變化在全部市" +
          "場及資產類別上都很普遍，投資者取回的投資金額有可能少於初次投放的資金。",
        "28.5 投資於高息債券，除以上列舉的一般風險外，還須承受其他風險，例如：",
        "(a) 較高的信貸風險：高息債券的評級通常低於投資級別，或不獲評級，因此涉及的發債機構違責風險往往較高；",
        "(b) 受制於經濟周期的轉變：經濟下滑時，高息債券價值的跌幅往往會較投資級別債券為大，原因" +
          "是（i）投資者會較為審慎，不願承擔風險；（ii）違責風險加劇。",
        "28.6 某些債券可能別具特點及風險，投資時須格外注意。這些包括：",
        "(a) 永續性債券的風險：永續性債券不設到期日，其利息派付取決於發行人在非常長遠的時間內的" +
          "存續能力，利息或會因根據其條款及細則而有所延遲或終止。一般而言，永續性債券一般為可" +
          "贖回及/或為後償債券，客戶須要承受再投資風險/或為後償債券風險，詳情如下。",
        "(b) 可提早贖回債券的再投資風險：如果這是可提早贖回的債券，當發行人於債券到期前行使贖回" +
          "權，客戶便會面對再投資風險。客戶於再投資時可能會收到較小的孳息率。",
        "(c) 後償債券的風險：後償債券於發行人遣債後的清盤過程中獲較低之索償權，因此後償債券之持" +
          "有人將承受比優先債券更高的風險。後償債券為無抵押，其信貸評級及債務的優先次序較優先" +
          "債券為低。客戶應特別注意產品之信貸資料，包括發行人，債券或擔保人的信貸評級（視情況而定）。",
        "(d) 浮息及／或延遲派付利息的風險：如果債券具有浮息及／或延遲派付利息的條款，客戶便無法" +
          "確定將收取的利息金額及利息派付的時間。",
        "(e) 可延遲到期日的風險：如果債券具有可延遲到期日的條款，客戶便沒有一個訂明償還本金的確實時間表。",
        "(f) 可換股或可交換性質的債券的投資風險：屬可換股或可交換性質的債券，客戶須同時承受股票" +
          "及債券的投資風險；及／或具有或然撇減或彌補虧損特點的債券。當發生觸發事件時，這些債" +
          "券可能會作全數或部分撇賬，或轉換為普通股。"
      ]
    },
    knowledge_courses: {
      page_title: "衍生品基本知識課程",
      h: "衍生產品基本知識課程",
      // p: "客戶確認以下買賣期貨或衍生工具的風險：",
      // h1: "A.期貨及期權交易的風險",
      // p1: [
      //   "客戶確認買賣期貨合約或期權的虧蝕風險可以極大。在若幹情況下，客戶所蒙受的虧蝕可能會超過最初存入的保證金數額。",
      //   "即使客戶設定了備用指示，例如「止蝕」或「限價」等指示，亦未必能夠避免損失，市場情況可能使該等指示無法執行。",
      //   "客戶可能會在短時間內被要求存入額外的保證金。",
      //   "假如未能在指定的時間內提供所需數額，客戶的未平倉合約可能會被平倉。",
      //   "然而，客戶仍然要對客戶的帳戶內任何因此而出現的短欠數額負責。",
      //   "因此，客戶在買賣前應研究及理解期貨合約及期權，以及根據本身的財政狀況及投資目標，仔細考慮這種買賣是否適合客戶。",
      //   "如果客戶買賣期權，便應熟悉行使期權及期權到期時的程序，以及客戶在行使期權及期權到期時的權利與責任。"
      // ],
      // h2: "B.關於期貨及期權買賣的額外風險披露",
      p2: [
        "1.   引言",
        "在日常生活中，不同的傳媒都會經常提及期貨、期權、及認股權證等金融產品，而這些金融產品均被稱為「衍生產品」。以下的課程內容主要解釋衍生產品的性質、常見 種類、用途以及相關之風險，以增加投資者對衍生產品的認識。由於衍生產品的種類眾多，而且各有特性，建議投資者在投資衍生產品前，須先向有關專業投資顧問查詢有關衍生產品的特性及相關之風險，清楚了解後才做出投資決定。",
        "2.  衍生品简介",
        "在金融市場中，衍生產品通常由現貨市場產品（ 如外幣、證券或黃金 ） 演變而成。相關的現貨市場產品稱為「相關資產」。衍生產品的價值會受相關資產的價值升跌而 有所波動，此外，衍生產品亦都會受到很多其他市場因素，如利率改變及經濟環境等而影響其價格。",
        "以認股權證（俗稱「窩輪」）為例，它便是一種衍生產品，與現貨市場的相關股票價格之波幅有直接的關係。由於衍生產品和現貨市場產品關係密切，而衍生產品是由現貨市場的相關資產衍生出來，因此，這類金融產品會被統稱為「衍生產品」。",
        "「現貨市場」是指產品可以在短時間之內，讓買家和賣家進行交易，買家付出金錢，而賣家就以現貨做交收。於金融市場內，買賣外幣或股票一般亦可在即日或短時間內交收，故這些產品被稱為現貨市場產品。",
        "一般而言，不同的交收時間亦是其中一樣現貨市場產品有別於衍生產品之特徵。若投資者已購買現貨市場產品，即使其價格大幅下跌，只要不將持有之產品賣出，都不會有即時的損失。相反，若已購買衍生產品，由於須在指定日期交收（例如一個月後），當相關資產價格大幅下跌時，往往有機會承受損失。",
        "3.  衍生產品常見種類",
        "市面上的衍生產品種類繁多，一般投資者較常見的有兩大類，分別是 (1)「期貨類」及 (2)「期權類」。",
        "3.1 期貨類",
        "「期貨類」產品是要求買賣雙方承諾在某個指定日期（例如一個月後），按一個指定價格，買賣雙方買入或沽出相關資產（如證券、外幣、黃金等）之一份合約。在雙方指定交收的日期（即一般稱的「到日」），雙方必須履行合約所訂之安排，按照合約上指定的價格及資產數量進行交收，即合約的買家要按指定的價格買入相關資產，而合約的賣家須按指定的價格將相關資產賣給買家。",
        "至於「期貨類」產品大致可分為兩種：一種是在「交易所買賣」的，而另一種是在「非交易所買賣」的。",
        "在交易所買賣的期貨類產品一般稱為「期貨合約」，例如「恆生指數期貨」就是在交易所買賣的期貨合約之一。而在非交易所買賣的期貨類產品，就稱為「遠期合約」。倘若由一對（即兩張）遠期合約組成，即同一時間買入及賣出不同的遠期合約，便稱為「掉期」，例如「外匯掉期」及「利率掉期」等。利用掉期產品可讓投資者在指定的日期及價格進行兩種不同貨幣或利率的交換。",
        "例如投資者希望於兩日後將港幣兌換成澳幣，然後敍做定期外匯存款以賺取利息，並預期到期時，以一個預定的外匯價格將澳幣轉回港幣。投資者便可以在今日同時買入及賣出兩張澳幣遠期合約，鎖定兌換價，避免外匯價格波動。",
        "在交易所買賣的期貨合約都有一個相同的特徵，就是「標準化合約」。例如交易所已經訂定恒生指數期貨的每一點子價值為 50 元，即每一位參與買賣恒生指數期貨的投資者，都是以指定的 50 元為一點子的價格計算，這就是標準化合約的特徵。",
        "至於非交易所買賣的遠期合約則有別於交易所買賣的期貨合約。非交易所買賣的遠期合約之價格及交易金額都可以按買賣雙方的需要而制訂。如果某產品不是在交易所進行買賣，該產品會被稱為「場外交易市場」產品。較為常見的例子為「外匯遠期合約」，客戶可以按自己的需求與金融機構制訂一份外匯遠期合約。",
        "3.2期權類",
        "「期權」是一種涉及買賣雙方的合約，合約賦予買家權利而並非責任，從賣家買入或向賣家賣出相關資產。合約在訂立時就已經釐訂了相關資產的數量、價格及期權的有效期限。如買家行使期權，賣家就必須根據合約的細則進行交收。",
        "在期權類產品中，投資者必須要認識「認購期權」和「認沽期權」兩者之間的分別（「認購」，就代表買入相關資產的意思；而「認沽」，就代表沽出或賣出相關資產的意思）。日常生活所看到的「認股權證」，均屬認購期權產品。另外，在報章上報導一些企業的高級管理層會有可能得到一批由個別企業分發的股票認購權，這亦屬於「認購期權」產品。",
        "在市場上，投資者可以選擇做合約的買家或賣家。合約的買家有權買入或沽出相關資產，買家需要支付「期權金」（Option Premium）以換取權利；而合約的賣家就會收取「期權金」作為回報，但同時亦須承受市場價格波動而有機會虧損的風險。",
        "即使合約的賣家有虧損的風險，但他們仍願意參與交易，原因包括：沒有人能準確預測相關資產一個月後價格的上落；合約賣家會向買家收取一個金額作為買合約的價錢，就是上文所述的「期權金」，即買入權利之成本，亦都是最主要原因。期權合約的賣收到這些期權金，從而可以提高其潛在回報。",
        "由不同衍生產品組合而成的投資產品稱為「結構性產品」。常見的結構性產品包括「股票掛鈎票據 / 股票連結票據」、「外匯掛鈎票據/ 外匯連結票據」或「信貸掛鈎票據 / 信用連結票據」。",
        "結構性產品大多數都包含了衍生產品在內，即由不同衍生產品結合而成，當中有些是「保本」，有些是「非保本」的，所以投資者購買這些包含了衍生產品的結構性產品時，必須清楚明白有關條款，理解其性質。當然，買賣結構性產品始終要承受市場價格波動而有機會虧損的風險。",
        "除此之外，市面上亦有許多衍生產品的例子，如交易所買賣的認股權證及牛熊證等，這些均屬期權類產品。而較常見的非交易所買賣的產品，就如透過金融機構買到的股票掛鈎票據 / 股票連結票據及外匯掛鈎票據 / 外匯連結票據等。",
        "以股票掛鈎票據 / 股票連結票據為例，這種產品的結構包含一個期權產品在內；購買了股票掛鈎票據 / 股票連結票據的客戶，等同於一個期權合約的賣家 （即賣方會收取期權金）。如果掛鈎的有關股票之價格未低過一個指定的價格，即「行使價」，投資者就可以賺取到這個期權金，從而增加投資者的回報，當然，投資者同時亦要承受市場價格波動而有機會虧損的風險。",
        "4.衍生產品的用途",
        "衍生產品用途廣泛。主要用途有四種：",
        "a) 第一種：投機活動 - 提高收益；",
        "b) 第二種：可以參與不同類別的資產；",
        "c) 第三種：槓桿效應；and 及",
        "d) 第四種：可以看漲，亦可以看淡以作為風險對沖。",
        "4.1 投機活動 - 提高收益",
        "假設某投機者有一投資的看法，認為股市未來一個月不會大跌，即使跌低於某一個指定價格，該投資者都願意用這個指定價格買入這批股票。 如果這樣，該名投資者便可以利用股票掛鈎票據 / 股票連結票據成為一個認購期權的賣家。如果有關的股票價格沒有跌低過指定價格，就可以在不需要買入股票的情況下收取期權金，提高其投資收益，但如果有關的股票價格跌低過指定價格就需要以高於市價買入股票，若股票大幅下跌，就會有大幅虧損的風險。",
        "4.2 可以參與不同類別的資產",
        "投資者可以透過衍生產品來參與或者買入或沽出各種不同類別的資產。舉例來說，國外人士無法參與 A 股市場，但透過一些「合成交易所買賣基金」就可以間接參與 A 股市場。這些合成交易所買賣基金運用衍生產品跟蹤或模擬某市場指數的表現為主要投資目標，透過這些合成交易所買賣基金，投資者雖然不能直接持有 A 股，但相關 A 股的表現卻可以反映於投資者持有的合成交易所買賣基金內。",
        "4.3 槓桿效應",
        "由於投資者買入一手股份或需要數萬元，故對現金流可能造成壓力。但如果投資者選擇購買認股權證，所需的成本只是數千元，便可以相對的買入一手股票，此做法就稱為「槓桿效應」，即投資者在成本上不用提供十足金額以購買一手股票。然而，因為買賣的是衍生產品，並不是股票，投資者一定要注意因市場價格波動而帶來的風險。",
        "4.4可以看漲，亦可以看淡以作為風險對沖",
        "投資者可以在市場買入一種看漲市場的認購權證，或可以買入一種看淡市場的認沽權證。認沽權證產品可以幫助投資者對沖一些市場下跌的風險。例如，若投資者擁有一些股票及看淡股市，可以買入一個認沽權證，如果市場價格真的下跌，其購入的認沽權證就可以帶來額外的收益，以補償其持有股票的部分損失。"
      ]
    },
    personal_data: {
      page_title: "個人資料（私隱）政策/私隱政策聲明",
      company_info:[
        "香港尖沙咀港威大廈 6 座 31 樓 3102 室",
        "電話: (852) 2187 2100",
        "傳真: (852) 2187 2107",
        "網址: www.goingf.hk"
      ],
      h: "隱私政策",
      p2: [
        "1. 作為高盈證券有限公司之客戶（“客戶”），當申請開立或維持帳戶或建立、維持或提供投資、交易或相關服務時，需" +
          "不時向高盈證券或聯屬公司提供有關之個人資料（“個人資料”）。（《個人資料（私隱）條例》（香港法例第 486 章）（“私隱條" +
          "例”）所賦予之定義）。",
        "2. 若未能向高盈證券提供有關資料，將會導致高盈證券無法開立或維持戶口或建立、維持或提供投資、交易或相關服務。",
        "3. 個人資料將可能在與高盈證券及/或聯屬公司的正常業務往來過程中被收集。",
        "4. 根據私隠條例的條文，資料將可能用於下列用途：",
        "(a) 為提供服務給客戶之日常運作；",
        "(b) 作信貸或反洗錢檢查；",
        "(c) 確保客戶之信用持續良好及反洗錢風險監控；",
        "(d) 宣傳投資、交易或相關服務或產品(詳情請見如下第 8 段)；",
        "(e) 支援高盈證券在有關服務上作出之任何文件內之任何聲明；",
        "(f) 協助其他有關第三者、專業人員、機構及有關監管機構確認某些高盈證券在有關服務上之事實；",
        "(g) 根據高盈證券須遵守之有關法例及／或條例要求作出披露；",
        "(h) 組成接收資料者所經營業務的紀錄的一部份；",
        "(i) 與上述有關或隨附之其他用途。",
        "5. 高盈證券會把個人資料保密，但為達至上述第(4)段所述的用途，高盈證券可能會把個人資料提供給：",
        "(a) 任何中間人，或提供與高盈證券業務運作有關服務之第三者服務供應商；",
        "(b) 任何對高盈證券作出保密責任之適當人仕，包括對高盈證券作出保密資料承諾的任何聯屬公司；",
        "(c) 任何與閣下已有或建議有交易之人仕及機構；",
        "(d) 信貸諮詢機構及 (發生拖欠付款時) 收數公司；",
        "(e) 任何管治或與高盈證券及聯屬公司的業務有關的監管機構及交易所；",
        "(f) 任何承讓人、受讓人、代表、繼承人或獲轉讓有關帳戶之人士及授權人士；",
        "(g) 任何高盈證券之實際或建議受讓人或參與人或附屬參與人或受讓人。",
        "6. 客戶同意個人資料可轉到香港以外的任何地點 (不論是用作在香港以外處理、持有或使用該等資料)，並同意可轉發給向任何聯屬公司" +
          "就其業務經營而提供服務的服務提供者。",
        "7. 在法律許可的範圍內，客戶同意高盈證券不時收集的個人資料可按照私隱政策的規定使用及披露。",
        "8. 使用個人資料作直接促銷",
        "高盈證券擬使用閣下的該等資料作直接促銷，為此高盈證券在使用該等資料前須取得閣下的同意（包括表示不反對）。閣下同意與否" +
          "純屬個人意願。就此，務請閣下注意︰",
        "(a) 由高盈證券不時持有的閣下的姓名、聯絡詳情、產品及服務組合信息、交易模式及行為、財務背景及統計資料（「可作直銷用" +
          "途的個人資料」）可由高盈證券用作直接促銷；",
        "(b) 可促銷的各類服務、產品及主題如下︰",
        "i. 財務、保險、證券、商品、投資及相關服務、產品及設施；",
        "ii. 上文第(8)(b)(i)條所述各類促銷主題涉及的獎賞、忠誠獎勵或優惠計劃；",
        "iii. 由高盈證券的合作品牌夥伴因應上文第(8)(b)(i)條所述各類促銷主題而提供的服務和產品（合作品牌夥伴的名稱見相關服" +
          "務和產品（視屬何情況而定）申請書）；及",
        "iv. 為慈善及/或非牟利目的而作出的捐款及捐獻；",
        "(c) 上述服務、產品及主題可由高盈證券及/或以下各方提供或（如涉及捐款及捐獻）收集：",
        "i. 任何聯屬公司；",
        "ii. 第三方金融機構、承保人、證券、商品及投資服務提供者；",
        "iii. 第三方獎賞、忠誠獎勵、合作品牌或優惠計劃提供者；",
        "iv. 高盈證券的合作品牌夥伴（合作品牌夥伴的名稱見相關服務和產品（視屬何情況而定）申請書）；",
        "v. 慈善或非牟利組織；",
        "(d) 除了自行推廣上述服務、產品及主題外，高盈證券亦擬將上文第(8)(a)條所述資料提供予上文第(8)(c)條所述的全部或當中任何" +
          "人士（不論提供資料是為得益與否），以供該等人士在促銷上文第(8)(b)條所述的該等服務、產品及主題時使用（高盈證券可能" +
          "就此收取報酬），而高盈證券須為此用途取得閣下的書面同意（包括表示不反對）；",
        "在未經閣下同意之前高盈證券不會使用閣下可作直銷用途的個人資料進行直接促銷。當簽署相關客戶開戶文件時，請註明閣下" +
          "同意與否。如閣下在相關開戶文件中表明閣下同意後欲改變意願，希望高盈證券不再使用或向其他人士提供閣下可作直銷用途" +
          "的個人資料進行上述直接促銷，閣下可向高盈證券發出書面通知或致電高盈證券的客戶服務部（郵寄地址及電話號碼載於下文" +
          "第(11)條），以行使閣下拒絕參與直銷活動的權利。",
        "但請注意，如閣下是以公司或業務代表身份在相關客戶文件中表明同意參與直接促銷活動，而非以個人身份收取促銷資料，則上述權" +
          "利並不適用於閣下。",
        "9. 收集個人資料聲明-滬深港通北向交易",
        "閣下瞭解並同意高盈證券在為閣下提供滬深港通北向交易的過程中，高盈證券會被要求按有關規則處理客戶個人資料，包括以下各項：",
        "1. 在向中華證券通系統（“CSC”）遞交閣下每單北向交易指令時,附加閣下唯一的券商客戶編碼（Broker-to-Client Assigned " +
          "Number，“BCAN”）/為閣下聯名帳戶編派的券商客戶編碼；及",
        "2. 在交易所可能不時依據交易所規則向高盈證券提出要求時，高盈證券將向交易所提供閣下的券商客戶編碼和客戶識別資訊" +
          "（Client Identification Data，“CID”）" ,
          "在不局限於高盈證券就處理閣下個人資料曾發予閣下的通知或已從閣下獲得的同意/授權，閣下在此瞭解並同意高盈證券在提供滬深" +
          "港通北向交易服務過程中可根據需要收集、存儲、使用、披露和轉交與閣下有關的個人資料，包括如下：",
        "(a) 不時向交易所和相關的港交所附屬公司披露並轉交閣下的券商客戶編碼和客戶識別資訊，包括在向中華證券通輸入中華通交易" +
          "時註明閣下的券商客戶編碼，並即時轉送給相關的中華通市場營運者；",
        "(b) 允許各交易所及相關的港交所附屬公司：",
        "i. 為達至市場監督和監測及執行交易所規則之目的，收集、使用和存儲由中華通結算所提供的閣下券商客戶編碼，客戶識" +
          "別資訊以及任何經整合、驗證和配對的券商客戶編碼和客戶識別資訊（可由上述任何各方或通過香港交易所存儲）；",
        "ii. 為達至下文（c）和（d）之目的，不時將有關資料轉交有關中華通市場營運者（直接或經有關中華通結算所）;",
        "iii. 向香港監管機構和執法機關披露此類資訊以便其履行就香港金融市場的法定職能；",
        "(c) 允許相關中華通結算所：",
        "i. 收集、使用和存儲閣下的券商客戶編碼和客戶識別資訊，以便整合及驗證券商客戶編碼和客戶識別資訊，配對券商客戶" +
          "編碼和客戶識別資訊至投資者識別資料庫，並將經整合、驗證和配對的券商客戶編碼及客戶識別資訊提供給相關的中華" +
          "通市場營運者，各交易所及相關港交所附屬公司;",
        "ii. 使用閣下的券商客戶編碼和客戶識別資訊進行其證券帳戶管理的監管職能;",
        "iii. 將這些資訊披露給具有管轄權的中國內地監管機構和執法機關，以便其就中國內地金融市場履行監管，監督和執法職能；",
        "(d) 允許相關的中華通市場營運者：",
        "i. 收集、使用和存儲閣下的券商客戶編碼和客戶識別資訊，以便其監督和監測經中華通服務在相關中華通市場的證券交易" +
          "及執行相關中華通市場營運者的規則;",
        "ii. 將這些資訊披露給具有管轄權的中國內地監管機構和執法機關，以便其就中國內地金融市場履行監管，監督和執法職能；" ,
          "如果閣下就任何有關中華通證券的交易向高盈證券發出指示，即表示閣下確認並同意高盈證券為遵守交易所就滬深港通北向交易不時" +
          "制定的的要求及規則使用閣下的個人資料。閣下同時承認，儘管閣下後續可能表示撤回該同意，閣下的個人資料仍可能繼續被存儲，" +
          "使用，披露，轉移和及為達至上述目的其他方式處理，無論是在該等聲稱的撤回同意之前或之後。",
        "未能提供個人資料或同意的後果",
        "如閣下未能向高盈證券提供閣下的個人資料或上述同意/授權，這可能代表著高盈證券不會或不再能夠執行閣下的交易指令或向閣下" +
          "提供滬深港通北向交易服務。",
        "10. 根據私隱條例中之條文，任何人有權：",
        "(a) 審查高盈證券是否持有他／她的資料及查閱有關之資料；",
        "(b) 要求高盈證券改正有關他／她不準確之資料；",
        "(c) 查悉高盈證券對於資料之政策及實際運用及被通知高盈證券持有何種個人資料；",
        "(d) 就客戶信貸而要求獲通知哪項個人資料是例行披露予信貸諮詢機構或收數公司，以及獲提供進一步的資訊以便向有關的信貸諮" +
          "詢機構或收數公司作出查閱及改正要求。",
        "11. 根據私隱條例規定，高盈證券有權就處理任何查閱資料之要求收取合理費用。任何關於資料查閱或改正資料(當客戶認為由高盈證券" +
          "所提供有關他／她的資料不準確時)或關於資料政策及實際應用或資料種類之要求，應向下列人仕提出：私隱保護主任 " +
          "高盈證券有限公司，中國香港尖沙咀港威大廈 6 座 31 樓 3102 室"
      ]
    },
    collection_statement: {
      page_title: "客戶資料收集聲明",
      h: "投資者識別及場外證券匯報制度之客戶資料收集聲明",
      p2: [
        "客戶明白並同意，高盈證券有限公司(“高盈證券”)為了向閣下提供與在香港聯合交易所（“聯交所”）上市或買賣的證券相關的",
        "服務，以及為了遵守不時生效的聯交所與證券及期貨事務監察委員會（“證監會”）的規則和規定，高盈證券可收集、儲存、處理、使用、披",
        "露及轉移與閣下有關的個人資料（包括閣下的客戶識別信息及券商客戶編碼）。在不限制以上的內容的前提下，當中包括:",
        "(a) 根據不時生效的聯交所及證監會規則和規定，向聯交所及／或證監會披露及轉移閣下的個人資料（包括客戶識別信息及券商客戶編碼）;",
        "(b) 允許聯交所：",
        "(i) 收集、儲存、處理及使用閣下的個人資料（包括客戶識別信息及券商客戶編碼），以便監察和監管市場及執行《聯交所規則》；",
        "(ii) 向香港相關監管機構和執法機構（包括但不限於證監會）披露及轉移有關資料，以便他們就香港金融市場履行其法定職能；及",
        "(iii) 為監察市場目的而使用有關資料進行分析；及;",
        "(c) 允許證監會：",
        "(i) 收集、儲存、處理及使用閣下的個人資料（包括客戶識別信息及券商客戶編碼），以便其履行法定職能，包括對香港金融市場的監管、監察及執法職能；及",
        "(ii) 根據適用法例或監管規定向香港相關監管機構和執法機構披露及轉移有關資料。",
        "(d) 向香港中央結算有限公司（香港結算）提供券商客戶編碼以允許香港結算：",
        "(i)從聯交所取得、處理及儲存允許披露及轉移給香港結算屬於閣下的客戶識別信息，及向發行人的股份過戶登記處轉移閣下的客戶識別信息，以便核實閣下未就相關股份認購進行重複申請，以及便利首次公開招股抽籤及首次公開招股結算程序；及",
        "(ii)處理及儲存閣下的客戶識別信息，及向發行人、發行人的股份過戶登記處、證監會、聯交所及其他公開招股的有關各方轉移閣下的客戶識別信息，以便處理閣下對有關股份認購的申請，或為載於公開招股發行人的招股章程的任何其他目的。",
        "閣下亦同意，即使閣下其後宣稱撤回同意，高盈證券在閣下宣稱撤回同意後，仍可繼續儲存、處理、使用、披露或轉移閣下的個人資料以作上述用途。如閣下未能向高盈證券提供個人資料或上述同意，可能意味著我們不會或不能夠再（視情況而定）執行閣下的交易指示或向閣下提供證券相關服務，惟出售、轉出或提取閣下現有的證券持倉（如有）除外。",
        "確認和同意",
        "本人確認已閱讀並理解由高盈證券所發布的這份聲明之內容。通過勾選下面的方框，本人表示同意高盈證券根據本聲明中的條款和目的使用本人的個人資料。"
      ],
      checkText:"本人/本公司同意高盈證券將本人的個人資料用於本聲明所述的目的。",
      endContent:"備註：本條文所述的“券商客戶編碼”及“客戶識別信息”具有《證券及期貨事務監察委員會持牌人或註冊人操守準則》第 5.6 段所界定的含義。"
    },
    service_opening: {
      nav_title: "服務開通",
      page_title: "請選擇要開通的服務",
      verify_fail_text: "請務必勾選香港期貨交易服務"
    },

    trade_password_setting: {
      nav_title: "設置交易密碼",
      page_title: "請設置交易密碼",

      password_field: {
        label: "密碼",
        placeholder: "至少6位數字和字母組合"
      },

      confirm_password_field: {
        label: "確認密碼",

        placeholder: "再次輸入密碼"
      }
    },

    electronic_sign: {
      nav_title: "電子簽署",
      page_title: "客戶確認及承諾",

      label: "倘簽署本部份，客戶即聲明、同意及確認：",

      checkbox_label_1: "本開戶表格提供的資料，均為完整、真實及準確；",

      checkbox_label_2_prev:
        "我 / 我们确认高盈證券以客户选择的语言(英文或中文)提供",
      checkbox_label_2_middle: "證券及/或期貨客戶協議", //U
      checkbox_label_2_next:
        "包括風險披露聲明及免責聲明。我 / 我們進壹步確認高盈證券已經邀請我 / 我們閱讀風險披露聲明，提出問題及征求獨立的意見(如我/我們有此意願)。我 / 我們應經常切留意市況，高盈證券可能在強制平倉前無法與我 / 我們聯絡或未能提供足夠時間讓客戶進行額外的存款。", //U
      checkbox_label_3:
        "我 / 我們謹此確認已收到並細閱及明白以上之「風險披露聲明書- 交易所買賣之衍生產品」。我 / 我們並且確認其財務狀況確可承受買賣交易所買賣之衍生產品所引致之潛在損失。我 / 我們亦聲明在其財務狀況有所變更時，將儘速地通知高盈證券。",

      checkbox_label_4_prev: "我已參閱給予客戶有關",

      checkbox_label_4_middle: "個人資料(私隱)政策 私隱政策聲明",

      checkbox_label_4_middle_name: "和",

      checkbox_label_4_middle1: "客戶常設授權",

      checkbox_label_4_next: "的通知，並明白且同意其條款",

      checkbox_label_5_prev: "我/我們確認已閱讀並理解由高盈證券所發布的關於實施",
      checkbox_label_5_middle: "投資者識別及場外證券匯報製度之客戶資料收集聲明",
      checkbox_label_5_next: "之內容。我/我們表示同意高盈證券根據本聲明中的條款和目的使用我/我們的個人資料。",

      desc:
        "我 / 我們現獲告知高盈證券擬使用及在高盈證券（如《交易帳戶條款及條件》中所定義）之間轉移我 / 我們於高盈證券之個人資料以直接促銷：(i) 金融服務和產品；(ii) 相關優惠計劃；(iii) 金融與投資建議；或(iv) 高盈證券就前述產品及服務之業務推廣和宣傳活動。該等個人資料包括我 / 我們在本開戶表格中向高盈證券提供的及高盈證券公司不時獲得的姓名、聯絡詳情、財務背景及統計資料等個人資料。我 / 我們明白可以隨時通過高盈證券指定的渠道要求高盈證券停止在直接促銷中使用我 / 我們的個人資料。",

      checkbox_label_5:
       "本人(等) (客戶)不希望高盈證券使用本人(等)的個人資料作直接促銷用途。",

      checkbox_label_6:
       "本人(等) (客戶)不希望在高盈證券之間轉移本人(等)的個人資料作直接促銷用途。",

      checkbox_label_7:
       "我/我們同意高盈證券或聯繫人士各種方式提供投資或有關財務產品及服務的資料，其包括研究報告及特別優惠等。",

      checkbox_label_8:
       "我/我們同意簽名同時用於開戶申請表、衍生產品基本知識課程、風險承受能力問卷、W-8BEN表格、風險披露聲明、客戶常設授權、稅務居民數據、FATCA、客戶資料收集聲明和其他適用文件。",

      checkbox_label_8_with_mainland:
       "我/我們同意簽名同時用於開戶申請表、衍生產品基本知識課程、風險承受能力問卷、W-8BEN表格、風險披露聲明、客戶常設授權、稅務居民數據、FATCA、客戶資料收集聲明、內地投資者開戶聲明書和其他適用文件。",

	  checkbox_label_8_1:
	   "我/我們同意輸入登入密碼確認簽名同時用於開戶申請表、衍生產品基本知識課程、風險承受能力問卷、W-8BEN表格、風險披露聲明、客戶常設授權、稅務居民數據、FATCA、客戶資料收集聲明和其他適用檔案。",

      sign_tip:
        "我/我們同意高盈證券或聯系人士各種管道提供投資或有關財務產品及服務的資料，其包括研究報告及特別優惠等。",

      sign_title: "用戶簽名",

      sign_desc: "點擊進入簽名頁"
    },

    sign_write: {
      reset_btn_text: "重置",
      confirm_btn_text: "確定",
      tip_dialog_title: "溫馨提示",
      tip_dialog_message: "請將手機橫屏操作",
      tip_dialog_btn_text: "知道了",
      empty_toast_text: "您還未簽名"
    },

    result_page: {
      title: "提交成功", //U
      desc: "開戶信息已提交，系統將盡快處理，請耐心等待", // U
      number_label: "業務受理編號" //U
    }
  },

  //人脸识别
  face_recognition: {
    nav_title: "人臉識別",
    pic_title: "正確示意流程",
    check_rule: "查看規範",
    tips_modal_title: "视频录制规范",
    tips_modal_close_btn_text: "我知道了",
    record_tip: ["請錄制", "1~2秒多次眨眼", "視頻"],
    record_btn_text: "開始錄制",
    verify_success_msg: "人臉驗證成功", //U1
    verify_success_btn_text: "完成驗證", //U1
    verify_fail_msg: "無法確認為同壹個人", //U1
    reVerify_btn_text: "重新驗證", //U1
    common_btn_text: "常規開戶", //U1
    dialog_content_msg: "常規開戶將采用人工方式核驗身份", //U1
    dialog_content_desc:
      "審核結果會以短信通知到您本人， \n 核審壹般需要1-3個工作日" //U1
  },

  check_progress: {
    nav_title: "進度",
    status_text: "系統審核中",
    status_desc: "開戶信息已提交，系統將盡快處理，請耐心等待",
    status_tip_prev: "審核時間平均1~3個工作日，如需加急，請",
    status_tip_next: "聯系客服",
    acceptance_sn_label: "受理編號",
    created_time_label: "提交時間",
    progress_label: "處理進度",
    step_first_name: "資料審核中",
    step_second_name: "資料審核完成"
  }, // U

  //结算单

  statement: {
    list: {
      nav_title: "結算單",

      page_title: "結算單類型",

      standard_contract_statement_title: "標準合約結算單",

      standard_contract_statement_list: [
        {
          name: "日結算單",

          desc: ["香港期貨", "環球期貨"]
        },

        {
          name: "月結算單",

          desc: ["香港期貨", "環球期貨"]
        }
      ]
    },

    day_statement: "日結算單",
    month_statement: "月結算單",
    statement_type: ["標準合約", "連續合約"],

    detail: {
      no_result_text: "暫無結算單"
    }
  },

  //激活账户

  account_activation: {
    nav_title: "激活帳戶",
    desc:
      "系證監會新指引，允許客戶通過同名香港銀行帳戶轉帳管道完成身份核驗，開通證券帳戶",
    desc1:
      "系證監會新指引，允許客戶通過同名香港銀行帳戶轉帳管道完成身份核驗，開通期貨帳戶",
    check_SFC_text: "查看證監會發文",

    steps_title: "您需要這樣激活用戶",

    step_first_name: "綁定客戶同名香港銀行帳戶",

    step_second_name: "轉帳至高盈證券銀行戶口",

    step_second_desc: "（不少於<strong style='color:#17161C;'>10,000港幣</strong>或<strong style='color:#17161C;'>1,500美元</strong>）",

    activate_btn_text: "開始激活"
  },

  //安全中心

  security_center: {
    idcard_verify: {
      nav_title: "身份驗證",
      page_title: "請驗證您的身份信息",
      form_title: "請輸入開戶時使用的證件號碼",
      idcard_field_placeholder: "證件號碼"
    },
    trade_password_reset: {
      nav_title: "設置交易密碼",

      page_title: "請設置交易密碼",

      password_placeholder: "至少六位數字和字母組合",

      confirm_placeholder: "再次輸入密碼",
      trade_password_verify_fail_text: "密碼應為數字和字母結合，長度不低於6位", //U
      trade_password_repeat_fail_text: "兩次輸入不壹致", //U
      trade_password_reset_success_text: "交易密碼設置成功" //U
    },

    login_password_modify: {
      nav_title: "登錄密碼",

      page_title: "修改密碼",

      original_password_placeholder: "原密碼",

      new_password_placeholder: "至少8位數字和字母的組合",

      confirm_new_password_placeholder: "重復新密碼",

      new_password_verify_fail_text: "新密碼應為數字和字母結合，長度不低於8位", //U
      new_password_repeat_fail_text: "新密碼兩次輸入不壹致" //U
    },

    trade_password_modify: {
      nav_title: "交易密碼",

      page_title: "修改密碼",

      original_password_placeholder: "原密碼",

      new_password_placeholder: "至少6位數字和字母的組合",

      confirm_new_password_placeholder: "重復新密碼",

      new_password_verify_fail_text: "新密碼應為數字和字母結合，長度不低於6位", //U
      new_password_repeat_fail_text: "新密碼兩次輸入不壹致", //U
	  account_fail_text:"請選擇一個帳號"
    },

    login_device: {
      nav_title: "登錄設備管理",
      tips:
        "已綁定的登錄設備：你可以刪除列表中的設備，刪除後在該設備登錄需要進行身份驗證。",
      del_btn: "删除",
      del_text: "刪除該登錄設備",
      cancel_btn: "取消",
      ok_btn: "確定",
      operated: "操作成功"
    }
  },

  //帮助中心

  help_center: {
    nav_title: "幫助中心", //U
    list: [
      {
        text: "內地用戶如何開戶",
        path: "/help-center/mainland-account-open"
      },

      {
        text: "怎樣激活郵箱",
        path: "/help-center/activation-email"
      }
    ]
  },

  //转出资金

  withdraw: {
    nav_title: "轉出資金",

    a_account_name: "標準合約A帳戶",

    b_account_name: "連續合約B帳戶",

    transferred_text: "可轉出",
    transferred_total_text: "可轉出總計", //U
    usd: "美元",

    hkd: "港幣",

    rmb: "人民幣",

    currency_field: {
      label: "轉出幣種",
      placeholder: "請選擇" //U
    },

    bankCard_field: {
      label: "轉出銀行卡",

      placeholder: "請選擇",

      tip: "註意：銀行卡必須能夠接收上述幣種"
    },

    amount_field: {
      label: "轉出金額",

      placeholder: "請填寫數字"
    },

    withdraw_explain_title: "資金轉出說明",

    withdraw_explain_desc_1:
      "1.匯率會在壹定期限內變動實際到帳資金可能與預計到帳金額存在差別；",

    withdraw_explain_desc_2:
      "2.請確保您選擇的銀行卡能夠接收您的轉出幣種以免資金不能及時到帳。",
    withdraw_success_title: "資金轉出訂單提交成功",
    withdraw_success_msg: "預計到帳時間1~3個工作日",
    no_bankCard_dialog_msg: "您未綁定銀行卡",
    no_bankCard_dialog_desc: "資金需要指定轉出的銀行卡",
    no_bankCard_dialog_cancel_btn_text: "暫不處理",
    no_bankCard_dialog_confirm_btn_text: "去綁定",
    all_amount: "全部餘額"
  },

  //资金划转

  transfer: {
    nav_title: "資金劃轉",
	fade_out_name:'轉出帳戶',
	fade_out_amout_name:'可轉出金額',
	arreny_name:['美元','港幣','人民幣'],
	fade_in_name:'轉入帳戶',
	fade_out_arreny:'轉出幣種',
	fade_out_amout:'轉出金額',
	amout_placeolder:'請輸入轉出金額',
	btn:'確認提交',
	toast_amout:'劃出金額不得超過可轉出金額',
	toast_amout1:'最小轉出金額不得小於0，請修改',
	confim:'知道了',
	confim_message:'資金劃轉訂單提交成功預計1個工作日生效',
	forget_pwd:'忘記交易密碼?',
	tr_pwd_title:'驗證交易密碼',
	confirm_btn:'確定',
	chanel_btn:'取消',
	rightBtn:'劃轉記錄'
  },

  //失败原因
  fail_reason: {
    nav_title: "資料修改",
    page_title: "請按照提示修改資料並提交",
    reason_item_label: "可能是因为",
    processed_status: "已处理",
    untreated_status: "未处理",
    submit_btn_text1: "提交完成",
    submit_btn_text2: "提交修改",
    checkPasswordTips: '密碼不能為空',
    checkPassword: '驗證登錄密碼',
    confirm: '確認',
    cancel: '取消',
    reasonText:'可能不通過的原因',
    fail_reason_list: [
      {
        id: 1,
        title: "照片問題",
        reasons: ["身份信息與證件照不一致", "證件照片有部分缺失、不清晰"],
        status: 0,
        path: "/idcard-upload"
      },
      {
        id: 2,
        title: "視頻問題",
        reasons: [
          "錄製環境太暗，請在光線充足環境錄製",
          "視頻不清晰",
          "視頻長度不夠，請在錄製時緩慢轉頭部或張口"
        ],
        status: 0,
        path: "/face-record"
      },
      {
        id: 3,
        title: "地址證明",
        reasons: [
          "地址證明與住址不一致",
          "地址證明不完整，缺少客戶姓名",
          "請使用近3個月內的地址證明"
        ],
        status: 0,
        path: "/address-proof"
      },
      {
        id: 4,
        title: "稅務資料有誤",
        reasons: ["稅務編號或其他信息不真實"],
        status: 0,
        path: "/tax-resident-info/page-one"
      },
      {
        id: 5,
        title: "W-8BEN資料有誤",
        reasons: ["地址與居住地址不一致", "英文地址不符合規範"],
        status: 0,
        path: "/w8ben"
      },
      {
        id: 6,
        title: "上傳憑證不合規範",
        reasons: ["上傳憑證不合規範"],
        status: 0,
        path: "/cognition-of-derivatives"
      },
      {
        id: 7,
        title: "簽名不正確或不符合規範",
        reasons: ["簽名不正確或不符合規範"],
        status: 0,
        path: "/electronic-sign"
      },
      {
        id: 8,
        title: "本公司不接受此類型用戶開戶",
        reasons: ["簽名不正確或不符合規範"],
        status: 0
      },
      {
        id: 9,
        title: "其他",
        reasons: ["簽名不正確或不符合規範"],
        status: 0
      },
      {
        id: 10,
        title: "地址證明",
        reasons: ["地址輸入不完整/和地址證明不符合"],
        status: 0
      },
      {
        id: 11,
        title: "風險承受能力問卷",
        reasons: ["風險承受能力問卷分數太低"],
        status: 0
      },
      {
        id: 12,
        title: "個人信息",
        reasons: ["公司名稱不清晰"],
        status: 0
      },
      {
        id: 13,
        title: "個人信息",
        reasons: ["業務屬性屬於高風險"],
        status: 0
      },
      {
        id: 14,
        title: "個人信息",
        reasons: [" 身份證照片模糊"],
        status: 0
      },
      {
        id: 15,
        title: "個人信息",
        reasons: ["住址證明需在三個月內"],
        status: 0
      },
      {
        id: 16,
        title: "個人信息",
        reasons: ["住址證明需包含本人名字和住址信息"],
        status: 0
      },
      {
        id: 17,
        title: "個人信息",
        reasons: ["電子簽名太小、不清晰"],
        status: 0
      },
      {
        id: 18,
        title: "適當性調查",
        reasons: ["財務狀況與收入不符"],
        status: 0
      },
      {
        id: 19,
        title: "適當性調查",
        reasons: ["職業狀態與資金來源不符"],
        status: 0
      },
      {
        id: 20,
        title: "個人信息",
        reasons: ["郵箱格式不正確"],
        status: 0
      },
      {
        id: 21,
        title: "客戶聲明",
        reasons: ["雇主書面同意書不清晰"],
        status: 0
      },
      {
        id: 22,
        title: "客戶聲明",
        reasons: ["持牌信息有誤"],
        status: 0
      },
      {
        id: 24,
        title: "個人信息",
        reasons: ["身份信息有誤"],
        status: 0
      },
      {
        id: 25,
        title: "稅務資料有誤",
        reasons: ["稅務證明資料需包含本人名字和稅務信息"],
        status: 0
      }
    ],
    mechanism: "開戶信息審核失敗，如需幫助，請聯繫客服"
  },

  //协议
  protocols: {
    customer_agreement_nav_title: "客戶協議",
    license_agreement_nav_title: "產品協議許可證",
    register_privacy_policy_nav_title: "隱私政策"
  },

  //验证交易密码弹框
  trade_password_verify: {
    header_title: "驗證交易密碼",
    reset_trade_password: "重置交易密碼"
  },
  privacyProtocol: {
    title: "個人資料(私隱)政策/私隱政策聲明",
    contents: [
      {
        content:
          "1.作為高盈證券有限公司之客戶（“客戶”），當申請開立或維持帳戶或建立、維持或提供投資、交易或相關服務時，需不時向高盈證券或聯屬公司提供有關之個人資料（“個人資料”）。（《個人資料（私隱）條例》（香港法例第486 章）（“私隱條例”）所賦予之定義）。"
      },
      {
        content:
          "2.若未能向高盈證券提供有關資料，將會導致高盈證券無法開立或維持戶口或建立、維持或提供投資、交易或相關服務。"
      },
      {
        content:
          "3.個人資料將可能在與高盈證券及/或聯屬公司的正常業務往來過程中被收集。"
      },
      {
        content: "4.根據私隠條例的條文，資料將可能用於下列用途：",
        childContent: [
          "(a) 為提供服務給客戶之日常運作；",
          "(b) 作信貸或反洗錢檢查；",
          "(c) 確保客戶之信用持續良好及反洗錢風險監控；",
          "(d) 宣傳投資、交易或相關服務或產品(詳情請見如下第8段)；",
          "(e) 支援高盈證券在有關服務上作出之任何文件內之任何聲明；",
          "(f) 協助其他有關第三者、專業人員、機構及有關監管機構確認某些高盈證券在有關服務上之事實；",
          "(g) 根據高盈證券須遵守之有關法例及／或條例要求作出披露；",
          "(h) 組成接收資料者所經營業務的紀錄的一部份；",
          "(i) 與上述有關或隨附之其他用途。"
        ]
      },
      {
        content:
          "5.高盈證券會把個人資料保密，但為達至上述第(4)段所述的用途，高盈證券可能會把個人資料提供給：",
        childContent: [
          "(a) 任何中間人，或提供與高盈證券業務運作有關服務之第三者服務供應商；",
          "(b) 任何對高盈證券作出保密責任之適當人士，包括對高盈證券作出保密資料承諾的任何聯屬公司；",
          "(c) 任何與閣下已有或建議有交易之人士及機構；",
          "(d) 信貸諮詢機構及(發生拖欠付款時)收數公司；",
          "(e) 任何管治或與高盈證券及聯屬公司的業務有關的監管機構及交易所；",
          "(f) 任何承讓人、受讓人、代表、繼承人或獲轉讓有關帳戶之人士及授權人士；",
          "(g) 任何高盈證券之實際或建議受讓人或參與人或附屬參與人或受讓人。"
        ]
      },
      {
        content:
          "6.客戶同意個人資料可轉到香港以外的任何地點(不論是用作在香港以外處理、持有或使用該等資料)，並同意可轉發給向任何聯屬公司就其業務經營而提供服務的服務提供者。"
      },
      {
        content:
          "7.在法律許可的範圍內，客戶同意高盈證券不時收集的個人資料可按照私隱政策的規定使用及披露。"
      },
      {
        content: "8.使用個人資料作直接促銷",
        childContent: [
          "高盈證券擬使用閣下的該等資料作直接促銷，為此高盈證券在使用該等資料前須取得閣下的同意（包括表示不反對）。閣下同意與否純屬個人意願。就此，務請閣下注意",
          "(a) 由高盈證券不時持有的閣下的姓名、聯絡詳情、產品及服務組合信息、交易模式及行為、財務背景及統計資料（「可作直銷用途的個人資料」）可由高盈證券用作直接促銷；",
          "(b) 可促銷的各類服務、產品及主題如下",
          "i. 財務、保險、證券、商品、投資及相關服務、產品及設施；",
          "ii. 上文第(8)(b)(i)條所述各類促銷主題涉及的獎賞、忠誠獎勵或優惠計劃；",
          "iii. 由高盈證券的合作品牌夥伴因應上文第(8)(b)(i)條所述各類促銷主題而提供的服務和產品（合作品牌夥伴的名稱見相關服務和產品（視屬何情況而定）申請書）；及",
          "iv. 為慈善及/或非牟利目的而作出的捐款及捐獻；",
          "(c) 上述服務、產品及主題可由高盈證券及/或以下各方提供或（如涉及捐款及捐獻）收集：",
          "i. 任何聯屬公司；",
          "ii. 第三方金融機構、承保人、證券、商品及投資服務提供者；",
          "iii. 第三方獎賞、忠誠獎勵、合作品牌或優惠計劃提供者；",
          "iv. 高盈證券的合作品牌夥伴（合作品牌夥伴的名稱見相關服務和產品（視屬何情況而定）申請書）；",
          "v. 慈善或非牟利組織；",
          "(d) 除了自行推廣上述服務、產品及主題外，高盈證券亦擬將上文第(8)(a)條所述資料提供予上文第(8)(c)條所述的全部或當中任何人士（不論提供資料是為得益與否），以供該等人士在促銷上文第(8)(b)條所述的該等服務、產品及主題時使用（高盈證券可能就此收取報酬），而高盈證券須為此用途取得閣下的書面同意（包括表示不反對）；",
          "在未經閣下同意之前高盈證券不會使用閣下可作直銷用途的個人資料進行直接促銷。當簽署相關客戶開戶文件時，請註明閣下同意與否。如閣下在相關開戶文件中表明閣下同意後欲改變意願，希望高盈證券不再使用或向其他人士提供閣下可作直銷用途的個人資料進行上述直接促銷，閣下可向高盈證券發出書面通知或致電高盈證券的客戶服務部（郵寄地址及電話號碼載於下文第(11)條），以行使閣下拒絕參與直銷活動的權利。",
          "但請注意，如閣下是以公司或業務代表身份在相關客戶文件中表明同意參與直接促銷活動，而非以個人身份收取促銷資料，則上述權利並不適用於閣下。"
        ]
      },
      {
        content: "9.收集個人資料聲明-滬深港通北向交易",
        childContent: [
          "閣下瞭解並同意高盈證券在為閣下提供滬深港通北向交易的過程中，高盈證券會被要求按有關規則處理客戶個人資料，包括以下各項：",
          "1. 在向中華證券通系統（“CSC”）遞交閣下每單北向交易指令時,附加閣下唯一的券商客戶編碼（Broker-to-Client Assigned Number，“BCAN”）/為閣下聯名帳戶編派的券商客戶編碼；及",
          "2. 在交易所可能不時依據交易所規則向高盈證券提出要求時，高盈證券將向交易所提供閣下的券商客戶編碼和客戶識別資訊（Client Identification Data，“CID”）",
          "在不局限於高盈證券就處理閣下個人資料曾發予閣下的通知或已從閣下獲得的同意/授權，閣下在此瞭解並同意高盈證券在提供滬深"+
          "港通北向交易服務過程中可根據需要收集、存儲、使用、披露和轉交與閣下有關的個人資料，包括如下：",
          "(a) 不時向交易所和相關的港交所附屬公司披露並轉交閣下的券商客戶編碼和客戶識別資訊，包括在向中華證券通輸入中華通交易"+
           "時註明閣下的券商客戶編碼，並即時轉送給相關的中華通市場營運者；",
          "(b) 允許各交易所及相關的港交所附屬公司：",
          "i. 為達至市場監督和監測及執行交易所規則之目的，收集、使用和存儲由中華通結算所提供的閣下券商客戶編碼，客戶識"+
          "別資訊以及任何經整合、驗證和配對的券商客戶編碼和客戶識別資訊（可由上述任何各方或通過香港交易所存儲）；",
          "ii. 為達至下文（c）和（d）之目的，不時將有關資料轉交有關中華通市場營運者（直接或經有關中華通結算所）;",
          "iii. 向香港監管機構和執法機關披露此類資訊以便其履行就香港金融市場的法定職能；",
          "(c) 允許相關中華通結算所：",
          "i. 收集、使用和存儲閣下的券商客戶編碼和客戶識別資訊，以便整合及驗證券商客戶編碼和客戶識別資訊，配對券商客戶"+
          "編碼和客戶識別資訊至投資者識別資料庫，並將經整合、驗證和配對的券商客戶編碼及客戶識別資訊提供給相關的中華"+
            "通市場營運者，各交易所及相關港交所附屬公司;",
          "ii. 使用閣下的券商客戶編碼和客戶識別資訊進行其證券帳戶管理的監管職能;",
          "iii. 將這些資訊披露給具有管轄權的中國內地監管機構和執法機關，以便其就中國內地金融市場履行監管，監督和執法職能；",
          "(d) 允許相關的中華通市場營運者：",
          "i. 收集、使用和存儲閣下的券商客戶編碼和客戶識別資訊，以便其監督和監測經中華通服務在相關中華通市場的證券交易"+
          "及執行相關中華通市場營運者的規則;",
          "ii. 將這些資訊披露給具有管轄權的中國內地監管機構和執法機關，以便其就中國內地金融市場履行監管，監督和執法職能；",

          "如果閣下就任何有關中華通證券的交易向高盈證券發出指示，即表示閣下確認並同意高盈證券為遵守交易所就滬深港通北向交易不時"+
          "制定的的要求及規則使用閣下的個人資料。閣下同時承認，儘管閣下後續可能表示撤回該同意，閣下的個人資料仍可能繼續被存儲，"+
          "使用，披露，轉移和及為達至上述目的其他方式處理，無論是在該等聲稱的撤回同意之前或之後。",
          "未能提供個人資料或同意的後果",
          "如閣下未能向高盈證券提供閣下的個人資料或上述同意/授權，這可能代表著高盈證券不會或不再能夠執行閣下的交易指令或向閣下"+
          "提供滬深港通北向交易服務。",
        ]
      },
      {
        content: "10.根據私隱條例中之條文，任何人有權：",
        childContent: [
          "(a) 審查高盈證券是否持有他／她的資料及查閱有關之資料；",
          "(b) 要求高盈證券改正有關他／她不準確之資料；",
          "(c) 查悉高盈證券對於資料之政策及實際運用及被通知高盈證券持有何種個人資料；",
          "(d) 就客戶信貸而要求獲通知哪項個人資料是例行披露予信貸諮詢機構或收數公司，以及獲提供進一步的資訊以便向有關的信貸諮詢機構或收數公司作出查閱及改正要求。"
        ]
      },
      {
        content:
          "11.根據私隱條例規定，高盈證券有權就處理任何查閱資料之要求收取合理費用。任何關於資料查閱或改正資料(當客戶認為由高盈證券所提供有關他／她的資料不準確時)或關於資料政策及實際應用或資料種類之要求，應向下列人士提出：私隱保護主任高盈證券有限公司，中國香港尖沙咀港威大廈 6 座 31 樓 3102 室。"
      }
    ]
  },
  newaccount: {
    title: "期貨帳戶",
    new_title: "開戶",
    startopen: "在線開戶",
    speedaudit: "極速審核",
    capital: "資金進出",
    futurestrade: "交易",
    time: "10分鐘",
    day: "1個工作日內",
    realtime: "實時T+0",
    world: "投資全球",
    compliance: "合規運營",
    low: "超低延時",
    commission: "超低傭金",
    worldcontent: "港美股、香港及環球期貨",
    compliancecontent: "我司接受中國香港證監會監管。",
    lowcontent: "與主流交易所搭建專屬服務器，交易延時降到最低。",
    commissioncontent: "機具競爭力的傭金比例，最大程度節省您的交易成本。",
    btnname: "馬上開戶",
    footertitle: "開戶前請準備好",
    idcard: "身份證",
    wifi: "WiFi或4G"
  },
  passwordErrorPrompt: {
    tryAgain: "再試一次",
    set: "去設置"
  },
  openReference: {
    nav_title: "推薦人信息",
    ipt_label: "推薦人信息",
    ipt_plh: "請輸入",
    periodOfValidity: "證件有效期"
  },
  marketServices: {
    t00001: "行情服務",
    t00002: "我的行情",
    t00003: "<div>實時行情服務，<span style='color: #328CF4; text-decoration: underline;'>請聯繫客服</span></div>",
    t00004: "數據加載中...",
    t00005: "暫無實時行情服務"
  },
  mki18n:{
    t00001: "開始時間",
    t00002: "結束時間",
    t00003: '*請不要使用他人銀行帳戶匯款，匯款人與帳戶持有人必須是同一人',
    t00004: '註冊帳號',
    t00005: '中國香港 +852',
    t00006: '中國大陸 +86',
    t00007: '持有人的英文名',
    t00008: '請輸入',
    t00009: '銀行名稱',
    t00010: '銀行代碼/銀行名稱',
    t00011: '扣款銀行',
    t00012: '收款銀行',
    t00013: '方式一、從手機銀行/網上銀行轉帳',
    t00014: '方式二、從手機銀行/網上銀行發起FPS轉帳',
    t00015: '我已轉帳，通知高盈收款',
    t00016: '通知高盈收款',
    t00017: '預計到帳時間',
    t00018: '1-3個工作日',
    t00019: '費用',
    t00020: '同行免費，跨行可能收費',
    t00021: '手機/網上銀行轉帳',
    t00022: '入金審核中',
    t00023: '1. 系統正在處理，審核時間平均1~3個工作日，請耐心等待',
    t00024: '2. 如果需要修改或補充資料，您會收到郵件或短信通知，請留意',
    t00025: '3. 如需加急，請',
    t00026: '入金審核通過',
    t00027: '如需加急，請',
    t00028: '入金審核不通過',
    t00029: '如有疑問，請',
    t00030: '開通交易帳戶',
    t00031: '開通交易帳戶中',
    t00032: '重新入金激活',
    t00033: '開戶進度',
    t00034: '保存',
    t00035: '終止開戶',
    t00036: '系統提示您屬於高風險人群，本公司不接收此類型用戶開戶',
    t00037: '我已知曉'
  },
  network_error_text: {
    t00001: '錯誤請求',
    t00002: '未授權，請重新登錄',
    t00003: '拒絕訪問',
    t00004: '請求錯誤,未找到該資源',
    t00005: '請求方法未允許',
    t00006: '請求超時',
    t00007: '服務器端出錯',
    t00008: '網絡未實現',
    t00009: '網絡錯誤',
    t00010: '服務不可用',
    t00011: '網絡超時',
    t00012: 'http版本不支持該請求',
    t00013: '連接錯誤',
  }
};

const languageFiles = require.context("./", false, /\.js$/);
languageFiles.keys().forEach(name => {
  moduleHk = { ...moduleHk, ...languageFiles(name).default };
});

export default moduleHk;
